{
  "activities": {
    "addTask": "Tâche",
    "allPersons": "Toutes les personnes",
    "empty": "Aucune activité",
    "filterByPerson": "Filtrer par personne",
    "hideCompleted": "Masquer les terminées",
    "open": "ouvertes",
    "showCompleted": "Afficher {{count}} terminées",
    "title": "Activités",
    "viaContact": "via {{name}}"
  },
  "addresses": {
    "tabCompanies": "Organisations",
    "tabContacts": "Contacts",
    "title": "Adresses"
  },
  "agb": {
    "footer": {
      "address": "Uniplacement GmbH · c/o S&K Partners AG · Samstagernstrasse 55 · 8832 Wollerau · Schweiz",
      "registration": "UID CHE-265.053.706 · Handelsregister Kanton Schwyz"
    },
    "notice": "La version allemande fait foi. Les honoraires et conditions sont régis par votre contrat individuel.",
    "sections": {
      "account": "§ 3 Konto und Zugang",
      "availability": "§ 10 Verfügbarkeit und Änderungen",
      "circumvention": "§ 12 Umgehungsverbot (Plattformebene)",
      "dataProtection": "§ 8 Datenschutz und KI-Verarbeitung",
      "finalProvisions": "§ 14 Schlussbestimmungen",
      "identification": "§ 7 Identifikation und Sorgfaltspflichten",
      "liability": "§ 11 Haftung",
      "offers": "§ 5 Angebote und Verkaufsverfahren",
      "scope": "§ 1 Geltungsbereich",
      "services": "§ 2 Leistungen der Plattform",
      "signature": "§ 6 Elektronische Signatur",
      "teaserNda": "§ 4 Teaser, NDA und Dossiers",
      "terms": "§ 13 Laufzeit, Sperrung, Änderungen der AGB",
      "usageRights": "§ 9 Nutzungsrechte und Daten"
    },
    "serviceItems": {
      "communication": "Kommunikation zwischen den Beteiligten",
      "contracts": "Generierung und elektronische Signatur von Verträgen",
      "dataRoom": "Datenraum, Dossiers und Dokumentenverwaltung",
      "objectInfo": "Aufbereitung und Bereitstellung von Objektinformationen",
      "offers": "Abgabe und Verwaltung von Angeboten"
    },
    "subtitle": "Plattform-Nutzungsbedingungen der Uniplacement GmbH (Betreiberin der Plattform «Immotron») · Gültig ab 1. Oktober 2026",
    "title": "Conditions générales (AGB)",
    "version": "Version 1.1 · Gültig ab 1. Oktober 2026"
  },
  "ai": {
    "aiAccuracy": "IA moy.",
    "cliUnavailable": "CLI non disponible",
    "confirmed": "Confirme",
    "disabled": "Desactive",
    "enabled": "Actif",
    "error": "Une erreur s'est produite",
    "fieldsBetter": "champs meilleurs",
    "images": {
      "loadFailed": "Bild konnte nicht geladen werden",
      "notAvailable": "Bild nicht verfügbar",
      "primaryImage": "Hauptbild",
      "removeImage": "Bild entfernen",
      "selectAll": "Alle",
      "selectLabel": "Auswählen",
      "selectNone": "Keine",
      "selectRelevant": "Relevante",
      "selectedLabel": "Ausgewählt",
      "setAsPrimary": "Als Hauptbild setzen",
      "title": "Bilder"
    },
    "jobs": {
      "active": "Aktiv",
      "addWarning": "Hinweis hinzufügen",
      "archive": "Archivieren",
      "cancelFailed": "Abbrechen fehlgeschlagen",
      "cancelStarted": "Job wird abgebrochen",
      "core": "Pflicht",
      "cost": "Kosten",
      "coverage": "Abdeckung",
      "createProperty": "Objekt erstellen",
      "createPropertyFailed": "Objekt konnte nicht erstellt werden",
      "createPropertyRecovered": "L'objet #{{id}} a été créé (la connexion a été brièvement interrompue)",
      "creating": "Erstellen...",
      "deleteConfirm": "Job endgültig löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteFailed": "Löschen fehlgeschlagen",
      "dismissFailed": "Konnte nicht abgeschlossen werden",
      "documentCoverage": "Dokumenten-Abdeckung",
      "documentMapping": "Dokumentenzuordnung",
      "documents": "Dokumente",
      "done": "Fertig",
      "duration": "Dauer",
      "error": "Fehler",
      "feedbackResetFailed": "Feedback konnte nicht zurückgesetzt werden",
      "feedbackSendFailed": "Feedback konnte nicht gesendet werden",
      "feedbackSent": "Feedback gesendet",
      "files": "Dateien",
      "goToProperty": "Zum Objekt",
      "helpful": "hilfreich",
      "listRefreshed": "Liste aktualisiert",
      "model": "Modell",
      "noJobsFound": "Keine Jobs gefunden",
      "optional": "Optional",
      "pipeline": {
        "jumpToLatest": "Aller au plus recent",
        "live": "Direct",
        "loadFailed": "Echec du chargement des evenements",
        "loading": "Chargement des evenements...",
        "logTitle": "Journal de traitement",
        "noEvents": "Aucun evenement pour le moment",
        "stages": {
          "classification": "Classification",
          "extraction": "Extraction",
          "persistence": "Persistance",
          "upload": "Telechargement",
          "validation": "Validation"
        },
        "title": "Pipeline IA"
      },
      "processing": "Verarbeitung...",
      "quality": {
        "charsExtracted": "{{formatted}} caractères extraits",
        "docType": "Type",
        "encryptedPdf": "Chiffré",
        "encryptedShort": "chiffrés",
        "encryptedWarning": "PDF chiffré — extraction impossible. Veuillez téléverser une version non protégée.",
        "pages": "{{formatted}} pages",
        "scanPdf": "PDF scanné",
        "scanShort": "scans",
        "scanWarning": "Document scanné — l'extraction peut être incomplète.",
        "summary": "Résumé",
        "textPdf": "PDF texte",
        "title": "Qualité PDF"
      },
      "reactivate": "Reaktivieren",
      "reactivateFailed": "Reaktivierung fehlgeschlagen",
      "recommended": "Empfohlen",
      "refreshFailed": "Aktualisierung fehlgeschlagen",
      "reset": "Zurücksetzen",
      "resetConfirm": "Job zurücksetzen? Das Ergebnis wird gelöscht.",
      "resetFailed": "Zurücksetzen fehlgeschlagen",
      "resetShort": "Reset",
      "retry": "Wiederholen",
      "retryFailed": "Retry fehlgeschlagen — Originaldateien evtl. nicht mehr vorhanden",
      "retryStarted": "Job wird wiederholt",
      "saveFailed": "Speichern fehlgeschlagen",
      "showAll": "Alle Jobs anzeigen",
      "showCompleted": "Auch abgeschlossene anzeigen",
      "startNewUpload": "Neuen Upload starten",
      "statistics": "Statistik",
      "status": {
        "cancelled": "Abgebrochen",
        "pending": "Wartend"
      },
      "timeAgo": {
        "justNow": "gerade eben"
      },
      "title": "KI-Extraktions-Jobs",
      "titleShort": "KI-Jobs",
      "tokens": "Tokens",
      "unhelpful": "nicht hilfreich",
      "warnings": "Hinweise",
      "warningsSaved": "Hinweise gespeichert"
    },
    "learningDescription": "Comparaison: extraction IA vs. sources statiques (GeoAdmin)",
    "learningHint": "Le systeme apprend automatiquement avec chaque extraction confirmee.",
    "learningMode": "Mode apprentissage IA",
    "model": "Modele",
    "noComparisonData": "Pas encore de donnees de comparaison",
    "noComparisonDataHint": "Les donnees sont collectees automatiquement apres chaque extraction IA + confirmation.",
    "prompt": "Prompt",
    "promptPlaceholder": "Posez une question...",
    "response": "Reponse",
    "send": "Envoyer",
    "sending": "Envoi en cours...",
    "staticAccuracy": "Statique moy.",
    "status": "Statut",
    "subtitle": "Environnement de test Claude AI",
    "title": "Assistant IA",
    "totalExtractions": "Extractions",
    "upload": {
      "addMoreDocs": "Weitere Dokumente ergänzen",
      "addMoreDocsHint": "Fehlende Dokumente hochladen — bestehende Daten werden ergänzt, nicht überschrieben.",
      "addMoreHint": "Weitere Dateien/Ordner oben hinzufügen, dann Analyse starten",
      "backOtherDocs": "Zurück / Andere Dokumente",
      "backToProperties": "Zurück zu Objekte",
      "batchFailed": "fehlgeschlagen",
      "batchObjectsProcessed": "Objekten verarbeitet",
      "batchOf": "von",
      "batchProcessing": "Portfolio-Verarbeitung",
      "batchResult": "Portfolio-Ergebnis",
      "batchSuccessful": "erfolgreich",
      "catCore": "Kern-Dokumente",
      "catOptional": "Optional",
      "catRecommended": "Empfohlen",
      "chooseDirectory": "Verzeichnis wählen",
      "clickToEdit": "Klicken zum Bearbeiten",
      "collapseAll": "Alle zuklappen",
      "confidence": "Confidence",
      "confidenceExplain": "Confidence-Score erklären",
      "confirmCreate": "Erstellen",
      "confirmTitle": "Objekt erstellen?",
      "coreComplete": "Kern komplett",
      "createProperty": "Objekt erstellen",
      "createdSuccess": "Objekt erfolgreich erstellt!",
      "detectedDocTypes": "Erkannte Dokumenttypen",
      "docTypesDetected": "Dokumenttypen erkannt",
      "documentCoverage": "Dokumenten-Abdeckung",
      "documentMapping": "Dokumenten-Zuordnung",
      "documentPlural": "Dokumente",
      "documentSingular": "Dokument",
      "dropzoneHint": "Déposez ici PDF, images, Excel ou Word, ou choisissez un répertoire / des fichiers",
      "dropzoneTitle": "Objekt-Unterlagen hochladen",
      "editProperty": "Objekt bearbeiten",
      "expandAll": "Alle aufklappen",
      "feedbackFailed": "Feedback konnte nicht gesendet werden",
      "feedbackSent": "Feedback gesendet",
      "filePlural": "Dateien",
      "fileSingular": "Datei",
      "filterAll": "Alle",
      "filterOpen": "Offen",
      "filterRated": "Bewertet",
      "groupingFiles": "Dateien werden gruppiert und hochgeladen",
      "headerAncillary": "NK",
      "headerAreaFrom": "Fläche von",
      "headerAreaSqm": "Fläche m²",
      "headerAreaTo": "Fläche bis",
      "headerFloor": "Etage",
      "headerNetRent": "Nettomiete",
      "headerRented": "Vermietet",
      "headerRooms": "Zimmer",
      "headerRooms2": "Zimmer",
      "headerStatus": "Status",
      "headerTotal": "Total",
      "helpful": "Hilfreich",
      "hints": "Hinweise",
      "individualFiles": "Einzelne Dateien",
      "locationAnalysis": "Standort-Analyse",
      "lowConfidenceWarning": "Niedrige Confidence — manuelle Prüfung der Daten wird empfohlen.",
      "metaCost": "Kosten",
      "metaDuration": "Dauer",
      "metaModel": "Modell",
      "metaTokens": "Tokens",
      "newUpload": "Neuer Upload",
      "noData": "Keine Daten",
      "noPdfInDirectory": "Aucun fichier PDF trouvé dans le répertoire",
      "noSupportedInDirectory": "Aucun fichier pris en charge trouvé dans le répertoire (PDF, images, Excel ou Word)",
      "noValidFiles": "Aucun fichier valide sélectionné",
      "unsupportedFormat": "Type de fichier non pris en charge — autorisés : PDF, e-mail (.eml), images (JPEG/PNG/WebP/GIF), Excel (.xlsx/.xls) et Word (.docx/.doc)",
      "notHelpful": "Nicht hilfreich",
      "objectCreatedEmail": "Objekt erstellt — E-Mail mit offenen Fragen wurde gesendet",
      "objectUpdatedEmail": "Objekt aktualisiert — E-Mail mit offenen Fragen wurde gesendet",
      "ofDocTypes": "von",
      "openHints": "Offene Hinweise",
      "preparing": "KI-Analyse wird vorbereitet...",
      "processingDirectory": "Verzeichnis wird verarbeitet...",
      "qualityGood": "Gute Datenqualität — bereit zur Bestätigung",
      "qualityLow": "Wenige Daten extrahiert — manuelle Eingabe empfohlen",
      "qualityPartial": "Teilweise Daten extrahiert — bitte prüfen",
      "ready": "bereit",
      "redirecting": "Sie werden zur Bearbeitungsseite weitergeleitet...",
      "removeAll": "Alle entfernen",
      "rentRollStats": "Mieterspiegel-Statistik",
      "retry": "Wiederholen",
      "retryAction": "Erneut versuchen",
      "retryFailed": "Wiederholung konnte nicht gestartet werden",
      "retryNotPossible": "Wiederholung nicht möglich",
      "retryStarted": "Wiederholung gestartet",
      "saveFailed": "Speichern fehlgeschlagen",
      "saving": "Objekt wird gespeichert...",
      "scoreCurrent": "Aktuell",
      "scoreHigh": "Alle wichtigen Felder extrahiert, Daten plausibel.",
      "scoreLow": "Wenige Daten — prüfen oder manuell ergänzen.",
      "scoreMedium": "Einige Felder fehlen oder Unstimmigkeiten.",
      "scoreTitle": "Was bedeutet der Score?",
      "sectionAnalysis": "Immobilienanalyse",
      "sectionFinance": "Finanzen",
      "sectionGeoAdmin": "Behörden-Daten (swisstopo)",
      "sectionImages": "Bilder",
      "sectionInsurance": "Versicherung",
      "sectionParking": "Parkierung",
      "sectionProperty": "Objekt",
      "sectionRentRoll": "Mieterspiegel",
      "sectionUnitMix": "Wohnungsmix",
      "startAnalysis": "KI-Analyse starten",
      "submitting": "Dokumente werden übermittelt...",
      "subtitle": "Laden Sie die relevanten Dateien hoch: Mieterspiegel, Baubeschrieb, Grundbuchauszug, Gebäudeversicherungsnachweis, Marktwertschätzungen — die KI extrahiert automatisch alle Objektdaten.",
      "supplement": "Ergänzen",
      "supplementDocs": "Dokumente ergänzen",
      "title": "KI-Objekterfassung",
      "uploadFailed": "Upload fehlgeschlagen",
      "uploadedFiles": "Hochgeladene Dateien",
      "uploading": "Hochladen...",
      "waitProcessing": "Bitte warten — Upload/Verarbeitung läuft noch.",
      "whatIsWrong": "Was stimmt nicht? (optional)",
      "whyHelpful": "Warum hilfreich? (optional)"
    }
  },
  "aiClauses": {
    "cancel": "Annuler",
    "confirmDelete": "Supprimer ?",
    "confirmYes": "Confirmer",
    "delete": "Supprimer",
    "edit": "Modifier",
    "editClause": "Modifier la clause",
    "generate": "Générer",
    "generateFailed": "Impossible de générer la clause",
    "generateSuccess": "Clause générée avec succès",
    "generating": "Génération en cours...",
    "hint": "Le générateur de clauses IA crée des clauses sur mesure et les attribue à la section contractuelle sélectionnée. Vous pouvez modifier le texte généré et ajuster l'ordre par la suite.",
    "moveDown": "Déplacer vers le bas",
    "moveUp": "Déplacer vers le haut",
    "noClauses": "Aucune clause générée",
    "prompt": "Décrire la clause",
    "promptPlaceholder": "Décrivez la clause souhaitée, p.ex. 'Droit de rétractation sous réserve de financement'",
    "save": "Enregistrer",
    "section": "Section",
    "sections": {
      "BROKER_CONDITIONS": "Conditions spéciales courtier",
      "BUYER_CONDITIONS": "Conditions spéciales acheteur",
      "GENERAL_CONDITIONS": "Conditions générales",
      "PAYMENT_TERMS": "Conditions de paiement",
      "SELLER_CONDITIONS": "Conditions spéciales vendeur",
      "TERMINATION": "Conditions de résiliation"
    },
    "templates": "Modeles",
    "title": "Générateur de clauses IA"
  },
  "app": {
    "name": "Immotron",
    "tagline": "Plateforme d'Investissement Immobilier"
  },
  "pwa": {
    "newVersionAvailable": "Nouvelle version disponible",
    "update": "Mettre à jour"
  },
  "auth": {
    "errors": {
      "accountInactive": "Votre compte n'est pas encore activé",
      "accountInactiveDescription": "Veuillez d'abord signer le contrat que nous vous avons envoyé par e-mail. Après la signature, vous recevrez un lien pour configurer votre mot de passe.",
      "accountInactiveTitle": "Compte pas encore activé",
      "invalidCredentials": "E-mail ou mot de passe invalide",
      "networkError": "Erreur réseau. Veuillez réessayer.",
      "sessionExpired": "Votre session a expiré"
    },
    "forgotPassword": {
      "backToLogin": "Retour à la connexion",
      "email": "Adresse e-mail",
      "networkError": "Erreur de connexion. Veuillez réessayer.",
      "submit": "Envoyer le lien",
      "subtitle": "Entrez votre adresse e-mail",
      "success": "Si un compte existe, vous recevrez un e-mail.",
      "title": "Mot de passe oublié"
    },
    "login": {
      "email": "Adresse e-mail",
      "emailPlaceholder": "votre@email.ch",
      "forgotPassword": "Mot de passe oublié?",
      "noAccount": "Pas encore de compte?",
      "password": "Mot de passe",
      "passwordError": "Adresse e-mail ou mot de passe incorrect.",
      "passwordPlaceholder": "Votre mot de passe",
      "register": "S'inscrire",
      "rememberMe": "Rester connecté",
      "selectCompany": "Sélectionner une entreprise",
      "selectCompanySubtitle": "Choisissez l'entreprise pour laquelle vous souhaitez vous connecter",
      "submit": "Se connecter",
      "subtitle": "Bienvenue",
      "title": "Connexion",
      "withPassword": "Se connecter avec un mot de passe"
    },
    "logout": "Déconnexion",
    "magicLink": {
      "continueToApp": "Continuer vers la plateforme",
      "emailFallbackHint": "Veuillez indiquer votre adresse e-mail afin que nous puissions vous envoyer un nouveau lien.",
      "expiredMessage": "Pour des raisons de sécurité, ce lien n'est valable que pour une durée limitée.",
      "expiredTitle": "Lien de connexion expiré",
      "networkError": "Erreur de connexion. Veuillez réessayer.",
      "newLinkSent": "Nous avons envoyé un nouveau lien de connexion à votre adresse e-mail enregistrée. Veuillez consulter votre boîte de réception.",
      "resend": "Renvoyer",
      "sendNewLink": "Envoyer un nouveau lien",
      "sentHint": "Pas de lien reçu ? Vérifiez votre dossier spam.",
      "sentMessage": "Nous avons envoyé un lien de connexion à {{email}}.",
      "sentTitle": "Lien en route !",
      "stillSignedIn": "Vous êtes déjà connecté.",
      "submit": "Demander un lien de connexion",
      "subtitle": "Nous vous enverrons un lien de connexion à votre adresse e-mail.",
      "switchedUser": "Précédemment connecté en tant que {{from}} — maintenant connecté en tant que {{to}}",
      "title": "Connexion",
      "verifyingSubtitle": "Veuillez patienter un instant.",
      "verifyingTitle": "Connexion en cours…",
      "wrongAddress": "Mauvaise adresse ? Retour à la saisie"
    },
    "passkey": {
      "cancelled": "Connexion par Passkey annulée.",
      "divider": "ou",
      "error": "Échec de la connexion par Passkey. Veuillez réessayer.",
      "login": "Se connecter avec un Passkey",
      "registerSuccess": "Passkey configuré avec succès !",
      "setupAction": "Configurer maintenant",
      "setupDialog": {
        "cancelled": "Configuration du passkey annulée.",
        "created": "Passkey créé. Saisissez un nom d'appareil si vous le souhaitez.",
        "description": "Avec un passkey, vous pouvez vous connecter rapidement et en toute sécurité par empreinte digitale, reconnaissance faciale ou verrouillage de l'appareil.",
        "deviceNameHint": "Un nom vous aide à identifier ce passkey plus tard.",
        "deviceNameLabel": "Nom de l'appareil (optionnel)",
        "deviceNamePlaceholder": "p.ex. iPhone de Max",
        "error": "Impossible de configurer le passkey. Veuillez réessayer.",
        "notSupported": "Votre navigateur ne prend pas en charge les passkeys. Veuillez utiliser un navigateur à jour.",
        "register": "Configurer un Passkey",
        "saveError": "Le passkey a été créé localement mais n'a pas pu être enregistré. Veuillez réessayer.",
        "skipName": "Ignorer",
        "success": "Passkey configuré avec succès !",
        "title": "Configurer un Passkey"
      },
      "setupDismiss": "Plus tard",
      "setupMessage": "Configurez un passkey pour une connexion plus rapide et plus sécurisée.",
      "setupTitle": "Configurer un Passkey"
    },
    "passwordSetup": {
      "backToLogin": "Retour a la connexion",
      "confirmPassword": "Confirmer le mot de passe",
      "emailPlaceholder": "Saisir l'adresse e-mail",
      "error": "Impossible d'enregistrer le mot de passe. Veuillez réessayer.",
      "expiredMessage": "Ce lien a expiré. Veuillez nous contacter pour obtenir un nouveau lien.",
      "expiredMessageNew": "Ce lien a expire. Veuillez en demander un nouveau.",
      "expiredTitle": "Lien expiré",
      "invalidMessage": "Ce lien est invalide ou a déjà été utilisé.",
      "invalidTitle": "Lien invalide",
      "magicLinkError": "Le lien magique n'a pas pu etre envoye.",
      "magicLinkSentHint": "Verifiez votre boite de reception et cliquez sur le lien.",
      "magicLinkSentMessage": "Un lien de connexion a ete envoye a votre adresse e-mail.",
      "magicLinkSentTitle": "Lien envoye",
      "newPassword": "Nouveau mot de passe",
      "reqDigit": "Un chiffre",
      "reqLowercase": "Une lettre minuscule",
      "reqMinLength": "Au moins 8 caractères",
      "reqUppercase": "Une lettre majuscule",
      "requestNewLink": "Demander un nouveau lien",
      "requirementsNotMet": "Le mot de passe ne remplit pas toutes les conditions",
      "settingUpFor": "Configuration du mot de passe pour",
      "submit": "Enregistrer le mot de passe",
      "subtitle": "Créez votre mot de passe pour accéder à la plateforme",
      "successMessage": "Votre mot de passe a été enregistré. Vous serez redirigé vers la connexion.",
      "successTitle": "Mot de passe configuré avec succès",
      "title": "Configurer le mot de passe",
      "weakPassword": "Le mot de passe ne remplit pas les conditions."
    },
    "profile": "Profil",
    "resetPassword": {
      "confirmPassword": "Confirmer le mot de passe",
      "error": "Lien invalide ou expiré",
      "newPassword": "Nouveau mot de passe",
      "submit": "Définir le mot de passe",
      "subtitle": "Entrez votre nouveau mot de passe",
      "success": "Mot de passe modifié avec succès. Vous serez redirigé vers la connexion.",
      "title": "Définir un nouveau mot de passe"
    },
    "settings": "Paramètres",
    "twoFactor": {
      "backToLogin": "Retour à la connexion",
      "codeLabel": "Code de vérification",
      "codeSent": "Un nouveau code a été envoyé",
      "expiredCode": "Le code a expiré. Veuillez en demander un nouveau.",
      "invalidCode": "Code invalide",
      "maxAttempts": "Trop de tentatives. Veuillez vous reconnecter.",
      "resend": "Renvoyer le code",
      "resendCooldown": "Renvoyer dans {{seconds}}s",
      "resendSuccess": "Un nouveau code a été envoyé.",
      "submit": "Vérifier",
      "subtitle": "Nous avons envoyé un code de vérification à {{email}}",
      "title": "Entrez le code de vérification",
      "verify": "Vérifier",
      "wrongCode": "Le code saisi est invalide."
    }
  },
  "buyerProfile": {
    "title": "Profil d'investisseur (IA)",
    "relevance": "Pertinence",
    "notProfiled": "Pas encore profilé",
    "notProfiledHint": "Aucun profil d'investisseur n'a encore été créé pour cette organisation.",
    "badgeTooltip": "Pertinence immobilière : {{score}}/100",
    "scoreOutOf": "{{score}} sur 100",
    "profiledAtValue": "Profilé le {{date}}",
    "openSearchProfile": "Ouvrir le profil de recherche",
    "run": "Créer le profil",
    "rerun": "Recréer le profil",
    "runSuccess": "Profil d'investisseur mis à jour",
    "runError": "Le profil d'investisseur n'a pas pu être créé",
    "groupRun": "Créer des profils d'investisseur pour le groupe",
    "batchSummary": "{{profiled}} profilés · {{skipped}} ignorés · {{errors}} erreurs",
    "batchStarted": "{{count}} organisations sont profilées en arrière-plan — actualisez la page plus tard",
    "filterLabel": "Filtrer par pertinence investisseur",
    "filterAll": "Pertinence : toutes",
    "filterProfiled": "Uniquement profilées",
    "filterMin": "Score ≥ {{min}}"
  },
  "campaigns": {
    "blocks": {
      "add": "Ajouter un bloc",
      "fields": {
        "addItem": "Ajouter un élément",
        "addRow": "Ajouter une ligne",
        "alt": "Texte alternatif",
        "body": "Texte",
        "buttonColor": "Couleur du bouton",
        "buttonText": "Texte du bouton",
        "buttonUrl": "URL du bouton",
        "caption": "Légende",
        "cardColor": "Couleur de la carte",
        "cardText": "Texte de la carte",
        "cardTitle": "Titre de la carte",
        "heading": "Titre",
        "imageHeight": "Hauteur d'image",
        "imageOpacity": "Opacité de l'image",
        "imageUrl": "URL de l'image",
        "itemText": "Texte de l'élément",
        "itemTitle": "Titre de l'élément",
        "label": "Libellé",
        "leftImage": "Image gauche",
        "leftText": "Texte gauche",
        "list": "Liste",
        "overlayOpacity": "Assombrissement",
        "rightImage": "Image droite",
        "rightText": "Texte droit",
        "subtitle": "Sous-titre",
        "textAlign": "Alignement",
        "textOffsetY": "Position du texte (vertical)",
        "title": "Titre",
        "value": "Valeur"
      },
      "moveDown": "Descendre",
      "moveUp": "Monter",
      "remove": "Supprimer le bloc",
      "title": "Blocs de contenu",
      "types": {
        "contract_details": "Détails du contrat",
        "cta": "Call-to-Action",
        "divider": "Séparateur",
        "expiry_notice": "Avis d'expiration",
        "feature": "Section Feature",
        "hero": "Image hero",
        "image": "Image",
        "key_value": "Tableau de données",
        "text": "Texte",
        "two_column": "Deux colonnes"
      }
    },
    "company": "Entreprise",
    "confirmDelete": "Voulez-vous vraiment supprimer cette campagne ?",
    "confirmDeleteDescription": "Etes-vous sur de vouloir supprimer cette campagne ?",
    "createSuccess": "Campagne créée avec succès",
    "deleteCampaign": "Supprimer la campagne",
    "deleteFailed": "La campagne n'a pas pu etre supprimee.",
    "deleteSuccess": "Campagne supprimée avec succès",
    "editCampaign": "Modifier la campagne",
    "errors": {
      "createFailed": "Impossible de créer la campagne",
      "deleteFailed": "Impossible de supprimer la campagne",
      "loadFailed": "Impossible de charger les campagnes",
      "noRecipients": "Aucun destinataire ajouté",
      "previewFailed": "Impossible de charger l'aperçu",
      "sendFailed": "Impossible d'envoyer la campagne",
      "updateFailed": "Impossible de mettre à jour la campagne"
    },
    "footer": {
      "address": "Adresse",
      "companyName": "Nom de l'entreprise",
      "email": "E-mail",
      "phone": "Téléphone",
      "title": "Pied de page",
      "website": "Site web"
    },
    "fromEmail": "E-mail de l'expéditeur",
    "fromName": "Nom de l'expéditeur",
    "header": {
      "backgroundColor": "Couleur de fond",
      "headerSubtitle": "Slogan / Sous-titre",
      "headerTitle": "Titre de l'en-tête",
      "logoUrl": "URL du logo",
      "textColor": "Couleur du texte",
      "title": "En-tête"
    },
    "imagePicker": {
      "confirmDelete": "Voulez-vous vraiment supprimer cette image ?",
      "delete": "Supprimer l'image",
      "deleteFailed": "L'image n'a pas pu etre supprimee.",
      "deleteSuccess": "Image supprimée",
      "empty": "Aucune image téléchargée",
      "title": "Choisir une image",
      "upload": "Télécharger une image",
      "uploading": "Téléchargement..."
    },
    "list": {
      "empty": {
        "description": "Creez votre premiere campagne e-mail",
        "title": "Aucune campagne"
      }
    },
    "name": "Nom",
    "newCampaign": "Nouvelle campagne",
    "noTemplate": "Sans modele",
    "pause": {
      "button": "Pause",
      "confirm": "Mettre l'envoi en pause ? Le destinataire en cours sera encore envoyé.",
      "failed": "La campagne n'a pas pu etre mise en pause.",
      "success": "La campagne a ete mise en pause.",
      "title": "Mettre la campagne en pause"
    },
    "preview": {
      "refresh": "Actualiser l'aperçu",
      "title": "Aperçu"
    },
    "recipients": {
      "actions": "Actions",
      "add": "Ajouter",
      "added": "{{count}} destinataires ajoutés",
      "clear": "Tout supprimer",
      "company": "Entreprise",
      "confirmClear": "Voulez-vous supprimer tous les destinataires ?",
      "confirmDelete": "Vraiment supprimer ce destinataire ?",
      "delete": "Supprimer",
      "deleteFailed": "Le destinataire n'a pas pu etre supprime.",
      "deleteSuccess": "Destinataire supprimé",
      "existingCount": "{{count}} destinataires déjà ajoutés",
      "filterAll": "Tous",
      "filterType": "Filtrer par type",
      "limitReached": "Limite d'envoi atteinte ({{sent}}/{{limit}})",
      "mode": "Mode",
      "modeAll": "Tous les contacts",
      "modeByCompany": "Par entreprise",
      "modeManual": "Sélection manuelle",
      "modeUpload": "Importer Excel/CSV",
      "noRecipients": "Aucun destinataire",
      "onlyWithEmail": "Uniquement avec e-mail",
      "previewTitle": "Aperçu des destinataires",
      "reset": "Reinitialiser",
      "resetConfirm": "Réinitialiser le statut de {{email}} ?",
      "resetFailed": "Les destinataires n'ont pas pu etre reinitialises.",
      "resetStatus": "Réinitialiser",
      "resetSuccess": "Statut réinitialisé",
      "search": "Rechercher des destinataires...",
      "searchCompanies": "Rechercher une entreprise...",
      "selectCompanies": "Sélectionner des entreprises",
      "selectContacts": "Sélectionner des contacts",
      "selected": "{{count}} sélectionnés",
      "send": "Envoyer",
      "sendConfirm": "Envoyer l'e-mail à {{email}} maintenant ?",
      "sendFailed": "La campagne n'a pas pu etre envoyee.",
      "sendLimit": "Limite d'envoi",
      "sendLimitHint": "Max. destinataires par envoi (vide = tous)",
      "sendSingle": "Envoyer",
      "sendSuccess": "E-mail envoyé",
      "statusTitle": "Statut des destinataires",
      "syncStatus": "Synchroniser",
      "title": "Destinataires",
      "total": "{{count}} destinataires au total",
      "uploadBtn": "Importer le fichier",
      "uploadErrors": "erreurs",
      "uploadHint": "Importer un fichier Excel (.xlsx) ou CSV avec des adresses e-mail",
      "uploadResult": "{{added}} ajoutés, {{skipped}} ignorés ({{total}} total)",
      "viewAll": "Voir les {{count}} destinataires"
    },
    "replyTo": "Adresse de réponse",
    "resume": {
      "button": "Reprendre",
      "confirm": "Reprendre l'envoi à {{count}} destinataires restants ?",
      "failed": "La campagne n'a pas pu etre reprise.",
      "success": "La campagne a ete reprise.",
      "title": "Reprendre la campagne"
    },
    "selectTemplate": "Choisir un modele",
    "send": {
      "confirmSend": "Envoyer la campagne à {{count}} destinataires maintenant ?",
      "paused": "En pause",
      "progress": "Progression : {{sent}} sur {{total}}",
      "rateHint": "5-120 e-mails par minute (par défaut : 30)",
      "rateLabel": "Vitesse d'envoi",
      "send": "Envoyer la campagne",
      "sendNow": "Envoyer maintenant",
      "sending": "Envoi en cours...",
      "testEmail": "Adresse e-mail de test",
      "testSend": "Envoyer un e-mail test",
      "title": "Envoyer"
    },
    "sendLimit": {
      "saveFailed": "La limite d'envoi n'a pas pu etre enregistree.",
      "saved": "Limite d'envoi enregistree."
    },
    "sendLimitSaved": "Limite d'envoi enregistree.",
    "sendSuccess": "La campagne est en cours d'envoi",
    "stats": {
      "bounced": "Rebonds",
      "clicked": "Cliques",
      "delivered": "Livres",
      "failed": "Echoues",
      "opened": "Ouverts",
      "recipients": "Destinataires",
      "sent": "Envoyes"
    },
    "statuses": {
      "CANCELLED": "Annulee",
      "DRAFT": "Brouillon",
      "PARTIALLY_SENT": "Partiellement envoyee",
      "PAUSED": "En pause",
      "SENDING": "En cours",
      "SENT": "Envoyee"
    },
    "subject": "Objet",
    "subtitle": "Gerer et envoyer des campagnes e-mail",
    "syncStatus": "Actualiser le statut",
    "template": "Modele",
    "testSendSuccess": "E-mail de test envoyé à {{email}}",
    "title": "Campagnes",
    "updateSuccess": "Campagne mise à jour avec succès"
  },
  "ceoAgent": {
    "batch": {
      "description": "Traiter plusieurs tâches ouvertes avec l'IA en une fois.",
      "run": "Traiter 5 tâches",
      "title": "Traitement par lots"
    },
    "results": {
      "title": "Résultats"
    },
    "status": {
      "available": "IA disponible",
      "openTasks": "Tâches ouvertes",
      "pendingAI": "En attente de l'IA",
      "processedToday": "Traitées aujourd'hui"
    },
    "subtitle": "Assistant IA autonome pour les tâches",
    "suggestions": {
      "empty": "Aucune suggestion — tout est terminé !",
      "process": "Traiter",
      "title": "Suggestions"
    },
    "title": "Assistant tâches"
  },
  "ceoComposer": {
    "refine": {
      "label": "Que dois-je adapter ?",
      "placeholder": "p.ex. supprimer les propositions de rendez-vous/téléphone, demander une réponse écrite",
      "apply": "Adapter",
      "regenerate": "Régénérer",
      "regenerateHint": "Générer l'e-mail à nouveau — reprend les notes épinglées",
      "hint": "Le texte de base est conservé — seule la modification demandée est appliquée. La version précédente reste dans l'historique."
    },
    "emptyState": {
      "contextAnchor": "Je connais cette tâche :",
      "loading": "Chargement des suggestions …",
      "quickStartHeading": "Démarrer concrètement",
      "linkCardTitle": "Associer un contact, une entreprise ou un objet",
      "linkCardDesc": "Associez une entité pour que l'assistant puisse faire des suggestions ciblées et exécutables.",
      "linkContact": "Associer un contact",
      "linkCompany": "Associer une entreprise",
      "linkProperty": "Associer un objet",
      "inlineEmpty": "Aucune suggestion concrète disponible pour le moment."
    },
    "suggestions": {
      "button": "Suggestions"
    },
    "selection": {
      "asPostit": "📌 En post-it",
      "created": "Enregistré en post-it",
      "error": "Impossible d'enregistrer le post-it"
    },
    "investorMatch": {
      "manualButton": "Identifier les acheteurs IA",
      "title": "Identification des acheteurs IA",
      "hint": "Trouve les acheteurs adaptés dans le CRM — préfiltre structuré et évaluation IA.",
      "run": "Identifier les acheteurs IA",
      "rerun": "Recalculer",
      "confirmAction": "Confirmer et exécuter",
      "linkProperty": "Lier un objet",
      "loading": "Identification des acheteurs …",
      "loadFailed": "L'identification a échoué.",
      "retry": "Réessayer",
      "empty": "Aucun acheteur correspondant trouvé.",
      "close": "Fermer",
      "selectPropertyHint": "Cette tâche n'est liée à aucun objet. Choisissez un objet pour l'identification des acheteurs.",
      "searchPlaceholder": "Rechercher un bien…",
      "change": "Modifier",
      "candidateCount": "{{count}} candidats",
      "aiUsed": "Évalué par IA",
      "aiNotUsed": "Préfiltre uniquement",
      "fitScore": "Score d'adéquation : {{score}} %",
      "showReasoning": "Afficher la justification",
      "hideReasoning": "Masquer la justification",
      "prefilterOnly": "Score de préfiltre (sans évaluation IA)",
      "rankedHint": "Meilleure correspondance en premier — score comme au Quality Gate.",
      "entityCompany": "Entreprise",
      "entityContact": "Personne",
      "recommendation": {
        "strong": "Correspondance forte",
        "possible": "Correspondance possible",
        "weak": "Correspondance faible",
        "none": "Aucune correspondance"
      },
      "rankLabel": "Rang {{rank}}"
    },
    "trace": {
      "title": "Ce que l'assistant a fait",
      "sectionLink": "Lien",
      "sectionSearch": "Recherche sémantique",
      "sectionSources": "Sources utilisées",
      "sectionPortfolio": "Contexte portefeuille",
      "linkContact": "Contact",
      "linkCompany": "Entreprise",
      "linkProperty": "Bien immobilier",
      "noLink": "aucun lien",
      "searchHits": "Recherche {{count}} résultats",
      "searchUsed": "{{count}} utilisés",
      "searchNotRun": "Recherche non effectuée",
      "query": "Requête",
      "relevance": "Pertinence {{pct}}%",
      "sourcesUsed": "{{count}} source(s) utilisée(s)",
      "noCrmContext": "aucun contexte CRM",
      "portfolioIncluded": "Données du portefeuille incluses",
      "portfolioRequested": "Portefeuille demandé mais non inclus",
      "showWeakHits_one": "Afficher {{count}} résultat supplémentaire",
      "showWeakHits_other": "Afficher {{count}} résultats supplémentaires",
      "hideWeakHits": "Masquer les résultats supplémentaires"
    },
    "aiUnavailable": "L'IA n'est pas configurée. Veuillez ajouter la clé API sous Admin > Système.",
    "assignedTo": "Assigné à",
    "attachments": {
      "add": "Ajouter une pièce jointe",
      "contextCount": "{{count}}/{{total}} dans le contexte",
      "deleted": "Pièce jointe supprimée",
      "excludedFromContext": "Hors contexte",
      "fileTooLarge": "Fichier trop volumineux : {{name}}",
      "inContext": "Dans le contexte",
      "uploadError": "La pièce jointe n'a pas pu être téléchargée",
      "uploaded": "Pièce jointe téléchargée"
    },
    "backToTasks": "Retour aux tâches",
    "bccPlaceholder": "bcc@example.com",
    "ccPlaceholder": "cc1@example.com, cc2@example.com",
    "chatReset": "Chatverlauf zurückgesetzt",
    "chatResetError": "Chatverlauf konnte nicht zurückgesetzt werden",
    "chips": {
      "email": "Rédiger un e-mail",
      "followup": "Relance",
      "noContact": "Aucun contact lié. Veuillez d'abord attribuer un contact.",
      "noEmail": "Le contact n'a pas d'adresse e-mail enregistrée.",
      "research": "Rechercher le contact",
      "summary": "Résumé",
      "companyResearch": "Firma recherchieren"
    },
    "chunks": {
      "title": "Notes",
      "save": "Enregistrer comme note",
      "alreadySaved": "Déjà enregistré comme note",
      "saved": "Note enregistrée",
      "saveError": "Impossible d'enregistrer la note",
      "delete": "Supprimer la note",
      "deleted": "Note supprimée",
      "deleteError": "Impossible de supprimer la note",
      "deleteConfirm": "Supprimer définitivement cette note ?",
      "empty": "Aucune note — épinglez des réponses du chat pour enregistrer des connaissances",
      "sourceCompany": "Entreprise",
      "sourcePerson": "Personne",
      "sourceManual": "Manuel",
      "sourceUserNote": "Note",
      "sourceEmailContext": "E-mail",
      "sourceAi": "IA",
      "sourceChat": "Chat",
      "emailNoSubject": "(Sans objet)",
      "emailFrom": "De:",
      "emailTo": "À:",
      "emailCc": "CC:",
      "emailExpand": "Déplier l'e-mail",
      "emailCollapse": "Replier l'e-mail",
      "addNote": "Ajouter une note",
      "edit": "Modifier la note",
      "expand": "Afficher plus",
      "collapse": "Afficher moins",
      "detach": "Supprimer le lien",
      "notePlaceholder": "Note pour le contexte IA (p.ex. « pas de visio », « ton formel ») — Entrée pour enregistrer, Maj+Entrée pour saut de ligne",
      "noteHint": "Pris en compte automatiquement dans le contexte IA",
      "noteAdded": "Note enregistrée",
      "noteAddError": "Impossible d'enregistrer la note",
      "pinFromChat": "Enregistrer comme note",
      "pinnedFromChat": "Enregistré comme note",
      "pinnedFromChatBadge": "Déjà enregistré comme note",
      "pinFromChatError": "Impossible d'enregistrer la note",
      "researchSaved": "{{count}} notes de recherche créées",
      "researchSavedRaw": "Recherche enregistrée comme note",
      "researchSaveError": "Impossible d'enregistrer les notes de recherche",
      "sourceAiResponse": "Réponse du chat",
      "sourceStrategyCards": "Stratégie",
      "sourceChatCard": "Carte du chat",
      "sourceContract": "Contrat",
      "sourceAppKnowledge": "Connaissances de l'application",
      "sourceCrmProfile": "Profil CRM",
      "sourceDocument": "Document",
      "sourceResearchQuestion": "Question de recherche",
      "sourceEmailSent": "E-mail envoyé",
      "sourceOfficialData": "Données officielles",
      "noteUpdated": "Note mise à jour",
      "noteUpdateError": "Impossible de mettre à jour la note",
      "emptyWithNotes": "Aucune note — saisissez une note ci-dessus ou épinglez des réponses du chat",
      "scopeLocal": "Local (uniquement cette tâche)",
      "scopeLocalBadge": "Ici uniquement",
      "scopeAtProperty": "Sur le bien #{{id}}",
      "scopeAtPropertyLabel": "Sur le bien : {{label}}",
      "scopeAtContact": "Sur le contact : {{name}}",
      "scopeAtContactId": "Sur le contact #{{id}}",
      "scopeAtCompany": "Sur l'organisation : {{name}}",
      "scopeAtCompanyId": "Sur l'organisation #{{id}}",
      "pin": "Marquer comme pertinent",
      "unpin": "Retirer l'épingle",
      "pinned": "Note épinglée",
      "unpinned": "Épingle retirée",
      "pinError": "Impossible d'épingler la note",
      "pinnedSection": "Épinglés ({{count}})",
      "historyShow": "Afficher l'historique ({{count}})",
      "historyHide": "Masquer l'historique",
      "historyBadge": "Historique",
      "historyBadgeHint": "Enregistré automatiquement depuis le chat — non épinglé comme note",
      "pinToCompany": "Épingler à la société",
      "pinToCompanyNamed": "Épingler à la société «{{name}}»",
      "pinToCompanyShort": "À la société",
      "pinToContact": "Épingler au contact",
      "pinToContactNamed": "Épingler au contact «{{name}}»",
      "pinToContactShort": "Au contact",
      "pinToProperty": "Épingler au bien",
      "pinToPropertyNamed": "Épingler au bien «{{label}}»",
      "pinToPropertyShort": "Au bien",
      "createContact": "Créer un contact dans le CRM",
      "createContactShort": "Contact",
      "createCompany": "Créer une organisation dans le CRM",
      "createCompanyShort": "Organisation",
      "createSubtask": "Créer une sous-tâche",
      "attachToExisting": "Joindre à une entrée existante",
      "attachShort": "Joindre",
      "dragHandle": "Déplacer la note",
      "dragHint": "Glissez-déposez les notes dans la zone cible — l'ordre détermine la mise en page de l'e-mail",
      "pinnedEmptyDropHint": "Glissez des notes ici pour définir l'ordre de l'e-mail",
      "reorderSaved": "Ordre enregistré",
      "reorderError": "L'ordre n'a pas pu être enregistré",
      "a11yDragStart": "La note {{id}} est en cours de déplacement",
      "a11yDragOverPinned": "La note {{id}} au-dessus de la zone cible",
      "a11yDragOverUnpinned": "La note {{id}} au-dessus de la zone de recherche",
      "a11yDragEndPinned": "Note {{id}} déposée dans la zone cible",
      "a11yDragEndUnpinned": "Note {{id}} retirée de la zone cible",
      "a11yDragCancel": "Déplacement annulé",
      "pinnedToMain": "Épinglé à la tâche principale",
      "convertedToSubtask": "→ Sous-tâche #{{id}}",
      "convertedToSubtaskHint": "Aller à la sous-tâche"
    },
    "clearContext": "Kontext-Auswahl leeren",
    "contextIncluded": "Pendenzen als Kontext",
    "contextView": {
      "agentPreview": "Was der CEO-Agent sieht",
      "ancestors": "Pfad im Baum",
      "inherited": "Vererbter Kontext",
      "own": "Eigener Kontext",
      "placeholder": "Kontext für diese Pendenz definieren...\\n\\nz.B. Warum existiert diese Aufgabe? Welche Informationen soll der CEO-Agent berücksichtigen?",
      "treeSelector": "Kontext-Auswahl im Baum"
    },
    "createdBy": "Créé par",
    "creating": "Création...",
    "edit": "Modifier",
    "emailPreview": "Aperçu de l'e-mail",
    "emailSettings": {
      "title": "Paramètres e-mail",
      "options": "Options",
      "tone": "Ton",
      "length": "Longueur",
      "purpose": "Objectif",
      "language": "Langue",
      "contextHint": "Contexte : {{docs}} document(s), {{nodes}} tâche(s) sélectionné(es). Contrôlé via la sélection des pièces jointes et du contexte.",
      "brief": "Consigne",
      "briefPlaceholder": "Que doit accomplir l'e-mail ? (laisser vide pour le contexte seul)",
      "recipient": "Destinataire",
      "noRecipient": "Aucun contact lié",
      "emailsInHistory": "{{count}} e-mail(s) dans l'historique",
      "autoContext": {
        "pinnedKnowledge": "{{count}} notes épinglées"
      },
      "create": "Créer l'e-mail",
      "fromContext": "Créer l'e-mail à partir de l'objectif et du contexte",
      "tones": {
        "visionary": "Visionnaire",
        "pragmatic": "Pragmatique",
        "formal": "Formel"
      },
      "lengths": {
        "short": "Court",
        "medium": "Moyen",
        "detailed": "Détaillé"
      },
      "purposes": {
        "first_contact": "Premier contact",
        "follow_up": "Suivi",
        "offer": "Offre",
        "forward": "Transfert"
      },
      "languages": {
        "de": "Allemand",
        "en": "Anglais",
        "fr": "Français",
        "it": "Italien"
      }
    },
    "error": "Erreur lors du traitement. Veuillez réessayer.",
    "errorInvalidInput": "Entrée non valide — veuillez réessayer.",
    "findings": "Erkenntnisse",
    "from": "De",
    "fromCompany": "Entreprise",
    "fromDefault": "Par défaut",
    "fromPrivate": "Privé",
    "hierarchy": "Hierarchie",
    "hint": "Écrivez librement — l'agent aide avec les e-mails, la recherche, les relances et plus encore.",
    "noEmail": "Aucun e-mail généré. Demandez à l'agent de rédiger un e-mail.",
    "noResearch": "Aucun résultat de recherche. Demandez à l'agent de rechercher un contact ou une entreprise.",
    "panel": {
      "actionPreview": "Aktions-Vorschau",
      "companyResearch": "Recherche IA",
      "contextView": "Kontext",
      "details": "Details",
      "email": "Aperçu e-mail",
      "findings": "Erkenntnisse",
      "overview": "Übersicht",
      "research": "Recherche",
      "subtasks": "Sous-tâches",
      "treeDetail": "Baum-Navigation",
      "workflow": "Workflow",
      "contactOrg": "Contact/Entreprise"
    },
    "panels": {
      "companyResearch": "KI Recherche",
      "details": "Details",
      "email": "E-Mail",
      "overview": "Übersicht",
      "research": "Recherche"
    },
    "participantHint": "Participants disponibles comme suggestions — saisir dans le champ CC",
    "pinError": "Pin konnte nicht gesetzt werden",
    "pinRemoved": "Pin entfernt",
    "pinSaved": "Erkenntnis gespeichert",
    "placeholder": "Saisir un message...",
    "preview": "Aperçu",
    "removePin": "Pin entfernen",
    "researchPanel": {
      "keyPersons": "Schlüsselpersonen (aus Recherche)"
    },
    "richMarkdown": {
      "miniCardsLabel": "Données structurées",
      "nextStepsTitle": "Prochaines étapes"
    },
    "saveInsight": "Als Erkenntnis speichern",
    "send": "Envoyer",
    "sendError": "L'e-mail n'a pas pu être envoyé.",
    "sendNow": "Envoyer maintenant",
    "sending": "Envoi en cours...",
    "sent": "Envoyé",
    "skills": {
      "actionError": "Aktion konnte nicht ausgeführt werden",
      "addNote": "Notiz erstellen",
      "companyUpdated": "Firmendaten aktualisiert",
      "contactUpdated": "Kontaktdaten aktualisiert",
      "createSubtask": "Sub-Pendenz erstellen",
      "enrichCompany": "Firma anreichern",
      "enrichContact": "Kontakt anreichern",
      "noteSaved": "Notiz gespeichert",
      "subtaskCreated": "Sub-Pendenz erstellt"
    },
    "skillChips": {
      "ariaLabel": "Compétence pour le prochain message",
      "modeHint": "Mode : {{mode}}",
      "research": "Recherche",
      "email": "E-mail",
      "companyResearch": "Rechercher entreprise",
      "personResearch": "Rechercher personne",
      "textGenerate": "Générer texte",
      "contextResearch": "Rechercher contexte",
      "emailDraft": "Rédiger e-mail",
      "noteCreate": "Créer note",
      "subtask": "Sous-tâche",
      "summarize": "Résumer",
      "matchInvestors": "Acheteurs IA"
    },
    "researchType": {
      "label": "Type de recherche",
      "auto": "détecté automatiquement",
      "autoReset": "Détection automatique",
      "menuAria": "Choisir le type de recherche",
      "deepRunning": "Recherche approfondie en cours …",
      "types": {
        "firmen_profil": "Entreprise",
        "person": "Personne",
        "produkt_api": "Produit/API",
        "preise": "Prix",
        "markt": "Marché"
      }
    },
    "strategyPostIts": {
      "title": "Suggestions — en note",
      "subtitle": "Épingler, créer une sous-tâche ou rattacher à un contact / une entreprise / un bien.",
      "types": {
        "research": "Recherche",
        "email": "E-mail",
        "note": "Note",
        "subtask": "Sous-tâche"
      },
      "actions": {
        "pin": "Épingler à l'objectif/contexte",
        "subtask": "Créer une sous-tâche",
        "attach": "Rattacher à un contact / une entreprise / un bien",
        "attachShort": "Rattacher à…"
      },
      "pinned": "Suggestion épinglée comme note",
      "pinError": "La suggestion n'a pas pu être épinglée",
      "subtaskCreated": "Sous-tâche créée",
      "subtaskError": "La sous-tâche n'a pas pu être créée",
      "attachError": "Échec de la liaison"
    },
    "postItCard": {
      "kinds": {
        "advice": "Recommandation",
        "strategy": "Stratégie",
        "research": "Recherche",
        "fact": "Fait",
        "action": "Action"
      },
      "handled": "Traité",
      "attachedTo": "📎 épinglé à {{label}}",
      "actions": {
        "pin": "Épingler",
        "subtask": "Sous-tâche",
        "attach": "Rattacher à…"
      },
      "notFound": "Note introuvable",
      "pinned": "Épinglé comme note",
      "pinError": "La carte n'a pas pu être épinglée",
      "subtaskCreated": "Sous-tâche créée",
      "subtaskError": "La sous-tâche n'a pas pu être créée",
      "attachError": "Échec de la liaison"
    },
    "statusChangeError": "Status konnte nicht geändert werden",
    "subject": "Objet",
    "subjectPlaceholder": "E-Mail-Betreff",
    "taskNotFound": "Tâche non trouvée",
    "template": "Modèle",
    "progress": {
      "queued": "Préparation …",
      "elapsed": "{{seconds}} s",
      "longRunning": "Une recherche approfondie est en cours – le résultat apparaîtra automatiquement. Vous pouvez annuler à tout moment."
    },
    "thinking": "Réflexion en cours...",
    "to": "À",
    "treeNav": {
      "addToContext": "Zum Kontext hinzufügen",
      "contextSelected": "im Kontext ausgewählt",
      "hint": "Klick = Details, Doppelklick = Öffnen",
      "navigateTo": "Zur Pendenz navigieren",
      "noHierarchy": "Keine Hierarchie verfügbar",
      "openTask": "Pendenz öffnen",
      "removeFromContext": "Aus Kontext entfernen",
      "selectHint": "Klicke auf einen Eintrag im Baum, um die Details zu sehen.",
      "title": "Pendenzen-Baum"
    },
    "ttsError": "Lecture à voix haute échouée.",
    "ttsPlay": "Lire la réponse à voix haute",
    "ttsStop": "Arrêter la lecture",
    "voiceDenied": "Accès au microphone refusé. Veuillez l'autoriser dans les paramètres du navigateur.",
    "voiceError": "Erreur de reconnaissance vocale.",
    "voiceMaxDurationHint": "Max. {{minutes}} min",
    "voiceMicError": "Le microphone n'a pas pu être activé.",
    "voiceNoSpeech": "Aucune parole détectée. Veuillez réessayer.",
    "voiceNotSupported": "La saisie vocale n'est pas prise en charge dans ce navigateur. Veuillez utiliser Chrome ou Edge.",
    "voiceStart": "Démarrer la saisie vocale",
    "voiceStop": "Arrêter l'enregistrement",
    "voiceTimeout": "Enregistrement trop long – la transcription a expiré. Veuillez faire des enregistrements plus courts.",
    "voiceTooLong": "Enregistrement trop long (max. 25 Mo / ~25 min). Veuillez faire des enregistrements plus courts.",
    "voiceTranscribing": "Transcription en cours...",
    "voiceTranscribingShort": "Transcription…",
    "welcome": "Que souhaitez-vous faire avec cette tâche ?",
    "workflow": {
      "advanceError": "Workflow-Schritt konnte nicht fortgesetzt werden",
      "completed": "Workflow abgeschlossen!",
      "startError": "Workflow konnte nicht gestartet werden"
    },
    "pinTarget": {
      "title": "Où épingler ?",
      "description": "Vous êtes dans une sous-tâche. Choisissez à quelle tâche la note doit apparaître.",
      "sub": "À cette sous-tâche",
      "main": "À la tâche principale",
      "mainFallback": "Tâche principale"
    },
    "company": "Entreprise",
    "contact": "Contact",
    "property": "Bien immobilier",
    "noContactLinked": "Aucun contact ou entreprise lié.",
    "demoMessage": {
      "label": "Message de l'intéressé"
    }
  },
  "changelog": {
    "title": "Nouveautés",
    "typeFixed": "Corrigé",
    "typeImproved": "Amélioré",
    "typeNew": "Nouveau"
  },
  "chunkAttach": {
    "attachAction": "Attacher à une entité",
    "attachError": "Impossible de lier la note",
    "attached": "Note liée",
    "badgeCompany": "Organisation",
    "badgeContact": "Contact",
    "badgeProperty": "Bien immobilier",
    "badgeTask": "Tâche",
    "detachConfirm": "Supprimer ce lien ?",
    "detachError": "Impossible de supprimer le lien",
    "detachHint": "Cliquer pour supprimer",
    "detached": "Lien supprimé",
    "minChars": "Saisir au moins 2 caractères",
    "noResults": "Aucun résultat trouvé",
    "searchCompany": "Rechercher une organisation...",
    "searchContact": "Rechercher un contact...",
    "searchProperty": "Rechercher un bien...",
    "startTyping": "Commencez à taper pour rechercher.",
    "subtitle": "À quelle entité la note doit-elle être liée ?",
    "tabCompany": "Organisation",
    "tabContact": "Contact",
    "tabProperty": "Bien immobilier",
    "tabsAriaLabel": "Sélectionner le type d'entité",
    "title": "Attacher une note"
  },
  "createFromChunk": {
    "headerContact": "Créer un contact dans le CRM",
    "headerCompany": "Créer une organisation dans le CRM",
    "subtitle": "À partir de cette note",
    "chunkSource": "Note",
    "parsing": "Analyse de la note...",
    "parseError": "La note n'a pas pu être analysée.",
    "parseFailed": "Échec de l'analyse",
    "parsedContact": "Contact détecté",
    "parsedCompany": "Organisation détectée",
    "unnamed": "Sans nom",
    "possibleDuplicates": "Doublons possibles ({{count}})",
    "duplicateHint": "Des entrées avec ce nom existent déjà. Choisissez une action :",
    "actionMerge": "Fusionner",
    "actionAttach": "Joindre comme note",
    "actionCreateContact": "Créer le contact",
    "actionCreateCompany": "Créer l'organisation",
    "actionCreateAnyway": "Créer quand même",
    "created": "Nouvelle entrée créée.",
    "createdToast": "Entrée créée",
    "createError": "Impossible de créer l'entrée",
    "merged": "L'entrée a été mise à jour avec de nouvelles informations.",
    "mergedToast": "Entrée enrichie",
    "mergeError": "Échec de l'enrichissement",
    "attached": "La note a été jointe.",
    "attachedToast": "Joint comme note",
    "attachError": "Échec de la jonction",
    "success": "C'est fait !"
  },
  "commissions": {
    "chart": {
      "atPrice": "à",
      "commission": "Honoraires",
      "rate": "Taux eff.",
      "title": "Courbe d'honoraires"
    },
    "default": "Défaut",
    "loading": "Chargement des modèles d'honoraires...",
    "settings": {
      "addBracket": "Ajouter une tranche",
      "bracketFrom": "De",
      "bracketRate": "Taux",
      "bracketTo": "À",
      "brackets": "tranches",
      "bracketsHint": "La première tranche commence toujours à CHF 0. Chaque taux s'applique uniquement au montant dans sa tranche.",
      "bracketsLabel": "Tranches marginales",
      "createNew": "Nouveau modèle",
      "createSuccess": "Modèle d'honoraires créé avec succès",
      "createTitle": "Créer un modèle d'honoraires",
      "default": "Défaut",
      "defaultBadge": "Défaut",
      "deleteConfirm": "Voulez-vous vraiment supprimer le modèle «{{name}}» ? Cette action est irréversible.",
      "deleteError": "Erreur lors de la suppression",
      "deleteSuccess": "Modèle d'honoraires supprimé avec succès",
      "deleteTitle": "Supprimer le modèle d'honoraires",
      "editTitle": "Modifier le modèle d'honoraires",
      "flatRate": "Taux forfaitaire",
      "namePlaceholder": "ex. Modèle marginal standard",
      "noModels": "Aucun modèle d'honoraires",
      "rate": "Taux / Tranches",
      "saveError": "Erreur lors de l'enregistrement",
      "setActive": "Actif",
      "setDefault": "Définir comme modèle par défaut",
      "subtitle": "Créer et gérer les modèles d'honoraires pour les contrats",
      "title": "Modèles d'honoraires",
      "type": "Type",
      "typeHints": {
        "FLAT": "Taux unique",
        "MARGINAL": "Tranches dégressives"
      },
      "types": {
        "FLAT": "Taux forfaitaire",
        "MARGINAL": "Marginal"
      },
      "updateSuccess": "Modèle d'honoraires mis à jour avec succès"
    },
    "source": {
      "appendix_b": "Annexe B",
      "property": "Objet",
      "framework": "Contrat-cadre",
      "default": "Standard",
      "none": "Aucune",
      "hint": "Source des conditions applicables : {{source}}"
    }
  },
  "common": {
    "actions": "Actions",
    "active": "Actif",
    "add": "Ajouter",
    "address": "Adresse",
    "all": "Tous",
    "back": "Retour",
    "cancel": "Annuler",
    "check": "Vérifier",
    "city": "Ort",
    "clearFilters": "Reinitialiser les filtres",
    "clearSelection": "Annuler la selection",
    "close": "Fermer",
    "confirm": "Confirmer",
    "copy": "Kopieren",
    "create": "Créer",
    "createNew": "Créer",
    "date": "Date",
    "days": "jours",
    "delete": "Supprimer",
    "deleted": "Supprimé",
    "description": "Description",
    "deselectAll": "Tout désélectionner",
    "details": "Détails",
    "done": "Terminé",
    "download": "Herunterladen",
    "edit": "Modifier",
    "email": "E-mail",
    "employees": "Mitarbeiter",
    "error": "Erreur",
    "export": "Exporter",
    "field": "Champ",
    "filter": "Filtrer",
    "filtered": "filtré",
    "firstName": "Vorname",
    "import": "Importer",
    "inactive": "Inactif",
    "industry": "Branche",
    "info": "Info",
    "languages": {
      "de": "Deutsch",
      "en": "English",
      "fr": "Français",
      "it": "Italiano"
    },
    "lastName": "Nachname",
    "less": "Moins",
    "linkedin": "LinkedIn",
    "loading": "Chargement...",
    "location": "Standort",
    "merge": "Fusionner",
    "more": "Plus",
    "name": "Nom",
    "new": "NEU",
    "next": "Suivant",
    "no": "Non",
    "noResults": "Aucun résultat",
    "none": "Aucun",
    "notFound": "Nicht gefunden",
    "notes": "Notes",
    "nothingRecorded": "Rien de saisi pour le moment",
    "phone": "Téléphone",
    "pin": "Épingler",
    "position": "Position",
    "preview": "Apercu",
    "previous": "Précédent",
    "refresh": "Actualiser",
    "refreshed": "Aktualisiert",
    "remove": "Retirer",
    "required": "Champ obligatoire",
    "reset": "Reinitialiser",
    "resizeColumn": "Redimensionner la colonne (double-clic pour réinitialiser)",
    "resizePanes": "Redimensionner les volets (flèches pour ajuster)",
    "retry": "Réessayer",
    "revenue": "Umsatz",
    "save": "Enregistrer",
    "saveAndClose": "Enregistrer et fermer",
    "saved": "Enregistré",
    "saving": "Enregistrement en cours...",
    "saveStatus": {
      "idle": "Synchronisé",
      "pending": "Modifications en attente",
      "saving": "Enregistrement…",
      "saved": "Enregistré",
      "error": "Échec de l'enregistrement"
    },
    "unsavedChanges": {
      "title": "Modifications non enregistrées",
      "description": "Vous avez des modifications non enregistrées. Les abandonner et fermer ?",
      "discard": "Abandonner et fermer",
      "keepEditing": "Continuer l'édition"
    },
    "search": "Rechercher",
    "select": "Veuillez sélectionner",
    "selectAll": "Tout sélectionner",
    "showAll": "Tout afficher",
    "skip": "Ignorer",
    "status": "Statut",
    "street": "Strasse",
    "success": "Succès",
    "uid": "UID",
    "unknown": "Unbekannt",
    "unknownError": "Erreur inconnue",
    "unpin": "Détacher",
    "view": "Voir",
    "warning": "Avertissement",
    "website": "Website",
    "yes": "Oui",
    "zip": "PLZ",
    "optional": "Optional",
    "print": "Drucken",
    "clear": "Effacer"
  },
  "companies": {
    "merge": {
      "activities": "Activités",
      "campaigns": "Campagnes",
      "clickToSelect": "Cliquez sur une valeur pour la sélectionner",
      "contacts": "Contacts",
      "contracts": "Contrats",
      "dataMergeDirection": "Daten werden in die Hauptfirma uebernommen",
      "emailAccounts": "Comptes e-mail",
      "emails": "Adresses e-mail",
      "investorGroups": "Groupes d'investisseurs",
      "listings": "Annonces",
      "mergeButton": "Fusionner",
      "offers": "Offres",
      "phones": "Numéros de téléphone",
      "previewError": "La comparaison n'a pas pu être chargée",
      "previewFailed": "L'aperçu a échoué.",
      "properties": "Biens",
      "relatedRecords": "Enregistrements liés",
      "secondaryDeactivated": "Les organisations secondaires sont désactivées, pas supprimées.",
      "tasks": "Tâches",
      "companiesSelected": "{{count}} organisations sélectionnées"
    },
    "name": "Nom de l'entreprise"
  },
  "company": {
    "all": "Toutes les entreprises",
    "count": "{{count}} entreprises",
    "done": "Terminé",
    "filter": "Filtre entreprises",
    "noSelection": "Aucune entreprise",
    "switch": "Changer d'entreprise",
    "switchError": "Impossible de changer d'entreprise"
  },
  "companyContacts": {
    "columns": {
      "actions": "Actions",
      "email": "E-mail",
      "functions": "Fonction(s)",
      "name": "Nom",
      "organisation": "Organisation",
      "signature": "Signature",
      "source": "Source",
      "status": "Statut",
      "verified": "Vérifié"
    },
    "duplicate": {
      "dialogLabel": "Fusionner les contacts",
      "hint": "Peut-être la même personne",
      "merge": "Fusionner",
      "mergeSuccess": "Contacts fusionnés",
      "mergeWith": "Fusionner avec {{name}}",
      "notSame": "Pas la même personne",
      "notSameAs": "Pas la même personne que {{name}}",
      "notSameSaved": "Enregistré comme personnes différentes",
      "reasonFirstName": "Même nom de famille, prénom similaire",
      "reasonInitial": "Même nom de famille, initiale correspondante"
    },
    "filters": {
      "active": "Actif",
      "import": "Import",
      "inactive": "Inactif",
      "label": "Filtrer les contacts",
      "labelCompanies": "Filtrer les organisations",
      "manual": "Manuel",
      "search": "Rechercher des contacts",
      "searchCompanies": "Rechercher des organisations",
      "withoutEmail": "Sans e-mail",
      "zefix": "Registre du commerce"
    },
    "functions": {
      "add": "Ajouter une fonction",
      "empty": "Aucune fonction saisie",
      "listLabel": "Fonctions saisies",
      "remove": "Supprimer la fonction « {{name}} »"
    },
    "groups": {
      "inactive": "Inactifs ({{count}})",
      "other": "Autres contacts",
      "otherCompanies": "Autres organisations",
      "register": "Personnes autorisées à signer (registre du commerce)",
      "registerCompanies": "Droit de signature (registre du commerce)"
    },
    "noResults": "Aucun contact pour ces filtres",
    "noResultsCompanies": "Aucune organisation pour ces filtres",
    "removeCompany": "Retirer l'organisation",
    "removeFromContact": "retirer de ce contact ?",
    "tableCaption": "Contacts de cette organisation",
    "tableCaptionCompanies": "Organisations de ce contact",
    "verified": "Vérifié",
    "verifiedOn": "Vérifié le {{date}}"
  },
  "companyDedup": {
    "fieldComparison": "Comparaison des champs",
    "loadingPreview": "Chargement de la comparaison...",
    "mergeSuccess": "Organisations fusionnées avec succès",
    "mergeTitle": "Fusionner des organisations"
  },
  "companyLookup": {
    "address": "Adresse",
    "createError": "Kontakte konnten nicht erstellt werden",
    "creating": "Kontakte werden erstellt...",
    "legalForm": "Rechtsform",
    "noSignatories": "Keine Zeichnungsberechtigten gefunden",
    "noSignatoriesHint": "Die SHAB-Daten für diese Firma sind nicht verfügbar (ältere Firmen oder fehlende Publikationen). Bitte tragen Sie die Zeichnungsberechtigten manuell ein.",
    "purpose": "Zweck",
    "searchLabel": "Firma aus Handelsregister suchen",
    "searchPlaceholder": "Firmenname oder UID eingeben...",
    "uid": "UID"
  },
  "companyRelations": {
    "add": "Lier",
    "added": "Organisation liée",
    "addTitle": "Lier une organisation",
    "auditedBy": "Organe de révision",
    "audits": "révise",
    "confirmDelete": "Supprimer ce lien ?",
    "editTitle": "Modifier le lien",
    "empty": "Aucune organisation liée",
    "emptyHint": "Liez des organisations qui appartiennent ensemble (p. ex. mère/filiale, partenaire ou société sœur).",
    "loadFailed": "Impossible de charger les liens",
    "notesLabel": "Note",
    "notesPlaceholder": "Note facultative sur la relation (p. ex. filiale, société soeur)...",
    "removed": "Lien supprimé",
    "targetLabel": "Organisation",
    "title": "Organisations liées",
    "types": {
      "auditor": "Organe de révision",
      "customer": "Client",
      "other": "Autre",
      "parent_subsidiary": "Mère/filiale",
      "partner": "Partenaire",
      "predecessor": "Prédécesseur",
      "sister": "Société sœur",
      "supplier": "Fournisseur"
    },
    "updated": "Lien mis à jour"
  },
  "companyResearch": {
    "approveError": "Fehler beim Anlegen",
    "approved": "Firma und Kontakte wurden angelegt",
    "approving": "Wird angelegt...",
    "extracting": "Extrahiere Firma und Kontakte...",
    "unknownCompany": "Firma",
    "openFullProfile": "Vollständiges Profil anzeigen",
    "companyDraft": "Firma-Entwurf",
    "name": "Firmenname",
    "legalForm": "Rechtsform",
    "street": "Strasse",
    "houseNr": "Nr.",
    "zip": "PLZ",
    "city": "Ort",
    "canton": "Kanton",
    "website": "Website",
    "phone": "Telefon",
    "email": "E-Mail",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "role": "Funktion",
    "results": "Recherche-Ergebnis",
    "contacts": "Kontakte",
    "addContact": "Kontakt hinzufügen",
    "approve": "Firma + Kontakte anlegen",
    "empty": "Keine KI-Recherche vorhanden. Frage den Agenten, eine Firma oder Person zu recherchieren."
  },
  "contactDedup": {
    "assignCompany": "Associer une autre entreprise (optionnel)",
    "backToScan": "Retour au scan",
    "companySection": "Associations d'entreprises",
    "companySectionDesc": "Toutes les associations d'entreprises seront transférées au contact principal.",
    "companyWillBeAssigned": "Sera associé après la fusion",
    "contactsAffected": "Contacts concernés",
    "empty": "(leer)",
    "executeMerge": "Fusionner",
    "field": "Feld",
    "fieldComparison": "Comparaison des champs",
    "fieldComparisonDesc": "Choisissez quelle valeur conserver pour chaque champ.",
    "groupsFound": "Groupes de doublons",
    "loadingCompanies": "Chargement des entreprises...",
    "loadingPreview": "Vergleich wird geladen...",
    "merge": "Fusionner",
    "mergeError": "Erreur lors de la fusion :",
    "mergeSuccess": "Contacts fusionnés avec succès !",
    "mergeWarning": "Les contacts secondaires seront désactivés (pas supprimés).",
    "minScore": "Score min.",
    "noCompanyLinks": "Aucune association d'entreprise trouvée",
    "noDuplicates": "Aucun doublon trouvé",
    "noDuplicatesDesc": "Tous les contacts sont uniques.",
    "primaryContact": "Contact principal",
    "related": {
      "activities": "Activités",
      "campaignRecipients": "Kampagnen-Empfänger",
      "companyAssignments": "Firmen-Zuordnungen",
      "contracts": "Verträge",
      "emailAddresses": "E-Mail-Adressen",
      "infoOwners": "Autorisations d'information",
      "investorGroups": "Groupes d'investisseurs",
      "knowledgeChunks": "Sections de connaissances",
      "notifications": "Benachrichtigungen",
      "propertyRefs": "Liens aux objets",
      "signatures": "Unterschriften",
      "syncedEmails": "E-mails synchronisés",
      "tags": "Tags",
      "tasks": "Pendenzen",
      "tokens": "Liens d'accès",
      "userAccount": "Compte utilisateur"
    },
    "relatedSection": "Sera repris",
    "relatedSectionDesc": "Ces enregistrements des contacts secondaires seront transférés vers le contact principal.",
    "scan": "Rechercher les doublons",
    "scanMore": "Rechercher d'autres doublons",
    "searchCompany": "Rechercher et associer une entreprise...",
    "selectPrimary": "Sélectionner le contact principal",
    "selectPrimaryDesc": "Le contact principal sera conservé. Tous les autres seront fusionnés.",
    "setAsPrimary": "Als Hauptkontakt",
    "source": "Source",
    "step1": "Rechercher les doublons",
    "step2": "Vérifier et fusionner",
    "step3": "Résultat",
    "subtitle": "Détecter et fusionner les doublons",
    "title": "Dédoublonnage des contacts",
    "totalContacts": "Total des contacts",
    "userAccountConflictDesc": "Un contact ne peut avoir qu'un seul compte utilisateur, la fusion est donc refusée. Désactivez d'abord l'un des deux comptes ou choisissez comme contact principal celui qui possède le compte souhaité.",
    "userAccountConflictTitle": "Les deux contacts ont un compte utilisateur"
  },
  "contactImport": {
    "backToOverview": "Retour à l'aperçu",
    "clickToExclude": "Klicke auf einen Kontakt um ihn vom Import auszuschliessen.",
    "confirmImport": "Import bestätigen",
    "connected": "Connecté",
    "continueImport": "Import fortsetzen",
    "duplicates": "Duplikate",
    "enrichExisting": "Bestehende anreichern:",
    "enrichableLabel": "Anreicherbar",
    "errorLoading": "Fehler beim Laden",
    "finishAnyway": "Trotzdem abschliessen",
    "goToContacts": "Zu den Kontakten",
    "goToSettings": "Aller aux paramètres",
    "google": {
      "checkAccount": "Bitte Google-Konto prüfen.",
      "contacts": "Google Kontakte",
      "enrichExisting": "Bestehende Kontakte mit Google-Daten anreichern",
      "loading": "Google Kontakte werden geladen...",
      "subtitle": "Importiere Kontakte aus deinem verbundenen Google-Konto in Immotron.",
      "title": "Google Kontakte importieren",
      "titleShort": "Google Import"
    },
    "importButton": "Importer",
    "importComplete": "Import abgeschlossen",
    "importFailed": "Import fehlgeschlagen",
    "importNow": "Jetzt importieren",
    "importing": "Importiere...",
    "inImmotron": "In Immotron",
    "inactive": "Désactivé",
    "linkedinDesc": "Upload JSON ou extension navigateur",
    "microsoft": {
      "allFolders": "Alle Ordner (empfohlen)",
      "allFoldersHint": "Durchsucht das gesamte Postfach — alle Kontaktordner ab Root rekursiv",
      "backToFolders": "Zurück zur Ordnerübersicht",
      "changeFolder": "Ordner wechseln",
      "checkAccount": "Bitte Microsoft-Konto prüfen.",
      "chooseAnotherFolder": "Anderen Ordner wählen",
      "chooseFolderHint": "Wähle den Kontaktordner oder nutze «Alle Ordner» um das gesamte Postfach ab Root rekursiv zu durchsuchen.",
      "contacts": "Microsoft Kontakte",
      "empty": "Leer",
      "emptyFolderHint": "Der gewählte Ordner ist leer — versuche «Alle Ordner» um das gesamte Postfach zu durchsuchen.",
      "enrichExisting": "Bestehende Kontakte mit Microsoft-Daten anreichern",
      "expiredHint": "Die Microsoft-Verbindung ist abgelaufen — verbinde dein Konto unter Einstellungen neu.",
      "includeSubfolders": "Unterordner einschliessen",
      "includeSubfoldersHint": "Beim Import eines Ordners werden auch alle darunter liegenden Ordner durchsucht.",
      "loading": "Microsoft Kontakte werden geladen...",
      "loadingFolders": "Kontaktordner werden geladen...",
      "noContactsFound": "Keine Kontakte gefunden",
      "noContactsHint": "Dieser Ordner enthält keine Kontakte. Das kann folgende Gründe haben:",
      "reconnectAccount": "Konto neu verbinden",
      "subtitle": "Importiere Kontakte aus deinem verbundenen Microsoft 365 Konto in Immotron.",
      "title": "Microsoft 365 Kontakte importieren",
      "titleShort": "Microsoft Import",
      "tokenExpired": "Microsoft-Verbindung abgelaufen",
      "tokenExpiredDetail": "Der Zugriff auf dein Microsoft-Konto ist abgelaufen. Bitte verbinde dein Konto unter Einstellungen neu und versuche es erneut."
    },
    "needsReauth": "Reconnexion requise",
    "newContacts": "Neue Kontakte",
    "newContactsToImport": "Neue Kontakte importieren:",
    "newImport": "Neu importieren",
    "nextConfirm": "Weiter: Import bestätigen",
    "nextReview": "Weiter: Kontakte prüfen",
    "noAccounts": "Aucun compte e-mail connecté",
    "noAccountsHint": "Connectez un compte Google ou Microsoft dans Paramètres → Comptes e-mail pour importer des contacts.",
    "noEmail": "Ohne E-Mail",
    "noLastName": "Ohne Nachnamen",
    "noLastNameBadge": "Kein Nachname",
    "noLastNameDescription": "Diese Kontakte haben keinen Nachnamen und werden standardmässig nicht importiert. Klicke um einzelne hinzuzufügen.",
    "notInImmotron": "noch nicht in Immotron",
    "onlyInImmotron": "Nur in Immotron",
    "partiallyDone": "Import teilweise abgeschlossen",
    "progressSoFar": "Bisheriger Fortschritt:",
    "refresh": "Actualiser",
    "selectSeparately": "separat auswählbar",
    "skipped": "Übersprungen:",
    "steps": {
      "analyze": "Analysieren",
      "done": "Fertig",
      "folders": "Ordner",
      "import": "Import",
      "review": "Prüfen"
    },
    "subtitle": "Importer des contacts depuis les comptes connectés ou LinkedIn",
    "summary": "Import-Zusammenfassung",
    "title": "Import de contacts"
  },
  "contacts": {
    "addAddress": "Ajouter une adresse",
    "addCompany": "Ajouter une organisation",
    "addContact": "Nouveau contact",
    "addInfoOwner": "Ajouter propriétaire d'info",
    "newContactPlaceholder": "Nouveau contact",
    "addTagPlaceholder": "Ajouter un tag...",
    "address": "Adresse",
    "addressAdded": "Adresse ajoutée",
    "addressCity": "Localité",
    "addressCountry": "Pays",
    "addressRemoved": "Adresse supprimée",
    "addressStreet": "Rue",
    "addressZip": "NPA",
    "allCompanies": "Toutes les entreprises",
    "allTags": "Tags",
    "alreadyRecorded": "Déjà enregistré",
    "privatePerson": "Personne",
    "assignedViaCompanies": "Über Firmen zugeordnet",
    "birthday": "Date de naissance",
    "companies": "Organisations",
    "company": "Entreprise",
    "companyAdded": "Organisation ajoutée avec succès",
    "companyAssignments": "Firmenzuordnungen",
    "companyCreated": "Entreprise créée depuis Zefix",
    "companyOnly": "Avec entreprise uniquement",
    "companyRemoved": "Association supprimée",
    "companyRoles": "Associations d'organisations",
    "companyUpdated": "Association mise à jour",
    "confirmDelete": "Voulez-vous vraiment supprimer ce contact?",
    "confirmRemoveCompany": "Voulez-vous vraiment supprimer cette association?",
    "contact": "Kontakt",
    "createNewCompany": "Créer comme entreprise : «{{query}}»",
    "createNewPerson": "Créer comme personne : «{{query}}»",
    "createSuccess": "Contact créé avec succès",
    "createUser": "Créer un utilisateur",
    "createdAt": "Créé",
    "creatingCompany": "Création de l'entreprise...",
    "currentPosition": "Aktuelle Position",
    "deleteContact": "Supprimer le contact",
    "deleteSuccess": "Contact supprimé avec succès",
    "detailsLoadFailed": "Impossible de charger les détails",
    "directlyAssigned": "Direkt zugeordnet",
    "duplicateBannerHint": "Vérifiez et fusionnez si nécessaire.",
    "duplicateBannerMany": "{{count}} doublons possibles",
    "duplicateBannerOne": "1 doublon possible",
    "duplicateCheckAria": "Vérifier le doublon {{name}}",
    "editContact": "Modifier le contact",
    "email": "E-mail",
    "emailOptional": "E-Mail (optional)",
    "emailStatuses": {
      "BOUNCED": "Rejeté",
      "CLICKED": "Cliqué",
      "DELIVERED": "Livré",
      "FAILED": "Échoué",
      "OPENED": "Ouvert",
      "PENDING": "En attente",
      "SENT": "Envoyé"
    },
    "emails": {
      "campaign": "Campagne",
      "contract": "Contrat",
      "empty": "Aucun e-mail envoyé",
      "property": "Bien immobilier",
      "resend": "Renvoyer",
      "resendSuccess": "L'e-mail a été renvoyé",
      "source": "Source",
      "subject": "Objet",
      "title": "E-mails"
    },
    "existingCompanies": "Entreprises existantes",
    "firstName": "Prénom",
    "function": "Funktion",
    "functionPlaceholder": "p. ex. directeur général",
    "gender": "Genre",
    "genderFemale": "Féminin",
    "genderMale": "Masculin",
    "genderNotSet": "Non spécifié",
    "googleImport": "Google Import",
    "hasAccount": "Actif",
    "import": "Import",
    "infoOwnerAdded": "Propriétaire d'info ajouté",
    "infoOwnerRemoved": "Propriétaire d'info supprimé",
    "infoOwners": "Propriétaires d'info",
    "langDe": "Deutsch",
    "langEn": "English",
    "langFr": "Français",
    "langIt": "Italiano",
    "languageAuto": "Automatique (allemand)",
    "lastName": "Nom",
    "lastNameRequired": "Nachname *",
    "localOnly": "Local",
    "location": "Ort",
    "manuallySelected": "Manuell ausgewählt",
    "markVerified": "Marquer comme vérifié",
    "merge": {
      "assessment": "Bewertung",
      "businessModel": "Geschäftsmodell",
      "company": "Firma",
      "contact": "Kontakt",
      "createAndImport": "Neu erstellen & Importieren",
      "enrichCompany": "Bestehende Firma wird mit neuen Infos ergänzt (leere Felder)",
      "enrichContact": "Bestehender Kontakt wird mit neuen Infos ergänzt",
      "existingRecord": "Bestand (Immotron)",
      "field": "Feld",
      "leadResearch": "Lead (Recherche)",
      "loadingComparison": "Lade Vergleichsdaten...",
      "match": "Übereinstimmung",
      "matchLabel": "Match",
      "mergeAndImport": "Zusammenführen & Importieren",
      "newEntry": "Neuer Eintrag",
      "researchExtras": "Zusatzinfos aus der Recherche",
      "source": "Quelle",
      "subtitleCompare": "Prüfe die Übereinstimmung vor dem Import",
      "subtitleNew": "Kein bestehendes Match gefunden — wird neu erstellt",
      "titleCompare": "Lead importieren — Vergleich",
      "titleNew": "Lead als neu importieren",
      "whatHappens": "Was passiert beim Import?",
      "willBeCreated": "wird neu erstellt",
      "willBeCreatedShort": "Wird neu erstellt"
    },
    "mergeSuccess": "Kontakte erfolgreich zusammengeführt",
    "metadata": "Métadonnées",
    "microsoftImport": "Microsoft Import",
    "name": "Name",
    "noAccount": "Pas de compte",
    "noCompanies": "Aucune affectation d'organisation",
    "noCompaniesFound": "Aucune société trouvée",
    "noCompanyAssignment": "Keine Firmenzuordnung",
    "noCompanyAssignmentHint": "Fügen Sie eine Firma hinzu, um Rollen und Zeichnungsrechte zu definieren.",
    "noContacts": "Aucun contact trouvé",
    "noContactsFound": "Keine Kontakte gefunden",
    "noLinkedinData": "Keine LinkedIn-Daten",
    "noLinkedinDataHint": "Dieser Kontakt wurde noch nicht mit LinkedIn synchronisiert.",
    "noTags": "Aucun tag",
    "notes": "Notes",
    "notesPlaceholder": "Notes internes sur le contact...",
    "openProfile": "Profil öffnen",
    "owner": "Propriétaire principal",
    "ownerAll": "Tous les propriétaires",
    "personsRegistered": "{{count}} personnes enregistrées",
    "phone": "Téléphone",
    "position": "Poste",
    "possibleDuplicate": "Mögliches Duplikat",
    "possibleDuplicates": "Mögliche Duplikate",
    "preferredLanguage": "Langue",
    "primaryAddress": "Adresse principale",
    "rawDataJson": "Rohdaten (JSON)",
    "reSyncPending": "Re-Sync angefordert",
    "reSyncRequested": "Re-Sync angefordert. Starten Sie einen neuen Sync im LinkedIn Scraper.",
    "requestReSync": "Re-Sync anfordern",
    "resultsLabel": "Contacts",
    "searchCompanyPlaceholder": "Rechercher une entreprise...",
    "searchContact": "Rechercher un contact...",
    "searchCriteria": {
      "areaRange": "Surface m²",
      "areaRangePlaceholder": "p. ex. 800–2 500",
      "cantons": "Cantons",
      "condition": "État",
      "constructionYear": "Année de construction",
      "constructionYearPlaceholder": "p. ex. dès 1990 ou neuf",
      "decisionProcess": "Processus de décision",
      "energyRequirements": "Énergie / durabilité",
      "excluded": "Exclu",
      "grossYieldMin": "Rendement brut min.",
      "grossYieldMinPercent": "Rendement brut min. (%)",
      "location": "Situation",
      "locationNotes": "Notes sur la situation",
      "macro": "Macro",
      "macroLocation": "Situation macro",
      "micro": "Micro",
      "microLocation": "Situation micro",
      "minUnits": "Taille minimale",
      "minUnitsPlaceholder": "p. ex. 6 appartements",
      "netYieldTarget": "Rendement net cible",
      "noGos": "Critères rédhibitoires",
      "price": "Prix (mio CHF)",
      "priceMax": "Prix max. (mio CHF)",
      "priceMin": "Prix min. (mio CHF)",
      "priceMinHard": "Exclure en dessous du prix min. (limite stricte)",
      "priceNotes": "Note sur le prix",
      "propertyTypes": "Types de biens",
      "regions": "Régions",
      "sought": "Recherché",
      "specialRequirements": "Exigences particulières",
      "timeline": "Calendrier"
    },
    "searchFailed": "Recherche échouée",
    "searchNameOrEmail": "Name oder E-Mail suchen...",
    "searchPlaceholder": "Rechercher par nom ou e-mail...",
    "selectCompany": "Firma wählen...",
    "selectMergeTarget": "Kontakt zum Zusammenführen auswählen",
    "sendPasswordReset": "Envoyer réinitialisation",
    "setPrimary": "Définir comme principale",
    "showCampaignContacts": "Contacts de campagne",
    "signature": "Signature",
    "signatureCollectiveMore": "Kollektivunterschrift zu mehreren",
    "signatureCollectiveTwo": "Kollektivunterschrift zu zweit",
    "signatureNone": "Keine",
    "signatureSingle": "Einzelunterschrift",
    "signatureType": "Zeichnungsberechtigung",
    "signatures": "Signatures",
    "source": "Quelle",
    "sourceAll": "Source",
    "sourceCampaign": "Campagne",
    "sourceGoogle": "Google",
    "sourceLabel": "Source",
    "sourceManual": "Manuel",
    "subtitle": "Tous les signataires autorisés et personnes de contact",
    "syncStatus": "Sync Status",
    "synced": "Synchronisiert",
    "contracts": {
      "empty": "Aucun contrat disponible",
      "propertyLabel": "Bien"
    },
    "tabs": {
      "addressContact": "Adresse & Kontakt",
      "companies": "Organisations",
      "contracts": "Contrats",
      "knowledge": "Connaissances",
      "linkedin": "LinkedIn",
      "masterData": "Stammdaten",
      "notes": "Notizen",
      "responsibility": "Zuständigkeit"
    },
    "tagAdded": "Tag attribué",
    "tagRemoved": "Tag supprimé",
    "tags": "Tags",
    "title": "Contacts",
    "tryZefix": "Rechercher dans Zefix",
    "typeNameOrEmail": "Tippen Sie einen Namen oder eine E-Mail-Adresse...",
    "unverified": "Non vérifié",
    "updateSuccess": "Contact mis à jour avec succès",
    "userAccount": "Compte utilisateur",
    "verified": "Vérifié",
    "verifiedSuccess": "Association vérifiée",
    "verifiedVia": "Vérifié via",
    "website": "Site web",
    "withUser": "Avec compte utilisateur",
    "withUserOnly": "Uniquement avec utilisateur",
    "withoutUser": "Sans compte utilisateur",
    "zefixSearch": "Recherche Zefix",
    "zefixSearchPlaceholder": "Rechercher une société dans Zefix (nom ou UID)...",
    "phoneAdded": "Telefonnummer hinzugefuegt",
    "phoneRemoved": "Telefonnummer entfernt",
    "phones": "Telefonnummern",
    "noCompanyAssigned": "Keine Firma zugeordnet",
    "addresses": "Adressen",
    "researchSuccess": "Recherche abgeschlossen",
    "researchFailed": "Recherche fehlgeschlagen",
    "researching": "Recherchiere...",
    "startResearch": "KI-Recherche starten",
    "researchError": "Recherche fehlgeschlagen. Bitte erneut versuchen.",
    "researchResult": "Recherche-Ergebnis",
    "lastResearch": "Letzte Recherche",
    "noResearchYet": "Noch keine KI-Recherche durchgeführt",
    "researchDescription": "Perplexity durchsucht das Web nach Informationen zu dieser Person",
    "infoOwnerRole": "Info",
    "noOwner": "-- Aucun propriétaire principal --",
    "notesAutoSaveHint": "Les modifications sont enregistrées automatiquement.",
    "removeInfoOwner": "Supprimer le propriétaire d'info"
  },
  "contractTermination": {
    "clause": "Clause",
    "clauseLabel": "Clause violée (optionnel)",
    "confirmButton": "Résilier maintenant",
    "confirmSummary": "Résumé:",
    "contract": "Contrat",
    "description": "Le contrat {{number}} sera résilié. Veuillez indiquer le motif.",
    "error": "Erreur lors de la résiliation du contrat",
    "reason": "Motif",
    "reasonLabel": "Motif",
    "reasonPlaceholder": "Décrivez le motif de la résiliation...",
    "reasonRequired": "Veuillez indiquer un motif",
    "selectClause": "-- Choisir clause --",
    "success": "Le contrat a été résilié",
    "title": "Résilier le contrat",
    "warningText": "Après la résiliation, toutes les clauses de protection (§6 Protection des contacts, §7 Clause pénale) restent en vigueur pendant 6 mois supplémentaires.",
    "warningTitle": "Attention: Période de carence"
  },
  "contractWizard": {
    "errors": {
      "generateFailed": "Impossible de générer le contrat",
      "loadCompaniesFailed": "Impossible de charger les entreprises",
      "loadSignatoriesFailed": "Les signataires n'ont pas pu etre charges",
      "noCompany": "Veuillez selectionner une entreprise",
      "noPartner": "Veuillez indiquer un partenaire contractuel",
      "noPartnerContact": "Veuillez selectionner un signataire du partenaire contractuel",
      "noRoles": "Veuillez selectionner au moins un role",
      "noSignatories": "Veuillez selectionner au moins un signataire"
    },
    "hidePreview": "Masquer l'aperçu",
    "navigation": {
      "back": "Retour",
      "cancel": "Annuler",
      "next": "Suivant"
    },
    "showPreview": "Afficher l'aperçu",
    "signatories": {
      "loading": "Chargement des signataires...",
      "none": "Aucun signataire disponible",
      "subtitle": "Sélectionnez les signataires pour ce contrat",
      "title": "Signataires"
    },
    "step1": {
      "loading": "Chargement des entreprises...",
      "subtitle": "Choisissez l'entreprise émettrice du contrat",
      "title": "Sélectionner l'entreprise"
    },
    "step2": {
      "city": "Ville",
      "contactName": "Personne de contact (signataire)",
      "email": "E-mail",
      "manualEntry": "Saisie manuelle",
      "name": "Nom / Entreprise",
      "partnerSignatory": "Signataire du partenaire contractuel",
      "partnerSignatoryHint": "En cas de signature collective, selectionnez plusieurs personnes.",
      "searchPartner": "Rechercher un partenaire contractuel (personne/entreprise — CRM & Zefix)",
      "searchPartnerPlaceholder": "Rechercher par nom, entreprise ou Zefix...",
      "searchPartnerHint": "Recherche dans les contacts CRM, les entreprises CRM et le registre du commerce Zefix. Introuvable ? Créez directement un nouvel enregistrement CRM.",
      "creatingPartner": "Création du partenaire contractuel dans le CRM...",
      "partnerCreated": "Partenaire contractuel créé dans le CRM",
      "partnerCreateFailed": "Le partenaire contractuel n'a pas pu être créé",
      "personBadge": "Personne privée (CRM)",
      "companyBadge": "Entreprise (CRM/Zefix)",
      "personIsSignatory": "Cette personne est le signataire du contrat.",
      "signerEmail": "E-mail du signataire",
      "emailSavedToCrm": "E-mail enregistré dans le CRM",
      "sourceCrm": "Dans le CRM",
      "sourceZefixNew": "Zefix — pas encore dans le CRM",
      "sourceCrmGone": "Dans le CRM — plus dans le registre",
      "noSignatoriesFound": "Aucun signataire trouvé. Veuillez d'abord l'enregistrer dans le CRM.",
      "searchCompany": "Rechercher une entreprise (Zefix)",
      "searchPlaceholder": "Rechercher une entreprise...",
      "signingEmailPlaceholder": "E-mail pour le lien de signature",
      "street": "Rue",
      "subtitle": "Recherchez un partenaire existant ou créez-en un nouveau",
      "title": "Partenaire contractuel",
      "zipCode": "Code postal"
    },
    "step3": {
      "broker": "Courtier",
      "brokerDesc": "Co-courtage, accès réseau, partage d'honoraires",
      "brokerDescription": "Partage d'honoraires avec courtier partenaire",
      "buyer": "Acheteur",
      "buyerDesc": "Accès aux propriétés hors marché, profil de recherche, support due diligence",
      "buyerDescription": "Contrat d'achat avec honoraires et profil de recherche",
      "seller": "Vendeur",
      "sellerDesc": "Commercialisation immobilière, mise en relation acheteurs, accompagnement",
      "sellerDescription": "Mandat de courtage avec honoraires et exclusivité",
      "subtitle": "Quel est le rôle du partenaire ?",
      "title": "Choisir le type de contrat"
    },
    "step4": {
      "brokerCommission": "Honoraires",
      "brokerSection": "Conditions courtier",
      "buyerSection": "Conditions acheteur",
      "commission": "Honoraires de courtage",
      "commissionMode": "Conditions",
      "commissionModeFixed": "Fixées dans le contrat",
      "commissionModeFixedDesc": "Les pourcentages sont fixés dans le contrat.",
      "commissionModeFixedRequired": "Veuillez saisir un taux supérieur à 0 % pour chaque rôle sélectionné.",
      "commissionModeVariable": "Par objet (annexe B)",
      "commissionModeVariableDesc": "Les conditions sont convenues par objet.",
      "commissionModeVariableHint": "Sans pourcentages fixes dans le contrat : les conditions sont convenues par objet dans l'annexe B et confirmées avant l'accès à l'objet.",
      "conditions": "Conditions de courtage",
      "contractDuration": "Durée du contrat",
      "exclusivity": "Exclusivité",
      "exclusivityDuration": "Durée d'exclusivité",
      "exclusivityHint": "Mandat de commercialisation exclusif",
      "findersFee": "Honoraires",
      "globalSection": "Conditions générales",
      "ourShare": "Notre part",
      "partnerShare": "Part du partenaire",
      "protectionDuration": "Durée de protection (mois)",
      "searchProfile": "Profil de recherche",
      "sellerSection": "Conditions vendeur",
      "subtitle": "Paramètres spécifiques au type",
      "title": "Configuration"
    },
    "step5": {
      "company": "Entreprise",
      "configuration": "Configuration",
      "contractType": "Type de contrat",
      "generate": "Générer le contrat",
      "generating": "Génération en cours...",
      "partner": "Partenaire",
      "subtitle": "Vérifiez les informations et générez le contrat",
      "title": "Résumé et génération"
    },
    "steps": {
      "company": "Entreprise",
      "config": "Configuration",
      "partner": "Partenaire",
      "preview": "Aperçu",
      "type": "Type de contrat"
    },
    "subtitle": "Créer un nouveau contrat",
    "success": "Contrat créé avec succès",
    "title": "Nouveau contrat",
    "validation": {
      "collectiveMore": "Signature collective : veuillez selectionner au moins 2 signataires.",
      "collectiveTwo": "Signature collective a deux : veuillez selectionner exactement 2 signataires.",
      "singleOnly": "Signature individuelle : veuillez selectionner exactement 1 signataire."
    },
    "searchMandate": {
      "companyLoadError": "Firma konnte nicht geladen werden",
      "onlyImages": "Nur Bilddateien erlaubt (PNG, JPG, WebP)",
      "fileTooLarge": "Maximale Dateigroesse: 2 MB",
      "logoUploaded": "Logo hochgeladen",
      "logoUploadFailed": "Logo-Upload fehlgeschlagen",
      "letterGenerated": "Anschreiben-Text generiert",
      "letterGenerateFailed": "Text konnte nicht generiert werden",
      "mandateCreated": "Suchmandat erstellt!",
      "createError": "Fehler beim Erstellen des Suchmandats",
      "title": "Suchmandat erstellen",
      "ourCompany": "Unsere Firma",
      "client": "Auftraggeber (Investor)",
      "searchCompany": "Firma suchen (Zefix)",
      "manualEntry": "Manuell eingeben",
      "signatories": "Unterzeichner des Vertragspartners",
      "signatoriesHint": "Bei Kollektivunterschrift mehrere Personen auswählen.",
      "clientLogo": "Logo des Auftraggebers",
      "clientLogoHint": "Das Logo erscheint oben rechts im Anschreiben. Das Anschreiben wird im Namen des Auftraggebers erstellt.",
      "logoUploadHint": "Logo hochladen oder hierhin ziehen (PNG, JPG, max. 2 MB)",
      "aiCoverLetter": "Anschreiben — KI-Textgenerator",
      "aiCoverLetterHint": "Stichworte zum Auftraggeber eingeben — die KI generiert ein professionelles Anschreiben.",
      "clientKeywords": "Stichworte zum Auftraggeber",
      "generating": "Wird generiert...",
      "generateLetter": "Anschreiben generieren",
      "generatedText": "Generierter Text (bearbeitbar)",
      "textEditable": "Text kann vor dem Erstellen angepasst werden.",
      "searchCriteria": "Suchkriterien",
      "propertyType": "Objektart",
      "noGoCriteria": "No-Go Kriterien",
      "noGoHint": "Was kommt fuer den Investor nicht in Frage?",
      "noGoCustom": "Weitere No-Gos (Freitext)",
      "regionLabel": "Region (Mehrfachauswahl)",
      "cantonsLabel": "Kantone (Mehrfachauswahl)",
      "macroLocation": "Makrolage",
      "noRestriction": "Keine Einschraenkung",
      "macroA": "A — Top-Standort (Zuerich, Genf, Basel)",
      "macroB": "B — Guter Standort (Agglomeration, Mittelstaedte)",
      "macroC": "C — Peripherer Standort (laendlich, Kleinstaedte)",
      "microLocation": "Mikrolage",
      "microA": "A — Beste Mikrolage (zentral, ruhig, top Anbindung)",
      "microB": "B — Gute Mikrolage (durchschnittlich, solide)",
      "microC": "C — Einfache Mikrolage (Randlage, maessige Anbindung)",
      "investmentVolume": "Investitionsvolumen",
      "investmentAndYield": "Investitionsvolumen & Rendite",
      "priceRange": "Kaufpreis-Bandbreite",
      "minimum": "Minimum",
      "maximum": "Maximum",
      "grossYieldMin": "Bruttorendite min.",
      "netYieldTarget": "Nettorendite Ziel",
      "timeline": "Zeitrahmen",
      "buildingAndTimeline": "Gebaeude & Zeitrahmen",
      "conditionLabel": "Zustand (Mehrfachauswahl)",
      "timelineNow": "Sofort",
      "timeline3m": "Innerhalb 3 Monaten",
      "timeline6m": "Innerhalb 6 Monaten",
      "timeline12m": "Innerhalb 12 Monaten",
      "timelineFlexible": "Flexibel",
      "specialRequirements": "Besondere Anforderungen",
      "conditions": "Konditionen",
      "feeNote": "des Kaufpreises, zzgl. MWST",
      "protectionDuration": "Kontaktschutz (Monate)",
      "contractDuration": "Mandatsdauer (Monate)",
      "hidePreview": "Vorschau ausblenden",
      "showPreview": "Vorschau anzeigen",
      "tabCoverLetter": "Anschreiben",
      "tabCriteria": "Suchkriterien",
      "tabAgreement": "Mandatsvereinbarung",
      "creating": "Wird erstellt...",
      "createMandate": "Suchmandat erstellen"
    }
  },
  "contracts": {
    "actions": {
      "cancel": "Annuler le contrat",
      "createNew": "Nouveau contrat",
      "downloadPdf": "Télécharger PDF",
      "generate": "Créer",
      "preview": "Aperçu",
      "proceedToSign": "Procéder à la signature",
      "send": "Envoyer le contrat",
      "terminate": "Resilier le contrat"
    },
    "cancel": "Annuler",
    "cancelFailed": "Le contrat n'a pas pu etre annule.",
    "cancelSuccess": "Le contrat a ete annule.",
    "categories": {
      "compliance": "Conformité",
      "contracts": "Contrats",
      "legitimation": "Légitimations",
      "v2": "Nouveaux contrats"
    },
    "collectiveSignatureWarning": "Signature collective à deux : veuillez sélectionner au moins 2 personnes.",
    "complete": {
      "contractNumber": "Numéro de contrat",
      "createdAt": "Créé le",
      "description": "Votre contrat {{number}} a été généré.",
      "sentDescription": "Le contrat {{number}} a été envoyé pour signature. Les signataires recevront un e-mail.",
      "sentTitle": "Contrat envoyé !",
      "signedDescription": "Le contrat {{number}} a été signé par toutes les parties.",
      "signedTitle": "Contrat signé avec succès !",
      "status": "Statut",
      "title": "Contrat créé avec succès !",
      "usersCreated": "{{count}} comptes utilisateurs créés automatiquement"
    },
    "confirmCancel": "Voulez-vous vraiment annuler ce contrat ?",
    "confirmCancelCustomerSigned": "ATTENTION : Des parties externes ont déjà signé ce contrat. Voulez-vous quand même l'annuler ?",
    "confirmCancelSent": "Ce contrat a déjà été envoyé. Les signataires ont reçu le lien. Annuler quand même ?",
    "confirmDelete": "Voulez-vous vraiment supprimer ce contrat ?",
    "confirmDeleteDescription": "Etes-vous sur de vouloir supprimer ce contrat ?",
    "confirmSend": "Etes-vous sur de vouloir envoyer ce contrat ?",
    "confirmTerminate": "Voulez-vous vraiment résilier ce contrat ? Cette action est irréversible.",
    "confirmTerminateDescription": "Etes-vous sur de vouloir resilier ce contrat ?",
    "deleteFailed": "Le contrat n'a pas pu etre supprime.",
    "deleteSuccess": "Le contrat a ete supprime.",
    "detail": {
      "aiSuggest": "Suggestion IA",
      "aiSuggestFailed": "La suggestion IA a echoue",
      "appendices": "Annexes ({{count}})",
      "appendicesInvestorHint": "Les annexes fixent les conditions applicables a un bien en particulier.",
      "appendixProperty": "Bien n° {{id}}",
      "autoRenewal": "automatische Verlängerung",
      "brokerCommission": "Honoraires du courtier",
      "buyer": "Acheteur",
      "buyerCommission": "Honoraires de l'acheteur",
      "cancelContract": "Annuler le contrat",
      "commissionRate": "Honoraires",
      "companyLink": "Voir l'entreprise",
      "companyName": "Entreprise",
      "config": "Configuration",
      "confirmSend": "Envoyer le contrat ?",
      "confirmSendDescription": "Le contrat sera envoyé à tous les signataires par e-mail.",
      "contactLink": "Voir le contact",
      "contractDuration": "Duree du contrat",
      "contractNumber": "Numéro de contrat",
      "contractTerms": "Conditions du contrat",
      "createdAt": "Créé le",
      "deleteContract": "Supprimer le contrat",
      "documents": "Documents",
      "downloadPdf": "Télécharger le PDF",
      "emailStatus": "Livraison des e-mails",
      "exclusive": "Mandat exclusif",
      "exclusivity": "Exclusivité",
      "expiresAt": "Valable jusqu'au",
      "goToCountersign": "Contresigner",
      "hidePdf": "Masquer le PDF",
      "months": "mois",
      "noAppendices": "Ce contrat n'a pas encore d'annexes.",
      "noData": "Aucune donnée disponible",
      "nonExclusive": "Non-exclusif",
      "parties": "Parties contractantes",
      "partner": "Partenaire",
      "pdfNotAvailable": "PDF non disponible",
      "pdfNotSupported": "PDF-Vorschau wird auf diesem Gerät nicht unterstützt.",
      "pdfPreviewNotSupported": "PDF-Vorschau wird auf diesem Gerät nicht unterstützt.",
      "personalMessage": "Message personnel (optionnel)",
      "personalMessagePlaceholder": "p.ex. Veuillez signer avant vendredi...",
      "plotNumber": "N° de parcelle",
      "property": "Bien immobilier",
      "propertyDetails": "Détails du bien",
      "propertyType": "Type d'objet",
      "protectionDuration": "Durée de protection",
      "resetSignaturesConfirm": "Zurücksetzen & neu versenden",
      "resetSignaturesDescription": "Alle Unterschriften werden gelöscht und neue Unterzeichnungslinks per E-Mail versendet. Die Unterzeichner müssen erneut unterschreiben.",
      "resetSignaturesFailed": "Zurücksetzen fehlgeschlagen",
      "resetSignaturesTitle": "Unterschriften zurücksetzen?",
      "roles": "Roles",
      "seller": "Vendeur",
      "sellerCommission": "Honoraires du vendeur",
      "sendContract": "Envoyer le contrat",
      "sentAt": "Envoyé le",
      "signatures": "Signatures",
      "signedAt": "Signé le",
      "template": "Modèle",
      "terminateContract": "Résilier le contrat",
      "title": "Détails du contrat",
      "viewDetails": "Voir les détails",
      "viewPdf": "Afficher le PDF"
    },
    "download": "Télécharger",
    "downloadFailed": "Le telechargement a echoue.",
    "errors": {
      "downloadFailed": "Échec du téléchargement",
      "generateFailed": "Impossible de créer le contrat",
      "loadFailed": "Impossible de charger les modèles",
      "missingEmails": "E-mail manquant pour",
      "missingSignatures": "Signatures manquantes",
      "previewFailed": "Impossible de générer l'aperçu",
      "sendFailed": "Impossible d'envoyer le contrat",
      "signingFailed": "Échec de la signature"
    },
    "form": {
      "agentEmail": "E-mail du mandataire",
      "agentName": "Mandataire",
      "authorizedEmail": "E-mail de la personne",
      "authorizedPerson": "Personne autorisée",
      "buyerAddress": "Adresse de l'acheteur",
      "buyerCommissionRate": "Taux d'honoraires acheteur",
      "buyerEmail": "E-mail de l'acheteur",
      "buyerName": "Nom de l'acheteur",
      "commissionRate": "Taux d'honoraires",
      "companyAddress": "Adresse de l'entreprise",
      "companyName": "Nom de l'entreprise",
      "exclusive": "Exclusif",
      "exclusiveDescription": "Mandat exclusif: Le vendeur s'engage à ne mandater aucun tiers pour la commercialisation et à ne pas contacter directement les acheteurs potentiels identifiés par Immotron.",
      "exclusivity": "Exclusivité",
      "exclusivityDescription": "§5 Exclusivité — Détermine si le vendeur peut mandater d'autres courtiers pendant la durée du contrat.",
      "exclusivityDuration": "Durée d'exclusivité",
      "groups": {
        "agent": "Représentation",
        "buyer": "Acheteur",
        "company": "Organisation",
        "config": "Configuration",
        "general": "Général",
        "partner": "Partenaire",
        "property": "Bien immobilier",
        "seller": "Vendeur"
      },
      "nonExclusive": "Non exclusif",
      "nonExclusiveDescription": "Mandat non exclusif: Le vendeur reste tenu de signaler immédiatement à Immotron tout contact ou toute demande initiée par Immotron.",
      "partnerAddress": "Adresse du partenaire",
      "partnerEmail": "E-mail du partenaire",
      "partnerName": "Nom du partenaire",
      "plotNumber": "N° de parcelle",
      "principalName": "Mandant",
      "propertyAddress": "Adresse du bien",
      "propertyType": "Type de bien",
      "protectionDuration": "Durée de protection",
      "protectionDurationBuyerDescription": "§8 Non-contournement — Clause de protection contre le contournement. Toute transaction avec un vendeur ou un bien présenté par la plateforme est réputée avoir été négociée. Pénalité: honoraires doublés.",
      "protectionDurationSellerDescription": "§7 Non-contournement — Clause de protection contre le contournement. Toute transaction avec un acheteur présenté par la plateforme est réputée avoir été négociée. Pénalité: honoraires doublés.",
      "sellerAddress": "Adresse du vendeur",
      "sellerCommissionRate": "Taux d'honoraires vendeur",
      "sellerEmail": "E-mail du vendeur",
      "sellerName": "Nom du vendeur"
    },
    "generate": "Générer un contrat",
    "generateClause": "Générer une clause IA",
    "generatingClause": "Génération...",
    "generator": {
      "subtitle": "Créez des contrats professionnels en quelques étapes",
      "title": "Générateur de contrats"
    },
    "issuer": "Émetteur du contrat",
    "list": {
      "allSigned": "alle",
      "appendix": "Annexe",
      "appendixTypes": {
        "ANHANG_A": "Annexe A",
        "ANHANG_B": "Annexe B"
      },
      "buyer": "Acheteur",
      "contractNumber": "Numéro de contrat",
      "created": "Erstellt",
      "createdAt": "Créé le",
      "dates": "Datum",
      "empty": {
        "description": "Créez votre premier contrat",
        "title": "Aucun contrat"
      },
      "page": "Page {{current}} sur {{total}}",
      "parties": "Parteien",
      "searchMandate": "Suchmandat",
      "searchNoResults": "Aucun contrat trouvé",
      "searchPlaceholder": "Rechercher par numéro, acheteur, vendeur...",
      "seller": "Vendeur",
      "sent": "Versendet",
      "signatories": "Unterzeichner",
      "signed": "unterschrieben",
      "signedDate": "Unterschrieben",
      "subtitle": "Gérez vos contrats créés",
      "template": "Modèle",
      "toParentContract": "vers le contrat-cadre",
      "typeFilter": "Type de contrat",
      "typeGroups": {
        "ALL": "Tous",
        "BROKER": "Courtier",
        "BUYER": "Acheteur",
        "OTHER": "Autres",
        "SELLER": "Vendeur"
      },
      "us": "Uns"
    },
    "livePreview": {
      "error": "L'aperçu n'a pas pu être mis à jour.",
      "hidePreview": "Afficher le formulaire",
      "loading": "Génération de l'aperçu...",
      "pages": "pages",
      "placeholder": "Veuillez renseigner les données du formulaire pour activer l'aperçu.",
      "previewLabel": "Apercu",
      "print": "Imprimer",
      "printTitle": "Aperçu du contrat",
      "showPreview": "Afficher l'aperçu",
      "title": "Aperçu en direct"
    },
    "loadingSignatories": "Chargement des signataires...",
    "newContract": "Nouveau contrat",
    "newSearchMandate": "Mandat de recherche",
    "noContracts": "Aucun contrat",
    "ourCompany": "Notre entreprise",
    "preview": {
      "document": "Aperçu du document",
      "title": "Aperçu"
    },
    "resultsLabel": "Contrats",
    "roles": {
      "BROKER": "Courtier",
      "BUYER": "Acheteur",
      "SELLER": "Vendeur",
      "buyer": "Käufer",
      "partner": "Partner",
      "seller": "Verkäufer"
    },
    "selectSignatoriesFor": "Sélectionnez les signataires autorisés pour {{company}} :",
    "selectedPersons": "{{count}} personne(s) sélectionnée(s)",
    "send": "Envoyer",
    "sendFailed": "Le contrat n'a pas pu être envoyé.",
    "sendSuccess": "Le contrat a ete envoye.",
    "sign": "Signer",
    "signatoryLoadError": "Impossible de charger les signataires.",
    "signatoryTypes": {
      "AGENT": "Mandataire",
      "BUYER": "Acheteur",
      "COMPANY_REP": "Organe autorisé",
      "IMMOTRON": "Intermédiaire",
      "PARTNER": "Partenaire",
      "SELLER": "Vendeur",
      "USER": "Utilisateur"
    },
    "signaturePad": {
      "complete": "Finaliser le contrat",
      "description": "Veuillez signer dans les champs ci-dessous. Toutes les signatures sont requises.",
      "placeholder": "signe ici",
      "signaturesRequired": "signature(s) requise(s)",
      "signed": "signé",
      "skipAndSaveDraft": "Enregistrer comme brouillon",
      "title": "Collecter les signatures"
    },
    "signing": {
      "modeDescription": "Comment le contrat doit-il être signé ?",
      "modeTitle": "Choisir le mode de signature",
      "onsite": "Signer sur place",
      "onsiteDescription": "Collecter les signatures directement sur l'appareil (ex. iPad, tablette).",
      "remote": "Envoyer pour signature",
      "remoteDescription": "Envoyer le contrat par e-mail aux signataires."
    },
    "slider": {
      "months": "Mois",
      "monthsUnit": "mo.",
      "months_one": "{{count}} mois",
      "months_other": "{{count}} mois",
      "noProtection": "Aucune protection",
      "years": "Annees",
      "yearsAndMonths": "{{years}} an(s) et {{months}} mois",
      "years_one": "{{count}} an",
      "years_other": "{{count}} ans"
    },
    "specialConditions": "Conditions particulières",
    "statuses": {
      "CANCELLED": "Annulé",
      "CUSTOMER_SIGNED": "Signé par le client",
      "DRAFT": "Brouillon",
      "EXPIRED": "Expiré",
      "PARTIALLY_SIGNED": "Partiellement signé",
      "PENDING": "En attente",
      "SENT": "Envoyé",
      "SIGNED": "Signé",
      "TERMINATED": "Résilié"
    },
    "steps": {
      "complete": "Terminé",
      "form": "Données",
      "preview": "Aperçu",
      "select": "Modèle",
      "sign": "Signature"
    },
    "terminate": "Résilier",
    "terminateFailed": "La resiliation a echoue.",
    "terminateSuccess": "Le contrat a ete resilie.",
    "termination": {
      "clause": "Clause de resiliation",
      "clauseLabel": "Selectionner une clause",
      "confirmButton": "Confirmer la resiliation",
      "confirmSummary": "Resume de la resiliation",
      "contract": "Contrat",
      "description": "Veuillez indiquer le motif de la resiliation.",
      "error": "La resiliation n'a pas pu etre effectuee.",
      "reason": "Motif de resiliation",
      "reasonLabel": "Motif",
      "reasonPlaceholder": "Veuillez saisir le motif de la resiliation...",
      "reasonRequired": "Un motif de resiliation est requis.",
      "selectClause": "Selectionner une clause",
      "success": "Le contrat a ete resilie avec succes.",
      "title": "Resilier le contrat",
      "warningText": "Cette action ne peut pas etre annulee.",
      "warningTitle": "Attention"
    },
    "title": "Contrats",
    "types": {
      "BROKER_AGREEMENT": "Contrat de courtage",
      "PLATFORM_AGREEMENT": "Contrat de plateforme",
      "SEARCH_MANDATE": "Mandat de recherche"
    },
    "v2": {
      "addAppendixB": "Créer une nouvelle annexe B",
      "aiClause": {
        "clauseNumber": "Clause {{number}}",
        "confirmDelete": "Supprimer?",
        "context": "Contexte (optionnel)",
        "contextPlaceholder": "p.ex. retard de rénovation, communauté héréditaire, droit de superficie...",
        "defaultDescription": "Disposition particulière",
        "editClause": "Modifier la clause",
        "empty": "Aucune clause. Entrez un contexte et générez.",
        "error": "Erreur lors de la génération de la clause",
        "generate": "Générer clause",
        "generating": "Génération...",
        "hint": "Le générateur de clauses IA crée des clauses spéciales sur mesure basées sur les données de l'objet. Vous pouvez modifier le texte généré par la suite.",
        "placeholder": "Les clauses spéciales générées par l'IA apparaîtront ici...",
        "regenerate": "Régénérer",
        "tags": {
          "buildingRight": "Droit de superficie",
          "divorce": "Divorce",
          "estateManagement": "Administration successorale",
          "forcedSale": "Vente forcée",
          "heirsCompany": "Communauté héréditaire",
          "liquidityShortfall": "Manque de liquidités",
          "relocation": "Déménagement",
          "renovationBacklog": "Retard de rénovation"
        },
        "title": "Générateur de clauses IA"
      },
      "appendices": "Annexes",
      "appendix": {
        "b": "Anhang B: Objektfreigabe"
      },
      "appendixB": {
        "add": "Ajouter libération d'objet",
        "commissionModel": "Modèle d'honoraires",
        "description": "Libérer les biens immobiliers à commercialiser via la plateforme.",
        "empty": "Aucune libération d'objet. Vous pouvez ajouter l'annexe B au contrat-cadre ultérieurement.",
        "exclusivity": "Exclusivité",
        "inheritedFromParent": "du contrat-cadre",
        "newProperty": {
          "canton": "Canton",
          "city": "Localité",
          "cityPlaceholder": "p.ex. Genève",
          "create": "Créer un nouveau bien",
          "createError": "Erreur lors de la création du bien",
          "hint": "Les détails du bien peuvent être complétés ultérieurement.",
          "propertyType": "Type de bien",
          "streetAddress": "Adresse",
          "streetAddressPlaceholder": "p.ex. Rue Exemple 1",
          "submit": "Créer & sélectionner",
          "title": "Créer un nouveau bien"
        },
        "overrideExclusivity": "Différent du contrat-cadre",
        "protectionDuration": "Durée de protection",
        "selectCommissionModel": "Choisir un modèle...",
        "selectProperty": "Sélectionner un bien",
        "selectPropertyPlaceholder": "Choisir un bien...",
        "title": "Libération d'objet"
      },
      "buyerPlatform": "Contrat plateforme acheteur",
      "noAppendices": "Aucune annexe disponible.",
      "parentContract": "Appartient au contrat-cadre",
      "sellerFramework": "Contrat-cadre vendeur",
      "viewParent": "Voir le contrat-cadre"
    },
    "validation": {
      "collectiveRequiresTwo": "Signature collective : au moins 2 personnes autorisées sont requises"
    },
    "searchMandate": "Suchauftrag",
    "countersign": "Gegenzeichnung"
  },
  "countersignPage": {
    "breadcrumb": {
      "contracts": "Contrats",
      "countersign": "Contresignature"
    },
    "buyer": "Acheteur",
    "contractDetails": "Détails du contrat",
    "contractNumber": "Numéro de contrat",
    "contractType": "Type de contrat",
    "customerSignedAt": "Client signé le",
    "days": "jours",
    "error": {
      "loadFailed": "Les données du contrat n'ont pas pu être chargées.",
      "noSlots": "Aucun emplacement de signature disponible pour lequel vous êtes autorisé.",
      "notFound": "Contrat introuvable.",
      "submitFailed": "La contresignature n'a pas pu être soumise. Veuillez réessayer.",
      "title": "Erreur",
      "unauthorized": "Vous n'êtes pas autorisé à signer cet emplacement de signature.",
      "wrongStatus": "Ce contrat n'est pas prêt pour la contresignature."
    },
    "geoConsent": "Partager la localisation pour la documentation juridique",
    "hidePdf": "Masquer le contrat",
    "legalNotice": "En contresignant, vous confirmez en tant que représentant autorisé que le contrat a été examiné et approuvé.",
    "loading": "Chargement des données du contrat...",
    "pdfTitle": "Aperçu du contrat",
    "selectSlot": "Sélectionner",
    "selectedSlot": "Sélectionné",
    "seller": "Vendeur",
    "signatureLabel": "Signature",
    "signatureSlots": "Emplacements de signature",
    "signatureTitle": "Votre contresignature",
    "slotAvailable": "Disponible pour vous",
    "slotLocked": "Non autorisé",
    "slotSigned": "Déjà signé",
    "submit": "Contresigner",
    "submitting": "Contresignature en cours...",
    "subtitle": "Contresignature interne du contrat",
    "success": {
      "allComplete": "Toutes les signatures sont complètes. Le contrat est maintenant juridiquement contraignant.",
      "description": "Votre contresignature a été soumise avec succès.",
      "moreRequired": "Des signatures internes supplémentaires sont encore nécessaires.",
      "title": "Contresignature réussie !"
    },
    "title": "Contresignature",
    "viewPdf": "Afficher le contrat",
    "waitingDays": "Temps d'attente"
  },
  "crm": {
    "activities": {
      "placeholder": "Gestion des activités",
      "placeholderDescription": "La gestion des activités CRM sera disponible dans une prochaine version.",
      "title": "Activités"
    },
    "contacts": {
      "addFirst": "Voir les contacts",
      "backToContacts": "Retour aux contacts",
      "backToList": "Retour à la liste",
      "companySearchCriteria": "Suchprofile verknüpfter Firmen",
      "contactInfo": "Coordonnées",
      "dedup": "Dédoublonnage",
      "details": "Details",
      "emptyDescription": "Erstellen Sie Ihren ersten Kontakt, um mit der CRM-Verwaltung zu beginnen.",
      "emptyTitle": "Noch keine Kontakte",
      "filterAll": "Tous",
      "filterWithCompany": "Avec entreprise",
      "filterWithoutCompany": "Sans entreprise",
      "goToCompany": "Zur Firma",
      "import": "Importer",
      "keyFigures": "Chiffres clés",
      "lastActivity": "Letzte Aktivität",
      "noCompanyCriteria": "Keine Suchkriterien hinterlegt",
      "noResults": "Keine Kontakte gefunden",
      "notFound": "Contact introuvable",
      "openDetail": "Ouvrir",
      "ownSearchCriteria": "Eigenes Suchprofil",
      "ownership": "Responsabilité",
      "personalData": "Kontaktdaten",
      "placeholder": "Gestion des contacts",
      "placeholderDescription": "La gestion des contacts CRM sera disponible dans une prochaine version.",
      "previewTitle": "Aperçu rapide",
      "searchPlaceholder": "Rechercher par nom, e-mail, téléphone ou entreprise...",
      "subtitle": "Gestion des contacts CRM",
      "tabOverview": "Aperçu",
      "tabResearch": "KI-Recherche",
      "tabSearchCriteria": "Profil de recherche",
      "tabTimeline": "Activités",
      "title": "Contacts",
      "tryDifferentSearch": "Essayez un autre terme de recherche",
      "unverifyConfirmText": "Cette personne perdra la vérification CRM pour la signature de contrats. Sans pouvoir de signature Zefix, le portail d'onboarding la refusera. Cette modification est pertinente pour l'audit.",
      "unverifyConfirmTitle": "Retirer la vérification ?",
      "verificationSection": "Vérification",
      "verifiedBadge": "Vérifié pour la signature de contrats",
      "verifiedForSigningHint": "Ouvre la demande de contrat en libre-service pour cette personne, même sans pouvoir de signature Zefix.",
      "verifiedForSigningLabel": "Vérifié pour la signature de contrats",
      "verifiedRemovedSuccess": "Vérification retirée",
      "verifiedSetSuccess": "Vérification définie",
      "verifiedUpdateError": "La vérification n'a pas pu être mise à jour",
      "verifyConfirmText": "Cette personne sera autorisée à signer des contrats et pourra terminer l'onboarding même sans inscription Zefix. Cette modification est pertinente pour l'audit.",
      "verifyConfirmTitle": "Définir la vérification ?",
      "masterDataCard": "Données de base",
      "channelsCard": "Adresse et coordonnées",
      "rolesCard": "Rôles en entreprise",
      "addRole": "Ajouter un rôle",
      "roleAlreadyLinked": "Cette organisation est déjà liée",
      "rolePersonNotAllowed": "Veuillez sélectionner une organisation, pas une personne",
      "contractsCard": "Contrats",
      "linkedinCard": "LinkedIn",
      "knowledgeTab": "Connaissances"
    },
    "organizations": {
      "addContact": "Ajouter un contact",
      "addFirst": "Voir les organisations",
      "addInvestorGroup": "Attribuer un groupe d'investisseurs",
      "addNew": "Nouvelle organisation",
      "addSearchCriteria": "Saisir le profil de recherche",
      "address": "Adresse",
      "allContacts": "Contacts : tous",
      "canton": "Canton",
      "capital": "Capital",
      "contactAdded": "Contact ajouté",
      "contactCreatedAndLinked": "Contact créé et lié",
      "contactInfo": "Données de base",
      "contactRemoved": "Contact retiré",
      "createdAt": "Créé le",
      "details": "Détails",
      "employees": "Employés",
      "emptyDescription": "Créez votre première organisation pour commencer la gestion CRM.",
      "emptyTitle": "Pas encore d'organisations",
      "hasContacts": "Avec contacts",
      "hasSearchCriteria": "Profil de recherche disponible",
      "industry": "Secteur",
      "industryPlaceholder": "Choisir un secteur...",
      "industriesFilter": "Secteurs",
      "removeIndustry": "Retirer le secteur",
      "investorGroupsTab": "Groupes d'investisseurs",
      "investorGroupsFilter": "Groupes d'investisseurs",
      "lastActivity": "Dernière activité",
      "lastResearched": "Dernière recherche",
      "legalForm": "Forme juridique",
      "newContact": "Nouveau contact",
      "noContacts": "Sans contacts",
      "noContactsFound": "Aucun contact trouvé",
      "noInvestorGroups": "Aucun groupe d'investisseurs attribué",
      "noResults": "Aucune organisation trouvée",
      "noResultsDescription": "Essayez d'ajuster vos termes de recherche ou vos filtres.",
      "noSearchCriteria": "Aucun profil de recherche enregistré",
      "notes": "Notes",
      "overviewTab": "Aperçu",
      "ownership": "Responsabilité",
      "parentCompany": "Société mère",
      "pendingProposal": "Proposition de recherche en attente — cliquer pour vérifier",
      "placeholder": "Gestion des organisations",
      "placeholderDescription": "La gestion des organisations CRM sera disponible dans une prochaine version.",
      "primaryContact": "Contact principal",
      "properties": {
        "contractActive": "Contrat actif",
        "contractExpired": "Contrat expiré",
        "contractMissing": "Aucun contrat",
        "empty": "Aucun bien pour cette organisation",
        "groupBy": "Grouper par",
        "groupByCanton": "Canton",
        "groupByNone": "aucun",
        "groupByStatus": "Statut",
        "groupByType": "Usage",
        "groupByVia": "Rattachement",
        "groupCount": "{{count}} biens",
        "groupCountOne": "1 bien",
        "groupNoValue": "Non renseigné",
        "groupSumMillions": "CHF {{value}} mio",
        "groupTotal": "{{count}} biens · {{sum}}",
        "groupTotalOne": "1 bien · {{sum}}",
        "groupViaCompany": "Société",
        "groupViaContact": "via le contact",
        "propertyLabel": "Bien",
        "sectionImmotron": "Sur Immotron",
        "viaContact": "via le contact : {{name}}"
      },
      "propertiesTab": "Biens",
      "purpose": "But",
      "registerDetails": "Extrait du registre du commerce",
      "removeContact": "Retirer le contact",
      "removeFromOrg": "retirer de cette organisation ?",
      "removePrimaryContact": "Retirer contact principal",
      "knowledgeTab": "Connaissances",
      "researchTab": "Recherche IA",
      "roleUpdated": "Rôle mis à jour",
      "searchContact": "Rechercher un contact...",
      "searchCriteriaTab": "Profil de recherche",
      "nlSearch": {
        "placeholder": "Posez votre question, p. ex. «tous ceux qui cherchent du commercial à Zurich»",
        "ariaLabel": "Recherche d'organisations en langage naturel",
        "submit": "Rechercher",
        "understoodAs": "Compris comme :",
        "reset": "Réinitialiser",
        "searchIn": "Recherche dans :",
        "sourceCriteria": "Mandats de recherche",
        "sourcePurpose": "But Zefix",
        "onlyWithCriteria": "avec mandat uniquement",
        "parseError": "Impossible d'interpréter la question. Veuillez réessayer.",
        "unrecognizedHint": "Non attribué clairement — non appliqué comme filtre",
        "removeChip": "Retirer le filtre",
        "reasonMandate": "Correspondance mandat de recherche",
        "reasonPurpose": "Correspondance but Zefix",
        "noMandate": "aucun mandat de recherche enregistré",
        "chipType": "Type de bien",
        "chipRegion": "Région",
        "chipCanton": "Canton",
        "chipYield": "Rendement dès",
        "chipPriceMin": "Prix dès",
        "chipPriceMax": "Prix jusqu'à",
        "chipUnits": "Unités min.",
        "chipText": "Texte",
        "noResultsTitle": "Aucun résultat",
        "noResultsHelp": "Essayez d'assouplir un filtre :",
        "loosenRemove": "Sans «{{label}}»",
        "loosenSources": "Rechercher dans les deux sources",
        "loosenMandate": "Aussi sans mandat"
      },
      "searchPlaceholder": "Rechercher nom, IDE ou secteur...",
      "selectGroup": "Choisir un groupe...",
      "setPrimaryContact": "Définir comme contact principal",
      "subtitle": "Gérer les entreprises et organisations",
      "title": "Organisations",
      "backToList": "Retour à la liste",
      "notFound": "Organisation introuvable",
      "openDetail": "Ouvrir",
      "previewTitle": "Aperçu rapide",
      "keyFigures": "Indicateurs",
      "recentActivities": "Dernières activités",
      "noActivities": "Aucune activité enregistrée",
      "zefixRevert": "Retirer le lien Zefix",
      "zefixRevertTitle": "Annuler les données Zefix",
      "zefixRevertConfirm": "Tous les contacts Zefix de cette organisation sont désactivés et le lien Zefix est retiré. Les contacts épinglés sont conservés.",
      "zefixRevertConfirmLabel": "Annuler",
      "zefixRevertFailed": "L'annulation du lien Zefix a échoué"
    },
    "createOrganization": {
      "stepSearch": "Étape 1 sur 2 — Recherche",
      "stepDetails": "Étape 2 sur 2 — Informations",
      "searchIntro": "Cherchez d'abord dans le CRM et au registre du commerce — cela évite les doublons.",
      "manualEntry": "Saisir sans rechercher",
      "existingCompany": "Cette organisation existe déjà",
      "existingContact": "Cette entrée existe déjà en tant que personne",
      "openExisting": "Vers l'entrée existante",
      "duplicateGeneric": "Cette organisation existe déjà.",
      "fromZefix": "Repris du registre du commerce",
      "nameRequired": "Le nom est obligatoire",
      "seat": "Siège",
      "seatRequired": "Le siège est obligatoire",
      "detailsHint": "Tout le reste — adresses, moyens de contact, notes — se complète ensuite sur la page de détail.",
      "submit": "Créer l'organisation"
    },
    "createContact": {
      "subtitle": "Seulement l'essentiel — tout le reste sur la page de détail.",
      "duplicateEmail": "Cette adresse e-mail existe déjà",
      "openExisting": "Vers l'entrée existante",
      "lastNameRequired": "Le nom est obligatoire",
      "firstNameRequired": "Le prénom est obligatoire",
      "emailOptional": "E-mail (facultatif)",
      "checkingEmail": "Vérification de l'e-mail...",
      "organizationOptional": "Organisation (facultatif)",
      "personPicked": "Il s'agit d'une personne — veuillez choisir une organisation.",
      "companyWillBeCreated": "Cette organisation sera créée et liée.",
      "submit": "Créer la personne"
    }
  },
  "crmActivities": {
    "activityType": "Type",
    "addFailed": "Impossible de créer l'activité",
    "addSuccess": "Activité créée",
    "description": "Description",
    "descriptionPlaceholder": "Détails optionnels...",
    "emptyTimeline": "Aucune activité",
    "emptyTimelineHint": "Aucune activité enregistrée pour cette entrée.",
    "entityCompany": "Entreprise",
    "entityContact": "Contact",
    "filterActivities": "Activités",
    "filterEmails": "E-mails",
    "filterTasks": "Tâches",
    "loadFailed": "Impossible de charger les activités",
    "newActivity": "Nouvelle activité",
    "searchPlaceholder": "Rechercher un contact ou une entreprise...",
    "selectEntity": "Sélectionner un contact ou une entreprise",
    "selectEntityHint": "Recherchez un contact ou une entreprise pour afficher la chronologie de ses activités.",
    "subject": "Sujet",
    "subjectPlaceholder": "Brève description...",
    "subtitle": "Chronologie CRM pour contacts et entreprises",
    "title": "Activités",
    "types": {
      "call": "Appel",
      "email": "E-mail",
      "meeting": "Réunion",
      "note": "Note",
      "task": "Tâche"
    }
  },
  "dashboard": {
    "actions": {
      "addProperty": "Ajouter une propriété",
      "createContract": "Créer un contrat",
      "manageUsers": "Gérer les utilisateurs",
      "searchProperties": "Rechercher des propriétés"
    },
    "activity": {
      "daysAgo": "Il y a {{count}}j",
      "hoursAgo": "Il y a {{count}}h",
      "justNow": "À l'instant"
    },
    "awaitingCountersign": "Contre-signature",
    "conversionRate": "Taux de conversion",
    "countersign": "Contre-signature requise",
    "customize": "Personnaliser le tableau de bord",
    "dealflowPipeline": "Pipeline Dealflow",
    "errors": {
      "loadFailed": "Impossible de charger le tableau de bord"
    },
    "investor": {
      "availableProperties": "Autres biens disponibles",
      "dossierAccess": "Accès au dossier",
      "goToSearch": "Vers la recherche",
      "kpi": {
        "activeListings": "Teasers actifs",
        "availableForYou": "Disponibles pour vous",
        "buying": "Acheter",
        "inPreparation": "En préparation",
        "inSale": "En vente",
        "myProperties": "Mes biens",
        "selling": "Vendre",
        "sold": "Vendus",
        "viewed": "Consultés"
      },
      "myProperties": "Mes biens approuvés",
      "noProperties": "Aucun bien disponible",
      "noPropertiesHint": "Aucun bien n'est actuellement visible pour vous.",
      "pendingAccess": "Sans accès",
      "propertiesAvailable": "Biens disponibles",
      "recentlyViewed": "Consultés récemment",
      "recentlyViewedEmpty": "Aucun objet consulté pour le moment — commencez par la recherche !",
      "ndaSigned": "NDA signé",
      "favorites": "Favoris",
      "newlyAdded": "Nouveautés"
    },
    "noActivity": "Aucune activité récente",
    "overdue": "En retard",
    "pendingSignatures": "Envoyés — en attente de signature",
    "quickActions": "Actions rapides",
    "recentActivity": "Activité récente",
    "resetLayout": "Réinitialiser",
    "role": "Rôle: {{role}}",
    "showAll": "Tout afficher",
    "statistics": "Statistiques",
    "stats": {
      "contactsTotal": "Contacts total",
      "contractsDraft": "Brouillons",
      "contractsPending": "Contrats en attente",
      "contractsSigned": "Signés",
      "contractsTotal": "Contrats total",
      "propertiesActive": "Propriétés actives",
      "propertiesTotal": "Propriétés total"
    },
    "statusBreakdown": "Aperçu des statuts",
    "statusCancelled": "Annulé",
    "statusDraft": "Brouillon",
    "statusPending": "En attente",
    "statusSigned": "Signé",
    "title": "Tableau de bord",
    "welcome": "Bienvenue, {{name}}",
    "widgets": {
      "activity": "Activité récente",
      "countersign": "Contresignature",
      "dealflow": "Pipeline Dealflow",
      "investorAvailable": "Biens disponibles",
      "investorKpi": "Aperçu KPI",
      "investorNetflix": "Découvrir des biens",
      "investorProperties": "Mes biens",
      "pendingSignatures": "Signatures en attente",
      "statCards": "Cartes statistiques",
      "tasks": "Tâches"
    },
    "colSpan": {
      "title": "Spaltenbreite"
    },
    "customizeHint": "Widgets per Drag & Drop sortieren. Klicke auf das Spalten-Icon für die Breite."
  },
  "deals": {
    "actions": {
      "cancel": "Annuler le deal"
    },
    "confirmCancel": "Voulez-vous vraiment annuler ce deal ?",
    "confirmDelete": "Voulez-vous vraiment supprimer ce deal ?",
    "confirmPhaseChange": "Changer la phase en {{phase}} ?",
    "create": "Nouveau Deal",
    "detail": {
      "dealNumber": "N° de deal",
      "financingPhase": "Phase de financement",
      "listing": "Teaser / Bien",
      "ourCompany": "Notre société",
      "phaseDetails": "Détails des phases",
      "qaPhase": "Phase Q&R",
      "seller": "Vendeur",
      "title": "Titre"
    },
    "documents": {
      "noneRequired": "Aucun document requis.",
      "progress": "Complétude",
      "title": "Documents"
    },
    "empty": {
      "description": "Créez un nouveau deal pour commencer.",
      "title": "Aucun deal"
    },
    "errors": {
      "cancelFailed": "Impossible d'annuler le deal.",
      "loadFailed": "Impossible de charger les deals.",
      "phaseChangeFailed": "Échec du changement de phase."
    },
    "phases": {
      "ACTIVE": "Actif",
      "CANCELLED": "Annulé",
      "CLOSING": "Clôture",
      "COMPLETED": "Terminé",
      "DRAFT": "Brouillon",
      "DUE_DILIGENCE": "Due Diligence",
      "FINANCING": "Financement",
      "QA_PHASE": "Q&R"
    },
    "searchPlaceholder": "Rechercher par numéro ou titre...",
    "subtitle": "Gérer les transactions immobilières",
    "timeline": {
      "addEvent": "Ajouter un événement",
      "empty": "Aucun événement pour le moment.",
      "eventPlaceholder": "Description de l'événement...",
      "title": "Chronologie"
    },
    "title": "Deals"
  },
  "deletionBlockers": {
    "description": "ne peut pas être supprimé(e) car des dépendances existent encore :",
    "forceDelete": "Supprimer quand même (Admin)",
    "hint": "Veuillez supprimer ou réattribuer les dépendances listées ci-dessus.",
    "title": "Suppression impossible"
  },
  "deletionWizard": {
    "actionDelete": "Supprimer",
    "actionIgnore": "Ignorer",
    "actionReassign": "Réattribuer",
    "confirmDelete": "Supprimer définitivement",
    "confirmDescription": "«{{name}}» et les dépendances sélectionnées seront supprimées de manière irréversible.",
    "confirmWarning": "Attention : cette action est irréversible !",
    "continue": "Continuer",
    "deleteSuccess": "Organisation et dépendances supprimées",
    "dependencySummary": "Cette organisation a {{count}} dépendance(s). Choisissez une action pour chaque groupe.",
    "endpointNotReady": "La vérification des dépendances n'est pas encore disponible.",
    "loadError": "Erreur lors du chargement des dépendances.",
    "loadingDependencies": "Vérification des dépendances…",
    "noDependencies": "Aucune dépendance trouvée — l'organisation peut être supprimée.",
    "selectTargetCompany": "Rechercher l'entreprise cible…",
    "stepActions": "Choisir les actions",
    "stepConfirm": "Confirmer",
    "title": "Supprimer l'organisation — Dépendances"
  },
  "documentViewer": {
    "deselectAll": "Tout désélectionner",
    "downloadComplete": "Téléchargement terminé",
    "downloadDossier": "Télécharger le dossier complet",
    "downloadFailed": "Échec du téléchargement",
    "downloading": "Téléchargement en cours...",
    "exitFullscreen": "Quitter le plein écran",
    "fullscreen": "Plein écran",
    "noDocuments": "Aucun document disponible",
    "of": "de",
    "page": "Document",
    "selectDocuments": "Sélectionner des documents",
    "selectedCount": "{{count}} documents",
    "viewer": "Visionneuse de documents",
    "zoomIn": "Agrandir",
    "zoomOut": "Réduire"
  },
  "documents": {
    "addCustomCategory": "Ajouter une catégorie",
    "allCategories": "Toutes les catégories",
    "categories": {
      "bo": "BO – offre ferme",
      "grundbuchauszug": "Extrait du registre foncier",
      "korrespondenz": "Correspondance",
      "legitimation": "Légitimation",
      "nbo": "NBO – offre indicative",
      "nda": "NDA",
      "sonstiges": "Divers",
      "vertrag": "Contrat"
    },
    "categoriesFilled": "{{done}} sur {{total}} catégories remplies",
    "category": "Catégorie",
    "categoryChanged": "Catégorie modifiée",
    "changeCategory": "Modifier la catégorie",
    "combinedDownload": "Téléchargement combiné",
    "customCategoryPlaceholder": "Nom de la catégorie...",
    "delete": "Supprimer le document",
    "deleteConfirm": "Voulez-vous vraiment supprimer «{{name}}» ?",
    "deleteSuccess": "Document supprimé",
    "description": "Description",
    "documentPlural": "documents",
    "documentSingular": "document",
    "documentsCount": "document(s)",
    "dossierCategories": {
      "amtliche_schaetzung": "Estimation officielle",
      "baubeschrieb": "Descriptif de construction",
      "bewertungsgutachten": "Rapport d'évaluation",
      "grundbuchauszug": "Extrait du registre foncier",
      "grundrisse": "Plans d'étage / Plans",
      "investitionen": "Investissements",
      "investorendossier": "Exposé",
      "katasterplan": "Plan cadastral / RDPPF",
      "liegenschaftenabrechnung": "Décompte immobilier",
      "mieterspiegel": "Indice des loyers",
      "mietvertraege": "Contrats de bail",
      "renovationen": "Rénovations"
    },
    "dossierGroups": {
      "custom": "Personnalisé",
      "investor_dossier": "Exposé",
      "supplementary": "Documents complémentaires",
      "valuation": "Documents d'évaluation"
    },
    "dossierProgress": "Complétude du dossier",
    "dossierSummary": "{{total}} document(s) dans {{categories}} de {{totalCategories}} catégories",
    "dossierTooltips": {
      "amtliche_schaetzung": "Rapport d'estimation officiel actuel de l'autorité fiscale cantonale ou de l'assurance bâtiment.",
      "baubeschrieb": "Descriptif de construction officiel de l'objet selon la demande de permis de construire ou la documentation de vente, avec indications sur le mode de construction, les matériaux et le standard d'aménagement.",
      "bewertungsgutachten": "Expertise indépendante de valeur vénale ou de valeur de marché par un expert estimateur reconnu.",
      "grundbuchauszug": "Extrait actuel du registre foncier de l'office compétent (datant de moins de 6 mois). Le document doit contenir le propriétaire, le numéro de parcelle, les servitudes et les gages immobiliers.",
      "grundrisse": "Plans d'étage à l'échelle de tous les niveaux avec indications de surface.",
      "investitionen": "Investissements documentés des dernières années avec factures ou récapitulatif des rénovations majeures.",
      "investorendossier": "Exposé complet avec description de l'objet, chiffres clés financiers et analyse de l'emplacement.",
      "katasterplan": "Plan cadastral officiel de l'office de mensuration avec limites de parcelle, numéros de bien-fonds et désignation de l'emplacement. Y compris extrait RDPPF si disponible.",
      "liegenschaftenabrechnung": "Dernier décompte annuel de l'immeuble avec charges d'exploitation et d'entretien.",
      "mieterspiegel": "Aperçu de tous les locataires avec loyer, surface et début du bail.",
      "mietvertraege": "Contrats de bail complets et signés de tous les rapports de location existants, y compris les avenants et conventions.",
      "renovationen": "Aperçu ou documentation des rénovations effectuées avec date et étendue des travaux."
    },
    "download": "Télécharger",
    "fileSize": "Taille",
    "fileTooLarge": "Le fichier «{{name}}» est trop volumineux (max. 50 Mo)",
    "filename": "Nom du fichier",
    "generate": "Générer",
    "generateFailed": "Échec de la génération du document",
    "generated": "{{type}} généré avec succès",
    "generatedAt": "Généré le",
    "immotronDocuments": "Documents Immotron",
    "inCategories": "dans {{count}} catégories",
    "link": "Lier",
    "linkExisting": "Lier un document",
    "linkNoResults": "Aucun document trouvé",
    "linkSearchPlaceholder": "Rechercher un document...",
    "linkSuccess": "Document lié",
    "mergingDocuments": "Fusion des documents...",
    "noCategory": "Sans catégorie",
    "noDocuments": "Aucun document",
    "noDocumentsShort": "Aucun document",
    "notGenerated": "Pas encore généré",
    "onlyMissing": "Manquants",
    "openInBrowser": "Ouvrir dans le navigateur",
    "originalDocuments": "Documents originaux",
    "pageOf": "Page {{current}} sur {{total}}",
    "preview": "Aperçu",
    "previewUnavailable": "Aperçu non disponible",
    "regenerate": "Régénérer",
    "requiredDocsTitle": "Documents obligatoires",
    "requiredDocsProgress": "{{done}} sur {{total}} documents obligatoires disponibles",
    "saveAsDraft": "Enregistrer comme brouillon",
    "saveFirstForDocuments": "Veuillez d'abord sauvegarder le bien pour pouvoir télécharger des documents.",
    "selectCategory": "Choisir une catégorie",
    "showOnlyMissing": "Afficher uniquement les documents manquants",
    "subgroup": {
      "label": "Sous-groupe",
      "placeholder": "p. ex. extraits ÖREB",
      "saved": "Sous-groupe enregistré"
    },
    "title": "Documents",
    "uncategorized": "Documents non classés",
    "unsupportedType": "Le type de fichier de «{{name}}» n'est pas supporté",
    "upload": "Télécharger un document",
    "uploadCategory": "Catégorie pour les nouveaux documents",
    "uploadDragDrop": "Glisser les fichiers ici ou cliquer pour télécharger",
    "uploadFirst": "Téléchargez le premier document",
    "uploadHint": "PDF, Word, Excel, images. Max. 50 Mo.",
    "uploadMore": "Télécharger d'autres fichiers",
    "uploadSuccess": "Document téléchargé",
    "uploadedAt": "Téléchargé le",
    "viaContact": "via {{name}}"
  },
  "emailAccounts": {
    "addImap": "Ajouter un compte IMAP",
    "autoFillHint": "Les champs ont été pré-remplis depuis votre profil",
    "cancel": "Annuler",
    "changeScope": "Firmenzuordnung ändern",
    "company": "Firma",
    "companyAccounts": "Boîtes d'entreprise",
    "connect": "Connecter",
    "connectGoogle": "Google verbinden",
    "connectMicrosoft": "Microsoft verbinden",
    "connected": "Verbunden",
    "connecting": "Connexion...",
    "deactivated": "Deaktiviert",
    "disconnect": "Konto trennen",
    "displayName": "Nom d'affichage",
    "emailAddress": "Adresse e-mail",
    "errors": {
      "connectFailed": "Échec de la connexion",
      "deleteFailed": "Erreur lors de la déconnexion",
      "invalidOAuthState": "Ungültiger OAuth-State — bitte erneut versuchen",
      "loadFailed": "Impossible de charger les comptes e-mail",
      "oauthFailed": "OAuth-Verbindung fehlgeschlagen",
      "scopeChangeFailed": "Impossible de modifier l'attribution",
      "tokenRefreshFailed": "Token-Erneuerung fehlgeschlagen — erneut verbinden"
    },
    "goToSettings": "Zu den Einstellungen",
    "imapFormTitle": "Ajouter manuellement un compte IMAP/SMTP",
    "imapHost": "Serveur IMAP",
    "imapPort": "Port IMAP",
    "loadError": "E-Mail-Konten konnten nicht geladen werden",
    "loading": "Konten werden geladen...",
    "noAccounts": "Aucun compte e-mail connecté",
    "noAccountsHint": "Connectez un compte Google, Microsoft ou IMAP",
    "notSynced": "Noch nicht synchronisiert",
    "password": "Mot de passe",
    "private": "Privat",
    "privateAccounts": "Boîtes privées",
    "reconnect": "Erneut verbinden",
    "refreshToken": "Token erneuern",
    "scope": "Attribution",
    "scopePrivate": "Privé (uniquement pour moi)",
    "smtpHost": "Serveur SMTP",
    "smtpPort": "Port SMTP",
    "subtitle": "Connecter des boîtes Google, Microsoft ou IMAP",
    "success": {
      "connected": "Compte e-mail connecté",
      "deleted": "Compte e-mail déconnecté",
      "scopeChanged": "Attribution mise à jour",
      "tokenRefreshed": "Token erneuert"
    },
    "syncTime": {
      "justNow": "gerade eben"
    },
    "thisCompany": "diese Firma",
    "title": "Comptes e-mail",
    "useTls": "Utiliser TLS"
  },
  "emailScore": {
    "level": "Score e-mail : {{level}}/5",
    "star1": "Syntaxe valide",
    "star2": "Domaine existant",
    "star3": "Enregistrement MX présent",
    "star4": "Boîte aux lettres joignable",
    "star5": "Livraison confirmée"
  },
  "emailAttachments": {
    "addShort": "Joindre",
    "all": "Tous",
    "confirm": "Valider",
    "empty": "Aucun document disponible. Téléchargez un fichier.",
    "emptyFilter": "Aucun document dans cette catégorie.",
    "selected": "{{count}} sélectionné(s)",
    "sourceCompany": "Entreprise",
    "sourceContact": "Contact",
    "sourceProperty": "Objet",
    "sourceTask": "Tâche",
    "title": "Joindre des documents",
    "uploadHint": "Télécharger un fichier",
    "uploading": "Téléchargement..."
  },
  "emailSignature": {
    "defaultTemplate": "Modèle par défaut",
    "emailHint": "Repris de votre compte e-mail (onglet «Comptes e-mail»).",
    "errors": {
      "loadFailed": "Impossible de charger les signatures",
      "previewFailed": "Impossible de charger l'aperçu",
      "saveFailed": "Impossible d'enregistrer la signature"
    },
    "fields": {
      "email": "E-mail",
      "function": "Fonction",
      "name": "Nom",
      "phone": "Téléphone"
    },
    "fullPreview": "Aperçu complet de l'e-mail",
    "infoText": "Configurez votre signature e-mail personnelle par mandant. Le nom, la fonction et l'e-mail sont repris de votre profil. Vous pouvez ajuster le numéro de téléphone et le modèle ici.",
    "livePreview": "Aperçu en direct",
    "noCompanies": "Aucune affiliation",
    "noCompaniesDesc": "Vous n'êtes affecté à aucun mandant. Demandez à un administrateur de vous ajouter.",
    "noSignatureYet": "Aucune donnée de signature disponible. Veuillez compléter votre profil.",
    "noTemplate": "Aucun modèle (signature uniquement)",
    "personal": "Personnel",
    "preview": "Aperçu",
    "previewTitle": "Aperçu e-mail — {{company}}",
    "saved": "Signature e-mail enregistrée",
    "signatureDetails": "Détails de la signature",
    "signaturePreview": "Aperçu de la signature",
    "subtitle": "Configurez votre signature e-mail et modèle par défaut par mandant",
    "tabLabel": "Signature e-mail",
    "template": "Modèle",
    "templateHint": "Seuls les modèles personnels sont affichés. Le modèle est utilisé pour les e-mails de l'Agent CEO.",
    "templateReadonlyHint": "Le modèle est géré par l'administrateur sous Paramètres > Modèles d'e-mail.",
    "title": "Signature e-mail personnelle"
  },
  "emailTemplates": {
    "active": "Actif",
    "allCompanies": "Tous les mandants",
    "categories": {
      "all": "Tous",
      "contract-signing": "Signature de contrat",
      "marketing": "Marketing",
      "notification": "Notifications"
    },
    "category": "Categorie",
    "categoryPlaceholder": "z.B. Immobilien, Newsletter",
    "confirmDelete": "Voulez-vous vraiment supprimer ce modele ?",
    "confirmDeleteDescription": "Etes-vous sur de vouloir supprimer ce modele ?",
    "createSuccess": "Modele créé avec succès",
    "deleteSuccess": "Modele supprimé avec succès",
    "deleteTemplate": "Supprimer le modele",
    "deleted": "Le modele a ete supprime.",
    "description": "Description",
    "editTemplate": "Modifier le modele",
    "errors": {
      "deleteFailed": "Le modele n'a pas pu etre supprime.",
      "loadFailed": "Impossible de charger les modeles",
      "saveFailed": "Le modele n'a pas pu etre enregistre."
    },
    "inactive": "Inactif",
    "list": {
      "empty": {
        "description": "Creez votre premier modele",
        "title": "Aucun modele"
      }
    },
    "name": "Nom",
    "newTemplate": "Nouveau modele",
    "personalOnly": "Persönliche Vorlage (nur für mich sichtbar)",
    "saved": "Le modele a ete enregistre.",
    "scopeCompany": "Firmenvorlage",
    "scopeCompanyLabel": "Firma",
    "scopePersonal": "Persönliche Vorlage",
    "scopePersonalLabel": "Persönlich",
    "search": "Rechercher des modeles...",
    "subtitle": "Modeles reutilisables pour campagnes",
    "title": "Modeles d'e-mail",
    "updateSuccess": "Modele mis à jour avec succès"
  },
  "emailTracking": {
    "expired": "Expiré",
    "pending": "En attente",
    "resend": "Renvoyer",
    "resendConfirm": "Renvoyer l'e-mail de signature à {{name}} ?",
    "resendFailed": "Échec de l'envoi de l'e-mail",
    "resendSuccess": "E-mail renvoyé à {{email}}",
    "steps": {
      "clicked": "Lien cliqué",
      "opened": "Ouvert",
      "sent": "Envoyé",
      "signed": "Signé"
    },
    "title": "Signatures & livraison"
  },
  "emails": {
    "account": "Konto:",
    "attachments": "Anhänge",
    "bulkDeleteConfirmDescription": "Die ausgewählten Emails werden dauerhaft gelöscht und können nicht wiederhergestellt werden. Sie werden auch beim E-Mail-Provider entfernt.",
    "bulkDeleteConfirmLabel": "Alle löschen",
    "bulkDeleteFailed": "Emails konnten nicht gelöscht werden",
    "classification": {
      "actionable": "Aktion",
      "ignored": "Ignoriert"
    },
    "createTask": "Pendenz erstellen",
    "date": "Datum:",
    "deleteConfirmDescription": "Die Email wird dauerhaft gelöscht und kann nicht wiederhergestellt werden. Sie wird auch beim E-Mail-Provider entfernt.",
    "deleteConfirmTitle": "Email löschen?",
    "deleteEmail": "Email löschen",
    "deleteFailed": "Email konnte nicht gelöscht werden",
    "deleted": "Email gelöscht",
    "deselectAll": "Auswahl aufheben",
    "detailLoadFailed": "Email konnte nicht geladen werden",
    "editor": {
      "bold": "Fett (Ctrl+B)",
      "bulletList": "Aufzählung",
      "enterImageUrl": "Bild-URL eingeben:",
      "enterUrl": "URL eingeben:",
      "heading1": "Überschrift 1",
      "heading2": "Überschrift 2",
      "heading3": "Überschrift 3",
      "insertImage": "Bild einfügen (URL)",
      "insertLink": "Link einfügen",
      "italic": "Kursiv (Ctrl+I)",
      "orderedList": "Nummerierte Liste",
      "redo": "Wiederholen (Ctrl+Shift+Z)",
      "removeColor": "Farbe entfernen",
      "removeLink": "Link entfernen",
      "textColor": "Textfarbe",
      "underline": "Unterstrichen (Ctrl+U)",
      "undo": "Rückgängig (Ctrl+Z)"
    },
    "enrichContact": "Kontakt anreichern",
    "filters": {
      "actionable": "Aktion nötig",
      "alert": "Alert",
      "allAccounts": "Alle Konten",
      "allDirections": "Alle Richtungen",
      "allTypes": "Alle Typen",
      "ignored": "Ignoriert",
      "inbound": "Eingehend",
      "informational": "Info",
      "outbound": "Gesendet",
      "read": "Gelesen",
      "unread": "Ungelesen"
    },
    "from": "Von:",
    "goToTask": "Zur Pendenz",
    "loadFailed": "Emails konnten nicht geladen werden",
    "markRead": "Als gelesen markieren",
    "markUnread": "Als ungelesen markieren",
    "noContent": "Kein Inhalt verfügbar",
    "noEmails": "Keine Emails vorhanden",
    "noResults": "Keine Ergebnisse",
    "noSubject": "(Kein Betreff)",
    "replyNotAvailable": "Les réponses s'envoient depuis votre compte de messagerie — Immotron affiche uniquement la conversation.",
    "searchPlaceholder": "Emails durchsuchen...",
    "syncFailed": "Sync fehlgeschlagen",
    "taskCreateFailed": "Pendenz konnte nicht erstellt werden",
    "thread": {
      "empty": "Aucun message dans cette conversation",
      "inbound": "Reçu",
      "loadFailed": "Impossible de charger la conversation",
      "messages": "{{count}} messages",
      "openEmail": "Ouvrir l'e-mail : {{subject}}",
      "openInInbox": "Ouvrir dans la boîte de réception",
      "outbound": "Envoyé",
      "reply": "Répondre",
      "title": "Conversation"
    },
    "title": "Emails",
    "to": "An:",
    "updateFailed": "Fehler beim Aktualisieren"
  },
  "entityInput": {
    "addPersonManually": "Person manuell hinzufügen",
    "address": "Adresse",
    "addressPlaceholder": "Strasse, PLZ Ort",
    "available": "verfügbar",
    "buyerName": "Name des Käufers",
    "capital": "Kapital",
    "clearSelection": "Auswahl löschen",
    "collectiveMoreRequired": "Kollektivunterschrift: mindestens 2 Personen erforderlich",
    "collectiveTwoRequired": "Kollektivunterschrift zu zweien: mindestens 2 Personen erforderlich",
    "company": "Firma",
    "companyName": "Firmenname",
    "crmBadge": "CRM",
    "crmContactsSection": "Contacts CRM",
    "deselectAll": "Keine auswählen",
    "email": "E-Mail",
    "emailForSignature": "E-Mail-Adresse für Vertragsunterschrift",
    "emailPlaceholder": "E-Mail-Adresse eingeben",
    "emailRequiredForSignature": "E-Mail wird für die Signatur benötigt",
    "fetchPdfFromRegister": "PDF vom Handelsregister abrufen",
    "fetchedAt": "Abgerufen",
    "fullNamePlaceholder": "Vor- und Nachname",
    "loadingCrmContacts": "Chargement des contacts CRM...",
    "manualPersonHint": "Erfassen Sie eine Person, die gemäss internem Kontrollsystem (IKS) zeichnungsberechtigt ist, aber nicht im Handelsregister eingetragen.",
    "manuallyAdded": "Manuell erfasst (IKS)",
    "noSignatoriesFound": "Keine Zeichnungsberechtigten in der Zefix-API gefunden.",
    "noSignatoriesInPdf": "Keine Zeichnungsberechtigten im PDF gefunden",
    "partnerName": "Name des Partners",
    "pdfFetchFailed": "PDF konnte nicht abgerufen werden",
    "pdfFetchHint": "Dies kann einige Sekunden dauern",
    "pdfFetching": "PDF wird abgerufen...",
    "private": "Privatperson",
    "searchCommercialRegister": "Firma im Handelsregister suchen",
    "searchPlaceholder": "Firmenname oder UID eingeben...",
    "selectAll": "Alle auswählen",
    "selectSignatories": "Zeichnungsberechtigte auswählen",
    "sellerName": "Name des Verkäufers",
    "signatories": "Zeichnungsberechtigte",
    "signatureType": "Unterschriftstyp",
    "zefixBadge": "Zefix",
    "zefixRevert": "Supprimer Zefix",
    "zefixRevertTitle": "Annuler les données Zefix",
    "zefixRevertConfirm": "Tous les contacts Zefix de cette organisation seront désactivés et le lien Zefix supprimé. Les contacts épinglés seront conservés.",
    "zefixRevertConfirmLabel": "Annuler",
    "zefixRevertFailed": "Échec de la réversion Zefix"
  },
  "entityAttachPicker": {
    "title": "Épingler la note",
    "subtitle": "À quelle entité épingler la note ?",
    "tabsAriaLabel": "Choisir le type d'entité",
    "tabContact": "Contact",
    "tabCompany": "Société",
    "tabProperty": "Bien",
    "searchContact": "Rechercher un contact...",
    "searchCompany": "Rechercher une société...",
    "searchProperty": "Rechercher un bien...",
    "minChars": "Saisissez au moins 2 caractères",
    "noResults": "Aucun résultat",
    "startTyping": "Commencez à saisir pour rechercher.",
    "suggestionsHeading": "Depuis le contexte de la tâche",
    "suggestionCount": "{{count}} suggestion",
    "suggestionCount_other": "{{count}} suggestions",
    "attached": "Note épinglée à {{label}}",
    "attachError": "Échec de l'épinglage"
  },
  "entityKnowledge": {
    "createdBy": "Saisi par {{name}}",
    "emptyCompany": "Pas encore de connaissances pour cette société. Épinglez des notes dans une tâche à la société pour qu'elles apparaissent ici.",
    "emptyContact": "Pas encore de connaissances pour ce contact. Épinglez des notes dans une tâche au contact pour qu'elles apparaissent ici.",
    "emptyProperty": "Pas encore de connaissances pour ce bien. Épinglez des notes dans une tâche au bien pour qu'elles apparaissent ici.",
    "loadError": "Impossible de charger les connaissances.",
    "openTask": "Ouvrir la tâche",
    "subtitle": "{{count}} notes — épinglées depuis des tâches."
  },
  "errors": {
    "duplicateEmail": {
      "companyTitle": "E-mail déjà associé à une organisation",
      "contactTitle": "E-mail déjà associé à un contact",
      "existingEntry": "Entrée existante",
      "openCompany": "Ouvrir l'organisation",
      "openContact": "Ouvrir le contact"
    },
    "forbidden": "Accès refusé",
    "general": "Une erreur s'est produite",
    "network": "Erreur réseau",
    "notFound": "Non trouvé",
    "server": "Erreur serveur",
    "unauthorized": "Non autorisé",
    "unexpected": "Erreur inattendue",
    "unexpectedDescription": "Une erreur inattendue s'est produite. Veuillez reessayer.",
    "validation": "Erreur de validation"
  },
  "favorites": {
    "addToList": "Ajouter à la liste de suivi",
    "added": "Ajouté à la liste de suivi",
    "allCantons": "Tous les cantons",
    "allStatuses": "Tous les statuts",
    "allTypes": "Tous les types",
    "browseProperties": "Parcourir les biens",
    "empty": "Aucun favori enregistré",
    "emptyHint": "Marquez des biens avec l'icône cœur pour les voir ici",
    "filterCanton": "Canton",
    "filterStatus": "Statut",
    "filterType": "Type de bien",
    "notifications": {
      "active": "actif",
      "award": "Attribution",
      "disableAll": "Tout desactiver",
      "enableAll": "Tout activer",
      "newDocuments": "Nouveaux documents",
      "offerPhase": "Phase d'offre",
      "priceChange": "Changements de prix",
      "statusChange": "Changements de statut",
      "title": "Notifications"
    },
    "properties": "Biens",
    "removeFromList": "Retirer de la liste de suivi",
    "removed": "Retiré de la liste de suivi",
    "sortBy": "Trier par",
    "sortCity": "Ville",
    "sortDate": "Date",
    "sortPrice": "Prix",
    "title": "Liste de suivi",
    "toggleFailed": "Erreur lors de la mise à jour de la liste de suivi"
  },
  "fundRadar": {
    "asOf": "État : {{date}}",
    "capacity": "Capacité d’achat",
    "capacityGreen": "argent frais",
    "capacityGrey": "aucun indice",
    "capacityRed": "bloquée",
    "capacityYellow": "possible",
    "colAgio": "Prime",
    "colAsOf": "État",
    "colAum": "AUM",
    "colCompany": "Société",
    "colFund": "Véhicule",
    "colLtv": "LTV",
    "colReason": "Pourquoi",
    "colSignals": "Feux",
    "empty": "Aucun véhicule avec ce signal.",
    "filterAll": "Tous",
    "filterAria": "Filtrer par signal",
    "filterBuy": "Achète",
    "filterNone": "Sans signal",
    "filterSell": "Vend",
    "noValue": "Aucune indication",
    "openCompany": "Ouvrir l’organisation « {{name}} »",
    "pressure": "Pression à la vente",
    "pressureGrey": "aucun indice",
    "pressureRed": "élevée",
    "pressureYellow": "moyenne",
    "searchLabel": "Rechercher un véhicule ou une société",
    "searchPlaceholder": "Rechercher un véhicule ou une société …",
    "subtitle": "Pression à la vente rouge = fin de durée, fusion ou rachats. Capacité d’achat verte = argent frais (augmentation de capital, souscriptions ouvertes). Une décote signifie que le véhicule ne peut pas lever de fonds propres, mais qu’il n’est pas obligé de vendre.",
    "title": "Radar des fonds"
  },
  "help": {
    "close": "Fermer",
    "contacts": {
      "description": "Gérez toutes les personnes de contact et signataires autorisés.",
      "steps": [
        "Créez de nouveaux contacts avec 'Nouveau contact'",
        "Assignez des contacts à une ou plusieurs entreprises",
        "Créez un compte utilisateur pour le contact si nécessaire"
      ],
      "tips": [
        "Les contacts peuvent être assignés à plusieurs entreprises",
        "L'autorité de signature est définie par entreprise",
        "Les comptes utilisateurs permettent la connexion à la plateforme"
      ],
      "title": "Contacts"
    },
    "contextual": "Aide pour cette page",
    "contractGenerator": {
      "description": "Créez des contrats professionnels en quelques étapes.",
      "steps": [
        "Étape 1: Sélectionnez un modèle (CGV, Contrat acheteur, etc.)",
        "Étape 2: Remplissez les données requises",
        "Étape 3: Vérifiez l'aperçu du contrat",
        "Étape 4: Collectez les signatures",
        "Étape 5: Téléchargez le PDF finalisé"
      ],
      "tips": [
        "Utilisez la recherche Zefix pour charger automatiquement les données d'entreprise",
        "Les signatures peuvent être faites à la souris ou au doigt sur les appareils tactiles",
        "Les adresses e-mail sont validées (vérification MX)"
      ],
      "title": "Générateur de contrats"
    },
    "contracts": {
      "description": "Créez et gérez vos contrats numériquement.",
      "steps": [
        "Cliquez sur 'Nouveau contrat' pour créer un contrat",
        "Sélectionnez un modèle de contrat",
        "Remplissez les parties et les données",
        "Vérifiez l'aperçu",
        "Collectez les signatures numériques"
      ],
      "tips": [
        "Les contrats ne peuvent être supprimés qu'en statut 'Brouillon'",
        "Vous pouvez enregistrer les contrats comme brouillons et les signer plus tard",
        "Toutes les signatures sont enregistrées avec horodatage et optionnellement avec localisation"
      ],
      "title": "Contrats"
    },
    "dashboard": {
      "description": "Votre aperçu central de toutes les informations importantes et actions rapides.",
      "steps": [
        "Consultez vos statistiques en un coup d'œil",
        "Utilisez les actions rapides pour les tâches fréquentes",
        "Basculez entre vos entreprises assignées"
      ],
      "tips": [
        "Utilisez le filtre d'entreprise en haut à droite pour filtrer les données par entreprise"
      ],
      "title": "Tableau de bord"
    },
    "general": "Aide générale",
    "organizations": {
      "description": "Gérez les entreprises et leurs signataires autorisés.",
      "steps": [
        "Les entreprises sont automatiquement enregistrées lors de la conclusion des contrats",
        "Cliquez sur une entreprise pour voir les contacts",
        "Utilisez 'Actualiser depuis Zefix' pour charger les données actuelles du registre du commerce"
      ],
      "tips": [
        "Les contacts épinglés ne sont pas désactivés lors de la synchronisation Zefix",
        "Les contacts manuels sont automatiquement épinglés",
        "Les contacts avec des signatures de contrat ne peuvent pas être supprimés"
      ],
      "title": "Organisations"
    },
    "properties": {
      "description": "Gérez votre portefeuille immobilier.",
      "steps": [
        "Ajoutez de nouvelles propriétés avec tous les détails",
        "Téléchargez des images et documents",
        "Gérez le statut (Brouillon, Actif, Réservé, Vendu)"
      ],
      "tips": [
        "Les propriétés en statut 'Brouillon' ne sont pas visibles publiquement",
        "Les descriptions multilingues sont possibles"
      ],
      "title": "Propriétés"
    },
    "settings": {
      "description": "Configuration et administration du système.",
      "steps": [
        "Gérez les signataires autorisés internes",
        "Consultez le schéma de la base de données"
      ],
      "tips": [
        "Les signataires autorisés internes sont gérés ici"
      ],
      "title": "Paramètres"
    },
    "signatories": {
      "description": "Gérez les signataires autorisés internes de votre entreprise.",
      "steps": [
        "Sélectionnez un contact existant",
        "Définissez la fonction (ex: PDG)",
        "Définissez l'autorité de signature (Individuelle ou Collective)"
      ],
      "tips": [
        "Ces personnes apparaissent comme signataires sur les contrats Immotron",
        "Le texte de signature apparaît sous la signature dans le PDF"
      ],
      "title": "Signataires autorisés"
    },
    "title": "Aide",
    "users": {
      "description": "Gérez les comptes utilisateurs et les permissions.",
      "steps": [
        "Créez de nouveaux utilisateurs avec 'Ajouter utilisateur'",
        "Assignez un rôle (Admin, Ventes, Investisseur)",
        "Optionnel: Liez l'utilisateur à un contact"
      ],
      "tips": [
        "Les admins ont accès à toutes les fonctions",
        "Les utilisateurs Ventes peuvent gérer les contrats et propriétés",
        "Les investisseurs peuvent uniquement chercher et voir leur portfolio"
      ],
      "title": "Gestion des utilisateurs"
    }
  },
  "investor": {
    "access": {
      "accessCount": "{{count}} investisseur(s) avec accès",
      "accessGranted": "Accès accordé",
      "accessViaDirect": "direct",
      "accessViaGroup": "via groupe {{name}}",
      "date": "Date",
      "emailBounced": "E-mail non délivrable",
      "emailClicked": "Lien cliqué",
      "emailNotSent": "E-mail non envoyé",
      "emailOpened": "E-mail ouvert",
      "emailSent": "E-mail envoyé",
      "grantAccess": "Accorder l'accès",
      "grantSuccess": "Accès accordé avec succès",
      "grantSuccessWithEmail": "Accès accordé — l'investisseur sera notifié par e-mail",
      "groupAccessHint": "Accès via groupe — ne peut être révoqué qu'en retirant du groupe",
      "manual": "Manuel",
      "noInvestors": "Aucun investisseur avec accès",
      "revokeAccess": "Révoquer l'accès",
      "revokeConfirm": "Voulez-vous vraiment révoquer l'accès de cet investisseur ?",
      "revokeSuccess": "Accès révoqué avec succès",
      "searchHint": "Rechercher par nom ou e-mail",
      "searchInvestor": "Rechercher un investisseur...",
      "selfService": "Autonome",
      "source": "Source",
      "title": "Accès investisseurs"
    },
    "activity": {
      "bounced": "Non délivrable",
      "clicked": "Cliqué",
      "failed": "Échoué",
      "noActivity": "Aucune notification pour le moment",
      "opened": "Ouvert",
      "sent": "Envoyé",
      "title": "Notifications",
      "type": {
        "ACCESS_GRANTED": "Accès accordé",
        "DOSSIER_UPDATE": "Nouveau document",
        "INTEREST_EXPRESSED": "Intérêt confirmé",
        "INTEREST_SALES_NOTIFY": "Équipe commerciale informée"
      }
    },
    "dossier": {
      "backToTeaser": "Retour à l'aperçu",
      "clearSelection": "Annuler la selection",
      "documentsCount": "{{count}} document(s)",
      "documentsLabel": "Documents",
      "download": "Télécharger",
      "downloadPdf": "Dossier en PDF",
      "downloadUnavailable": "Téléchargement non disponible",
      "groups": {
        "custom": "Personnalisé",
        "investor_dossier": "Exposé",
        "supplementary": "Documents complémentaires",
        "valuation": "Documents d'évaluation"
      },
      "lastUpload": "Dernier téléchargement",
      "newBadge": "Nouveau",
      "newCount": "{{count}} nouveau(x)",
      "noAccess": "Pas d'accès",
      "noAccessHint": "Vous avez besoin d'un accès à l'exposé. Veuillez d'abord exprimer votre intérêt.",
      "noDocuments": "Aucun document dans cette catégorie",
      "offerHint": "Vente à prix fixe — soumettez votre offre sur la page de l’objet.",
      "pdfDownloaded": "PDF du dossier telecharge",
      "pdfFailed": "Le telechargement du PDF a echoue",
      "previewSelected": "Apercu",
      "selected": "selectionne(s)",
      "subtitle": "Documentation complète",
      "title": "Exposé"
    },
    "expose": {
      "pages": "{{count}} pages",
      "read": "Lire l'exposé",
      "title": "Exposé"
    },
    "interest": {
      "agbNote": "En exprimant votre intérêt, vous confirmez que les CGV et les dispositions de confidentialité de votre abonnement s'appliquent.",
      "alreadyExpressed": "Vous avez déjà exprimé votre intérêt pour ce bien.",
      "confirm": "Confirmer l'intérêt",
      "description": "Vous exprimez votre intérêt pour le bien suivant :",
      "salesNotified": "L'équipe commerciale a été informée de votre intérêt.",
      "success": "Intérêt exprimé avec succès",
      "successHint": "Vous avez maintenant accès à l'exposé complet.",
      "successWithEmail": "Confirmation envoyée par e-mail. Vous avez maintenant accès au dossier.",
      "title": "Exprimer son intérêt"
    },
    "listing": {
      "includedProperties": "Biens inclus",
      "ndaConfirmAccess": "Confirmer le NDA et obtenir l'accès",
      "ndaConfirmHint": "Confirmez l'accord de confidentialité pour accéder au dossier complet.",
      "properties": "Biens",
      "propertyIndex": "Bien {{index}}",
      "submitOffer": "Soumettre une offre",
      "totalPrice": "Prix total"
    },
    "nda": {
      "bracketFrom": "à partir de {{from}}",
      "bracketRange": "{{from}} à {{to}}",
      "bracketsTitle": "Commission de l'acheteur (paliers sur le prix d'achat) :",
      "checkbox": "J'ai lu l'accord de confidentialité et je l'accepte.",
      "commissionModel": "Modèle de commission",
      "conditionsCheckbox": "J'ai lu les conditions pour ce bien et je les accepte.",
      "conditionsLoading": "Chargement des conditions …",
      "conditionsTitle": "Conditions pour ce bien",
      "confidentialityText": "Toutes les informations mises à votre disposition dans le cadre de cet exposé sont strictement confidentielles. Vous vous engagez à ne pas divulguer ces informations à des tiers et à les utiliser exclusivement pour évaluer l'opportunité d'investissement.",
      "confidentialityTitle": "Confidentialité",
      "confirm": "Confirmer et ouvrir le dossier",
      "criteriaText": "Vous confirmez que ce bien correspond à vos critères d'investissement et que vous disposez des moyens financiers nécessaires pour réaliser une éventuelle transaction.",
      "criteriaTitle": "Critères d'investissement",
      "decline": "Retour",
      "dueNote": "La commission est due lors de l'authentification du contrat de vente.",
      "findersFeeText": "En cas de réalisation d'une transaction, une commission d'intermédiation sera due conformément aux conditions convenues. Contourner l'intermédiaire n'est pas autorisé.",
      "findersFeeTitle": "Commission d'intermédiation",
      "flatRate": "Taux unique : {{rate}} du prix d'achat.",
      "noModel": "Aucun modèle de commission n'est actuellement enregistré pour ce bien. Les conditions sont réglées dans le contrat-cadre acheteur ou dans l'annexe B relative au bien.",
      "sourceAppendixB": "Spécifique au bien (annexe B)",
      "sourceDefault": "Conditions standard",
      "specialConditionsTitle": "Conditions particulières",
      "successContinue": "Accéder au dossier",
      "successText": "Votre confirmation a été enregistrée. Vous avez accepté ces conditions :",
      "successTitle": "NDA et conditions confirmés",
      "title": "Accord de confidentialité (NDA)",
      "vatNote": "Tous les montants de commission s'entendent hors TVA légale.",
      "objection": {
        "button": "Ne pas accepter les conditions",
        "title": "Refuser les conditions",
        "intro": "Indiquez le taux souhaité et motivez votre objection. La partie venderesse examine la contre-proposition — d'ici là, vous n'obtenez pas accès aux données de l'objet.",
        "rateLabel": "Taux souhaité (facultatif)",
        "ratePlaceholder": "p. ex. 2.5",
        "rateHint": "Pourcentage du prix d'achat. Sans indication, seule la motivation est transmise.",
        "reasonLabel": "Motivation",
        "reasonPlaceholder": "Pourquoi n'acceptez-vous pas les conditions ?",
        "reasonRequired": "Sans motivation, l'objection ne peut pas être envoyée.",
        "back": "Retour",
        "submit": "Envoyer l'objection",
        "sentTitle": "Objection transmise",
        "sentText": "Votre objection a été enregistrée. La partie venderesse examine votre contre-proposition et prendra contact avec vous. D'ici là, les données de l'objet restent fermées."
      }
    },
    "search": {
      "accessGranted": "Accès accordé",
      "allCantons": "Tous les cantons",
      "allTypes": "Tous les types",
      "areaFrom": "Surface dès (m²)",
      "areaTo": "Surface jusqu'à (m²)",
      "canton": "Canton",
      "clearFilters": "Réinitialiser les filtres",
      "contractError": {
        "CONTRACT_EXPIRED": {
          "message": "Votre contrat de plateforme a expiré. Veuillez contacter votre interlocuteur pour le renouvellement.",
          "title": "Contrat de plateforme expiré"
        },
        "NO_ACTIVE_CONTRACT": {
          "message": "Il n'y a pas de contrat de plateforme actif. Veuillez contacter votre interlocuteur.",
          "title": "Aucun contrat de plateforme actif"
        }
      },
      "errorTitle": "Erreur de chargement",
      "filters": "Filtres",
      "loadError": "Les biens n'ont pas pu être chargés. Veuillez réessayer.",
      "noResults": "Aucun bien trouvé",
      "noResultsHint": "Modifiez vos critères de recherche",
      "placeholder": "Ville, région ou NPA...",
      "priceFrom": "Prix dès (CHF)",
      "priceRange": "Fourchette de prix",
      "priceTo": "Prix jusqu'à (CHF)",
      "resultsCount": "{{count}} biens trouvés",
      "sortNewest": "Plus récents",
      "sortPriceAsc": "Prix croissant",
      "sortPriceDesc": "Prix décroissant",
      "sortSizeDesc": "Plus grands",
      "subtitle": "Trouvez votre prochain investissement",
      "title": "Recherche immobilière"
    },
    "teaser": {
      "accessGranted": "Accès accordé",
      "accessGrantedHint": "Vous avez accès à l'exposé complet de ce bien.",
      "approximateLocation": "Emplacement approximatif",
      "atAGlance": "En un coup d'œil",
      "backToSearch": "Retour à la recherche",
      "buildingPermit": "Permis de construire",
      "confirmNda": "Je confirme l'accord de confidentialité (NDA)",
      "description": "Description",
      "emptyGallery": "Images à venir",
      "exclusiveMandate": "Mandat exclusif hors marché",
      "financial": {
        "title": "Indicateurs financiers",
        "grossYield": "Rendement brut",
        "netYield": "Rendement net",
        "annualIncome": "Revenu locatif p.a.",
        "factor": "Facteur (× loyer annuel)",
        "vacancy": "Vacance",
        "pricePerSqm": "Prix/m²",
        "rentPerSqm": "Loyer/m² p.a.",
        "netYieldAssumption": "Hypothèse : 18% de frais d'exploitation"
      },
      "locked": "Après NDA",
      "lockedLocation": "Emplacement après NDA",
      "lockedLocationHint": "L'emplacement exact devient visible après la signature de l'accord de confidentialité.",
      "region": "Région {{canton}}",
      "regionAddress": "{{region}} · adresse exacte après NDA",
      "ndaRequired": "NDA requis",
      "lockedLocationPlaceholder": "Le bien est idéalement situé dans une commune établie, avec de bonnes liaisons de transports publics ainsi que des commerces et des écoles à proximité immédiate.",
      "signNda": "Signer le NDA",
      "technicalDetails": "Détails techniques",
      "detailLabels": {
        "buildingCount": "Nombre de bâtiments",
        "cadastreNumber": "N° cadastral",
        "commercialUnits": "Unités commerciales",
        "condition": "État",
        "constructionYear": "Année de construction",
        "egridNumber": "N° E-GRID",
        "garageParking": "Parking en garage",
        "heatingSystem": "Système de chauffage",
        "lotSize": "Surface du terrain",
        "outdoorParking": "Parking extérieur",
        "propertyType": "Catégorie / Type d'utilisation",
        "renovation": "Rénovation",
        "residentialUnits": "Unités résidentielles",
        "usableArea": "Surface utile",
        "utilizationFactor": "Indice d'utilisation",
        "volume": "Volume"
      },
      "details": "Détails",
      "expressInterest": "Exprimer son intérêt",
      "grossYield": "Rendement brut",
      "highlights": "Points forts de l'investissement",
      "interestedHint": "Exprimez votre intérêt pour accéder au dossier complet.",
      "interestedTitle": "Intéressé par ce bien ?",
      "keyFacts": "Chiffres clés",
      "location": "Emplacement",
      "macroLocation": "Macro-situation",
      "microLocation": "Micro-situation",
      "netYield": "Rendement net",
      "ownership": "Type de propriété",
      "openInGoogleMaps": "Ouvrir dans Google Maps",
      "price": "Prix",
      "privateListingNotice": "Ce bien est une offre privée et n'est accessible qu'aux investisseurs sélectionnés.",
      "salesContact": "Votre interlocuteur",
      "title": "Aperçu du bien",
      "type": "Type",
      "usableArea": "Surface utile",
      "viewDossier": "Voir le dossier",
      "viewOnMaps": "Voir sur Google Maps",
      "yearBuilt": "Année de construction",
      "gallery": {
        "openFullscreen": "Ouvrir la galerie en plein écran",
        "close": "Fermer le plein écran"
      },
      "preview": {
        "previewAs": "Aperçu en tant que",
        "levels": {
          "buyer_no_nda": "Acheteur sans NDA",
          "buyer_nda": "Acheteur avec NDA",
          "internal": "Interne"
        },
        "internalBlockTitle": "Section interne",
        "internalBlockHint": "Visible uniquement par les utilisateurs internes — ne fait pas partie de la vue acheteur.",
        "investorGroups": "Groupes d'investisseurs",
        "noInvestorGroups": "Aucun groupe d'investisseurs attribué.",
        "memberCount": "{{count}} membres",
        "noMembers": "Aucun membre",
        "memberType": {
          "user": "Utilisateur",
          "company": "Entreprise",
          "contact": "Contact"
        }
      }
    },
    "viewer": {
      "close": "Fermer l'aperçu",
      "exitFullscreen": "Quitter le plein écran",
      "fullscreen": "Plein écran",
      "loadError": "L'aperçu n'a pas pu être chargé.",
      "page": "Page {{current}} sur {{total}}"
    },
    "dealStage": {
      "bo": "BO abgegeben",
      "nbo": "NBO abgegeben",
      "offer": "Angebot abgegeben",
      "nda": "NDA unterzeichnet",
      "teaser": "Teaser verfügbar"
    }
  },
  "investorContracts": {
    "active": "Contrats actifs",
    "expired": "Contrats expires",
    "subtitle": "Apercu de vos contrats",
    "title": "Mes contrats"
  },
  "investorGroups": {
    "addGroupAccess": "Accorder l'accès au groupe",
    "addMember": "Ajouter un membre",
    "addMemberSuccess": "Membre ajouté avec succès",
    "createGroup": "Créer un groupe",
    "createSuccess": "Groupe créé avec succès",
    "deleteConfirm": "Voulez-vous vraiment supprimer le groupe «{{name}}» ? Tous les accès du groupe seront révoqués.",
    "deleteGroup": "Supprimer le groupe",
    "deleteSuccess": "Groupe supprimé avec succès",
    "description": "Description",
    "editGroup": "Modifier le groupe",
    "grantAccessSuccess": "Accès de groupe accordé avec succès",
    "groupAccess": "Accès de groupe",
    "hideRecipients": "Masquer les destinataires de {{name}}",
    "memberCompanyCount": "{{count}} entreprises",
    "memberCount": "{{count}} membre(s)",
    "memberTypeCompany": "Entreprise",
    "memberTypeContact": "Contact",
    "members": "Membres",
    "name": "Nom",
    "noGroups": "Aucun groupe d'investisseurs créé",
    "noMembers": "Aucun membre dans ce groupe",
    "noRecipients": "aucun destinataire",
    "recipientCount": "{{count}} destinataire(s)",
    "removeGroupAccess": "Révoquer l'accès du groupe",
    "removeMember": "Retirer un membre",
    "removeMemberConfirm": "Voulez-vous vraiment retirer cet investisseur du groupe ?",
    "removeMemberSuccess": "Membre retiré avec succès",
    "revokeAccessSuccess": "Accès de groupe révoqué avec succès",
    "searchInvestor": "Rechercher un contact ou une entreprise …",
    "searchNoResults": "Aucun contact ou entreprise trouvé",
    "selectGroup": "Sélectionner un groupe",
    "showRecipients": "Afficher les destinataires de {{name}}",
    "skippedWithoutEmail": "{{count}} contacts sans e-mail",
    "subtitle": "Grouper les investisseurs et gérer les accès en bloc",
    "title": "Groupes d'investisseurs",
    "updateSuccess": "Groupe mis à jour avec succès"
  },
  "investorSettings": {
    "activities": {
      "empty": "Aucune activité dans cette période",
      "emptyAll": "Aucune activité pour le moment",
      "emptyHint": "Essayez une période plus longue ou sélectionnez «Tout» pour voir plus d'entrées.",
      "entries": "Entrees",
      "errorHint": "Veuillez vérifier votre connexion internet et réessayer.",
      "errorRetry": "Réessayer",
      "filter30d": "30 jours",
      "filter7d": "7 jours",
      "filter90d": "90 jours",
      "filterAll": "Tout",
      "filterLabel": "Période",
      "loadError": "Impossible de charger les activités",
      "title": "Mes activités",
      "type": {
        "CONTRACT_SIGNED": "Contrat signé",
        "DOCUMENTS_RECEIVED": "Documents reçus",
        "FAVORITE_ADDED": "Favori ajouté",
        "INQUIRY_RECEIVED": "Nouvelle demande reçue",
        "INTEREST_EXPRESSED": "Intérêt exprimé",
        "INVESTOR_INTEREST_RECEIVED": "Nouvel intérêt investisseur reçu",
        "LISTING_CREATED": "Annonce créée",
        "LISTING_PUBLISHED": "Annonce publiée",
        "MESSAGE_RECEIVED": "Message reçu",
        "NDA_CONFIRMED": "NDA confirmé",
        "OFFER_SUBMITTED": "Offre envoyée",
        "PROFILE_UPDATED": "Profil mis à jour",
        "PROPERTY_CREATED": "Bien immobilier créé",
        "VIEWING_CONFIRMED": "Visite confirmée"
      }
    },
    "contracts": {
      "contactUs": "Nous contacter",
      "downloadPdf": "Télécharger le contrat en PDF",
      "empty": "Aucun contrat trouvé",
      "expiredNotice": "Ce contrat a expiré. Veuillez nous contacter pour un renouvellement.",
      "expiresAt": "Expire le",
      "signedAt": "Signé le",
      "status": {
        "CANCELLED": "Annulé",
        "CUSTOMER_SIGNED": "Signé par le client",
        "DRAFT": "Brouillon",
        "EXPIRED": "Expiré",
        "SENT": "Envoyé",
        "SIGNED": "Signé",
        "TERMINATED": "Résilié"
      },
      "type": {
        "BROKER_AGREEMENT": "Contrat de courtage",
        "PLATFORM_AGREEMENT": "Contrat de plateforme",
        "SEARCH_MANDATE": "Mandat de recherche"
      }
    },
    "passkeys": {
      "addPasskey": "Ajouter un passkey",
      "confirmDelete": "Vraiment supprimer ?",
      "confirmDeleteBtn": "Confirmer la suppression",
      "deleteError": "Impossible de supprimer le passkey",
      "deleteSuccess": "Passkey supprimé avec succès",
      "deviceName": "Nom de l'appareil",
      "deviceNamePlaceholder": "p.ex. iPhone de Max",
      "editName": "Modifier le nom",
      "empty": "Aucun passkey enregistré",
      "lastPasskeyWarning": "C'est votre seul passkey. Après la suppression, vous pourrez toujours vous connecter avec votre mot de passe.",
      "lastUsed": "Dernière connexion",
      "notSupported": "Votre navigateur ne prend pas en charge les passkeys. Veuillez utiliser un navigateur récent.",
      "registerError": "Impossible d'enregistrer le passkey",
      "registerSuccess": "Passkey enregistré avec succès",
      "registeredAt": "Enregistré",
      "registrationCancelled": "Enregistrement du passkey annulé",
      "removePasskey": "Supprimer le passkey",
      "renameError": "Impossible d'enregistrer le nom de l'appareil",
      "renameSuccess": "Nom de l'appareil enregistré",
      "subtitle": "Gérer les passkeys pour une connexion plus rapide et sécurisée",
      "title": "Méthodes de connexion",
      "unnamedDevice": "Appareil sans nom"
    },
    "profile": {
      "changePassword": "Changer le mot de passe",
      "changePasswordBtn": "Changer le mot de passe",
      "companies": "Appartenance à l'entreprise",
      "confirmPassword": "Confirmer le mot de passe",
      "currentPassword": "Mot de passe actuel",
      "currentPasswordWrong": "Le mot de passe actuel est incorrect",
      "email": "Adresse e-mail",
      "firstName": "Prénom",
      "forgotCurrentPassword": "Mot de passe actuel inconnu ? Définir un nouveau mot de passe par e-mail",
      "hidePassword": "Masquer le mot de passe",
      "lastName": "Nom de famille",
      "newPassword": "Nouveau mot de passe",
      "noPasswordSet": "Aucun mot de passe n'est défini pour ce compte. Définissez-le via le lien envoyé par e-mail.",
      "passwordError": "Impossible de changer le mot de passe. Veuillez vérifier votre mot de passe actuel.",
      "passwordLinkError": "Le lien n'a pas pu être envoyé. Veuillez réessayer plus tard.",
      "passwordLinkSent": "Nous avons envoyé un lien à {{email}}. Il vous permet de définir votre mot de passe.",
      "passwordMismatch": "Les mots de passe ne correspondent pas",
      "passwordSuccess": "Mot de passe changé avec succès",
      "personalInfo": "Informations personnelles",
      "readOnly": "Lecture seule",
      "saveError": "Impossible d'enregistrer le profil",
      "saveSuccess": "Profil enregistré avec succès",
      "sendPasswordLink": "Envoyer le lien par e-mail",
      "setPassword": "Définir le mot de passe",
      "setPasswordHint": "Aucun mot de passe n'est encore défini pour ce compte — vous vous connectez par lien, passkey ou signature mobile. Nous vous envoyons un lien par e-mail pour définir un mot de passe.",
      "showPassword": "Afficher le mot de passe",
      "weakPassword": "Le mot de passe ne remplit pas les conditions"
    },
    "subtitle": "Gérez votre compte et vos contrats",
    "tabs": {
      "activities": "Activités",
      "contracts": "Contrats",
      "invoices": "Factures",
      "notifications": "Notifications",
      "privacy": "Confidentialité",
      "profile": "Profil"
    },
    "title": "Paramètres"
  },
  "invoices": {
    "columns": {
      "actions": "Actions",
      "amount": "Montant",
      "date": "Date",
      "dueDate": "Échéance",
      "number": "N° facture",
      "property": "Bien",
      "status": "Statut"
    },
    "download": "Télécharger le PDF",
    "downloadFailed": "Échec du téléchargement du PDF",
    "empty": "Aucune facture disponible",
    "emptyHint": "Vos factures apparaîtront ici une fois créées",
    "filters": {
      "allStatuses": "Tous les statuts",
      "fromDate": "Du",
      "status": "Statut",
      "toDate": "Au"
    },
    "loadFailed": "Impossible de charger les factures",
    "openWarning": "Vous avez {{count}} facture(s) ouverte(s) ou en retard",
    "statuses": {
      "CANCELLED": "Annulée",
      "OPEN": "Ouverte",
      "OVERDUE": "En retard",
      "PAID": "Payée"
    },
    "title": "Factures"
  },
  "kyc": {
    "badge": {
      "exempt": "Aucune identification requise",
      "exemptHint": "Votre société est surveillée (FINMA ou équivalent) — une identification personnelle n'est pas nécessaire.",
      "pending": "Identification en attente",
      "verified": "Identifié"
    },
    "capture": {
      "analysis": {
        "continueAnyway": "Continuer malgré tout",
        "critiqueTitle": "Veuillez reprendre la photo : {{slot}}.",
        "prefilled": "Nous avons lu votre pièce d'identité — veuillez vérifier brièvement.",
        "quality": {
          "blurry": "La photo est floue.",
          "cut_off": "La pièce d'identité n'est pas entièrement visible.",
          "glare": "La photo présente un reflet — veuillez la reprendre sans source de lumière directe.",
          "not_document": "Nous n'avons pas pu reconnaître de pièce d'identité."
        },
        "retake": "Reprendre la photo",
        "skip": "Continuer sans vérification et remplir moi-même",
        "waitHint": "Cela peut prendre un instant.",
        "waitTitle": "Votre pièce d'identité est en cours de lecture …"
      },
      "camera": {
        "backDefault": "Caméra arrière (par défaut)",
        "denied": "Nous n'avons pas accès à votre caméra. Autorisez l'accès dans le navigateur ou téléversez des photos à la place.",
        "deniedFallback": "Nous n'avons pas accès à votre caméra. Téléversez plutôt les prises de vue sous forme de fichiers.",
        "documentHint": "Les quatre coins visibles, sans reflets.",
        "frameHint": "Placez la pièce d’identité exactement dans le cadre.",
        "frontDefault": "Caméra frontale (par défaut)",
        "lowResolution": "La prise de vue est petite ({{width}} × {{height}} px). Rapprochez-vous de la pièce d’identité ou choisissez une meilleure caméra.",
        "numbered": "Caméra {{n}}",
        "previewAlt": "Aperçu de la prise de vue",
        "retake": "Recommencer",
        "select": "Caméra",
        "selfieGuideHint": "Visage dans l'ovale, main dans le contour.",
        "selfieHint": "Votre visage bien visible, sans couvre-chef.",
        "shutter": "Prendre la photo",
        "starting": "Démarrage de la caméra …",
        "unavailable": "Nous ne trouvons aucune caméra sur cet appareil. Téléversez plutôt des photos ou une copie PDF.",
        "unavailableFallback": "Nous ne trouvons aucune caméra sur cet appareil. Téléversez plutôt les prises de vue sous forme de fichiers.",
        "use": "Utiliser"
      },
      "details": {
        "country": "Pays de délivrance",
        "countryHint": "Deux lettres, p. ex. CH, DE ou FR.",
        "expiry": "Valable jusqu'au",
        "lead": "Il ne reste que le pays de délivrance — le numéro et la date d'expiration sont facultatifs.",
        "number": "Numéro du document",
        "submit": "Soumettre pour vérification",
        "title": "Informations sur le document"
      },
      "documentTypes": {
        "ID_CARD": "Carte d'identité",
        "OTHER": "Autre pièce d'identité officielle",
        "PASSPORT": "Passeport",
        "RESIDENCE_PERMIT": "Permis de séjour"
      },
      "errors": {
        "allSlotsFilled": "Toutes les pages sont déjà saisies. Utilisez «Remplacer» pour échanger une prise de vue.",
        "alreadySubmitted": "Cette identification a déjà été soumise et est en cours de vérification.",
        "expired": "Ce document est échu. Veuillez utiliser un document valable.",
        "incomplete": "Il manque encore des prises de vue :",
        "submitFailed": "L'envoi n'a pas fonctionné. Veuillez réessayer.",
        "tooLarge": "Le fichier est trop volumineux. Les fichiers jusqu'à 15 Mo sont autorisés.",
        "uploadFailed": "Le fichier n'a pas pu être transmis. Veuillez réessayer.",
        "wrongType": "Nous ne pouvons pas lire ce format. Les formats JPG, PNG, HEIC et PDF sont autorisés."
      },
      "face": {
        "loading": "Préparation de la détection du visage …",
        "multiple": "Une seule personne sur l'image.",
        "none": "Aucun visage détecté.",
        "offCenter": "Placez votre visage dans l'ovale.",
        "showFingersNow_one": "Montrez maintenant {{count}} doigt",
        "showFingersNow_other": "Montrez maintenant {{count}} doigts",
        "steady": "Ne bougez plus …",
        "tooLarge": "Un peu plus loin.",
        "tooSmall": "Un peu plus près."
      },
      "liveness": {
        "LOOK_UP": "Regarder vers le haut",
        "SHOW_FINGERS": "Montrer {{count}} doigts",
        "SHOW_TWO_FINGERS": "Montrer deux doigts",
        "TURN_HEAD_LEFT": "Tourner la tête vers la gauche",
        "TURN_HEAD_RIGHT": "Tourner la tête vers la droite",
        "instructions": {
          "LOOK_UP": "Regardez brièvement vers le haut",
          "SHOW_FINGERS_one": "Tenez {{count}} doigt à côté de votre visage",
          "SHOW_FINGERS_other": "Tenez {{count}} doigts à côté de votre visage",
          "SHOW_TWO_FINGERS": "Tenez deux doigts à côté de votre visage",
          "TURN_HEAD_LEFT": "Tournez légèrement la tête vers la gauche",
          "TURN_HEAD_RIGHT": "Tournez légèrement la tête vers la droite"
        },
        "title": "Votre tâche pour le selfie"
      },
      "scanner": {
        "backgroundHint": "Conseil : posez la pièce d'identité sur un support foncé et uni — ou prenez la photo vous-même avec «Prendre la photo».",
        "closer": "Approchez-vous.",
        "loading": "Chargement du scanner …",
        "searching": "Tenez la pièce d'identité dans le cadre.",
        "steady": "Ne bougez plus …",
        "straightened": "Pièce d'identité redressée automatiquement"
      },
      "setup": {
        "documentType": "Quelle pièce d'identité présentez-vous ?",
        "lead": "Nous avons besoin d'une image de votre pièce d'identité et d'un selfie. Vous pouvez prendre les deux directement ou les téléverser comme fichiers.",
        "live": "Prendre avec la caméra",
        "liveDesc": "Caméra du téléphone ou webcam — pièce d'identité et selfie en deux minutes.",
        "title": "Saisir la pièce d'identité",
        "upload": "Téléverser des fichiers",
        "uploadDesc": "Photos (JPG, PNG, HEIC) ou une copie PDF de votre pièce d'identité."
      },
      "slots": {
        "back": "Verso de la pièce d'identité",
        "front": "Recto de la pièce d'identité",
        "pdf": "Copie PDF de la pièce d'identité",
        "selfie": "Selfie"
      },
      "summary": {
        "lead": "Voici les prises de vue que nous avons enregistrées. Si quelque chose est flou ou coupé, reprenez-la.",
        "pdfNote": "Copie PDF",
        "previewUnavailable": "Aperçu indisponible — le fichier est enregistré.",
        "retake": "Reprendre",
        "title": "Vos prises de vue"
      },
      "upload": {
        "choose": "Choisir des fichiers",
        "dropHint": "Glissez les fichiers ici ou choisissez-les",
        "formats": "JPG, PNG, HEIC ou PDF — jusqu'à 15 Mo par fichier.",
        "lead": "Photos du recto et du verso — ou une copie PDF de la pièce d'identité. Un selfie nous aide lors de la vérification, mais il est facultatif ici.",
        "nativeCamera": "Prendre avec la caméra",
        "pdfHint": "Vous avez une copie PDF de votre pièce d'identité ? Téléversez simplement le PDF — le recto et le verso ne sont alors plus nécessaires.",
        "replace": "Remplacer",
        "select": "Choisir un fichier",
        "title": "Téléverser des fichiers"
      }
    },
    "choice": {
      "autoIdent": "Pièce d'identité + selfie (2 min.)",
      "autoIdentDesc": "Présentez votre carte d'identité ou votre passeport à la caméra, puis prenez un selfie.",
      "regulated": "Mon entreprise est surveillée ou cotée",
      "regulatedDesc": "Banque, assurance, fonds, caisse de pension ou société cotée — une confirmation suffit.",
      "swissId": "Se connecter avec SwissID",
      "swissIdDesc": "Déjà identifié ? Avec SwissID, c'est réglé immédiatement.",
      "title": "Comment souhaitez-vous vous identifier ?"
    },
    "done": {
      "generic": "Votre identification est enregistrée et valable sans limite de temps.",
      "regulatedConfirmed": "{{company}} est enregistrée comme contrepartie surveillée.",
      "title": "Merci — c'est terminé",
      "verifiedAt": "Identifié le {{date}}",
      "yourCompany": "Votre entreprise"
    },
    "errors": {
      "declareFailed": "La confirmation n'a pas pu être enregistrée. Veuillez réessayer plus tard.",
      "startFailed": "L'identification n'a pas pu être lancée. Veuillez réessayer plus tard."
    },
    "handoff": {
      "continueHere": "Continuer ici sur l’ordinateur",
      "expired": "Ce code a expiré. Générez un nouveau code.",
      "failed": "Le code n’a pas pu être généré. Générez-en un nouveau ou continuez ici sur l’ordinateur.",
      "lead": "Scannez le code avec l’appareil photo de votre téléphone. Le code est valable {{minutes}} minutes.",
      "phoneStarted": "Ouvert sur le téléphone — veuillez terminer là-bas. Cette fenêtre se met à jour d’elle-même.",
      "qrAlt": "Code QR pour l’identification sur le téléphone",
      "regenerate": "Générer un nouveau code",
      "regenerateHint": "Un nouveau code rend le précédent invalide.",
      "remaining": "Code encore valable {{time}}",
      "title": "Souhaitez-vous faire l’identification sur votre téléphone ?"
    },
    "intro": {
      "bodyAfter": "C'est votre première visite. Depuis le 1er octobre 2026, la loi suisse sur le blanchiment d'argent exige que nous identifiions une seule fois nos partenaires contractuels — comme votre banque. Cela prend deux minutes et reste valable durablement.",
      "bodyBefore": "C'est votre première visite. Dès le 1er octobre 2026, la loi suisse sur le blanchiment d'argent exige que nous identifiions une seule fois nos partenaires contractuels — comme votre banque. Cela prend deux minutes et reste valable durablement.",
      "pointDuration": "Deux minutes, aucun formulaire.",
      "pointOnce": "Une seule fois — valable sans limite de temps.",
      "start": "S'identifier maintenant",
      "title": "Bienvenue chez Immotron — une identification unique"
    },
    "later": "Plus tard",
    "methods": {
      "AUTO_IDENT": "Pièce d'identité + selfie",
      "CHECK_RUN": "Contrôle",
      "MANUAL": "Saisie manuelle",
      "REGULATED_SELF_DECLARATION": "Autodéclaration en tant que contrepartie surveillée",
      "SWISSID": "SwissID"
    },
    "mobile": {
      "done": {
        "body": "Merci — nous vérifions vos données. Vous pouvez retourner à votre ordinateur.",
        "title": "Transmis, en cours de vérification"
      },
      "errors": {
        "alreadySubmitted": "Votre identification a déjà été transmise.",
        "expired": "Ce code a expiré.",
        "generic": "La page n’a pas pu être ouverte. Veuillez réessayer.",
        "hint": "Ouvrez un nouveau code QR sur votre ordinateur.",
        "sessionExpired": "La session a expiré.",
        "unknown": "Code invalide.",
        "used": "Ce code a déjà été utilisé."
      },
      "greeting": "Bonjour {{name}}",
      "greetingAnonymous": "Bonjour",
      "lead": "Ensuite, c’est terminé — votre ordinateur se met à jour tout seul.",
      "loading": "Un instant, nous ouvrons votre identification …",
      "title": "Identification sur le téléphone"
    },
    "pending": {
      "body": "Votre identification a été lancée mais n'est pas encore confirmée. Dès que le résultat sera disponible, vous le verrez ici et dans les réglages.",
      "refresh": "Actualiser le statut",
      "resume": "Poursuivre l'identification",
      "resumeBody": "Votre identification a été lancée mais pas encore transmise. Vous pouvez reprendre là où vous vous êtes arrêté.",
      "resumeTitle": "Identification non terminée",
      "title": "Identification en cours"
    },
    "progress": {
      "cards": {
        "seco": "0 résultat sur la liste de sanctions de la Confédération (SECO)",
        "signature": "Inscription au registre du commerce",
        "uid": "IDE"
      },
      "continue": "Continuer",
      "doneTitle": "Identifié",
      "failed": "La vérification n’a pas pu être lancée. Nous vérifions vos données manuellement et revenons vers vous.",
      "followUpBody": "Nous vérifions encore vos données manuellement et revenons vers vous dans un délai d’un jour ouvrable.",
      "followUpTitle": "Presque terminé",
      "heading": "Un instant — nous vérifions votre identité",
      "lead": "Vous voyez en direct avec quoi nous comparons vos données. Cela ne prend que quelques secondes.",
      "starting": "Un instant, nous vérifions votre identité …",
      "state": {
        "error": "En cours d’examen",
        "hit": "En cours d’examen",
        "ok": "Vérifié",
        "pending": "En cours d’examen",
        "running": "En cours",
        "skipped": "Pas nécessaire",
        "waiting": "En attente"
      },
      "title": "Étapes de vérification"
    },
    "regulated": {
      "authority": "Autorité de surveillance ou source",
      "authorityPlaceholder": "p. ex. FINMA, CHS PP, SIX",
      "categories": {
        "LISTED": "Société cotée",
        "PUBLIC_LAW": "Collectivité de droit public",
        "REGULATED": "Surveillée par la FINMA ou la CHS PP (banque, assurance, fonds, caisse de pension)"
      },
      "category": "Catégorie",
      "company": "Entreprise",
      "confirm": "Je confirme que l'entreprise mentionnée est surveillée, cotée ou de droit public.",
      "description": "Si votre entreprise est surveillée, cotée ou de droit public, votre confirmation suffit — aucune identification personnelle n'est nécessaire.",
      "noCompany": "Aucune entreprise n'est liée à votre compte. Veuillez vous identifier en tant que personne ou nous contacter.",
      "reference": "Numéro d'autorisation ou de registre",
      "submit": "Confirmer",
      "title": "Contrepartie surveillée"
    },
    "review": {
      "title": "Vérifier les identifications",
      "subtitle": "Vérifier les auto-identifications soumises et les approuver ou les refuser. Une identification n’est jamais confirmée automatiquement.",
      "forbidden": "Réservé à l’administration / aux responsables LBA.",
      "empty": "Aucune identification ouverte.",
      "emptyAll": "Aucune identification disponible.",
      "selectHint": "Sélectionnez un cas à gauche.",
      "submittedAt": "Soumis le",
      "unknownPerson": "Personne inconnue",
      "captureModeLabel": "Mode de saisie",
      "checkRunLabel": "Contrôle automatique",
      "livenessLabel": "Tâche de vivacité",
      "fingerCountLabel": "Nombre de doigts demandé",
      "fingerCountCheck": "Le nombre de doigts sur le selfie correspond-il ?",
      "openInNewTab": "Ouvrir dans un nouvel onglet",
      "zoom": "Agrandir {{slot}}",
      "uploadHint": "Les images téléversées n’ont pas été prises en direct — à vérifier avec une attention particulière.",
      "correct": "Corriger",
      "correctHint": "Les corrections sont enregistrées avec votre décision.",
      "nationalityHint": "Code pays à trois lettres (ISO 3166), p. ex. CHE pour la Suisse.",
      "nationalityInvalid": "Veuillez saisir exactement trois lettres, p. ex. CHE.",
      "approve": "Approuver",
      "reject": "Refuser",
      "reasonLabel": "Motif",
      "reasonPlaceholder": "Pourquoi l’identification est-elle refusée ?",
      "reasonHint": "Au moins 5 caractères.",
      "rejectSubmit": "Envoyer le refus",
      "approveSuccess": "Identification approuvée.",
      "rejectSuccess": "Identification refusée.",
      "filter": {
        "open": "Ouvertes",
        "all": "Toutes"
      },
      "captureMode": {
        "live": "Prise en direct",
        "upload": "Téléversée"
      },
      "fieldsSource": {
        "ai": "par IA",
        "reviewer": "corrigé par le vérificateur",
        "customer": "saisi par le client"
      },
      "state": {
        "OPEN": "Ouverte",
        "FIRST_APPROVED": "1re approbation donnée — une deuxième personne est nécessaire",
        "APPROVED": "Approuvée",
        "REJECTED": "Refusée"
      },
      "checkRun": {
        "CLEAN": "Contrôle sans constat",
        "HIT": "Correspondance sur liste — vérifier attentivement",
        "INCOMPLETE": "Contrôle incomplet"
      },
      "files": {
        "title": "Pièce d’identité et selfie",
        "none": "Aucun fichier disponible."
      },
      "slot": {
        "front": "Pièce d’identité recto",
        "back": "Pièce d’identité verso",
        "selfie": "Selfie",
        "pdf": "Pièce d’identité (PDF)"
      },
      "document": {
        "title": "Données du document",
        "type": "Type de document",
        "country": "Pays de délivrance",
        "number": "Numéro du document",
        "expiry": "Valable jusqu’au",
        "nationality": "Nationalité",
        "expired": "échu"
      },
      "documentType": {
        "ID_CARD": "Carte d’identité",
        "PASSPORT": "Passeport",
        "RESIDENCE_PERMIT": "Permis de séjour",
        "OTHER": "Autre document"
      },
      "contact": {
        "title": "Contact",
        "name": "Nom",
        "email": "E-mail",
        "birthday": "Date de naissance",
        "company": "Entreprise",
        "open": "Ouvrir le contact"
      },
      "decisions": {
        "title": "Décisions précédentes",
        "first": "Premier examen",
        "second": "Deuxième examen",
        "reason": "Motif",
        "none": "Pas encore de décision."
      },
      "decision": {
        "APPROVE": "Approuvée",
        "REJECT": "Refusée"
      },
      "errors": {
        "fourEyes": "La deuxième approbation doit être donnée par une autre personne.",
        "ownIdentification": "Vous ne pouvez pas approuver votre propre identification.",
        "alreadyDecided": "Ce cas a déjà été tranché.",
        "reasonRequired": "Un motif est requis (au moins 5 caractères).",
        "decisionFailed": "La décision n’a pas pu être enregistrée."
      },
      "ai": {
        "title": "Contrôle par IA",
        "hintOnly": "Proposition de l’IA — l’approbation reste une décision humaine",
        "pending": "Contrôle par IA en cours …",
        "approve": "Approuver (recommandé par l’IA)",
        "recommendation": {
          "approve": "Approbation recommandée",
          "review": "À vérifier",
          "reject": "Refus recommandé"
        },
        "checks": {
          "face_match": "Comparaison des visages",
          "finger_count": "Nombre de doigts sur le selfie",
          "mrz_checksum": "Zone lisible par machine (MRZ)",
          "not_expired": "Validité de la pièce d’identité",
          "identity_match": "Nom et date de naissance",
          "sanctions": "Listes de sanctions"
        },
        "result": {
          "ok": "en ordre",
          "failed": "pas en ordre",
          "unknown": "non vérifiable"
        }
      },
      "extraction": {
        "title": "Lu sur la pièce d’identité (IA, simple indication)",
        "hintOnly": "Simple indication — l’approbation reste une décision humaine",
        "pending": "Lecture des données de la pièce d’identité …",
        "failed": "Les données de la pièce d’identité n’ont pas pu être lues.",
        "retry": "Relire",
        "match": "Correspond au contact",
        "mismatchCount": "{{count}} différences par rapport au contact",
        "mismatchCount_one": "Une différence par rapport au contact",
        "disabled": "La lecture automatique est désactivée.",
        "running": "La lecture est déjà en cours — veuillez patienter.",
        "fields": {
          "lastName": "Nom",
          "firstNames": "Prénom(s)",
          "birthDate": "Date de naissance",
          "nationality": "Nationalité",
          "documentType": "Type de document",
          "documentNumber": "Numéro du document",
          "expiryDate": "Date d’expiration",
          "mrz": "Zone lisible par machine (MRZ)"
        },
        "flags": {
          "LAST_NAME_MISMATCH": "Le nom diffère de celui du contact",
          "FIRST_NAME_MISMATCH": "Le prénom diffère de celui du contact",
          "BIRTH_DATE_MISMATCH": "La date de naissance diffère de celle du contact",
          "DOCUMENT_EXPIRED": "Pièce d’identité expirée"
        }
      }
    },
    "settings": {
      "declareRegulated": "Déclarer l'entreprise comme surveillée",
      "lastRun": "Dernière vérification",
      "lastRunAt": "Effectuée le {{date}}",
      "legalHintAfter": "Depuis le 1er octobre 2026, la loi suisse sur le blanchiment d'argent exige que nous identifiions une seule fois nos partenaires contractuels. L'identification est valable sans limite de durée.",
      "legalHintBefore": "Dès le 1er octobre 2026, la loi suisse sur le blanchiment d'argent exige que nous identifiions une seule fois nos partenaires contractuels. L'identification est valable sans limite de durée.",
      "method": "Méthode : {{method}}",
      "open": "Identification en attente",
      "openHint": "Vous ne vous êtes pas encore identifié. Cela prend environ deux minutes.",
      "pending": "Identification en cours",
      "pendingHint": "Le résultat n'est pas encore disponible.",
      "regulated": "Contrepartie surveillée",
      "regulatedHint": "{{company}} est déclarée comme surveillée — aucune identification personnelle n'est nécessaire.",
      "restart": "S'identifier à nouveau",
      "runChecks": "Lancer la vérification",
      "start": "S'identifier maintenant",
      "title": "Identification",
      "verified": "Identifié",
      "verifiedAt": "Identifié le {{date}}",
      "verifiedHint": "Votre identification est valable sans limite de temps."
    },
    "stepper": {
      "identification": "1 Identification",
      "label": "Progression du contrôle de conformité",
      "lexKoller": "2 Droit d'acquérir"
    },
    "steps": {
      "IDENT": {
        "error": "La vérification d'identité n'a pas abouti. Veuillez la relancer.",
        "ok": "Pièce d'identité et selfie confirmés.",
        "pending": "Le résultat du prestataire d'identification n'est pas encore disponible.",
        "running": "Nous vérifions votre identité.",
        "title": "Identité",
        "waiting": "Pièce d'identité et selfie via le prestataire d'identification."
      },
      "REGULATED": {
        "ok": "{{COMPANY_NAME}} est enregistrée comme contrepartie surveillée.",
        "running": "Nous vérifions si votre société est surveillée.",
        "skipped": "Aucune surveillance déclarée — la vérification ordinaire s'applique.",
        "title": "Contrepartie surveillée",
        "waiting": "Vérification si votre société est surveillée ou cotée."
      },
      "SECO": {
        "error": "La comparaison n'est momentanément pas possible. Nous vérifions cela manuellement.",
        "hit": "Nous vérifions encore vos données manuellement et revenons vers vous.",
        "ok": "Aucune inscription sur la liste de sanctions de la Confédération.",
        "running": "Nous comparons avec la liste de sanctions de la Confédération.",
        "title": "Liste de sanctions du SECO",
        "waiting": "Comparaison avec la liste de sanctions de la Confédération."
      },
      "SIGNATORY": {
        "error": "Nous clarifions le droit de signature personnellement avec vous.",
        "ok": "Vous disposez du droit de signature pour {{COMPANY_NAME}}.",
        "running": "Nous vérifions le droit de signature.",
        "skipped": "Aucun droit de signature à vérifier — vous agissez en tant que particulier.",
        "title": "Droit de signature",
        "waiting": "Vérification de votre droit de signature pour la société."
      },
      "TRANSPARENCY_REGISTER": {
        "error": "Le registre de transparence est momentanément indisponible. Nous vérifions cela manuellement.",
        "ok": "Aucune observation dans le registre de transparence.",
        "running": "Nous vérifions le registre de transparence.",
        "skipped": "La comparaison aura lieu dès le 1er octobre 2026.",
        "title": "Registre de transparence",
        "waiting": "Comparaison avec le registre fédéral de transparence."
      },
      "ZEFIX": {
        "error": "Le registre du commerce est momentanément indisponible. Nous vérifions cela manuellement.",
        "ok": "{{COMPANY_NAME}} est inscrite au registre du commerce suisse.",
        "running": "Nous comparons avec le registre du commerce.",
        "skipped": "Aucune comparaison nécessaire — vous agissez en tant que particulier.",
        "title": "Registre du commerce (Zefix)",
        "waiting": "Comparaison de votre société avec le registre du commerce suisse."
      }
    },
    "stub": {
      "back": "Retour à l'application",
      "description": "Cette page remplace le prestataire d'identification sur l'environnement de test. Un clic termine l'identification — ce n'est pas possible en production.",
      "failed": "La simulation n'a pas pu être terminée.",
      "reference": "Référence",
      "simulate": "Simuler l'identification",
      "success": "Identification terminée. Vous allez être redirigé.",
      "title": "Simuler l'identification",
      "unavailable": "La simulation n'est pas disponible dans cet environnement."
    },
    "submitted": {
      "body": "Nous vérifions vos informations et vous recontactons. Vous pouvez continuer à utiliser la plateforme.",
      "title": "Soumis, en cours de vérification"
    },
    "title": "Identification unique"
  },
  "layout": {
    "endImpersonation": "Retour à l'admin",
    "footer": {
      "allRightsReserved": "Tous droits réservés.",
      "build": "Build"
    },
    "impersonating": "Connecté en tant que {{name}}",
    "reloadNow": "Mettre à jour maintenant",
    "updateAvailable": "Une nouvelle version est disponible."
  },
  "compliance": {
    "hint": {
      "action": "Commencer maintenant",
      "pendingText": "Nous vous contactons dès que la vérification est terminée. Vous n’avez rien d’autre à faire.",
      "pendingTitle": "Votre identification est en cours de vérification",
      "retryAction": "Recommencer",
      "retryText": "La dernière vérification n’a pas pu être finalisée. Veuillez effectuer l’identification encore une fois.",
      "retryTitle": "Veuillez refaire votre identification",
      "statusLink": "Voir le statut",
      "textIdent": "Une seule fois et en deux minutes environ : pièce d’identité et brève évaluation concernant l’acquisition d’immeubles (Lex Koller). Vous verrez ensuite tous les documents.",
      "textLexKoller": "Il ne manque plus que la brève évaluation concernant l’acquisition d’immeubles (Lex Koller).",
      "title": "Veuillez finaliser votre identification"
    }
  },
  "lexKoller": {
    "company": {
      "domicile": "Siège en Suisse ?",
      "domicilePrefilled": "Le siège en Suisse de l'entreprise est confirmé via Zefix.",
      "foreignOwnership": "Participation étrangère supérieure à 33% ?",
      "foreignOwnershipDesc": "Part du capital ou des droits de vote détenue par des personnes à l'étranger.",
      "title": "Données de l'entreprise"
    },
    "details": {
      "canton": "Canton",
      "noPermit": "Aucun",
      "permit": "Permis de séjour",
      "permitB": "B — Séjour",
      "permitC": "C — Établissement",
      "permitG": "G — Frontalier",
      "permitL": "L — Courte durée",
      "residence": "Domicile en Suisse ?",
      "selectCanton": "Choisir un canton...",
      "title": "Séjour et autorisation"
    },
    "disclaimer": "Ceci est une évaluation informative et ne constitue pas un avis juridique. Pour des renseignements contraignants, veuillez consulter un notaire ou un avocat.",
    "entityType": {
      "company": "Entreprise / Société",
      "companyDesc": "SA, Sàrl ou autre personne morale",
      "description": "Veuillez indiquer si vous achetez en tant que personne privée ou en tant qu'entreprise.",
      "person": "Personne privée",
      "personDesc": "Personne physique",
      "title": "Qui souhaite acquérir ?"
    },
    "errors": {
      "assessFailed": "L'évaluation n'a pas pu être enregistrée. Veuillez réessayer plus tard.",
      "declareFailed": "La confirmation n'a pas pu être enregistrée. Veuillez réessayer plus tard."
    },
    "institutional": {
      "confirm": "La société n'est pas contrôlée par des personnes à l'étranger à plus d'un tiers (art. 5 LFAIE).",
      "description": "{{company}} est enregistrée comme institution surveillée/inscrite ({{source}}). La Lex Koller ne s'applique donc pas.",
      "doneBody": "Votre confirmation est enregistrée. Aucune restriction Lex Koller ne s'applique à {{company}}.",
      "submit": "Confirmer",
      "title": "La Lex Koller ne s'applique pas",
      "unknownSource": "registre public",
      "yourCompany": "votre société"
    },
    "later": "Plus tard",
    "nationality": {
      "ch": "Suisse",
      "chDesc": "Citoyen suisse (y c. double nationalité)",
      "companyDesc": "Nationalité des ayants droit économiques.",
      "euEfta": "UE / AELE",
      "euEftaDesc": "Ressortissant UE ou AELE",
      "other": "Autre pays",
      "otherDesc": "Ressortissant d'un État tiers",
      "personDesc": "Sélectionnez votre nationalité.",
      "title": "Nationalité"
    },
    "prefill": {
      "fromIdent": "Nous avons repris votre nationalité de votre identification — nous ne demandons que ce qui manque encore.",
      "fromDocument": "Repris de votre pièce d’identité — veuillez vérifier et modifier si nécessaire."
    },
    "result": {
      "cantonalApproval": "Autorisation cantonale requise",
      "commercial": "Bien commercial",
      "investmentProperty": "Bien d'investissement",
      "primaryResidence": "Résidence principale"
    },
    "settings": {
      "assessedInfo": "Évaluation terminée",
      "editAssessment": "Modifier l'évaluation",
      "noAssessment": "Aucune évaluation disponible",
      "startAssessment": "Démarrer l'évaluation"
    },
    "status": {
      "conditional": "Autorisé sous conditions",
      "notApplicableInstitutional": "Non applicable (institutionnel)",
      "restricted": "Restreint",
      "unrestricted": "Sans restriction"
    },
    "title": "Évaluation Lex Koller",
    "auto": {
      "title": "Déterminé automatiquement : citoyen suisse — aucune restriction",
      "description": "Votre nationalité provient de votre pièce d’identité. La Lex Koller ne vous restreint donc pas — vous n’avez rien à remplir.",
      "edit": "Modifier les indications"
    }
  },
  "linkedinImport": {
    "confirm": {
      "create": "créer",
      "execute": "Exécuter l'import",
      "merge": "fusionner",
      "skip": "ignorer",
      "summary": "{{total}} contacts seront traités :",
      "title": "Confirmer l'import",
      "warningCreate": "De nouveaux contacts et entreprises seront créés",
      "warningMerge": "Les entrées existantes seront enrichies avec les nouvelles informations",
      "warningSkip": "Les entrées ignorées ne seront pas modifiées",
      "warningTitle": "Que se passe-t-il lors de l'import ?"
    },
    "detail": {
      "error": "Erreur lors du chargement des détails",
      "loading": "Chargement des détails...",
      "records": "enregistrements",
      "title": "Détails de l'import"
    },
    "history": {
      "clickHint": "Cliquer pour détails",
      "colCreated": "Créés",
      "colDate": "Date",
      "colMerged": "Fusionnés",
      "colName": "Nom",
      "colRecords": "Enregistrements",
      "colSkipped": "Ignorés",
      "colStatus": "Statut",
      "detailColAction": "Aktion",
      "detailColCompany": "Organisation",
      "detailColMatch": "Abgleich",
      "detailColName": "Kontakt",
      "detailJobChanges": "Jobwechsel",
      "detailMerged": "Zusammengeführt",
      "detailNew": "Neu erstellt",
      "detailSkipped": "Übersprungen",
      "detailUpdated": "Aktualisiert",
      "loading": "Details werden geladen...",
      "noDetails": "Keine Details verfügbar",
      "statusCompleted": "Terminé",
      "statusFailed": "Échoué",
      "statusPending": "En attente",
      "title": "Historique des imports",
      "viewDetail": "Details anzeigen"
    },
    "preview": {
      "aiParsed": "Reconnu par IA",
      "autoMerge": "Fusion automatique",
      "colAction": "Action",
      "colCompany": "Entreprise",
      "colCompanyJob": "Entreprise / Poste",
      "colEmail": "E-mail",
      "colMatch": "Correspondance",
      "colName": "Nom",
      "company": "Firma",
      "crmMatch": "Correspondance CRM",
      "decideAll": "Veuillez décider pour toutes les entrées à vérifier",
      "executeImport": "Exécuter l'import",
      "importData": "Données d'import",
      "jobChangeDetected": "Changement d'emploi détecté",
      "jobChanges": "Changements de poste",
      "matchMethod": "Méthode",
      "matchScore": "Score",
      "matchedCompany": "Entreprise (CRM)",
      "matchedContact": "Contact",
      "needsReview": "Vérification nécessaire",
      "newContacts": "Nouveaux contacts",
      "noMatch": "Nouveau",
      "noMatchFound": "Aucun contact existant trouvé",
      "parsedFromHeadline": "Extrait du titre",
      "position": "Jobtitel"
    },
    "result": {
      "backToOverview": "Retour à l'aperçu",
      "colAction": "Action",
      "colName": "Nom",
      "colStatus": "Statut",
      "created": "Créés",
      "errors": "Erreurs",
      "merged": "Fusionnés",
      "skipped": "Ignorés",
      "title": "Import terminé"
    },
    "scraper": {
      "batchSize": "Taille du lot: 5 à 100 contacts par passage",
      "directSync": "Sync direct: l'extension peut aussi envoyer les contacts directement à Immotron",
      "step1Desc": "Charger l'extension Chrome depuis le dépôt Immotron et l'activer dans Chrome",
      "step1Title": "Installer l'extension",
      "step2Desc": "Ouvrir LinkedIn, démarrer l'extension et laisser capturer les contacts automatiquement",
      "step2Title": "Scraper les contacts",
      "step3Desc": "Télécharger l'export en fichier JSON et le charger ci-dessous ou synchroniser directement avec Immotron",
      "step3Title": "Exporter JSON & importer ici",
      "subtitle": "Exporter les contacts directement depuis LinkedIn",
      "title": "Extension Chrome LinkedIn Scraper"
    },
    "steps": {
      "confirm": "Confirmer",
      "preview": "Aperçu",
      "result": "Résultat",
      "upload": "Télécharger"
    },
    "subtitle": "Importer les contacts LinkedIn et les comparer avec les adresses existantes",
    "title": "Import LinkedIn",
    "toast": {
      "importFailed": "Import fehlgeschlagen"
    },
    "upload": {
      "contactsFound": "{{count}} contacts détectés",
      "emptyArray": "Tableau vide — aucun contact trouvé",
      "fileButton": "Charger un fichier JSON",
      "fileHint": "Accepte les fichiers .json",
      "fileReadError": "Datei konnte nicht gelesen werden",
      "importName": "Nom de l'import (optionnel)",
      "invalidJson": "Format JSON invalide",
      "namePlaceholder": "z.B. LinkedIn Export März 2026",
      "pasteLabel": "Coller le JSON",
      "placeholder": "[\n  {\n    \"linkedinUrl\": \"https://linkedin.com/in/...\",\n    \"firstName\": \"Jean\",\n    \"lastName\": \"Dupont\",\n    \"email\": \"jean@example.com\",\n    \"currentCompany\": \"Société SA\",\n    \"headline\": \"PDG chez Société SA\"\n  }\n]",
      "previewFailed": "Vorschau fehlgeschlagen",
      "startPreview": "Lancer l'aperçu",
      "validationError": "Validierungsfehler",
      "wrongFormat": "Falsches JSON-Format. Erwartet: [{linkedinUrl, firstName, lastName, ...}]"
    }
  },
  "listings": {
    "addListing": "Nouveau teaser",
    "addProperty": "Ajouter un bien",
    "assignedBuyers": {
      "activeBadge": "Accès actif",
      "companyGroup": "Société {{name}}",
      "conditionDeviates": "diffère du contrat-cadre",
      "conditionOwnForProperty": "condition propre à cet objet",
      "conditionUnknown": "Aucune condition définie",
      "emailLabelFor": "Adresse e-mail de {{name}}",
      "emailMissing": "Adresse e-mail manquante",
      "emailPlaceholder": "nom@entreprise.ch",
      "emailSave": "Enregistrer",
      "emailSaveFailed": "L'adresse e-mail n'a pas pu être enregistrée.",
      "emailSaveFor": "Enregistrer l'adresse e-mail de {{name}}",
      "emailSaved": "Adresse e-mail enregistrée.",
      "empty": "Aucun acheteur attribué pour le moment",
      "inviteCount": "({{count}} invitations)",
      "inviteNever": "pas encore contacté",
      "inviteSent": "invité le {{date}}",
      "inviteUsed": "lien ouvert le {{date}}",
      "mixedBadge": "Mixte",
      "pendingBadge": "Onboarding en attente",
      "pendingHint": "Ignoré lors de l'approbation : aucun contrat d'acheteur actif. L'accès sera accordé automatiquement après la signature du contrat.",
      "personCount": "{{count}} personne(s)",
      "plannedCondition": "prévu : {{model}}",
      "remove": "Retirer",
      "removeConfirm": "Retirer l'attribution ?",
      "removeConfirmGroup": "Les {{count}} personnes de « {{name}} » perdront l'accès à cet objet.",
      "removeConfirmPerson": "« {{name}} » perdra l'accès à cet objet. L'attribution peut être recréée à tout moment.",
      "removeDone": "Attribution retirée.",
      "removeFailed": "Échec du retrait.",
      "removeFor": "Retirer l'attribution de {{name}}",
      "removeGroup": "Retirer toutes les attributions de {{name}}",
      "resend": "Renvoyer l'e-mail",
      "resendConfirm": "Renvoyer l'invitation ?",
      "resendConfirmText": "{{count}} destinataire(s) ont déjà été invités. Un nouvel envoi rend les liens envoyés précédemment invalides.",
      "resendDone": "Invitation renvoyée.",
      "resendFailed": "Échec de l'envoi.",
      "resendFor": "Renvoyer l'e-mail à {{name}}",
      "resendGroupCount": "Contacter toutes les personnes en attente de {{name}} ({{count}})",
      "resendNoPending": "Personne dans ce groupe n'attend son onboarding",
      "resendSkipped": "Aucune invitation envoyée : {{reason}}",
      "resendSkippedUnknown": "Aucun motif indiqué",
      "sendAfterApproval": "Envoi après la validation",
      "singlePersons": "Personnes individuelles",
      "skipReason": {
        "no_active_contract": "Aucun contrat acheteur actif",
        "no_contact": "Aucun interlocuteur enregistré",
        "no_email": "Aucune adresse e-mail enregistrée"
      },
      "statusOnApproval": "Accès à la validation",
      "title": "Acheteurs attribués",
      "viaGroup": "via le groupe {{name}}"
    },
    "bundle": "Lot",
    "bundleCreated": "Le lot a ete cree.",
    "confirmDelete": "Voulez-vous vraiment supprimer ce teaser ? Les biens contenus seront conservés.",
    "confirmDeleteDescription": "Etes-vous sur de vouloir supprimer ce teaser ?",
    "confirmRemoveProperty": "Voulez-vous retirer ce bien du teaser ? Il sera attribué à un nouveau teaser individuel.",
    "confirmRemovePropertyDescription": "Etes-vous sur de vouloir retirer ce bien ?",
    "createBundle": "Créer un lot",
    "deleteSuccess": "Le teaser a ete supprime.",
    "errors": {
      "addPropertyFailed": "Impossible d'ajouter le bien",
      "deleteFailed": "Impossible de supprimer le teaser",
      "loadFailed": "Impossible de charger les teasers",
      "notFound": "Teaser introuvable",
      "removePropertyFailed": "Impossible de retirer le bien",
      "saveFailed": "Impossible de sauvegarder le teaser"
    },
    "fields": {
      "location": "Emplacement",
      "price": "Prix",
      "private": "Privé",
      "properties": "Biens contenus",
      "public": "Public",
      "status": "Statut",
      "title": "Titre",
      "totalPrice": "Prix total",
      "type": "Type",
      "timeline": "Timeline",
      "interested": "Interessenten"
    },
    "list": {
      "empty": {
        "description": "Les teasers sont créés automatiquement lorsque vous ajoutez un bien.",
        "title": "Aucun teaser trouvé"
      }
    },
    "noAvailableProperties": "Aucun autre bien disponible",
    "propertyRemoved": "Le bien a ete retire.",
    "removeProperty": "Retirer le bien",
    "resultsLabel": "Teasers",
    "selection": {
      "createBundle": "Commercialiser ensemble",
      "selectMode": "Sélection",
      "selected": "{{count}} sélectionné(s)"
    },
    "single": "Individuel",
    "statuses": {
      "ACTIVE": "Actif",
      "ARCHIVED": "Archivé",
      "DRAFT": "Brouillon",
      "SOLD": "Vendu"
    },
    "subtitle": "Gérer les teasers et les lots",
    "title": "Teasers",
    "saleMode": {
      "offerCollection": "Bieterverfahren",
      "fixedPrice": "Fixpreis"
    },
    "preview": {
      "title": "Aperçu du teaser",
      "hint": "C'est ainsi que l'investisseur voit le bien",
      "propertyPickerLabel": "Choisir le bien pour l'aperçu",
      "loadFailed": "L'aperçu n'a pas pu être chargé."
    },
    "management": {
      "title": "Gestion des acheteurs",
      "hint": "Ajouter des acheteurs ultérieurement — via les groupes d'investisseurs, les suggestions IA ou la recherche manuelle.",
      "groupsTitle": "Groupes d'investisseurs",
      "groupsLoadFailed": "Les groupes d'investisseurs n'ont pas pu être chargés.",
      "groupsEmpty": "Aucun groupe d'investisseurs disponible.",
      "assignGroups": "Attribuer {{count}} groupe(s)",
      "groupsAssigned": "Groupes d'investisseurs attribués — les membres reçoivent l'accès.",
      "suggestionsTitle": "Suggestions d'acheteurs IA",
      "load": "Charger les suggestions d'acheteurs",
      "reload": "Recalculer",
      "loading": "Calcul des suggestions …",
      "loadFailed": "Les suggestions d'acheteurs n'ont pas pu être chargées.",
      "retry": "Réessayer",
      "empty": "Aucun acheteur correspondant trouvé.",
      "assignSelected": "Attribuer {{count}} acheteur(s)",
      "buyersAssigned": "{{count}} acheteur(s) attribué(s).",
      "manualTitle": "Recherche de personnes",
      "manualHint": "Ajouter manuellement des contacts ou sociétés CRM comme acheteurs.",
      "assignFailed": "Échec de l'attribution.",
      "conditionsPreview": "Conditions de cet objet : {{model}}"
    },
    "masterData": {
      "title": "Données de base",
      "hint": "Titre, statut, visibilité et prix total du teaser. Le mode de vente, le prix et les échéances NBO/BO sont définis dans le Quality Gate.",
      "saved": "Données de base enregistrées"
    },
    "stats": {
      "title": "Statistiques",
      "hint": "Ouvertures et téléchargements du teaser par investisseur",
      "loadFailed": "Les statistiques n'ont pas pu être chargées.",
      "retry": "Réessayer",
      "empty": "Aucune activité enregistrée pour le moment.",
      "totalOpens": "Total des ouvertures",
      "uniqueVisitors": "Visiteurs uniques",
      "documentViews": "Vues de fichiers",
      "downloads": "Téléchargements",
      "investor": "Investisseur",
      "opens": "Ouvertures",
      "lastOpened": "Dernière ouverture",
      "viewedDocuments": "Fichiers consultés",
      "downloadedDocuments": "Fichiers téléchargés",
      "never": "—"
    }
  },
  "mandanten": {
    "accentColor": "Couleur d'accent",
    "active": "Actif",
    "addUser": "Ajouter un utilisateur",
    "address": "Adresse",
    "allRoles": "Tous les rôles",
    "allUsers": "Tous les utilisateurs",
    "brandColors": "Couleurs de marque",
    "brandColorsHint": "Ces couleurs sont utilisées dans la signature e-mail. Couleur primaire pour le texte et le séparateur, couleur d'accent pour les liens.",
    "canton": "Canton",
    "city": "Ville",
    "confirmDeleteMandant": "Voulez-vous vraiment supprimer définitivement «{{name}}» ? Toutes les données associées seront supprimées.",
    "confirmDeleteUser": "Voulez-vous vraiment supprimer cet utilisateur ? Cette action est irréversible.",
    "confirmRemove": "Voulez-vous vraiment supprimer cet utilisateur?",
    "createAndAssign": "Créer & Attribuer",
    "createMandant": "Créer un mandant",
    "createMandantSuccess": "Mandant créé",
    "createUser": "Créer un utilisateur",
    "createUserSuccess": "Utilisateur créé et attribué",
    "customTemplate": "Modèle personnalisé",
    "deleteConfirmBtn": "Supprimer définitivement",
    "deleteConfirmInput": "Entrez «{{name}}» pour confirmer :",
    "deleteKeys": {
      "campaign_recipients": "Destinataires de campagne",
      "campaigns": "Campagnes",
      "company_contacts": "Contacts d'entreprise",
      "contract_bundles": "Lots de contrats",
      "contracts": "Contrats",
      "email_templates": "Modèles d'e-mail",
      "offers": "Offres",
      "user_companies": "Attributions utilisateurs"
    },
    "deleteMandant": "Supprimer le mandant",
    "deleteNoRelated": "Aucune donnée associée",
    "deletePreviewTitle": "Les données suivantes seront supprimées :",
    "deleteSuccess": "Mandant «{{name}}» et toutes les données associées supprimés",
    "deleteUser": "Supprimer l'utilisateur",
    "deleteUserSuccess": "Utilisateur supprimé",
    "directPhone": "Téléphone direct",
    "directPhonePlaceholder": "p.ex. +41 44 123 45 67",
    "editMandant": "Modifier le mandant",
    "editMandantSuccess": "Mandant mis à jour",
    "editUser": "Modifier l'utilisateur",
    "email": "E-mail",
    "empty": "Aucune entreprise interne trouvée",
    "errors": {
      "loadFailed": "Impossible de charger les mandants",
      "loadUsersFailed": "Impossible de charger les utilisateurs"
    },
    "filterByRole": "Filtrer par rôle",
    "function": "Fonction",
    "functionPlaceholder": "p.ex. COO, Président du CA",
    "houseNumber": "N°",
    "impersonate": "Se connecter en tant qu'utilisateur",
    "impersonateAction": "Se connecter",
    "impersonateHint": "Ouvre une session en tant que cet utilisateur",
    "impersonateSuccess": "Connecté en tant que {{name}}",
    "inactive": "Inactif",
    "legalForm": "Forme juridique",
    "linkCompany": "Associer une entreprise",
    "linkCompanySuccess": "Entreprise associée comme mandant",
    "logo": "Logo",
    "logoDragOrClick": "Glissez le logo ici ou cliquez pour sélectionner",
    "logoFormatError": "Seuls PNG, JPG et WebP sont autorisés",
    "logoRemove": "Supprimer le logo",
    "logoSizeError": "Le fichier ne doit pas dépasser 5 Mo",
    "logoUploadError": "Échec du téléchargement du logo",
    "logoUploadSuccess": "Logo téléchargé avec succès",
    "logoUploading": "Téléchargement du logo...",
    "mandantAssignment": "Attribution mandant",
    "noCompaniesAvailable": "Aucune entreprise disponible",
    "noMandant": "–",
    "noPreference": "Aucune préférence",
    "noUsers": "Aucun utilisateur attribué",
    "pageSubtitle": "Gérer les mandants, utilisateurs et autorisations",
    "pageTitle": "Gestion des mandants",
    "passwordReset": "Réinitialisation du mot de passe",
    "passwordResetHint": "Envoie un lien de réinitialisation par e-mail",
    "phone": "Téléphone",
    "preferredLanguage": "Langue préférée",
    "primaryColor": "Couleur primaire",
    "removeFromMandant": "Supprimer l'attribution",
    "removeSuccess": "Utilisateur retiré du mandant",
    "resetLinkCopied": "Lien copié dans le presse-papiers",
    "resetSent": "Lien de réinitialisation envoyé par e-mail",
    "searchCompany": "Rechercher une entreprise...",
    "searchUsers": "Rechercher des utilisateurs...",
    "sectionAddress": "Adresse",
    "sectionCompany": "Données de l'entreprise",
    "sectionContact": "Contact",
    "sectionSignature": "Signature e-mail",
    "selectUser": "Sélectionner un utilisateur",
    "sendReset": "Envoyer le lien",
    "signatories": "Signataires",
    "signaturePreview": "Aperçu de la signature",
    "signaturePreviewError": "Impossible de charger l'aperçu",
    "signaturePreviewHint": "Cliquez sur «Aperçu» pour voir la signature e-mail actuelle.",
    "signatureText": "Texte de signature",
    "signatureType": "Autorité de signature",
    "signatureTypes": {
      "COLLECTIVE_MORE": "Signature collective à plusieurs",
      "COLLECTIVE_TWO": "Signature collective à deux",
      "NONE": "Aucune",
      "SINGLE": "Signature individuelle"
    },
    "status": "Statut",
    "street": "Rue",
    "subtitle": "Gérer les entreprises internes et les attributions",
    "tabCreate": "Créer nouveau",
    "tabExisting": "Existant",
    "tabMandanten": "Mandants",
    "tabManual": "Manuel",
    "tabUsers": "Utilisateurs",
    "tabZefix": "Recherche Zefix",
    "templateActive": "(actif)",
    "templateDefault": "(par défaut)",
    "templateHint": "Variables : {{ user_name }}, {{ user_function }}, {{ company_name }}, {{ company_logo_url }}, {{ disclaimer }}, {{ primary_color }}, {{ accent_color }} etc.",
    "templatePlaceholder": "Modèle HTML Jinja2 (vide = modèle par défaut)",
    "title": "Mandants",
    "updateUserSuccess": "Modifications enregistrées",
    "userDetails": "Données utilisateur",
    "userEmail": "E-mail",
    "userIsActive": "Utilisateur actif",
    "userMandanten": "Mandant(s)",
    "userName": "Nom",
    "userRole": "Rôle",
    "users": "Utilisateurs",
    "verbindlichkeitsklausel": "Clause de non-engagement",
    "verbindlichkeitsklauselHint": "Afficher la clause dans la signature e-mail",
    "website": "Site web",
    "zipCode": "NPA",
    "actions": "Aktionen"
  },
  "mapView": {
    "approximateLocation": "Emplacement approximatif",
    "cluster": "Groupe",
    "exactLocation": "Emplacement exact",
    "gridView": "Grille",
    "kmRadius": "env. {{km}} km de rayon",
    "mapView": "Carte",
    "showOnMap": "Voir les détails"
  },
  "media": {
    "confirmDelete": "Voulez-vous vraiment supprimer cette image ?",
    "copyUrl": "Copier l'URL",
    "delete": "Supprimer",
    "deleteFailed": "Le fichier n'a pas pu etre supprime.",
    "deleteSuccess": "Image supprimée",
    "empty": "Aucun média téléchargé",
    "subtitle": "Gérer les images et fichiers médias",
    "title": "Médias",
    "upload": "Télécharger une image",
    "uploadFailed": "Le telechargement a echoue.",
    "uploadSuccess": "Telechargement reussi.",
    "uploadedAt": "Téléchargé le",
    "uploading": "Téléchargement...",
    "urlCopied": "URL copiée dans le presse-papiers"
  },
  "missingConditions": {
    "title": "Aucune condition convenue",
    "assignDescription": "Aucune condition n'est convenue pour les personnes suivantes sur cet objet. Sans condition convenue, aucune attribution n'a lieu.",
    "approveDescription": "Aucune condition vendeur n'est convenue pour le mandant de cet objet. Sans condition convenue, la validation n'a pas lieu.",
    "blockedDescription": "La validation n'est possible que lorsqu'une condition est enregistrée pour chaque acheteur. Le plus rapide : définir une condition d'objet valable pour tous.",
    "roles": {
      "buyer": "Acheteur",
      "seller": "Vendeur"
    },
    "entityCompany": "Société",
    "entityContact": "Personne",
    "checkedSources": "Éléments vérifiés :",
    "sources": {
      "appendix_b": "Annexe B (validation de l'objet)",
      "appendix_b_buyer": "Annexe B pour cet acheteur",
      "property": "Condition de l'objet",
      "framework": "Taux du contrat-cadre",
      "default_model": "Modèle standard du mandant"
    },
    "setConditions": "Enregistrer une condition",
    "setBuyerConditions": "Définir la condition pour cet acheteur",
    "buyerContractPending": "Le contrat acheteur de {{name}} n'est pas encore contresigné — la condition ne peut être définie qu'ensuite.",
    "variableHint": "Contrat-cadre « variable » : les conditions sont convenues par objet — le modèle standard ne s'applique pas ici. Enregistrez une condition d'objet ou définissez-la pour cet acheteur.",
    "reasonLabel": "Motif (obligatoire)",
    "reasonPlaceholder": "Pourquoi poursuivre sans condition convenue ?",
    "reasonHint": "Sans motif, l'action ne peut pas être confirmée. La confirmation délibérée est consignée dans le journal d'activité avec l'utilisateur et l'horodatage.",
    "assignAnyway": "Attribuer quand même",
    "approveAnyway": "Valider quand même",
    "confirmed": "Action confirmée malgré l'absence de condition.",
    "retryFailed": "L'action a échoué. Veuillez réessayer.",
    "conditionsSetRetry": "Condition définie — l'opération a été exécutée."
  },
  "myOffers": {
    "activeOffers": "Offres actives",
    "columns": {
      "actions": "Actions",
      "amount": "Montant",
      "date": "Date",
      "proof": "Preuve",
      "property": "Bien",
      "status": "Statut",
      "type": "Type"
    },
    "confirmWithdraw": "Voulez-vous vraiment retirer cette NBO ?",
    "confirmWithdrawDescription": "Etes-vous sur de vouloir retirer cette offre ?",
    "detail": {
      "amount": "Montant",
      "expired": "Expirée",
      "financingProof": "Preuve de financement",
      "loiSigned": "LOI signée",
      "no": "Non",
      "notUploaded": "En attente",
      "offerType": "Type d'offre",
      "reservationExpires": "Réservation expire",
      "submittedAt": "Soumise le",
      "title": "Détails de l'offre",
      "uploaded": "Téléchargée",
      "yes": "Oui",
      "conditions": "Bedingungen"
    },
    "empty": "Aucune offre",
    "emptyHint": "Vos offres soumises apparaîtront ici",
    "filters": {
      "allStatuses": "Tous les statuts",
      "allTypes": "Tous les types",
      "status": "Statut",
      "title": "Filtres",
      "type": "Type d'offre"
    },
    "loadFailed": "Impossible de charger les offres",
    "statuses": {
      "CANCELLED": "Annulée",
      "COMPLETED": "Terminée",
      "EXPIRED": "Expirée",
      "LOST": "Non retenue",
      "PROOF_PENDING": "Preuve en attente",
      "REJECTED": "Rejetée",
      "RESERVED": "Réservée",
      "SUBMITTED": "Soumise",
      "UNDER_REVIEW": "En examen",
      "WITHDRAWN": "Retirée",
      "WON": "Attribuée"
    },
    "title": "Mes offres",
    "types": {
      "BO": "BO",
      "FIXED_PRICE": "Prix fixe",
      "NBO": "NBO"
    },
    "withdraw": "Retirer",
    "withdrawFailed": "Impossible de retirer la NBO",
    "withdrawSuccess": "NBO retirée avec succès"
  },
  "navigation": {
    "activities": "Activités",
    "addresses": "Adresses",
    "admin": "Administration",
    "aiJobs": "Taches IA",
    "aiLearning": "Mode apprentissage",
    "aiUpload": "Telechargement IA",
    "bids": "Offres",
    "campaigns": "Campagnes",
    "ceoAgent": "Assistant tâches",
    "companies": "Organisations",
    "contactDedup": "Dédoublonnage",
    "contacts": "Contacts",
    "contractExpiredTooltip": "Contrat expiré — contactez-nous pour un renouvellement",
    "contracts": "Contrats",
    "createProperty": "Créer un bien",
    "dashboard": "Tableau de bord",
    "deals": "Deals",
    "emailTemplates": "Modeles d'e-mail",
    "emails": "Emails",
    "favorites": "Liste de suivi",
    "fundRadar": "Radar des fonds",
    "investorSettings": "Paramètres",
    "investors": "Investisseurs",
    "linkedinImport": "Import LinkedIn",
    "listings": "Teasers",
    "myContracts": "Mes contrats",
    "myOffers": "Mes offres",
    "myProperties": "Mes biens immobiliers",
    "portfolio": "Portefeuille",
    "properties": "Propriétés",
    "qualityGate": "Quality Gate",
    "researchLeads": "Leads de recherche",
    "schema": "Schéma BDD",
    "search": "Recherche",
    "sectionAI": "Intelligence artificielle",
    "sectionAdmin": "Administration",
    "sectionBroker": "Courtier",
    "sectionCRM": "CRM",
    "sectionImmobilien": "Immobilier",
    "sectionInvestor": "Investisseur",
    "sectionSales": "Ventes",
    "sectionSeller": "Vendeur",
    "sectionSystem": "Système",
    "sectionTransactions": "Transactions",
    "settings": "Paramètres",
    "users": "Utilisateurs",
    "e2eReports": "E2E Reports",
    "menu": "Menü"
  },
  "nbobo": {
    "bo": {
      "amount": "Offre d'achat",
      "amountPlaceholder": "Montant en CHF",
      "bindingNotice": "Cette offre est juridiquement contraignante. En la soumettant, vous vous engagez à l'achat.",
      "conditions": "Conditions (optionnel)",
      "conditionsPlaceholder": "p.ex. Date de reprise, souhaits particuliers",
      "description": "Soumettez une offre d'achat ferme. Cette offre est juridiquement contraignante.",
      "step1": "Offre",
      "step2": "Signature LOI",
      "step3": "Preuve de financement",
      "step4": "Confirmation",
      "submit": "Soumettre offre ferme",
      "submitted": "Votre BO a été soumis.",
      "title": "Offre ferme (BO)",
      "waitingDecision": "En attente de la décision du vendeur",
      "withdraw": "Retirer BO",
      "withdrawn": "Votre BO a été retiré.",
      "stepAmount": "Angebot",
      "stepLoi": "LOI",
      "stepFinancing": "Nachweis",
      "stepConfirm": "Bestaetigung"
    },
    "boPhase": "Phase d'offre ferme (BO)",
    "boStatus": {
      "lost": "Non retenu",
      "rejected": "Rejeté",
      "submitted": "Soumis",
      "withdrawn": "Retiré",
      "won": "Attribué"
    },
    "countdown": {
      "ended": "Phase terminée",
      "endsIn": "Se termine dans {{time}}"
    },
    "guidePrice": "Prix indicatif",
    "minimumPrice": "Prix minimum",
    "nbo": {
      "amount": "Votre offre",
      "amountPlaceholder": "Montant en CHF",
      "conditions": "Conditions (optionnel)",
      "conditionsPlaceholder": "p.ex. Sous réserve de financement, due diligence",
      "description": "Soumettez une offre de prix non contraignante. Ceci sert de sondage de marché.",
      "evaluation": "Évaluation NBO",
      "evaluationPending": "L'évaluation des offres est en cours.",
      "median": "Médiane",
      "nonBindingNotice": "Cette offre est non contraignante et ne constitue pas une obligation d'achat.",
      "offers": "Offres",
      "range": "Fourchette",
      "submit": "Soumettre NBO",
      "submitted": "Votre NBO a été soumis.",
      "title": "Offre indicative (NBO)",
      "withdraw": "Retirer NBO",
      "withdrawConfirm": "Voulez-vous vraiment retirer votre NBO ?",
      "withdrawn": "Votre NBO a été retiré.",
      "stepAmount": "Angebot",
      "stepConditions": "Bedingungen",
      "stepFinancing": "Nachweis",
      "stepConfirm": "Unterschrift",
      "submittedDetail": "Ihr indikatives Angebot wurde erfolgreich eingereicht. Sie werden ueber den weiteren Verlauf informiert."
    },
    "nboPhase": "Phase d'offre indicative (NBO)",
    "nboStatus": {
      "lost": "Non qualifié",
      "outbid": "Surenchéri",
      "rejected": "Rejeté",
      "shortlisted": "Présélectionné",
      "submitted": "Soumis",
      "withdrawn": "Retiré",
      "won": "Qualifié"
    },
    "phase": "Phase",
    "sales": {
      "amount": "Montant",
      "award": "Attribuer",
      "awardConfirm": "Voulez-vous attribuer le marché à cet investisseur ?",
      "awardSuccess": "L'attribution a été effectuée.",
      "awarded": "Attribué",
      "boTab": "Phase BO",
      "date": "Date",
      "financingProof": "Preuve fin.",
      "investor": "Investisseur",
      "nboTab": "Phase NBO",
      "noOffers": "Pas encore d'offres",
      "status": "Statut",
      "title": "Offres"
    },
    "status": {
      "closed": "Clôturé",
      "evaluating": "En évaluation",
      "open": "Ouvert",
      "upcoming": "À venir"
    },
    "title": "Procédure d'offre",
    "report": {
      "viewReport": "Auswertung anzeigen",
      "title": "NBO-Auswertung"
    },
    "myOffer": {
      "titleNbo": "Votre NBO soumis",
      "titleBo": "Votre BO soumis",
      "amount": "Montant de l'offre",
      "status": "Statut",
      "submittedAt": "Soumis le",
      "updatedAt": "Dernière modification",
      "deadline": "Délai du tour",
      "loiSigned": "LOI signée",
      "financingProof": "Preuve de financement",
      "notAvailable": "Non disponible",
      "conditions": "Conditions et réserves",
      "noConditions": "Aucune indication",
      "readOnlyHint": "Cette vue affiche votre offre soumise. Aucune modification n'est possible ici."
    }
  },
  "notifications": {
    "allRead": "Toutes les notifications lues",
    "empty": "Aucune notification",
    "filterAll": "Toutes",
    "filterUnread": "Non lues",
    "markAllRead": "Tout marquer comme lu",
    "pushBlocked": "Push bloqué",
    "pushDisable": "Désactiver push",
    "pushEnable": "Activer push",
    "pushEnabled": "Push actif",
    "timeAgo": {
      "days": "il y a {{count}}j",
      "hours": "il y a {{count}}h",
      "justNow": "À l'instant",
      "minutes": "il y a {{count}} min"
    },
    "title": "Notifications",
    "types": {
      "ACCESS_GRANTED": "Accès accordé",
      "AI_EXTRACTION": "Extraction IA terminée",
      "AI_EXTRACTION_COMPLETE": "Extraction IA terminée",
      "BIDDING_ROUND_CLOSED": "Enchères fermées",
      "BIDDING_ROUND_CLOSING_SOON": "Enchères bientôt terminées",
      "BIDDING_ROUND_OPENED": "Enchères ouvertes",
      "BID_LOST": "Offre non retenue",
      "BID_SUBMITTED": "Offre soumise",
      "BID_SUBMITTED_SALES": "Nouvelle offre reçue",
      "BID_WON": "Offre acceptée",
      "CONTRACT_SIGNED_SALES": "Contrat signé",
      "CONTRACT_SIGNED_WELCOME": "Bienvenue – Contrat signé",
      "COUNTERSIGN_READY": "Contresignature prête",
      "COUNTERSIGN_REMINDER": "Rappel contresignature",
      "DOSSIER_UPDATE": "Dossier mis à jour",
      "INTEREST_EXPRESSED": "Intérêt exprimé",
      "INTEREST_SALES_NOTIFY": "Nouvel intérêt investisseur",
      "NDA_CONFIRMED": "NDA confirmé",
      "SIGNATURE_REQUIRED": "Signature requise"
    },
    "unreadCount": "non lues",
    "viewAll": "Tout afficher"
  },
  "offer": {
    "confirm": {
      "bindingWarning": "En soumettant, vous faites une offre d'achat contraignante au prix fixe. La réservation est valable 14 jours.",
      "financingProof": "Preuve de financement",
      "loiSigned": "LOI signée",
      "nonBindingInfo": "En soumettant, vous faites une offre d'achat non contraignante. Ceci n'est pas encore un contrat de vente.",
      "price": "Prix d'achat",
      "property": "Objet",
      "submit": "Soumettre l'offre contraignante",
      "title": "Résumé",
      "uploadLater": "Sera soumise ultérieurement"
    },
    "dialog": {
      "title": "Soumettre une offre",
      "yourPrice": "Ihr Angebot (CHF)",
      "stepsLabel": "Étapes de la remise d’offre",
      "steps": {
        "amount": "Votre offre",
        "document": "Votre document",
        "review": "Vérifier et envoyer"
      },
      "amount": {
        "wholeFrancs": "Francs entiers, sans centimes.",
        "fixedPrice": "Prix fixe : {{price}}",
        "guidePrice": "Prix indicatif : {{price}}",
        "minimumPrice": "Prix minimum : {{price}}"
      },
      "document": {
        "title": "Document d’offre",
        "description": "Utilisez le modèle standard ou téléversez votre propre document d’offre.",
        "standardOption": "Utiliser le modèle standard",
        "customOption": "Téléverser son propre document",
        "customDescription": "Téléversez votre propre document d’offre au format PDF. Il remplace le modèle standard.",
        "customHint": "PDF uniquement, max. 50 Mo",
        "dropHint": "Glissez le document d’offre ici ou sélectionnez-le",
        "removeFile": "Supprimer le fichier",
        "chooseHint": "Veuillez d’abord choisir comment vous souhaitez soumettre votre offre."
      },
      "reservations": {
        "title": "Réserves",
        "description": "Cochez les réserves qui s’appliquent à votre offre. Seuls les points cochés figurent dans le document.",
        "templateTitle": "Votre offre est soumise aux réserves suivantes :",
        "none": "Aucune réserve cochée",
        "loadFailed": "Les réserves n’ont pas pu être chargées. Vous pouvez aussi soumettre votre offre sans réserves."
      },
      "remarks": {
        "title": "Remarques",
        "description": "Indiquez ici ce qui va au-delà des réserves — par exemple une reprise au plus tôt à une date donnée. Le texte est transmis tel quel.",
        "placeholder": "p. ex. reprise au plus tôt au 1.1.2028"
      },
      "summary": {
        "document": "Document d’offre",
        "standardSigned": "Modèle standard, signé numériquement",
        "noRemarks": "Aucune remarque"
      },
      "template": {
        "heading": "Déclaration d’intention",
        "subtitleBinding": "Déclaration d’intention d’achat contraignante",
        "subtitleNonBinding": "Déclaration d’intention d’achat non contraignante",
        "date": "Date",
        "object": "Objet",
        "price": "Prix d’achat",
        "bodyBinding": "Je déclare par la présente mon intérêt contraignant à acquérir l’objet mentionné ci-dessus au prix d’achat indiqué. Cette déclaration constitue la base des négociations ultérieures et de la conclusion d’un contrat de vente notarié.",
        "bodyNonBinding": "Je déclare par la présente mon intérêt à acquérir l’objet mentionné ci-dessus au prix d’achat indiqué. Cette déclaration est non contraignante et ne crée aucune obligation d’achat.",
        "note": "La déclaration sert de base au projet de contrat de vente établi par le notaire.",
        "signatureLine": "Lieu, date / signature de l’acheteuse ou de l’acheteur"
      },
      "notice": {
        "binding": "Il s’agit d’une offre contraignante. En l’envoyant, vous vous engagez à acheter aux conditions indiquées.",
        "nonBinding": "Il s’agit d’une offre non contraignante. Aucun contrat de vente n’est encore conclu."
      },
      "uploadFailed": "Votre offre a été soumise. Le transfert a échoué pour : {{files}}. Veuillez réessayer.",
      "retryUploads": "Transférer à nouveau les fichiers",
      "success": {
        "title": "Offre soumise",
        "message": "Votre offre a été soumise avec succès. Vous recevrez une confirmation par e-mail."
      }
    },
    "errors": {
      "alreadySubmitted": "Vous avez déjà soumis une offre pour cet objet.",
      "noLongerAvailable": "Cet objet n'est plus disponible.",
      "submitFailed": "L'offre n'a pas pu être soumise. Veuillez réessayer."
    },
    "financing": {
      "browse": "Choisir un fichier",
      "description": "Téléchargez une preuve de financement (p.ex. confirmation bancaire, engagement de financement). Vous pouvez aussi la soumettre plus tard.",
      "dropHint": "Glissez le fichier ici ou cliquez",
      "fileTooLarge": "Le fichier est trop volumineux (max. 50 Mo).",
      "hint": "PDF, PNG ou JPG, max. 50 Mo",
      "required": "Veuillez télécharger une preuve de financement.",
      "skipForNow": "Soumettre plus tard",
      "title": "Preuve de financement",
      "upload": "Télécharger la preuve",
      "uploadFailed": "Échec du téléchargement. Veuillez réessayer.",
      "uploadSuccess": "Preuve de financement téléchargée avec succès.",
      "uploaded": "Téléchargé le {{date}}",
      "descriptionOptional": "Laden Sie einen Finanzierungsnachweis hoch (z.B. Bankbestaetigung). Sie koennen diesen auch spaeter nachreichen."
    },
    "loi": {
      "bindingNotice": "En signant, vous confirmez votre intérêt contraignant à l'achat au prix fixe indiqué. Ceci n'est pas encore un contrat de vente.",
      "description": "Veuillez signer la lettre d'intention (LOI) pour confirmer votre intérêt contraignant à l'achat.",
      "nonBindingNotice": "Par votre signature, vous confirmez votre intérêt d'achat au prix indiqué. Ceci n'est pas encore un contrat de vente et est sans engagement.",
      "signatoryHint": "Veuillez signer ici",
      "signatureLabel": "Votre signature",
      "title": "Signer la lettre d'intention"
    },
    "status": {
      "awarded": "Attribue",
      "cancelled": "Annulé",
      "completed": "Terminé",
      "expired": "Expiré",
      "outbid": "Surenchere",
      "proofPending": "Preuve en attente",
      "rejected": "Rejeté",
      "reserved": "Réservé",
      "submitted": "Soumise",
      "withdrawn": "Retire"
    },
    "statusCard": {
      "expired": "Réservation expirée",
      "expiresIn": "Expire dans {{time}}",
      "submittedAt": "Soumise le {{date}}",
      "title": "Votre offre"
    },
    "submitButton": "Soumettre une offre",
    "success": {
      "message": "Votre offre a été soumise avec succès. Vous recevrez une confirmation par e-mail.",
      "proofReminder": "Veuillez télécharger la preuve de financement dans les délais.",
      "reservationInfo": "Votre réservation est valable jusqu'au {{date}}. Veuillez soumettre la preuve de financement à temps.",
      "title": "Offre soumise avec succès"
    }
  },
  "organizations": {
    "accentColor": "Couleur d'accentuation",
    "addAddress": "Ajouter une adresse",
    "addContactToOrg": "Ajouter un contact",
    "addEmail": "Ajouter une adresse e-mail",
    "addInfoOwner": "+ Ajouter un responsable info",
    "addOrganization": "Ajouter une organisation",
    "addPhone": "Ajouter un numéro de téléphone",
    "addressAdded": "Adresse ajoutée",
    "addressDeleted": "Adresse supprimée",
    "addressUpdated": "Adresse mise à jour",
    "addresses": "Adresses",
    "allTypes": "Tous les types",
    "bindingClauseEnabled": "Clause d'engagement activée",
    "cancelResearch": "Annuler",
    "cannotDelete": "Suppression impossible",
    "cannotDeleteSigned": "Impossible de supprimer : signatures de contrat existantes",
    "canton": "Canton",
    "city": "Ville",
    "companyTab": "Entreprise",
    "confirmDelete": "Voulez-vous vraiment supprimer cette organisation? Toutes les associations seront également supprimées.",
    "contactCreateFailed": "Le contact n'a pas pu être créé",
    "contacts": "Contacts",
    "contactsTab": "Contacts",
    "createSuccess": "Organisation créée avec succès",
    "createUser": "Créer un utilisateur",
    "dataQuality": {
      "title": "Qualité des données",
      "scoreOutOf": "{{score}} sur 100 points",
      "openTitle": "Points ouverts ({{count}})",
      "fulfilledSummary": "{{count}} remplis",
      "passedOfTotal": "{{passed}} sur {{total}} remplis",
      "filterIncomplete": "incomplet (< {{min}})",
      "assignedToMe": "Organisation vous a été attribuée",
      "duplicateRow": "Doublon : {{name}} ({{reason}})",
      "status": {
        "ok": "Complet",
        "warn": "À vérifier",
        "missing": "Manquant",
        "alert": "Conflit"
      },
      "actions": {
        "upload_logo": "Téléverser le logo",
        "apply_research": "Appliquer la proposition",
        "run_research": "Lancer la recherche",
        "sync_zefix": "Actualiser depuis Zefix",
        "merge_contacts": "Fusionner les contacts",
        "merge_companies": "Fusionner les organisations",
        "assign_owner": "M’attribuer",
        "choose_owner": "Choisir",
        "add_email": "Ajouter un e-mail",
        "add_address": "Ajouter une adresse",
        "edit_search_profile": "Saisir le profil de recherche"
      },
      "checks": {
        "logo": "Logo",
        "generic_email": "E-mail d’entreprise",
        "address": "Adresse postale",
        "phone": "Téléphone",
        "zefix_age": "Registre du commerce",
        "research": "Recherche investisseur",
        "research_pending": "Proposition de recherche",
        "contact_duplicates": "Doublons de contacts",
        "company_duplicates": "Doublon",
        "owner": "Responsabilité",
        "search_profile": "Profil de recherche",
        "holdings": "Parc immobilier propre"
      }
    },
    "dedupBannerTitle": "Doublons possibles détectés:",
    "dedupReasonName": "nom similaire",
    "dedupReasonUid": "même IDE",
    "dedupWarning": "Doublon?",
    "deleteOrganization": "Supprimer l'organisation",
    "deleteSuccess": "Organisation supprimée avec succès",
    "description": "Description",
    "discardResearch": "Supprimer",
    "discardResearchConfirm": "Les résultats de la recherche seront retirés de la vue. Ils seront rechargés lors de la prochaine actualisation.",
    "discardResearchTitle": "Supprimer la recherche ?",
    "duplicateUid": "Une organisation avec ce numéro IDE existe déjà",
    "editOrganization": "Modifier l'organisation",
    "editRole": "Modifier le rôle",
    "email": "E-mail",
    "emailAdded": "Adresse e-mail ajoutée",
    "emailAddresses": "Adresses e-mail",
    "emailDeleted": "Adresse e-mail supprimée",
    "emailSignatureTemplate": "Modèle de signature e-mail (HTML)",
    "emailUpdated": "Adresse e-mail mise à jour",
    "filterContacts": "Filtrer les contacts...",
    "hasBlockers": "ne peut pas être supprimée car des dépendances existent encore :",
    "hasProfile": "Profil d'entreprise disponible",
    "hideContacts": "Masquer les contacts",
    "houseNumber": "Numéro",
    "infoOwner": "Responsable info (plusieurs possibles)",
    "infoOwnerRole": "Info",
    "isTenant": "Mandant (interne)",
    "keyPersonsFromResearch": "Personnes clés (de la recherche)",
    "legalForm": "Forme juridique",
    "logoAlt": "Logo de {{name}}",
    "logoDragOrClick": "Glissez le logo ici ou cliquez",
    "logoFormatError": "Seuls les formats PNG, JPG ou WebP sont autorisés",
    "logoSizeError": "Fichier trop volumineux (max. 5 Mo)",
    "logoUploadFailed": "Le téléversement du logo a échoué",
    "logoUploaded": "Logo téléversé",
    "logoUploading": "Téléversement...",
    "logoUrlPlaceholder": "Ou saisir une URL directement : https://...",
    "mergeFailed": "La fusion a échoué",
    "mergeLinkMissing": "Lien avec cette organisation introuvable",
    "mergeSuccess": "Organisations fusionnées avec succès",
    "name": "Nom",
    "noContactsForOrg": "Aucun contact assigné",
    "noFilterResults": "Aucun contact trouvé",
    "noOrganizations": "Aucune organisation trouvée",
    "noOwner": "-- Aucun responsable --",
    "noUidDescription": "Cette organisation n'a pas d'UID. Vous pouvez la lier à une entrée Zefix.",
    "notesAutoSaveHint": "Les modifications sont enregistrées automatiquement.",
    "notesPlaceholder": "Notes sur l'organisation...",
    "openZefix": "Ouvrir dans Zefix",
    "owner": "Responsable",
    "ownerRole": "Responsable",
    "phone": "Telephone",
    "phoneAdded": "Numéro de téléphone ajouté",
    "phoneDeleted": "Numéro de téléphone supprimé",
    "phoneNumbers": "Numéros de téléphone",
    "phoneUpdated": "Numéro de téléphone mis à jour",
    "pin": "Épingler",
    "pinToggled": "Statut d'épingle modifié",
    "pinned": "Épinglé",
    "possibleDuplicate": "Doublon possible",
    "possibleMatches": "Correspondances possibles :",
    "primaryAddress": "Adresse principale",
    "primaryColor": "Couleur primaire",
    "primaryContact": "Personne de contact",
    "primaryEmail": "Adresse e-mail principale",
    "primaryPhone": "Numéro principal",
    "profile": "Profil",
    "removeBlockersHint": "Veuillez supprimer ou réattribuer les dépendances listées ci-dessus avant de supprimer cette organisation.",
    "removeInfoOwner": "Retirer le responsable info",
    "removeInvestorGroup": "Retirer le groupe d'investisseurs",
    "removePrimaryContact": "Retirer l'interlocuteur",
    "researchCancelled": "Recherche annulée",
    "researchDiscarded": "Résultats de recherche supprimés",
    "resultsLabel": "Organisations",
    "revenue": "Chiffre d'affaires",
    "sameUid": "même UID",
    "searchNameOrUid": "Rechercher un nom ou un UID...",
    "searchPlaceholder": "Rechercher par nom, UID ou ville...",
    "selectMergeTarget": "Sélectionner une organisation à fusionner",
    "setPrimaryContact": "Définir comme interlocuteur",
    "showContacts": "Afficher les contacts",
    "signatureAuth": "Droit de signature",
    "similarName": "nom similaire",
    "sourceManual": "Manuel",
    "street": "Rue",
    "subtitle": "Toutes les entreprises enregistrées au registre du commerce",
    "syncAdded": "{{count}} ajouté(s)",
    "syncDeactivated": "{{count}} désactivé(s)",
    "syncNoPersons": "Aucun signataire autorisé trouvé dans le registre du commerce",
    "syncNotFound": "Entreprise non trouvée dans le registre du commerce — UID inexistant chez Zefix",
    "syncReactivated": "{{count}} réactivé(s)",
    "syncSkippedPinned": "{{count}} épinglé(s) (ignorés)",
    "syncSuccess": "Contacts mis à jour depuis Zefix",
    "syncUnchanged": "{{count}} inchangé(s)",
    "syncUpdated": "{{count}} mis à jour",
    "syncingContacts": "Chargement des contacts depuis Zefix...",
    "tabAddressContact": "Adresse et contact",
    "tabCommercialRegister": "Registre du commerce",
    "tabMasterData": "Données de base",
    "tabNotes": "Notes",
    "tabResearch": "Recherche",
    "tabResponsibility": "Responsabilité",
    "tabSignature": "Signature",
    "title": "Organisations",
    "type": "Type",
    "typeNameOrUid": "Saisissez un nom ou un UID...",
    "types": {
      "broker": "Courtier",
      "buyer": "Acheteur",
      "other": "Autre",
      "partner": "Partenaire",
      "seller": "Vendeur"
    },
    "uid": "UID",
    "unpin": "Désépingler",
    "updateSuccess": "Organisation mise à jour avec succès",
    "viaZefixCreate": "Créer via Zefix",
    "website": "Site web",
    "zefixAssign": "Attribuer Zefix",
    "zefixAssigned": "Zefix attribué",
    "zefixAssignFailed": "Échec de l'association Zefix",
    "zefixAutoMerged": "{{count}} contacts mis à jour automatiquement (fonction/signature)",
    "zefixContactCreated": "{{name}} créé",
    "zefixContactMerged": "{{name}} fusionné",
    "zefixCreated": "Organisation créée via Zefix",
    "zefixRefresh": "Actualiser depuis Zefix",
    "zefixReviewDescription": "Les contacts suivants du registre du commerce n'ont pas pu être attribués de manière univoque. Veuillez vérifier l'attribution manuellement.",
    "zefixReviewTitle": "Vérifier les contacts Zefix",
    "zefixSearchPlaceholder": "Rechercher une entreprise au registre du commerce...",
    "zefixSync": "Actualiser depuis Zefix",
    "zefixSyncFailed": "La synchronisation Zefix a échoué",
    "zefixSynced": "Données Zefix mises à jour",
    "zipCode": "Code postal",
    "capital": "Capital",
    "quickProfile": "Profil succinct",
    "industry": "Secteur",
    "employees": "Employés",
    "parentCompany": "Société mère",
    "revenueEstimate": "Chiffre d'affaires",
    "keyPersons": "Personnes clés",
    "contactImportFailed": "L'import a échoué",
    "contactAcknowledged": "Contact confirmé",
    "acknowledgeFailed": "La confirmation a échoué",
    "extractedContacts": "Contacts trouvés",
    "alreadyExists": "Déjà présent",
    "acknowledge": "Confirmer",
    "imported": "Repris",
    "importContact": "Reprendre",
    "researchComplete": "Recherche terminée",
    "researchFailed": "La recherche a échoué",
    "researchStarting": "Démarrage de la recherche...",
    "discardFailed": "La suppression a échoué",
    "purpose": "But",
    "research": "Recherche IA",
    "discard": "Supprimer",
    "researching": "Recherche en cours...",
    "updateResearch": "Actualiser",
    "startResearch": "Lancer la recherche",
    "discardConfirmTitle": "Supprimer les résultats de la recherche ?",
    "discardConfirmText": "Toutes les données de recherche enregistrées (profil, personnes clés, secteur, etc.) seront définitivement supprimées.",
    "confirmDiscard": "Oui, supprimer",
    "researchBackground": "S'exécute en arrière-plan — vous pouvez quitter la page.",
    "noResearch": "Aucune recherche disponible",
    "editSection": "Modifier {{section}}",
    "editMore": "Modifier les autres informations",
    "addressLabel": "Libellé",
    "phoneLabel": "Libellé",
    "emailLabel": "Libellé",
    "removeAddress": "Supprimer l'adresse",
    "removePhone": "Supprimer le numéro de téléphone",
    "removeEmail": "Supprimer l'adresse e-mail",
    "contactData": {
      "title": "Coordonnées de l’organisation",
      "webLinks": "Web",
      "badgePrimary": "Principal",
      "badgeCentral": "Centrale",
      "badgeRank": "Rang {{rank}}",
      "genericHint": "Les adresses génériques (investments@, info@) appartiennent à l’organisation, les adresses personnelles au contact concerné.",
      "updated": "Coordonnées mises à jour"
    },
    "contactImported": "Contact repris : {{name}}",
    "dedupInfo": "{{count}} des personnes trouvées sont déjà enregistrées comme contacts de cette organisation.",
    "revenuePlaceholder": "1-5 mio CHF",
    "keyFigures": {
      "title": "Chiffres clés",
      "empty": "—",
      "add": "Compléter",
      "rows": {
        "capital": "Capital",
        "founded": "Fondation",
        "employees": "Collaborateurs",
        "revenue": "Chiffre d'affaires",
        "dealSize": "Taille de transaction",
        "relevance": "Score de pertinence"
      },
      "relevanceValue": "{{score}} sur 100",
      "dealSizeFrom": "à partir de {{min}}",
      "dealSizeUpTo": "jusqu'à {{max}}",
      "sources": {
        "zefix": {
          "badge": "Z",
          "label": "Source : registre du commerce (Zefix)"
        },
        "research": {
          "badge": "IA",
          "label": "Source : recherche IA"
        },
        "searchProfile": {
          "badge": "PR",
          "label": "Source : profil de recherche"
        }
      },
      "pendingHint": "AUM, portefeuille et transactions suivront avec Investor Research."
    },
    "searchProfile": {
      "title": "Profil de recherche",
      "empty": "—",
      "add": "Compléter",
      "today": "aujourd'hui",
      "hardMin": "en dessous du minimum exclu",
      "dealSizeRange": "{{min}} – {{max}} mio CHF",
      "dealSizeFrom": "dès {{min}} mio CHF",
      "dealSizeUpTo": "jusqu'à {{max}} mio CHF",
      "yieldGross": "brut dès {{value}}%",
      "columns": {
        "criterion": "Critère",
        "sought": "Recherché",
        "excluded": "Exclu",
        "source": "Source",
        "action": "Action"
      },
      "rows": {
        "usage": "Affectation",
        "region": "Région / cantons",
        "dealSize": "Taille de transaction",
        "yield": "Rendement",
        "investmentForm": "Forme d'investissement",
        "conditionYear": "État / année de construction",
        "ownershipForm": "Forme de propriété",
        "minSize": "Taille minimale",
        "noGos": "Critères rédhibitoires"
      },
      "sources": {
        "pitchdeck": {
          "badge": "PD",
          "label": "Source : reprise du pitch deck"
        },
        "ai": {
          "badge": "IA",
          "label": "Source : recherche IA"
        },
        "manual": {
          "badge": "✎",
          "label": "Source : saisie manuelle"
        },
        "archive": {
          "badge": "Archive",
          "label": "Source : reprise de données archivées"
        },
        "contract": {
          "badge": "MR",
          "label": "Source : mandat de recherche"
        }
      }
    },
    "registerChecks": {
      "title": "Registres et contrôles",
      "empty": "—",
      "asOf": "État au {{date}}",
      "checkedAt": "contrôlé le {{date}}",
      "checks": {
        "zefix": "Registre du commerce",
        "seco": "Liste de sanctions du SECO",
        "finma": "FINMA",
        "oak_bv": "CHS PP",
        "six": "SIX Swiss Exchange",
        "sro": "OAR (LBA)",
        "ubo": "Ayants droit économiques",
        "kyc": "Identification (LBA)",
        "memberships": "Associations / affiliations"
      },
      "status": {
        "ok": "Contrôlé et confirmé",
        "unknown": "Non répertorié / inconnu",
        "warn": "En attente ou plus ancien que 180 jours",
        "alert": "Correspondance exigeant une action"
      },
      "actions": {
        "zefix_sync": "Actualiser via Zefix",
        "zefix_search": "Associer à Zefix"
      }
    },
    "researchPortrait": {
      "portfolioTitle": "Portefeuille",
      "transactionsTitle": "Transactions",
      "portfolioObjects_one": "{{count}} objet",
      "portfolioObjects_other": "{{count}} objets",
      "portfolioFocus": "Focus",
      "amountMillions": "{{value}} mio CHF",
      "amountBillions": "{{value}} mia CHF",
      "source": "Source",
      "empty": "Aucune donnée exploitable"
    },
    "researchApply": {
      "openCta": "Vérifier et reprendre la recherche ({{count}})",
      "title": "Reprendre le résultat de la recherche",
      "fieldsTitle": "Champs",
      "personsTitle": "Personnes",
      "colMark": "Marqué",
      "colField": "Champ",
      "colCurrent": "Actuel",
      "colProposal": "Proposition",
      "colConfidence": "Fiabilité",
      "colAction": "Action",
      "markRow": "Marquer {{field}}",
      "actionFor": "Action pour {{field}}",
      "actions": {
        "keep": "conserver",
        "accept": "reprendre",
        "both": "les deux"
      },
      "personActions": {
        "link": "lier",
        "create": "créer",
        "link_auditor": "lier comme organe de révision",
        "discard": "écarter"
      },
      "personMatch": "Correspondance : {{name}}",
      "empty": "—",
      "lowConfidence": "Information incertaine — à vérifier avant reprise",
      "applyAll": "Tout reprendre",
      "applyMarked": "Seulement marqués",
      "applied": "{{fields}} champs et {{persons}} personnes repris",
      "failed": "Échec de la reprise",
      "nothingMarked": "Aucune ligne marquée",
      "noProposals": "Aucune proposition en attente",
      "pendingTitle": "{{count}} propositions de recherche en attente",
      "pendingHint": "La décision se prend dans la fenêtre «Reprendre le résultat de la recherche» — le bouton se trouve en haut de cette page.",
      "personsHint": "Liez, créez ou écartez les personnes dans la fenêtre «Reprendre le résultat de la recherche» en haut de cette page.",
      "nothingToApply": "Toutes les lignes sont sur «conserver» — rien à reprendre."
    },
    "sourceBadge": {
      "ai": {
        "badge": "IA",
        "label": "Source : recherche IA"
      },
      "zefix": {
        "badge": "Z",
        "label": "Source : registre du commerce (Zefix)"
      },
      "manual": {
        "badge": "✎",
        "label": "Source : saisie manuelle"
      },
      "public_data": {
        "badge": "PD",
        "label": "Source : données publiques"
      },
      "import": {
        "badge": "IMP",
        "label": "Source : import de données"
      },
      "research": {
        "badge": "IA",
        "label": "Source : recherche IA"
      },
      "amtsblatt": {
        "badge": "FOSC",
        "label": "Source : feuille officielle (FOSC)"
      },
      "dateLabel": "État au {{date}}"
    },
    "hero": {
      "aiBadge": "IA",
      "aiSourceHint": "Repris de la recherche IA",
      "applyResearch": "Vérifier et reprendre la recherche",
      "applyResearchCount": "Vérifier et reprendre la recherche ({{count}})",
      "cantons": "Cantons",
      "dataQuality": "Qualité des données {{value}}",
      "dataQualityComplete": "Données complètes",
      "dataQualityHint": "Aller aux points ouverts",
      "dataQualityOpen": "Données : {{open}} à compléter",
      "dealFrom": "Deal dès CHF {{min}} mio",
      "dealRange": "Deal CHF {{min}}–{{max}} mio",
      "dealTo": "Deal jusqu'à CHF {{max}} mio",
      "holdings": "Parc : {{objects}} · CHF {{value}}",
      "holdingsObjects": "Parc : {{objects}}",
      "holdingsHint": "Vers l'onglet Immobilier",
      "more": "+{{n}}",
      "owner": "Responsable : {{name}}",
      "ownerMissing": "Responsable : —",
      "relevance": "Pertinence {{score}}",
      "relevanceMissing": "Pertinence — pas de profil",
      "usages": "Affectations"
    },
    "holdings": {
      "title": "Parc immobilier propre",
      "objects": "{{count}} biens",
      "objectsOne": "1 bien",
      "objectFallback": "Bien #{{id}}",
      "value": "CHF {{value}}",
      "valueMillions": "{{value}} mio",
      "valueBillions": "{{value}} mia",
      "asOf": "État au {{date}}",
      "groupBy": "Vue",
      "byFund": "Par véhicule/cluster",
      "byUsage": "Usage",
      "byCanton": "Canton",
      "unassignedFund": "Sans véhicule",
      "fundFilter": "Véhicule « {{name}} » uniquement",
      "fundFilterClear": "Annuler le filtre",
      "focusReason": "Candidats : {{reason}} ({{count}})",
      "focusReasonAny": "Candidats ({{count}})",
      "focusUsage": "Usage : {{usage}} ({{count}})",
      "focusCanton": "Canton : {{canton}} ({{count}})",
      "focusClear": "Supprimer le filtre",
      "candidate": "Candidat à la transaction",
      "area": "{{value}} m²",
      "units": "{{count}} unités",
      "unitsOne": "1 unité",
      "since": "depuis {{year}}",
      "transactions": "Transactions",
      "columnDate": "Date",
      "columnObject": "Bien",
      "columnPrice": "Prix",
      "columns": {
        "object": "Bien",
        "place": "Lieu/adresse",
        "usage": "Usage",
        "size": "Unités/surface",
        "value": "Valeur",
        "acquired": "Acquisition",
        "fund": "Véhicule",
        "flag": "Candidat",
        "source": "Source",
        "select": "Sélection"
      },
      "source": "Source",
      "sourceRef": "Source : {{ref}}",
      "empty": "Aucun parc immobilier connu",
      "fundKpis": {
        "value": "Valeur de marché",
        "objects": "Biens",
        "objectsSource": "{{count}} selon la source",
        "objectsRecorded": "{{count}} saisis",
        "vacancy": "Vacance",
        "yield": "Rendement",
        "status": "Statut",
        "asOf": "État au",
        "empty": "{{name}} · aucun bien saisi"
      },
      "transactionKinds": {
        "buy": "Achat",
        "sell": "Vente",
        "stake": "Participation"
      },
      "edit": {
        "start": "Modifier le parc immobilier propre",
        "saved": "Parc immobilier propre mis à jour",
        "addFund": "Véhicule",
        "addCluster": "Groupe",
        "addObject": "Saisir un objet",
        "fundName": "Nom du véhicule",
        "clusterName": "Nom du groupe",
        "clusterKind": "Type de regroupement",
        "clusterKinds": {
          "region": "Région",
          "usage": "Affectation",
          "strategy": "Stratégie",
          "size": "Taille",
          "custom": "Personnalisé"
        },
        "renameFund": "Renommer le véhicule",
        "renameCluster": "Renommer le groupe",
        "deleteFund": "Supprimer le véhicule",
        "deleteCluster": "Supprimer le groupe",
        "deleteFundTitle": "Supprimer le véhicule ?",
        "deleteClusterTitle": "Supprimer le groupe ?",
        "deleteGroupHint": "«{{name}}» sera supprimé. Les objets subsistent mais perdent leur affectation.",
        "deleteObject": "Supprimer l'objet",
        "deleteObjectTitle": "Supprimer l'objet ?",
        "deleteObjectHint": "«{{name}}» sera retiré du parc immobilier.",
        "editObject": "Modifier l'objet",
        "selectObject": "Sélectionner {{name}}",
        "selectedCount": "{{count}} sélectionné(s)",
        "clearSelection": "Annuler la sélection",
        "moveTo": "Déplacer vers",
        "moveToFund": "Déplacer vers un véhicule",
        "moveToCluster": "Déplacer vers un groupe",
        "objectTitleNew": "Saisir un objet",
        "objectTitleEdit": "Modifier l'objet",
        "objectCreated": "Objet saisi",
        "objectUpdated": "Objet enregistré",
        "sourceManual": "Source : saisie manuelle",
        "usage": "Affectation",
        "usageDetail": "Affectation, détail",
        "usageOther": "Autre affectation",
        "usageNone": "Sans indication",
        "area": "Surface (m²)",
        "units": "Unités",
        "buildYear": "Année de construction",
        "acquiredYear": "Année d'acquisition",
        "value": "Valeur (CHF)",
        "fund": "Véhicule",
        "cluster": "Groupe",
        "noCluster": "Sans groupe",
        "notes": "Note",
        "cantonInvalid": "Canton en 2 lettres, p. ex. ZH",
        "yearInvalid": "Année à 4 chiffres, p. ex. 1998",
        "numberInvalid": "Veuillez saisir un nombre"
      }
    },
    "portfolioReview": {
      "title": "Nettoyage du portefeuille",
      "headerCount": "{{candidates}} sur {{objects}} objets",
      "reasonCount": "{{label}} {{count}}",
      "reasons": {
        "non_core": "Non-core",
        "small": "petite taille",
        "old": "ancien",
        "manual": "manuel"
      },
      "reasonHints": {
        "non_core": "ne correspond pas au profil de recherche (usage ou canton)",
        "small": "valeur inférieure à 10 % de l’objet moyen de même usage",
        "old": "année de construction plus de 25 ans antérieure au parc",
        "manual": "marqué à la main"
      },
      "noProfileHint": "Aucun profil de recherche — seuls la taille et l'âge sont évalués",
      "shareOfObjects": "{{label}} : {{count}} sur {{objects}} objets",
      "openProperties": "Voir les {{candidates}} candidats dans l’onglet Immobilier",
      "empty": "Aucun candidat trouvé",
      "pdf": "PDF",
      "pdfAria": "Télécharger l’assainissement du portefeuille en PDF",
      "pdfFailed": "Le PDF n’a pas pu être chargé",
      "flagSet": "Marquer comme candidat à la vente",
      "flagRemove": "Retirer le marquage",
      "flagSaved": "Marquage enregistré",
      "noteTitle": "Marquer comme candidat à la vente",
      "noteHint": "«{{name}}» sera marqué comme candidat à la vente.",
      "noteLabel": "Note (facultative)",
      "notePlaceholder": "Pourquoi cet objet peut-il être cédé ?",
      "taskCreated": "Tâche créée",
      "taskCreatedFor": "Tâche créée pour {{name}}"
    },
    "fundMonitor": {
      "title": "Véhicules de placement",
      "kpiAum": "Encours total",
      "kpiProperties": "Immeubles",
      "kpiLtv": "LTV moy. / limite",
      "kpiVacancy": "Vacance moy.",
      "kpiSell": "Signaux de vente",
      "kpiBuy": "Signaux d'achat",
      "colAum": "Encours",
      "colProperties": "Objets",
      "colLtv": "LTV / limite",
      "colVacancy": "Vacance",
      "colTerm": "Durée",
      "expand": "Déplier « {{name}} »",
      "collapse": "Replier « {{name}} »",
      "sellSignal": "Signal de vente",
      "buySignal": "Signal d'achat",
      "moreSignals": "+{{count}} autres",
      "structureOpenEnd": "structure ouverte",
      "structureClosedEnd": "structure fermée",
      "termEnd": "jusqu'au {{date}}",
      "inception": "depuis {{year}}",
      "subscription": "Souscription",
      "subscriptionOpen": "ouverte",
      "subscriptionClosed": "fermée",
      "redemption": "Rachat",
      "redemptionAnnounced": "annoncé {{value}}",
      "capitalIncrease": "Augmentation de capital",
      "performance": "Rendement",
      "perfYtd": "Cumul annuel",
      "perf1y": "1 an",
      "perf3y": "3 ans",
      "perf5y": "5 ans",
      "valuation": "Évaluation",
      "nav": "Valeur nette",
      "gav": "Valeur brute",
      "propertyValue": "Valeur des immeubles",
      "agio": "Prime",
      "fiscalYearEnd": "Exercice",
      "source": "Provenance",
      "sourceLink": "Rapport",
      "openObjects": "Objets",
      "openObjectsAria": "Objets de « {{name}} » dans l'onglet Immobilier",
      "noObjectList": "Liste des objets manquante – source : rapport"
    },
    "qualification": {
      "action": "Qualifier",
      "blockedHint": "La branche et la personne de contact sont obligatoires",
      "chipHint": "Importée de l'entonnoir d'adresses — pas encore qualifiée",
      "contactExisting": "Choisir une personne existante",
      "contactNew": "Saisir une nouvelle personne",
      "dialogTitle": "Qualifier l'organisation",
      "failed": "La qualification a échoué",
      "filterAll": "Qualification : toutes",
      "filterLabel": "Qualification",
      "finish": "Terminer",
      "industryHint": "Au moins une branche est obligatoire.",
      "nameMismatch": "Le registre du commerce indique « {{register}} », la fiche indique « {{stored}} ». Veuillez d'abord synchroniser.",
      "noUid": "Attribuer d'abord un IDE",
      "noUidHint": "Sans IDE, le registre du commerce ne peut pas être comparé. Reliez l'organisation à une entrée Zefix.",
      "position": "Fonction",
      "qualified": "Qualifiée",
      "stepContact": "Saisir la personne de contact",
      "stepIndustry": "Choisir la branche",
      "stepRegister": "Confirmer le registre du commerce",
      "success": "Organisation qualifiée",
      "unqualified": "Non qualifiée"
    },
    "glossary": {
      "objects": {
        "title": "Objets",
        "what": "Immeubles enregistrés de cette société (portefeuille propre), tous véhicules confondus.",
        "how": "Nombre d'objets dans l'onglet Immeubles."
      },
      "units": {
        "title": "Unités",
        "what": "Logements et surfaces commerciales de tous les objets enregistrés.",
        "how": "Somme des unités ; « — » si aucune n'est saisie."
      },
      "value": {
        "title": "Valeur",
        "what": "Somme des valeurs de marché des objets enregistrés — pas la fortune gérée (AUM).",
        "how": "Additionne la valeur estimée par objet."
      },
      "candidates": {
        "title": "Candidats",
        "what": "Objets susceptibles d'être vendus lors d'un assainissement du portefeuille.",
        "how": "Non-core, petit et ancien sont calculés ; ⚑ manuel est enregistré."
      },
      "funds": {
        "title": "Véhicules",
        "what": "Fonds, groupes de placement et fondations de placement de cette société.",
        "how": "Tous les véhicules enregistrés, même sans objets attribués."
      },
      "non_core": {
        "title": "Non-core",
        "what": "Ne correspond pas à la stratégie de la société.",
        "how": "Usage ou canton hors du profil de recherche, ou objet dans le cluster « Non-core ». Sans profil, ce motif est ignoré."
      },
      "small": {
        "title": "petit",
        "what": "Trop petit pour le portefeuille.",
        "how": "Valeur inférieure à 10 % de l'objet moyen de même usage."
      },
      "old": {
        "title": "ancien",
        "what": "Nettement plus ancien que le reste du portefeuille.",
        "how": "Année de construction de plus de 25 ans antérieure au portefeuille, pas de rénovation dans les notes."
      },
      "manual": {
        "title": "manuel",
        "what": "Marqué comme candidat à la main (⚑).",
        "how": "Marquage dans l'onglet Immeubles, avec note."
      },
      "sourceReport": "Rapport/portrait",
      "aum_chf": {
        "title": "AUM",
        "what": "Fortune gérée par le véhicule.",
        "how": "Selon la source : immeubles, liquidités et autres actifs."
      },
      "properties_count": {
        "title": "Objets",
        "what": "Immeubles de ce véhicule, selon la source.",
        "how": "Chiffre du rapport ou du portrait ; à défaut, la ligne compte les objets enregistrés chez nous."
      },
      "ltv_pct": {
        "title": "LTV",
        "what": "Part des hypothèques dans la valeur immobilière. Élevé = peu de marge pour acheter.",
        "how": "Loan-to-value = hypothèques ÷ valeur de marché des immeubles, selon la source."
      },
      "ltv_limit_pct": {
        "title": "Limite",
        "what": "Plafond d'endettement de ce véhicule.",
        "how": "Selon le règlement ou le prospectus. Plus le LTV s'en approche, moins d'achats sont possibles."
      },
      "vacancy_pct": {
        "title": "Vacance",
        "what": "Perte locative en pour cent. Bas = portefeuille sain.",
        "how": "Selon la source (définition de la source : revenu ou surface)."
      },
      "agio_pct": {
        "title": "Agio / Disagio",
        "what": "Cours boursier par rapport à la valeur nette d'inventaire (VNI), uniquement pour les véhicules cotés.",
        "how": "Disagio (négatif) = cours sous la VNI → augmentation de capital peu attrayante → achète peu, vend plutôt."
      },
      "nav": {
        "title": "VNI",
        "what": "Fortune du véhicule après déduction des dettes.",
        "how": "Valeur nette d'inventaire selon le rapport."
      },
      "gav": {
        "title": "VBI",
        "what": "Fortune du véhicule avant déduction des dettes.",
        "how": "Valeur brute d'inventaire selon le rapport."
      },
      "signals_sell": {
        "title": "Signal de vente",
        "what": "Déclaration de la source indiquant des ventes.",
        "how": "Citée du rapport ou du communiqué."
      },
      "signals_buy": {
        "title": "Signal d'achat",
        "what": "Déclaration de la source indiquant des achats.",
        "how": "P. ex. souscription ouverte, augmentation de capital prévue."
      },
      "subscription": {
        "title": "Souscription",
        "what": "Si de nouvelles parts peuvent être souscrites.",
        "how": "ouverte = afflux d'argent, achats probables ; fermée = pas de nouveau capital."
      },
      "redemption": {
        "title": "Rachat",
        "what": "Délai pour que les investisseurs rendent leurs parts.",
        "how": "Rachats annoncés en CHF = sorties d'argent → pression à la vente."
      },
      "structure": {
        "title": "Durée",
        "what": "Si le véhicule est limité dans le temps.",
        "how": "structure ouverte = illimitée ; fermée = durée jusqu'à une date, puis vente du portefeuille."
      },
      "capital_increase": {
        "title": "Augmentation de capital",
        "what": "Si le véhicule lève de nouveaux capitaux.",
        "how": "Dernière et prochaine augmentation selon la source ; prévue = achats probables."
      },
      "sourceLine": "Source : {{source}} · état au {{date}}"
    },
    "holdingsCard": {
      "title": "Immobilier · Parc immobilier propre",
      "kpiObjects": "Objets",
      "kpiUnits": "Unités",
      "kpiUnitsKnown": "{{known}} sur {{total}} renseignés",
      "kpiValue": "Valeur",
      "kpiCandidates": "Candidats",
      "kpiFunds": "Véhicules",
      "byUsage": "Par usage",
      "byReason": "Nettoyage du portefeuille",
      "byCanton": "Par canton",
      "segment": "{{usage}} : {{count}} objets",
      "noCandidates": "Nettoyage du portefeuille : 0 candidat — tous les objets correspondent au profil de recherche",
      "noValue": "Non renseigné",
      "openProperties": "Onglet Immobilier",
      "barLink": "{{label}} : afficher {{count}} objets dans l'onglet Immeubles"
    },
    "uidSource": {
      "zefix": "UID : registre du commerce",
      "uid_register": "UID : registre UID",
      "manual": "UID : saisie manuelle",
      "fetchedAt": "{{label}} — consulté le {{date}}"
    }
  },
  "pagination": {
    "next": "Suivant",
    "page": "Page {{current}} sur {{total}}",
    "previous": "Précédent",
    "rowsPerPage": "Lignes par page",
    "showing": "Affichage {{from}}-{{to}} sur {{total}}"
  },
  "preferences": {
    "notifications": {
      "categories": {
        "contract_updates": "Mises à jour des contrats",
        "favorites_updates": "Mises à jour des favoris",
        "new_matches": "Nouvelles correspondances",
        "offer_updates": "Mises à jour des offres",
        "platform_news": "Actualités de la plateforme"
      },
      "descriptions": {
        "contract_updates": "Changements de statut sur vos contrats, p.ex. signature ou expiration.",
        "favorites_updates": "Modifications sur vos biens favoris.",
        "new_matches": "Nouveaux biens correspondant à votre profil de recherche.",
        "offer_updates": "Mises à jour importantes sur vos offres.",
        "platform_news": "Actualités et nouveautés sur Immotron."
      },
      "devices": {
        "empty": "Aucun appareil n'est encore enregistré pour les notifications push. Enregistrez cet appareil pour recevoir les messages push.",
        "namePlaceholder": "Nom de l'appareil (p.ex. iPhone personnel)",
        "permissionBlocked": "Vous avez bloqué les notifications push pour ce site. Veuillez les activer dans les paramètres du navigateur.",
        "permissionDenied": "Autorisation refusée. Activez les notifications dans les paramètres du navigateur.",
        "registerAnother": "Enregistrer un autre appareil",
        "registerError": "Impossible d'enregistrer l'appareil",
        "registerSuccess": "Appareil enregistré",
        "registerThis": "Enregistrer cet appareil",
        "registeredOn": "Enregistré le {{date}}",
        "removeAria": "Supprimer l'appareil",
        "removeError": "Impossible de supprimer l'appareil",
        "removeSuccess": "Appareil supprimé",
        "renameAria": "Renommer l'appareil",
        "renameError": "Impossible d'enregistrer le nom",
        "renameSuccess": "Nom mis à jour",
        "serverNotConfigured": "Les notifications push ne sont pas encore configurées côté serveur. Vos préférences sont enregistrées et les messages seront livrés dès que le push sera disponible.",
        "subtitle": "Gérez les appareils sur lesquels vous souhaitez recevoir des notifications push.",
        "testButton": "Envoyer un test",
        "testError": "Impossible d'envoyer le test",
        "testNone": "Aucun appareil joignable",
        "testSending": "Envoi …",
        "testSent": "Push de test envoyé à {{count}} appareil(s)",
        "title": "Appareils pour notifications push",
        "unnamedDevice": "Appareil sans nom",
        "unregisterError": "Impossible de désinscrire l'appareil",
        "unregisterSuccess": "Cet appareil a été désinscrit",
        "unregisterThis": "Désinscrire cet appareil",
        "unsupported": "Ce navigateur ne prend pas en charge les notifications push."
      },
      "emailColumn": "E-mail",
      "loadFailed": "Impossible de charger les paramètres de notification",
      "locked": "Ne peut pas être désactivé",
      "pushColumn": "Push",
      "pushRequiresDevice": "Veuillez d'abord enregistrer un appareil pour activer les notifications push.",
      "saveFailed": "Impossible d'enregistrer le paramètre",
      "subtitle": "Choisissez comment vous souhaitez être notifié pour chaque événement.",
      "title": "Notifications"
    },
    "privacy": {
      "activityTracking": {
        "description": "Nous autoriser à analyser votre utilisation de la plateforme de manière anonyme pour améliorer l'expérience.",
        "title": "Suivi d'activité"
      },
      "anonymizeActivity": "Anonymiser l'activité",
      "anonymizeDescription": "Vos activités seront affichées de manière anonyme aux autres utilisateurs",
      "anonymous": "Anonyme",
      "anonymousDescription": "Votre profil n'est pas visible par les autres utilisateurs",
      "dataManagement": "Gestion des données",
      "deleteAccount": {
        "button": "Supprimer le compte",
        "description": "Votre compte et toutes les donnees associees seront definitivement supprimes.",
        "title": "Supprimer le compte"
      },
      "exportData": {
        "button": "Exporter",
        "description": "Telechargez une copie de vos donnees personnelles.",
        "error": "Échec de l'export des données",
        "success": "Export des données téléchargé avec succès",
        "title": "Exporter les données"
      },
      "legal": "Mentions legales",
      "loadFailed": "Impossible de charger les paramètres de confidentialité",
      "marketingEmails": {
        "description": "Recevez occasionnellement des actualités, conseils et offres par e-mail.",
        "title": "E-mails marketing"
      },
      "privacyPolicyLink": "Politique de confidentialite",
      "profileVisibility": "Visibilité du profil",
      "profileVisible": {
        "description": "Votre profil est visible par les autres utilisateurs de la plateforme.",
        "title": "Profil visible"
      },
      "public": "Public",
      "publicDescription": "Votre profil est visible par les autres utilisateurs",
      "saveFailed": "Impossible d'enregistrer le paramètre",
      "settings": "Parametres de confidentialite",
      "termsLink": "Conditions d'utilisation",
      "title": "Confidentialité"
    }
  },
  "profile": {
    "active": "Aktiv",
    "admin": {
      "backToUsers": "Zurück zur Benutzerliste",
      "impersonate": "Als Benutzer einloggen",
      "impersonateDescription": "Öffnet eine Session als dieser Benutzer",
      "loginAs": "Einloggen",
      "resetEmailSent": "Reset-E-Mail gesendet",
      "resetLinkCopied": "Reset-Link in Zwischenablage kopiert",
      "resetPassword": "Passwort zurücksetzen",
      "sendResetLink": "Reset-Link senden"
    },
    "companyAssignments": "Firmenzugehörigkeiten",
    "directPhone": "Direktnummer",
    "functionPlaceholder": "z.B. Geschäftsführer, Sales Manager",
    "functionTitle": "Funktion",
    "languageAuto": "Automatisch (Systemsprache)",
    "preferredLanguage": "Hauptsprache",
    "role": "Rôle",
    "sections": {
      "compliance": "Compliance",
      "emailAccounts": "E-Mail-Konten",
      "passkeys": "Passkeys",
      "password": "Mot de passe",
      "profile": "Profil",
      "security": "Sécurité"
    },
    "subtitle": "Gérer les paramètres personnels et la sécurité",
    "title": "Mon profil"
  },
  "properties": {
    "activate": "Activer",
    "activated": "Bien immobilier activé.",
    "activeHighlights": "Aktive Highlights",
    "addProperty": "Ajouter une propriété",
    "addRow": "Ajouter une ligne",
    "address": "Adresse",
    "aiBanner": {
      "confidence": "Confiance",
      "hideHints": "Masquer les indications",
      "hintsCount": "{{count}} indications",
      "showHints": "Afficher les indications",
      "title": "Extraction IA"
    },
    "aiConfidence": "Qualité des données IA",
    "approve": "Approuver",
    "approved": "Bien immobilier approuvé.",
    "area": "Surface",
    "availableData": "Verfügbare Daten",
    "backToList": "Retour a la liste",
    "bulk": {
      "affectedCount": "{{count}} biens concernés",
      "confirmDelete": "Supprimer les biens ?",
      "confirmStatus": "Changer le statut ?",
      "error": "Opération en masse échouée",
      "newStatus": "Nouveau statut",
      "success": "Operation groupee reussie."
    },
    "city": "Ville",
    "compactMode": "Compact",
    "condition": {
      "EXCELLENT": "Excellent",
      "FAIR": "Convenable",
      "GOOD": "Bon",
      "GUTTED": "Décapé",
      "NEW": "Neuf",
      "RENOVATION_NEEDED": "À rénover"
    },
    "conditions": {
      "EXCELLENT": "Excellent",
      "FAIR": "Satisfaisant",
      "GOOD": "Bon",
      "GUTTED": "Décapé",
      "NEW": "Neuf",
      "RENOVATION_NEEDED": "À rénover"
    },
    "confirmDelete": "Voulez-vous vraiment supprimer ce bien ? Cette action est irréversible.",
    "country": "Pays",
    "createSuccess": "Bien créé avec succès",
    "deleteFinal": "Supprimer définitivement",
    "deleteProperty": "Supprimer le bien",
    "deleteSuccess": "Bien supprimé avec succès",
    "description": "Description",
    "detail": {
      "activate": "Activer",
      "archive": "Archiver",
      "changeStatus": "Changer le statut",
      "gallery": "Galerie d'images",
      "investorAccess": "Accès investisseurs",
      "keyFacts": "Chiffres clés",
      "noAccess": "Aucun investisseur avec accès"
    },
    "diff": {
      "city": "Ort",
      "condition": "Zustand",
      "constructionYear": "Baujahr",
      "empty": "(leer)",
      "grossYield": "Bruttorendite",
      "heating": "Heizung",
      "lotSize": "Grundstücksflaeche",
      "marketValue": "Marktwert",
      "price": "Preis",
      "propertyType": "Immobilientyp",
      "rentalIncome": "Mieteinnahmen",
      "residentialUnits": "Wohneinheiten",
      "status": "Status",
      "street": "Strasse",
      "usableArea": "Nutzfläche",
      "zipCode": "PLZ"
    },
    "documents": "Documents",
    "draft": {
      "discard": "Supprimer",
      "found": "Un brouillon non sauvegardé a été trouvé",
      "restore": "Restaurer",
      "restored": "Brouillon restauré"
    },
    "duplicate": "Dupliquer",
    "duplicateSuccess": "Bien préparé comme copie",
    "editProperty": "Modifier la propriété",
    "errors": {
      "deleteFailed": "Impossible de supprimer le bien",
      "imageDeleteFailed": "Impossible de supprimer l'image",
      "imageRotateFailed": "Impossible de faire pivoter l'image",
      "imageTooLarge": "L'image «{{name}}» est trop volumineuse (max. 10 Mo)",
      "imageUnsupportedType": "Format d'image de «{{name}}» non pris en charge",
      "imageUploadFailed": "Impossible de télécharger l'image",
      "loadFailed": "Impossible de charger les biens",
      "saveFailed": "Impossible de sauvegarder le bien",
      "submitFailed": "Fehler beim Einreichen",
      "unrealisticYield": "Unrealistischer Wert — bitte Eingabedaten prüfen",
      "updateFailed": "La mise a jour a echoue."
    },
    "externalLinks": "Externe Links",
    "favorites": {
      "empty": "Aucun favori pour le moment",
      "impersonate": "Se connecter en tant qu'investisseur",
      "loginAs": "Connexion",
      "showDetails": "Afficher les détails",
      "title": "Favoris des investisseurs"
    },
    "fields": {
      "canton": "Canton",
      "createdBy": "Créé par",
      "favorites": "Favoris",
      "location": "Emplacement",
      "name": "Désignation",
      "price": "Prix min.",
      "status": "Statut",
      "type": "Type"
    },
    "filters": {
      "clearAll": "Réinitialiser les filtres",
      "max": "Max",
      "min": "Min",
      "priceRange": "Fourchette de prix (CHF)",
      "results": "résultats",
      "sortBy": "Trier par",
      "sortNewest": "Plus récents",
      "sortOldest": "Plus anciens",
      "sortPriceAsc": "Prix croissant",
      "sortPriceDesc": "Prix décroissant",
      "title": "Filtres"
    },
    "floor": "Étage",
    "form": {
      "addressPlaceholder": "Saisir l'adresse (p.ex. Bahnhofstrasse 1, Zurich)",
      "annualRentalIncome": "Revenus locatifs annuels (CHF)",
      "anzahl_etagen": "Etagen",
      "assignedTo": "Attribue a",
      "bruttorendite_pct": "Bruttorendite",
      "buildingCount": "Nombre de bâtiments",
      "cadastralNumber": "No cadastral",
      "cadastreNumber": "N° cadastre",
      "cadastre_number": "Kataster-Nr.",
      "calcAutoHint": "Calculé automatiquement",
      "canton": "Canton",
      "city": "Localité",
      "commercialArea": "Surface commerciale",
      "commercialAreaSqm": "Surface commerciale (m²)",
      "commercialUnits": "Unités commerciales",
      "commercial_area_sqm": "Surface commerciale",
      "commissionRate": "Commission (%)",
      "condition": "État",
      "conditionField": "État",
      "constructionYear": "Année de construction",
      "country": "Pays",
      "description": "Description",
      "desiredPrice": "Prix souhaité (CHF)",
      "desiredPricePlaceholder": "p.ex. 1800000",
      "desiredTimeline": "Délai souhaité",
      "desiredTimelinePlaceholder": "p.ex. Vente d'ici Q3 2026",
      "detailedDescription": "Description",
      "dragToReorder": "Glisser pour réordonner",
      "egridNumber": "N° E-GRID",
      "energieklasse": "Classe énergétique",
      "energyClassEnvelope": "Classe énergétique (enveloppe)",
      "energyClassTotal": "Classe énergétique (globale)",
      "equityYield": "Rendement des fonds propres",
      "floorAreaRatio": "Indice d'utilisation",
      "floorCount": "Nombre d'étages",
      "garageParking": "Places de garage",
      "garageParkingCount": "Places de garage",
      "grossYield": "Rendement brut",
      "groundLeaseExpiration": "Expiration droit de superficie",
      "hasBuildingPermit": "Permis de construire disponible",
      "hasBuildingRight": "Droit de superficie",
      "hasGroundLease": "Droit de superficie",
      "hasLift": "Lift vorhanden",
      "has_building_permit": "Baubewilligung",
      "has_ground_lease": "Baurecht",
      "has_lift": "Lift",
      "heatingSystem": "Système de chauffage",
      "heating_system": "Heizung",
      "highlightOrder": "Ordre",
      "highlights": "Points forts de l'investissement",
      "houseNumber": "Numéro",
      "imageDragDrop": "Glisser les images ici ou cliquer pour télécharger",
      "imageHint": "JPG, PNG, WEBP. Max. 10 Mo.",
      "imageUploading": "Téléchargement de l'image...",
      "investmentHighlights": "Points forts investissement",
      "isPrivateListing": "Offre privée",
      "isPrivateListingHint": "Visible uniquement pour les investisseurs sélectionnés",
      "latitude": "Latitude",
      "leerstand_pct": "Vacance",
      "listingExpirationDate": "Date d'expiration",
      "longitude": "Longitude",
      "lotSizeSqm": "Surface du terrain (m²)",
      "macroLocation": "Macro-situation",
      "marketValueChf": "Valeur vénale (CHF)",
      "marketValueDate": "Date de la valeur vénale",
      "marketValueSource": "Source de la valeur vénale",
      "marketValueSourcePlaceholder": "IAZI, Wüest Partner",
      "marktwert_chf": "Valeur vénale",
      "max_building_height": "Hauteur max. du bâtiment",
      "microLocation": "Micro-situation",
      "minimumPrice": "Prix minimum (CHF)",
      "multipleSelectionAllowed": "Sélection multiple possible",
      "name": "Désignation",
      "netYield": "Rendement net",
      "noImages": "Aucune image téléchargée",
      "orderLost": "Mandat perdu",
      "outdoorParking": "Places extérieures",
      "outdoorParkingCount": "Places de parking extérieures",
      "ownershipType": "Type de propriété",
      "ownership_type": "Eigentum",
      "parking": "Places de parc",
      "postalCode": "NPA",
      "price": "Prix",
      "pricePerSqm": "Prix au m²",
      "price_per_sqm": "Preis/m²",
      "primaryImage": "Image principale",
      "propertySubtype": "Sous-type",
      "propertyType": "Type de bien",
      "renovation": "Rénovation",
      "renovationPlaceholder": "p.ex. Dernière rénovation 2018, toit 2020",
      "residentialArea": "Surface habitable",
      "residentialAreaSqm": "Surface habitable (m²)",
      "residentialUnits": "Unités résidentielles",
      "residential_area_sqm": "Surface habitable",
      "rotateImage": "Pivoter de 90°",
      "saleEndDate": "Fin de vente",
      "saleStartDate": "Debut de vente",
      "salesUserId": "Responsable des ventes",
      "salesUserIdPlaceholder": "Aucune attribution",
      "sellerNotes": "Notes du vendeur",
      "sendExpirationReminder": "Envoyer un rappel avant l'expiration",
      "setPrimary": "Définir comme image principale",
      "status": "Statut",
      "street": "Rue",
      "subheader": "Sous-titre",
      "teaserHighlights": "Points forts teaser",
      "teaserHighlightsHint": "Sélectionnez les points clés affichés sur la page teaser investisseur. Définissez l'ordre avec des numéros.",
      "uploadImages": "Télécharger des images",
      "usableAreaSqm": "Surface utile (m²)",
      "utilization_factor": "Indice d'utilisation",
      "vacancyRate": "Vacance (%)",
      "volume": "Volumen",
      "volumeM3": "Volume (m³)",
      "volume_m3": "Volumen",
      "vrTourUrl": "URL visite virtuelle",
      "yearBuilt": "Année de construction"
    },
    "heating": {
      "DISTRICT": "Chauffage à distance",
      "ELECTRIC": "Chauffage électrique",
      "GAS": "Chauffage au gaz",
      "HEAT_PUMP": "Pompe à chaleur",
      "OIL": "Chauffage au mazout",
      "OTHER": "Autre",
      "PELLETS": "Chauffage à pellets",
      "SOLAR": "Chauffage solaire"
    },
    "highlights": {
      "annual_income": "Revenus locatifs p.a.",
      "building_count": "Bâtiments",
      "building_permit": "Permis de construire",
      "commercial_area": "Surface commerciale",
      "commercial_units": "Unités commerciales",
      "condition": "État",
      "construction_year": "Année de construction",
      "energieklasse": "Classe énergétique",
      "etagen": "Étages",
      "gross_yield": "Rendement brut",
      "heating_system": "Chauffage",
      "location": "Emplacement",
      "lot_size": "Surface du terrain",
      "marktwert": "Valeur de marché",
      "net_yield": "Rendement net",
      "ownership": "Type de propriété",
      "parking": "Places de parc",
      "price": "Prix demandé",
      "property_type": "Type de bien",
      "residential_area": "Surface habitable",
      "residential_units": "Unités résidentielles",
      "usable_area": "Surface utile",
      "vacancy": "Vacance",
      "volume": "Volume"
    },
    "highlightsAddHint": "Highlights aus der Liste unten hinzufügen...",
    "images": "Images",
    "list": {
      "companyLabel": "Mandant",
      "empty": {
        "description": "Ajoutez votre première propriété pour commencer.",
        "title": "Aucune propriété trouvée"
      },
      "emptyFiltered": "Aucun objet ne correspond aux filtres actifs : {{filters}}",
      "emptyFilteredTitle": "Aucun résultat",
      "resetFilters": "Réinitialiser les filtres",
      "switchCompany": "Changer de mandant"
    },
    "listingPreview": "Aperçu du teaser",
    "listingPreviewBanner": "Aperçu — Comment les investisseurs voient ce teaser",
    "teaserViewToggle": {
      "ariaLabel": "Choisir l'affichage de l'aperçu",
      "web": "Vue web",
      "newsletter": "Newsletter e-mail",
      "delivery": "Envoi & analyse"
    },
    "teaserDelivery": {
      "title": "Envoi & analyse",
      "summary": {
        "sent": "Envoyés",
        "delivered": "Remis",
        "opened": "Ouverts",
        "clicked": "Cliqués"
      },
      "columns": {
        "recipient": "Destinataire",
        "mail": "E-mail",
        "sent": "Envoyé",
        "delivered": "Remis",
        "opened": "Ouvert",
        "clicked": "Cliqué"
      },
      "types": {
        "ACCESS_GRANTED": "E-mail d'accès",
        "BUYER_ONBOARDING_INVITE": "Invitation",
        "ONBOARDING_CORRECTION": "Invitation de correction"
      },
      "bounced": "Non distribuable",
      "empty": "Aucun e-mail n'a encore été envoyé pour cette offre.",
      "loadError": "L'analyse n'a pas pu être chargée."
    },
    "sendAsCampaign": {
      "button": "Envoyer comme campagne",
      "gateLocked": "Disponible uniquement après le contrôle qualité",
      "title": "Envoyer le teaser comme campagne",
      "intro": "Le teaser devient une campagne e-mail — avec le même contenu qu'un investisseur voit sans NDA. Vous pouvez ensuite vérifier le contenu et les destinataires, envoyer un test, puis l'expédier.",
      "gateChecking": "Vérification de la barrière NDA …",
      "gateOk": "Barrière NDA franchie — {{count}} image(s) du teaser publiée(s)",
      "gateBlocked": "La barrière NDA bloque l'envoi",
      "gateLoadFailed": "L'aperçu du teaser n'a pas pu être chargé.",
      "locationConfirm": "Publier délibérément les images sensibles à la localisation",
      "includeRecipients": "Ajouter {{count}} destinataire(s) des groupes d'investisseurs",
      "includeRecipientsHint": "Membres des groupes d'investisseurs attribués à ce bien.",
      "noRecipients": "Aucun destinataire issu des groupes d'investisseurs — vous pourrez téléverser des destinataires via CSV à l'étape suivante.",
      "create": "Créer la campagne",
      "created": "Campagne créée — veuillez vérifier le contenu et effectuer un envoi de test.",
      "createFailed": "La campagne n'a pas pu être créée.",
      "recipientsFailed": "Les destinataires n'ont pas pu être ajoutés — veuillez les ajouter dans le flux de campagne."
    },
    "loading": "Chargement en cours...",
    "map": {
      "noCoordinates": "{{count}} biens sans coordonnées (non visibles sur la carte)"
    },
    "media": {
      "showArchive": "Afficher aussi les images supprimées",
      "archiveTitle": "Archives ({{count}})",
      "archiveEmpty": "Aucune image supprimée.",
      "deletedOn": "Supprimée le {{date}}",
      "restore": "Restaurer",
      "restored": "Image restaurée",
      "restoreError": "Échec de la restauration",
      "teaserText": {
        "label": "Texte court du teaser",
        "placeholder": "p.ex. Bien entièrement loué, rendement stable et réserve de développement ...",
        "hint": "Visible avant le NDA — pas de localités, pas de n° d'objet."
      }
    },
    "ownershipTypes": {
      "CORPORATE": "Entreprise",
      "MULTIPLE": "Copropriété",
      "SINGLE": "Propriétaire unique",
      "TRUST": "Trust"
    },
    "price": "Prix",
    "propertyDetails": "Détails de la propriété",
    "quarantine": {
      "badge": "Localisation manquante",
      "banner": {
        "action": "Veuillez vérifier et compléter manuellement les champs d'adresse, puis enregistrer.",
        "description": "La localisation n'a pas pu être déterminée automatiquement. Les données d'adresse (NPA, coordonnées, EGRID/EGID) sont manquantes.",
        "title": "Extraction IA incomplète"
      }
    },
    "reject": "Rejeter",
    "rejectReason": "Motif du rejet",
    "rejected": "Bien immobilier rejeté.",
    "removeRow": "Zeile entfernen",
    "rentRoll": {
      "ancillaryCostsChf": "Charges CHF",
      "areaSqm": "Surface m²",
      "floor": "Étage",
      "netRentChf": "Loyer net CHF",
      "nutzungsart": "Type d'utilisation",
      "nutzungsartUnset": "Non défini",
      "nutzungsartOptions": {
        "wohnung": "Logement",
        "gewerbe": "Commercial",
        "parkplatz": "Place de parc",
        "werbeflaeche": "Surface publicitaire",
        "antenne": "Antenne",
        "sonstige": "Autre"
      },
      "rooms": "Pièces",
      "status": "Status"
    },
    "rentalYield": "Rendement locatif",
    "rooms": "Pièces",
    "saveSuccess": "Bien sauvegardé avec succès",
    "search": {
      "placeholder": "Rechercher par nom, ville, adresse..."
    },
    "sections": {
      "address": "Adresse",
      "calculations": "Chiffres clés",
      "buildingRight": "Droit de superficie",
      "classification": "Classification",
      "dealState": "Statut & étape du deal",
      "dossierDocuments": "Documents du dossier",
      "images": "Images",
      "land": "Terrain",
      "objectDetails": "Détails de l'objet",
      "ownershipAndCadastre": "Propriété & cadastre",
      "pricingTerms": "Prix & Conditions",
      "salesTimeline": "Vente & calendrier",
      "sellerDesiredTerms": "Souhaits du vendeur",
      "statusLegal": "Statut & Droit",
      "teaserHighlights": "Points clés du teaser"
    },
    "states": {
      "CLOSED": "Clôturé",
      "CLOSING": "Clôture",
      "DUE_DILIGENCE": "Due Diligence",
      "IDENTIFIED": "Identifié",
      "NEGOTIATION": "En négociation",
      "UNDER_CONTRACT": "Sous contrat"
    },
    "status": "Statut",
    "statusChanged": "Le statut a ete modifie.",
    "statusDescriptions": {
      "ACTIVE": "Actif : Le bien est publié et visible par les investisseurs. Des offres peuvent être soumises.",
      "ARCHIVED": "Archivé : Le bien a été désactivé et n'est plus visible par les investisseurs.",
      "DRAFT": "Brouillon : Le bien a été créé mais pas encore publié. Il n'est visible que par le personnel interne et peut encore être modifié.",
      "PENDING": "En attente : Le bien attend l'approbation via le Quality Gate. Tous les champs obligatoires et documents doivent être complets.",
      "SOLD": "Vendu : Le bien a été vendu avec succès. Plus d'offres possibles."
    },
    "statuses": {
      "ACTIVE": "Actif",
      "ARCHIVED": "Archivé",
      "DRAFT": "Brouillon",
      "PENDING": "En attente",
      "SOLD": "Vendu",
      "active": "Actif",
      "archived": "Archivé",
      "draft": "Brouillon",
      "reserved": "Réservé",
      "sold": "Vendu",
      "IN_REVIEW": "En vérification"
    },
    "submitForReview": "Soumettre pour vérification",
    "submittedForReview": "Soumis pour verification.",
    "subtitle": "Gérez vos propriétés",
    "subtypes": {
      "AGRICULTURAL": "Terrain agricole",
      "APARTMENT": "Appartement / PPE",
      "AUTO_REPAIR": "Garage automobile",
      "CONDOMINIUM": "Copropriété",
      "DATA_CENTER": "Centre de données",
      "DEVELOPMENT": "Terrain à bâtir",
      "FACTORY": "Usine / Site de production",
      "FITNESS_CENTER": "Centre de fitness / Wellness",
      "GAS_STATION": "Station-service",
      "HOTEL": "Hôtel",
      "LOGISTICS": "Immobilier logistique",
      "MEDICAL_PRACTICE": "Cabinet médical / Centre de santé",
      "MIXED_COMMERCIAL": "Surface commerciale mixte",
      "MULTI_FAMILY": "Maison plurifamiliale",
      "OFFICE": "Bureau",
      "PARKING": "Parking / Place de parc",
      "PRODUCTION": "Surface de production",
      "RESTAURANT": "Restaurant / Gastronomie",
      "RETAIL": "Surface commerciale",
      "SHOWROOM": "Surface d'exposition / Showroom",
      "SINGLE_FAMILY": "Maison individuelle",
      "VILLA": "Villa",
      "WAREHOUSE": "Entrepôt",
      "WORKSHOP": "Atelier / Artisanat"
    },
    "tabs": {
      "basicData": "Données de base",
      "details": "Caractéristiques",
      "legal": "Aspects juridiques",
      "media": "Médias & Marketing",
      "pricing": "Prix & Finances",
      "translations": "Traductions"
    },
    "templates": {
      "deleted": "Modèle supprimé",
      "empty": "Aucun modèle enregistré",
      "loaded": "Modèle chargé",
      "namePrompt": "Nom du modèle :",
      "saveAs": "Enregistrer comme modèle...",
      "saved": "Modèle enregistré",
      "title": "Modèles"
    },
    "regenerateTexts": {
      "button": "Régénérer les textes",
      "error": "Échec de la génération des textes",
      "field": {
        "ariaLabel": "Régénérer {{field}}",
        "button": "Régénérer",
        "description": "Ajoutez éventuellement une remarque — seul ce champ sera régénéré (allemand).",
        "instructionLabel": "Remarque / instruction (facultatif)",
        "instructionPlaceholder": "p. ex. raccourcir, davantage axé sur le rendement",
        "loading": "Génération...",
        "submit": "Régénérer",
        "success": "Le champ a été régénéré",
        "title": "Régénérer {{field}}"
      },
      "hint": "Régénère le sous-titre, les points forts, la description ainsi que la macro et micro-localisation par IA (allemand). Les textes existants seront écrasés.",
      "loading": "Génération des textes...",
      "success": "Les textes ont été régénérés"
    },
    "title": "Propriétés",
    "translations": {
      "autoTranslate": "Traduction auto",
      "autoTranslateFailed": "Échec de la traduction automatique",
      "autoTranslateSuccess": "Traductions générées automatiquement",
      "autoTranslating": "Création des traductions...",
      "compareTo": "Comparer avec",
      "contentSection": "Contenus",
      "hint": "Les textes sont enregistrés séparément par langue. Remplissez une langue et utilisez la traduction automatique pour les autres.",
      "locationSection": "Description de l'emplacement",
      "namePlaceholder": "p.ex. Immeuble de bureaux Zurich City",
      "noSourceContent": "Veuillez d'abord remplir au moins le titre ou la description",
      "notFilled": "Non rempli",
      "outOfSync": "La langue principale ({{lang}}) a été modifiée. Les traductions ne sont peut-être plus à jour.",
      "sideBySide": "Comparer les langues côte à côte",
      "sideBySideShort": "Comparer",
      "subheaderPlaceholder": "p.ex. Emplacement de premier ordre dans le quartier d'affaires"
    },
    "type": "Type",
    "types": {
      "COMMERCIAL": "Commercial",
      "INDUSTRIAL": "Industriel",
      "LAND": "Terrain",
      "MIXED_USE": "Résidentiel / Commercial",
      "RESIDENTIAL": "Résidentiel",
      "apartment": "Appartement",
      "commercial": "Commercial",
      "house": "Maison",
      "land": "Terrain",
      "office": "Bureau",
      "retail": "Commerce"
    },
    "unitMix": {
      "addRange": "Plage",
      "area": "Surface m²",
      "areaFrom": "Surface m² de",
      "areaTo": "Surface m² à",
      "removeRange": "Supprimer la plage",
      "rentedCount": "Loués",
      "rooms": "Pièces",
      "totalCount": "Total"
    },
    "validation": {
      "fixErrors": "Veuillez remplir tous les champs obligatoires",
      "required": "Champ obligatoire"
    },
    "unifiedWizard": {
      "advancedFields": "Informations avancées",
      "annualRentalIncome": "Revenus locatifs annuels (CHF)",
      "anzahlEtagen": "Nombre d'étages",
      "areas": "Surfaces",
      "buildingCount": "Nombre de bâtiments",
      "cadastreNumber": "Numéro cadastral",
      "commercialAreaSqm": "Surface commerciale (m²)",
      "commercialUnits": "Unités commerciales",
      "create": "Créer le bien",
      "createFailed": "Échec de la création",
      "createSuccess": "Bien créé avec succès",
      "detailedDescription": "Description détaillée",
      "energyEnvelope": "Classe énergétique enveloppe",
      "energyTotal": "Classe énergétique globale",
      "garageParking": "Places de parc en garage",
      "groundLeaseExpiration": "Échéance droit de superficie",
      "hasBuildingPermit": "Permis de construire disponible",
      "hasGroundLease": "Droit de superficie",
      "hasLift": "Ascenseur disponible",
      "imageUploadFailed": "{{count}} sur {{total}} images n'ont pas pu être téléchargées",
      "internalFields": "Informations internes",
      "investmentHighlights": "Atouts d'investissement",
      "offerPrice": "Prix d'offre",
      "offerPriceHint": "Le prix d'offre est affiché aux investisseurs.",
      "outdoorParking": "Places de parc extérieures",
      "ownershipType": "Forme de propriété",
      "principal": {
        "blockedHint": "Le mandant et le type de mandat sont obligatoires avant de continuer.",
        "contactCreateFailed": "Le contact n'a pas pu être créé.",
        "contactCreated": "Contact créé avec succès",
        "contactHint": "Sélectionnez un contact CRM existant ou créez un nouveau mandant.",
        "contactLabel": "Mandant (contact CRM)",
        "createNew": "Créer un nouveau contact",
        "email": "E-mail",
        "firstName": "Prénom",
        "lastName": "Nom",
        "lastNameRequired": "Veuillez saisir le nom",
        "optionalHint": "Le mandant est optionnel. Vous pouvez le compléter à tout moment via le bandeau fixe de la page d'édition.",
        "ready": "Mandant enregistré — vous pouvez continuer.",
        "saveContact": "Créer le contact",
        "searchPlaceholder": "Rechercher un contact...",
        "subtitle": "Qui est le mandant pour la commercialisation de ce bien ?"
      },
      "principalRequired": "Veuillez d'abord saisir le mandant et le type de mandat.",
      "renovation": "Rénovation",
      "residentialAreaSqm": "Surface habitable (m²)",
      "residentialUnits": "Unités résidentielles",
      "status": {
        "complete": "Complet",
        "incomplete": "Incomplet",
        "neutral": "Optionnel"
      },
      "steps": {
        "aiUpload": "Téléchargement IA",
        "basicData": "Données de base",
        "details": "Caractéristiques",
        "legal": "Aspects juridiques",
        "media": "Médias et marketing",
        "pricing": "Prix et commercialisation",
        "principal": "Mandant",
        "summary": "Récapitulatif"
      },
      "subtitle": "Saisissez votre bien en 8 étapes",
      "summaryHint": "Vérifiez les informations et créez le bien.",
      "title": "Saisir un bien",
      "virtualTourUrl": "URL visite virtuelle (optionnel)",
      "volumeM3": "Volume (m³)"
    },
    "wizard": {
      "button": "Assistant",
      "create": "Créer le bien",
      "descriptionPlaceholder": "Description détaillée du bien...",
      "imagesCount": "images",
      "investmentHighlightsPlaceholder": "p.ex. Rendement stable de 4.5%, baux à long terme...",
      "photosFormats": "JPG, PNG, WEBP — max. 20 Mo par image",
      "photosHint": "De bonnes photos sont le meilleur argument de vente. Téléchargez des photos significatives.",
      "photosUpload": "Glissez les photos ici ou cliquez pour télécharger",
      "primaryImage": "Image principale",
      "steps": {
        "address": "Adresse",
        "classification": "Classification",
        "details": "Données objet",
        "land": "Terrain",
        "photos": "Photos",
        "pricing": "Prix",
        "summary": "Résumé",
        "teaser": "Teaser",
        "titleAddress": "Titre & Adresse",
        "type": "Type"
      },
      "subtitle": "Assistant étape par étape",
      "summaryHint": "Après la création, vous pourrez modifier le bien en détail, télécharger des documents et ajouter des traductions.",
      "teaserHighlightsPlaceholder": "p.ex. Emplacement top à Zurich, fraîchement rénové, entièrement loué...",
      "teaserHint": "Décrivez le bien pour les investisseurs potentiels. Ces textes apparaissent sur le teaser.",
      "title": "Nouveau bien immobilier",
      "virtualTourUrl": "URL visite virtuelle (optionnel)"
    },
    "yearBuilt": "Année de construction",
    "yield": "Rendement",
    "activateProperty": "Immobilie aktivieren",
    "activateDescription": "Die Immobilie wird für Investoren sichtbar und kann in Angebotslisten (Listings) aufgenommen werden.",
    "activateChecklist": "Bitte stelle sicher, dass folgende Punkte erfüllt sind:",
    "activateCheck1": "Übersetzungen (Name, Beschreibung) vorhanden",
    "activateCheck2": "Mindestens ein Bild hochgeladen",
    "activateCheck3": "Mindestpreis gesetzt",
    "activateCheck4": "Adresse und Standort korrekt",
    "reviewSubmitted": "Immobilie zur Prüfung eingereicht",
    "ownerDraftHint": "Diese Immobilie ist noch nicht sichtbar für Investoren.",
    "ownerReviewHint": "Wird gerade vom Immotron-Team geprüft.",
    "ownerActiveHint": "Sichtbar für Investoren.",
    "saleMode": {
      "fixedPrice": "Fixpreis",
      "offerCollection": "Bieterverfahren"
    },
    "commissionConditions": {
      "title": "Conditions",
      "hint": "S'applique à tous les acheteurs de cet objet, sauf annexe B individuelle.",
      "currentModel": "Modèle d'honoraires applicable",
      "noModel": "Aucun modèle d'honoraires défini",
      "noModelOption": "Aucun modèle d'honoraires — aucune condition d'objet",
      "specialConditions": "Conditions particulières",
      "specialConditionsPlaceholder": "Dispositions dérogatoires pour cet objet, p. ex. partage de commission ou honoraires minimaux",
      "save": "Enregistrer les conditions",
      "saved": "Conditions enregistrées",
      "saveFailed": "Les conditions n'ont pas pu être enregistrées",
      "loading": "Chargement des conditions …",
      "loadFailed": "Les conditions n'ont pas pu être chargées",
      "noneHint": "Aucune condition d'objet. Par acheteur s'applique le taux de son contrat-cadre, sinon le standard « {{model}} » — si le contrat acheteur indique « variable », rien n'est convenu sans condition d'objet.",
      "noneHintNoDefault": "Aucune condition d'objet. Par acheteur s'applique le taux de son contrat-cadre — si le contrat acheteur indique « variable », rien n'est convenu sans condition d'objet.",
      "blocked": {
        "no_contract": {
          "title": "Aucun contrat-cadre lié",
          "hint": "Les conditions de l’objet dépendent du contrat-cadre du mandant. Créez ou liez d’abord le contrat, puis les conditions pourront être définies.",
          "cta": "Créer un contrat-cadre"
        },
        "unsupported_contract": {
          "title": "Conditions de l'objet impossibles sur ce contrat",
          "hint": "L'annexe B (libération de l'objet) n'est prévue que pour un contrat-cadre vendeur. D'ici là, les conditions affichées s'appliquent."
        }
      }
    }
  },
  "propertyChat": {
    "askButton": "Poser une question",
    "disclaimer": "Généré par IA — pas un avis juridique",
    "error": "Désolé, je n'ai pas pu répondre à la question. Veuillez réessayer.",
    "placeholder": "Saisir une question...",
    "suggestion1": "Quel est le rendement ?",
    "suggestion2": "Décris l'emplacement",
    "suggestion3": "Quand a-t-il été construit ?",
    "title": "Questions sur le bien",
    "welcome": "Posez une question sur ce bien — par ex. sur l'emplacement, le rendement ou l'équipement."
  },
  "propertyDetail": {
    "approvalError": "Fehler bei der Genehmigung",
    "available": "Vorhanden",
    "buildingArea": "Surface bâtie",
    "buyNow": "Acheter maintenant",
    "description": "Description",
    "documents": "Documents",
    "documentsLocked": "Documents disponibles après approbation NDA",
    "download": "Download",
    "downloadFailed": "Download fehlgeschlagen",
    "energyEnvelope": "Hülle",
    "energyTotal": "Gesamt",
    "financialMetrics": "Finanzielle Kennzahlen",
    "floors": "Étages",
    "grossIncome": "Revenus locatifs bruts",
    "imageCounter": "{{current}} / {{total}}",
    "investmentHighlights": "Points forts de l'investissement",
    "investorActivity": {
      "interested": "{{count}} investisseurs intéressés",
      "ndaConfirmed": "{{count}} NDA confirmés"
    },
    "keyFigures": "Chiffres clés",
    "location": "Emplacement",
    "lotSize": "Terrain",
    "ndaRequired": "Confirmation NDA requise pour l'acces aux documents",
    "noDocuments": "Aucun document disponible",
    "noImages": "Aucune image disponible",
    "overview": "Aperçu",
    "parkingGarage": "Garage",
    "parkingOutdoor": "Aussen",
    "placeBid": "Placer une enchère",
    "preview": "Vorschau",
    "priceLocked": "Prix après NDA",
    "pricePerSqm": "Prix/m²",
    "rejectionError": "Fehler bei der Ablehnung",
    "rentalYield": "Rendement",
    "sections": {
      "details": "Details",
      "documents": "Documents",
      "financials": "Finances",
      "overview": "Apercu",
      "timeline": "Chronologie",
      "offers": "Angebot"
    },
    "submitError": "Fehler beim Einreichen",
    "submitOffer": "Soumettre une offre",
    "technicalDetails": "Technische Details",
    "title": "Détails du bien",
    "totalPrice": "Prix total",
    "units": "Unités",
    "uploadFailed": "Upload fehlgeschlagen",
    "yearBuilt": "Année de construction",
    "building": {
      "floors": "Stockwerke",
      "lift": "Aufzug",
      "heating": "Heizung",
      "energyTotal": "Energieklasse",
      "energyEnvelope": "Gebäudehülle",
      "condition": "Zustand",
      "renovation": "Renovierung",
      "residentialArea": "Wohnfläche",
      "commercialArea": "Gewerbefläche",
      "parking": "Parkplätze",
      "groundLease": "Baurecht",
      "title": "Gebäudedetails"
    },
    "investmentMetrics": "Investitionskennzahlen",
    "metrics": {
      "grossYield": "Bruttorendite",
      "vacancyRate": "Leerstand",
      "marketValue": "Marktwert"
    },
    "auftraggeber": {
      "title": "Mandant",
      "subtitle": "Avec qui puis-je parler ?",
      "openDrawer": "Afficher les détails du mandant",
      "statusActive": "Mandat de commercialisation actif",
      "statusExpired": "Mandat de commercialisation expiré",
      "statusNone": "Aucun mandat de commercialisation",
      "ownMandate": "Mandat propre (hors Immotron)",
      "ownMandateShort": "Mandat propre",
      "ownMandateHint": "Le mandat de vente existe en dehors de la plateforme.",
      "company": "Société",
      "companyMissing": "Société pas encore saisie",
      "uid": "IDE",
      "primaryContact": "Contact principal",
      "contact": "Coordonnées",
      "noContact": "Aucune coordonnée enregistrée. Merci de compléter via \"Modifier\".",
      "phoneMissing": "Téléphone pas encore saisi",
      "emailMissing": "E-mail pas encore saisi",
      "mandate": "Mandat de commercialisation",
      "startDate": "Début",
      "endDate": "Fin",
      "minimumPrice": "Prix minimum",
      "noMandate": "Aucune donnée de mandat enregistrée.",
      "contract": "Détails du contrat",
      "contractNumber": "Numéro de contrat",
      "contractType": "Type",
      "signedAt": "Signé",
      "expiresAt": "Expire",
      "duration": "Durée",
      "durationMonths": "{{count}} mois",
      "openContract": "Ouvrir le contrat",
      "commission": "Honoraires",
      "commissionModel": "Modèle",
      "commissionFlatRate": "Forfait",
      "commissionBrackets": "Tranches",
      "commissionBracketsCount": "{{count}} paliers",
      "wishes": "Souhaits & notes du vendeur",
      "desiredPrice": "Prix souhaité",
      "desiredTimeline": "Calendrier souhaité",
      "notes": "Notes",
      "noWishes": "Aucun souhait ou note enregistré.",
      "quickActions": "Actions rapides",
      "actionCall": "Appeler",
      "actionEmail": "E-mail",
      "actionMeeting": "Rendez-vous",
      "actionEdit": "Modifier",
      "comingSoon": "Bientôt disponible",
      "search": {
        "title": "Rechercher le mandant",
        "subtitle": "Seules les entreprises et les contacts avec un contrat de plateforme actif sont affichés.",
        "placeholder": "Entreprise, UID, nom ou e-mail...",
        "hint": "Saisissez au moins 2 caractères pour lancer la recherche.",
        "empty": "Aucun résultat avec un contrat de plateforme actif. Veuillez d'abord signer un mandat de commercialisation.",
        "error": "La recherche a échoué. Veuillez réessayer.",
        "saveSuccess": "Mandant enregistré",
        "saveFailed": "Échec de l'enregistrement. Veuillez réessayer.",
        "clearSuccess": "Lien supprimé",
        "current": "Lien actuel",
        "currentCompany": "Entreprise liée",
        "currentContact": "Contact lié",
        "unlink": "Supprimer",
        "typeCompany": "Entreprise",
        "typeContact": "Contact",
        "linked": "Actif",
        "noDetails": "Pas d'autres détails",
        "contractActive": "Contrat actif",
        "contractActiveHint": "Le contrat de plateforme (SELLER_FRAMEWORK) est signé."
      }
    }
  },
  "publicHelp": {
    "badge": "Aide & Guide",
    "cta": {
      "button": "S'inscrire maintenant",
      "subtitle": "Créez votre compte et découvrez des opportunités immobilières exclusives.",
      "title": "Prêt à commencer ?"
    },
    "faq": {
      "items": [
        {
          "a": "La plateforme est gratuite pour les investisseurs. Les vendeurs et courtiers paient des honoraires basés sur le succès lors de la conclusion.",
          "q": "L'utilisation d'Immotron est-elle gratuite ?"
        },
        {
          "a": "Toutes les données sensibles sont protégées par des accords de confidentialité (NDA) et des contrôles d'accès basés sur les rôles. Les documents sont stockés sous forme chiffrée.",
          "q": "Comment mes données sont-elles protégées ?"
        },
        {
          "a": "Après le NDA, vous accédez immédiatement au dossier complet avec tous les détails, l'adresse exacte et l'ensemble des indicateurs financiers.",
          "q": "Que se passe-t-il après la confirmation du NDA ?"
        },
        {
          "a": "Oui, Immotron est entièrement responsive et fonctionne sur tous les appareils — ordinateur, tablette et smartphone.",
          "q": "Puis-je utiliser Immotron sur mon téléphone ?"
        },
        {
          "a": "Téléchargez un PDF et notre IA reconnaît automatiquement les surfaces, les revenus locatifs, l'année de construction et d'autres indicateurs clés. Vous vérifiez et confirmez les résultats.",
          "q": "Comment fonctionne l'extraction de données par IA ?"
        },
        {
          "a": "Lors d'un tour d'enchères, plusieurs investisseurs peuvent soumettre des offres dans un délai défini. Le vendeur décide ensuite de l'adjudication.",
          "q": "Qu'est-ce qu'un tour d'enchères ?"
        }
      ],
      "title": "Questions fréquentes"
    },
    "features": {
      "automated": {
        "desc": "Extraction de données par IA, e-mails automatiques et suggestions intelligentes de clauses.",
        "title": "Workflows automatisés"
      },
      "digital": {
        "desc": "Du premier contact à la signature — tout en ligne, sans papier et traçable.",
        "title": "100% numérique"
      },
      "realtime": {
        "desc": "Notifications push et mises à jour par e-mail à chaque étape importante du processus.",
        "title": "Notifications en temps réel"
      },
      "roles": {
        "desc": "Vues personnalisées pour les investisseurs, vendeurs, équipes commerciales et administrateurs.",
        "title": "Des rôles pour chaque besoin"
      },
      "secure": {
        "desc": "Dossiers protégés par NDA, documents chiffrés et contrôles d'accès basés sur les rôles.",
        "title": "Sécurisé & confidentiel"
      },
      "title": "Pourquoi Immotron ?",
      "transparent": {
        "desc": "Exposé et état locatif avec toutes les données financières pertinentes en un coup d'œil.",
        "title": "Indicateurs transparents"
      }
    },
    "footer": "Tous droits réservés",
    "hero": {
      "subtitle": "Immotron met en relation investisseurs immobiliers et vendeurs sur une plateforme numérique sécurisée. Voici comment le processus se déroule, étape par étape.",
      "title": "Comment fonctionne Immotron"
    },
    "investor": {
      "steps": {
        "deal": {
          "desc": "En cas d'adjudication, vous recevez le projet de contrat pour signature numérique. L'ensemble du processus est documenté de manière transparente sur la timeline.",
          "title": "Conclure la transaction"
        },
        "dossier": {
          "desc": "Le dossier comprend l'état locatif, l'exposé, les plans, les photos et tous les indicateurs financiers pertinents — en téléchargement ou en aperçu en ligne.",
          "title": "Examiner le dossier complet"
        },
        "nda": {
          "desc": "Intéressé ? Confirmez le NDA numériquement pour accéder au dossier complet avec tous les détails et l'adresse exacte.",
          "title": "Accord de confidentialité (NDA)"
        },
        "offer": {
          "desc": "Soumettez une offre indicative (NBO) ou une offre ferme (BO). Lors des tours d'enchères, vous pouvez voir le délai et ajuster votre offre en conséquence.",
          "title": "Soumettre une offre"
        },
        "search": {
          "desc": "Explorez les biens d'investissement disponibles avec des filtres par emplacement, rendement, type de bien et gamme de prix. La vue carte vous montre la localisation approximative.",
          "title": "Parcourir les biens"
        },
        "teaser": {
          "desc": "Chaque bien dispose d'un dossier teaser anonymisé avec les données clés, photos et indicateurs — sans révéler l'adresse exacte.",
          "title": "Consulter le dossier teaser"
        }
      },
      "title": "Le processus investisseur"
    },
    "login": "Se connecter",
    "seller": {
      "steps": {
        "contract": {
          "desc": "Créez des contrats de vente directement sur la plateforme avec notre assistant contractuel. Les clauses sont suggérées grâce à l'IA.",
          "title": "Création du contrat"
        },
        "matching": {
          "desc": "Immotron propose votre bien à des investisseurs qualifiés. Vous voyez en temps réel qui a manifesté son intérêt et signé le NDA.",
          "title": "Matching investisseurs"
        },
        "review": {
          "desc": "Vérifiez les données extraites par l'IA et complétez les informations manquantes. Un contrôle qualité garantit que tous les champs obligatoires sont remplis.",
          "title": "Vérifier & compléter les données"
        },
        "updates": {
          "desc": "Suivez l'avancement de la transaction sur la timeline. Les notifications push vous tiennent informé à chaque étape.",
          "title": "Mises à jour en temps réel"
        },
        "upload": {
          "desc": "Téléchargez photos et documents — notre IA extrait automatiquement les données clés telles que les surfaces, les revenus locatifs et l'année de construction.",
          "title": "Enregistrer votre bien"
        }
      },
      "title": "Le processus vendeur"
    },
    "tabs": {
      "investor": "Pour les investisseurs",
      "seller": "Pour les vendeurs"
    }
  },
  "onboarding": {
    "title": "Ouvrir un compte",
    "intro": "Veuillez vérifier les informations dont nous disposons. Si elles sont correctes, confirmez-les et accédez directement à la signature du contrat.",
    "footer": "Tous droits réservés.",
    "loading": "Chargement des informations...",
    "validUntil": "Lien valable jusqu'au",
    "confirmHint": "Si toutes les informations sont correctes, confirmez-les pour poursuivre la signature du contrat.",
    "confirm": "Ouvrir un compte →",
    "confirming": "Ouverture du compte …",
    "reportCorrection": "Signaler une correction",
    "legalNotice": "En confirmant, vous déclarez que les informations affichées sont correctes.",
    "coSigner": {
      "title": "Deuxième signature",
      "description": "Votre société signe collectivement. Le contrat nécessite donc une deuxième personne habilitée à signer en plus de votre signature.",
      "selectLabel": "Deuxième personne habilitée à signer",
      "otherPerson": "Indiquer une autre personne",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "E-mail de la deuxième personne",
      "emailPlaceholder": "nom@entreprise.ch",
      "emailHint": "Nous envoyons le lien de signature personnel à cette adresse.",
      "bothSignHint": "Les deux personnes reçoivent un lien pour signer.",
      "required": "Veuillez indiquer la deuxième personne habilitée à signer avec une adresse e-mail valide.",
      "confirmedTitle": "Informations confirmées",
      "confirmedDescription": "Les deux personnes reçoivent un lien pour signer. Vous pouvez signer dès maintenant.",
      "signatories": "Signataires",
      "signNow": "Signer maintenant"
    },
    "company": {
      "title": "Données de l'entreprise",
      "name": "Entreprise",
      "uid": "IDE",
      "address": "Adresse"
    },
    "person": {
      "title": "Personne de contact",
      "name": "Nom",
      "function": "Fonction"
    },
    "conditions": {
      "title": "Vos conditions",
      "propertyHint": "Il s'agit de {{hint}}.",
      "contractGroup": "Contrat",
      "feeGroup": "Honoraires",
      "costLabel": "Coûts",
      "buyerCommission": "Commission acheteur (à votre charge)",
      "sellerCommission": "Commission vendeur (à la charge du vendeur)",
      "transparencyHint": "Immotron communique les deux commissions — aucune commission cachée.",
      "matchHint": "Ces conditions figurent mot pour mot dans le contrat que vous recevrez pour signature après la confirmation.",
      "CONTRACT_TYPE_TEXT": "Contrat",
      "COMMISSION_TEXT": "Commission"
    },
    "correction": {
      "title": "Signaler une correction",
      "description": "Veuillez décrire quelles informations sont incorrectes. Notre équipe examinera votre message et vous recontactera.",
      "label": "Votre correction",
      "placeholder": "Que faut-il corriger ?",
      "submit": "Envoyer la correction",
      "submitting": "Envoi...",
      "cancel": "Annuler"
    },
    "correctionSent": {
      "title": "Message reçu",
      "description": "Merci — nous vérifions les informations et vous envoyons un nouveau lien.",
      "descriptionWithAdvisor": "Merci — votre conseiller {{advisor}} vérifie les informations et vous envoie un nouveau lien.",
      "yourMessage": "Votre message",
      "quotedMessage": "« {{message}} »",
      "advisorContact": "Votre interlocuteur"
    },
    "actions": {
      "home": "Vers la page d'accueil",
      "close": "Fermer la fenêtre",
      "closeHint": "Votre navigateur n'autorise pas la fermeture automatique. Veuillez fermer l'onglet manuellement."
    },
    "alreadyActive": {
      "title": "Déjà actif",
      "description": "Un contrat actif existe déjà pour vous. Vous pouvez consulter vos contrats à tout moment dans les paramètres."
    },
    "alreadyUsed": {
      "title": "Lien déjà utilisé",
      "description": "Ce lien de confirmation a déjà été utilisé. Pour toute question, veuillez contacter votre interlocuteur."
    },
    "verificationFailed": {
      "title": "Confirmation impossible",
      "description": "Votre pouvoir de signature n'a pas pu être confirmé automatiquement. Notre équipe a été informée et vous recontactera."
    },
    "expired": {
      "title": "Lien expiré",
      "description": "Ce lien de confirmation a malheureusement expiré. Veuillez contacter votre interlocuteur pour obtenir un nouveau lien."
    },
    "error": {
      "title": "Erreur",
      "generic": "Une erreur inattendue s'est produite. Veuillez réessayer.",
      "invalidToken": "Lien de confirmation invalide ou inconnu.",
      "loadFailed": "Les informations n'ont pas pu être chargées.",
      "confirmFailed": "La confirmation n'a pas pu être traitée. Veuillez réessayer.",
      "correctionFailed": "La correction n'a pas pu être envoyée. Veuillez réessayer."
    },
    "welcome": "Bienvenue, {{name}}",
    "invitedBy": "{{mandant}} vous invite à consulter des biens immobiliers sur Immotron.",
    "invitedGeneric": "Vous êtes invité à consulter des biens immobiliers sur Immotron.",
    "nextStep": "ensuite : une brève signature",
    "fullContract": "Afficher le contrat complet",
    "termsLink": "Lire les conditions d'utilisation",
    "benefits": {
      "title": "Voici ce que vous obtenez :",
      "account": "un compte gratuit",
      "view": "consulter les biens et leurs documents",
      "offer": "soumettre des offres"
    },
    "cost": {
      "title": "Combien cela coûte-t-il ?",
      "text": "Rien. Vous ne payez une commission que si vous achetez un bien. Le montant est indiqué pour chaque bien, avant que vous n'ouvriez les documents."
    },
    "details": {
      "title": "Vos informations sont-elles correctes ?",
      "change": "modifier"
    }
  },
  "publicProvider": {
    "offeredBy": "Offre de",
    "contact": "Votre contact"
  },
  "publicTeaser": {
    "title": "Opportunité d'investissement exclusive",
    "subtitle": "Un premier aperçu. Vous verrez l'adresse, le dossier et tous les documents dès que vous aurez ouvert votre compte gratuit.",
    "footer": "Tous droits réservés.",
    "loading": "Chargement du teaser...",
    "cta": {
      "loginTitle": "Vous disposez déjà d'un accès",
      "loginHint": "Connectez-vous pour consulter le dossier complet avec l'adresse, la situation et tous les documents.",
      "loginButton": "Se connecter",
      "startTitle": "Ouvrir un compte",
      "startHint": "Saisissez votre adresse e-mail — nous vous conduisons directement à l'ouverture de votre compte, puis débloquons l'adresse, la situation et l'intégralité du dossier de l'objet.",
      "createAccountTitle": "Créer un compte",
      "createAccountHint": "Pour voir l'adresse, la situation et le dossier complet, ouvrez maintenant votre compte gratuit. À l'étape suivante, vous vérifiez vos indications et signez brièvement en ligne.",
      "createAccountButton": "Créer un compte",
      "emailLabel": "Adresse e-mail",
      "emailHint": "Veuillez saisir l'adresse e-mail à laquelle ce teaser a été envoyé.",
      "emailInvalid": "Veuillez saisir une adresse e-mail valide.",
      "newHereToggle": "Je suis nouveau ici",
      "firstName": "Prénom",
      "lastName": "Nom",
      "companyName": "Entreprise",
      "companyUid": "Numéro IDE",
      "continueButton": "Continuer vers l'ouverture du compte",
      "submitError": "L'ouverture du compte n'a pas pu être lancée. Veuillez réessayer plus tard.",
      "rateLimitError": "Trop de tentatives. Veuillez patienter un instant et réessayer.",
      "sentTitle": "Nous vous avons envoyé le lien",
      "sentHint": "Nous vous avons envoyé par e-mail le lien pour ouvrir votre compte. Veuillez consulter votre boîte de réception.",
      "hasContractTitle": "Vous disposez déjà d'un compte",
      "hasContractHint": "Un compte existe déjà pour cette adresse e-mail. Connectez-vous pour consulter le dossier complet."
    },
    "expired": {
      "title": "Lien expiré",
      "description": "Ce lien teaser a malheureusement expiré. Veuillez contacter votre interlocuteur pour obtenir un nouveau lien."
    },
    "error": {
      "title": "Teaser introuvable",
      "description": "Ce lien est invalide ou n'est plus disponible. Veuillez vérifier le lien reçu par e-mail ou contacter votre interlocuteur."
    }
  },
  "publicSigning": {
    "accountLead": "Vous recevez un compte pour consulter les objets et déposer des offres. Des frais ne sont dus qu'en cas d'achat.",
    "accountTitle": "Ouvrir un compte : signature",
    "agb": {
      "accept": "J'ai lu et j'accepte les conditions de la plateforme de {{owner}}.",
      "acceptWithMandant": "J'ai lu et j'accepte les conditions de la plateforme de {{owner}} ainsi que les conditions complémentaires de {{mandant}}.",
      "description": "La plateforme « Immotron » est exploitée par {{owner}}. Ses conditions d'utilisation s'appliquent en complément du présent contrat conclu avec {{counterparty}}. Pour les honoraires et les conditions, le contrat prévaut.",
      "descriptionNoCounterparty": "La plateforme « Immotron » est exploitée par {{owner}}. Ses conditions d'utilisation s'appliquent en complément du présent contrat. Pour les honoraires et les conditions, le contrat prévaut.",
      "mandantTerms": "Voir les conditions complémentaires de {{mandant}}",
      "modalTitle": "Conditions d'utilisation de la plateforme (CG)",
      "requiredHint": "Veuillez accepter les Conditions Générales pour signer le contrat.",
      "title": "Conditions d'utilisation de la plateforme (CG)",
      "viewAgb": "Voir les conditions de la plateforme de {{owner}}"
    },
    "authority": {
      "manual": "vérifié manuellement",
      "register": "vérifié au registre du commerce",
      "signatureType": {
        "COLLECTIVE_MORE": "Signature collective à plusieurs",
        "COLLECTIVE_TWO": "Signature collective à deux",
        "NONE": "aucun droit de signature",
        "SINGLE": "Signature individuelle"
      },
      "unverified": "non vérifié",
      "unverifiedHint": "Le droit de signature n'a pas encore été vérifié au registre du commerce. Par votre signature, vous confirmez que vous êtes autorisé à signer pour {{company}}.",
      "unverifiedHintGeneric": "Le droit de signature n'a pas encore été vérifié au registre du commerce. Par votre signature, vous confirmez que vous êtes autorisé à signer ce contrat."
    },
    "alreadySigned": {
      "countersignHint": "Votre signature a été enregistrée. Le contrat est en cours de contresignature par Immotron. Vous serez notifié par e-mail et votre compte sera activé.",
      "countersignPending": "Contresignature en attente",
      "description": "Ce contrat a déjà été signé par vous.",
      "downloadPdf": "Télécharger le contrat en PDF",
      "fullySigned": "Contrat entièrement signé",
      "fullySignedHint": "Toutes les parties ont signé. Vous recevrez vos identifiants et pourrez consulter vos contrats dans les paramètres.",
      "noActionNeeded": "Votre signature est enregistrée. Aucune autre action n'est nécessaire.",
      "othersPending": "Autres signatures en attente",
      "othersPendingHint": "Votre signature a été enregistrée. Vous serez informé par e-mail des prochaines étapes une fois que toutes les parties auront signé.",
      "signedAt": "Signé le",
      "signedAtValue": "{{date}} à {{time}}",
      "title": "Vous avez déjà signé"
    },
    "backToSigning": "Retour à la signature",
    "cancelled": {
      "description": "Il ne peut plus être signé. Pour toute question, adressez-vous à votre interlocuteur.",
      "title": "Ce contrat a été annulé"
    },
    "contractDetails": "Détails du contrat",
    "contractNumber": "Numéro de contrat",
    "contractType": "Type de contrat",
    "downloadPdf": "Télécharger le PDF",
    "error": {
      "generic": "Une erreur inattendue s'est produite. Veuillez réessayer.",
      "invalidToken": "Lien de signature invalide ou inconnu.",
      "kycRequired": "Veuillez d'abord finaliser votre identification.",
      "loadFailed": "Le contrat n'a pas pu être chargé.",
      "submitFailed": "La signature n'a pas pu être transmise. Veuillez réessayer.",
      "title": "Erreur"
    },
    "expired": {
      "description": "Ce lien de signature a expiré. Veuillez contacter votre interlocuteur pour obtenir un nouveau lien.",
      "title": "Lien expiré"
    },
    "footer": "Tous droits réservés.",
    "geo": {
      "allow": "Partager la localisation",
      "description": "Pour la documentation juridique, votre localisation peut être enregistrée. Ceci est facultatif.",
      "title": "Partage de localisation"
    },
    "legalNotice": "En signant, vous confirmez avoir lu et compris le contrat.",
    "loading": "Chargement du contrat...",
    "newTabHint": "Ouvre dans un nouvel onglet",
    "otp": {
      "description": "Cette signature nécessite en plus un code de confirmation (signature électronique avancée).",
      "error": {
        "channelUnavailable": "Le code n'a pas pu être remis. Veuillez contacter votre interlocuteur.",
        "cooldown": "Veuillez patienter un instant avant de demander un nouveau code.",
        "expired": "Le code a expiré — veuillez demander un nouveau code.",
        "invalid": "Le code est incorrect.",
        "locked": "Trop de tentatives échouées — veuillez demander un nouveau code.",
        "notRequired": "Aucun code de confirmation n'est nécessaire pour cette signature.",
        "required": "Veuillez d'abord demander et saisir le code.",
        "sendFailed": "Le code n'a pas pu être envoyé. Veuillez réessayer."
      },
      "label": "Code à 6 chiffres",
      "requiredHint": "Veuillez saisir le code de confirmation à 6 chiffres.",
      "resend": "Renvoyer le code",
      "resendIn": "Renvoyer le code ({{seconds}} s)",
      "send": "Envoyer le code",
      "sending": "Envoi du code ...",
      "sentHint": "Nous avons envoyé un code à 6 chiffres à {{hint}} (valable 5 minutes).",
      "sentHintGeneric": "Nous vous avons envoyé un code à 6 chiffres (valable 5 minutes).",
      "title": "Code de confirmation"
    },
    "parties": "Parties au contrat",
    "partiesCompact": "Qui signe",
    "partyStatus": {
      "pending": "En attente",
      "signed": "Signé"
    },
    "pdfTitle": "Aperçu du contrat",
    "role": {
      "agent": "Mandataire",
      "broker": "Intermédiaire",
      "buyer": "Acheteur",
      "companyRep": "Représentant de l'entreprise",
      "label": "Rôle",
      "operator": "Exploitante",
      "partner": "Partenaire",
      "seller": "Vendeur",
      "user": "Utilisateur"
    },
    "signatory": "Signataire",
    "signatureLabel": "Signature",
    "signatureTitle": "Votre signature",
    "signedFor": "Signé pour le compte de",
    "signingFor": "Vous signez pour le compte de",
    "steps": {
      "agb": "Accepter les conditions d'utilisation",
      "contract": "Consulter le contrat",
      "otp": "Saisir le code",
      "sign": "Signer"
    },
    "submit": "Signer maintenant",
    "submitting": "Signature en cours...",
    "success": {
      "contractNumber": "Numéro de contrat",
      "description": "Votre signature a été transmise avec succès. Vous recevrez une confirmation par e-mail.",
      "title": "Signé avec succès !"
    },
    "title": "Signature du contrat",
    "validUntil": "Valable jusqu'au",
    "viewPdf": "Afficher le contrat",
    "youPrefix": "Vous :"
  },
  "qualityGate": {
    "buyerSuggestions": {
      "title": "Suggestions d'acheteurs IA",
      "hint": "Acheteurs suggérés par l'IA, classés par pertinence. Les acheteurs sélectionnés obtiennent l'accès au teaser lors de la validation.",
      "load": "Charger les suggestions d'acheteurs",
      "reload": "Recalculer",
      "loading": "Calcul des suggestions …",
      "loadFailed": "Impossible de charger les suggestions d'acheteurs",
      "retry": "Réessayer",
      "empty": "Aucun acheteur correspondant trouvé",
      "fitScore": "Pertinence : {{score}}%",
      "showReasoning": "Afficher la justification",
      "hideReasoning": "Masquer la justification",
      "summary": "{{count}} acheteurs obtiennent l'accès lors de la validation",
      "assign": "Attribuer {{count}} acheteur(s)"
    },
    "address": "Adresse",
    "approve": "Approuver",
    "approveConfirm": "Voulez-vous vraiment approuver ce bien ?",
    "approveSuccess": "Bien approuvé avec succès",
    "approvedAt": "Approuvé le",
    "approvedTitle": "Contrôle qualité réussi",
    "releaseInvitations": {
      "title": "Des e-mails vont être envoyés",
      "description": "Avec la validation, {{count}} acheteurs reçoivent maintenant un e-mail avec le teaser et le lien d'intégration :",
      "noEmail": "Aucune adresse e-mail enregistrée — ce destinataire sera ignoré.",
      "hint": "Attention : un e-mail envoyé ne peut pas être rappelé.",
      "inviteTitle": "Invitation aux nouveaux acheteurs",
      "accessTitle": "E-mail d'accès aux acheteurs avec contrat actif",
      "groupTitle": "E-mail d'accès aux membres du groupe",
      "accessHint": "Ces destinataires reçoivent l'e-mail d'accès à chaque validation.",
      "approveAndSend": "Approuver et envoyer",
      "approveOnly": "Approuver seulement",
      "approveWithoutInvitations": "Approuver sans invitations",
      "sentToast": "{{count}} invitations envoyées",
      "notSentToast": "Non envoyé à {{count}} destinataire(s) : {{names}}",
      "groupNotifiedToast_one": "E-mail d'accès envoyé à {{names}}",
      "groupNotifiedToast_other": "E-mail d'accès envoyé à {{count}} membres du groupe : {{names}}",
      "groupAlreadyToast_one": "1 membre du groupe avait déjà accès — aucun nouvel e-mail",
      "groupAlreadyToast_other": "{{count}} membres du groupe avaient déjà accès — aucun nouvel e-mail",
      "groupInvitedToast_one": "Invitation envoyée à {{names}}",
      "groupInvitedToast_other": "Invitation envoyée à {{count}} membres du groupe : {{names}}",
      "groupInviteFailedToast": "Invitation non envoyée à {{names}}"
    },
    "checkpoints": {
      "canton": "Canton indiqué",
      "city": "Ville indiquée",
      "contractSigned": "Contrat signé",
      "description": "Description vérifiée",
      "documents": "Documents complets",
      "images": "Au moins 1 image téléchargée",
      "minimumPrice": "Prix minimum défini",
      "minimumPricePositive": "Prix minimum supérieur à 0",
      "pricing": "Prix défini",
      "propertyType": "Type de bien défini",
      "requiredFields": "Champs obligatoires remplis",
      "translations": "Au moins 1 traduction disponible"
    },
    "autoCheckTitle": "Liste de contrôle automatique",
    "autoCheckHint": "Ces points sont vérifiés automatiquement à partir des données du bien.",
    "autoChecks": {
      "required_fields": "Champs obligatoires remplis",
      "images": "Au moins 3 images téléchargées",
      "description": "Description fournie",
      "pricing": "Prix défini",
      "documents": "Documents téléchargés",
      "highlights": "Points forts d'investissement fournis",
      "location": "Description de l'emplacement fournie",
      "contract_signed": "Contrat de commercialisation signé"
    },
    "cannotApproveYet": "L'approbation nécessite que tous les points obligatoires soient verts.",
    "approveBlocked": {
      "title": "Approbation pas encore possible — ces points obligatoires sont ouverts :"
    },
    "optional": "Facultatif",
    "pendingReviews": "{{count}} à vérifier",
    "morePropertiesPending": "{{count}} biens en attente de vérification — sélectionnez-en un pour changer.",
    "selectAnother": "Sélectionner un autre bien",
    "selectProperty": "Sélectionner un bien",
    "selectPropertyHint": "Choisissez un bien à gauche pour afficher l'aperçu et la liste de contrôle.",
    "teaserPreview": "Aperçu investisseur",
    "teaserPreviewHint": "Aperçu tel que l'investisseur le voit",
    "discretion": {
      "title": "Discrétion avant la NDA",
      "none": "Aucun élément identifiant dans le teaser",
      "edit": "Modifier les textes du teaser"
    },
    "newsletterPreview": {
      "description": "Comment ce teaser est envoyé en tant qu'e-mail/newsletter — l'aperçu correspond exactement à l'e-mail envoyé.",
      "teaserImages": "{{count}} images du teaser",
      "hiddenImages": "{{count}} visibles seulement après la NDA",
      "locationConfirm": "Libérer délibérément les images sensibles à la localisation pour le teaser",
      "blocked": "Envoi bloqué — veuillez d'abord résoudre les points suivants :",
      "refresh": "Actualiser",
      "loadFailed": "Impossible de charger l'aperçu de la newsletter.",
      "retry": "Réessayer",
      "iframeTitle": "Aperçu de la newsletter en e-mail",
      "empty": "Aucun aperçu de newsletter disponible."
    },
    "contractNotSigned": "Aucun contrat signe disponible",
    "decideFailed": "Impossible d'enregistrer la décision",
    "empty": "Aucun bien en attente de vérification",
    "emptyHint": "Les nouvelles soumissions apparaîtront ici automatiquement",
    "images": "{{count}} images",
    "imagesNone": "Aucune image",
    "investorGroups": {
      "createNew": "Créer un nouveau groupe",
      "empty": "Aucun groupe d'investisseurs",
      "hint": "Ces groupes reçoivent automatiquement l'accès au teaser après approbation.",
      "loadFailed": "Impossible de charger les groupes d'investisseurs",
      "summary": "{{investors}} investisseurs de {{groups}} groupes recevront l'accès",
      "summaryPersons": "{{persons}} personnes de {{groups}} groupes recevront l'accès",
      "title": "Groupes d'investisseurs",
      "showMembers": "Afficher les membres de {{name}}",
      "hideMembers": "Masquer les membres de {{name}}",
      "noMembers": "Aucun membre",
      "unknownMember": "Membre inconnu",
      "assign": "Attribuer {{count}} groupe(s)",
      "coversGroups": "S'applique également aux membres des groupes d'investisseurs sélectionnés.",
      "missingHint": "Membres des groupes d'investisseurs sélectionnés : une condition d'objet définie via «Définir pour tous» couvre chaque membre sans condition propre."
    },
    "loadFailed": "Impossible de charger la file d'attente",
    "owner": "Propriétaire",
    "previewFailed": "Impossible de charger l'aperçu",
    "previewListing": "Aperçu acheteur",
    "price": "Prix",
    "progress": "{{checked}}/{{total}} points de contrôle",
    "propertyDetails": "Détails du bien",
    "readOnlyAfterApproval": "Cette propriété a été approuvée et ne peut plus être modifiée.",
    "readOnlyHint": "Cette propriété a été approuvée et ne peut être modifiée que par un administrateur.",
    "reject": "Rejeter",
    "rejectReason": "Motif (obligatoire)",
    "rejectReasonPlaceholder": "Veuillez indiquer le motif du rejet...",
    "rejectSuccess": "Bien rejeté",
    "required": "Obligatoire",
    "reviewChecklist": "Liste de vérification",
    "sellerContract": {
      "active": "Contrat actif",
      "activeSince": "Contrat actif depuis le {{date}}",
      "changeContract": "Modifier le contrat",
      "commission": "Condition",
      "contractNumber": "Numéro de contrat",
      "expiresAt": "Expire le {{date}}",
      "hideDetails": "Masquer les détails",
      "noActive": "Aucun contrat de plateforme actif",
      "noActiveHint": "Ce bien ne peut pas être validé tant que le vendeur n'a pas signé de contrat de plateforme.",
      "openContract": "Ouvrir le contrat",
      "ownMandate": "Mandat propre (hors Immotron)",
      "principal": "Mandant",
      "searchContract": "Rechercher un contrat",
      "showDetails": "Afficher les détails",
      "signatoryTypes": {
        "BUYER": "Acheteur",
        "PLATFORM": "Plateforme",
        "SELLER": "Vendeur",
        "WITNESS": "Témoin"
      },
      "signedBy": "Signé par",
      "title": "Contrat du vendeur"
    },
    "statuses": {
      "ACTIVE": "Actif",
      "APPROVED": "Approuvé",
      "DRAFT": "Brouillon",
      "IN_REVIEW": "En vérification",
      "REJECTED": "Rejeté"
    },
    "submittedAt": "Soumis le {{date}}",
    "subtitle": "Approbation des biens",
    "timeline": {
      "boDays": "Phase BO (jours)",
      "boPhase": "Phase BO",
      "boReviewDays": "Revue BO (jours)",
      "boReviewPhase": "Revue BO",
      "days": "jours",
      "excludeLowestNbo": "Exclure la NBO la plus basse de la BO",
      "excludeLowestNboHint": "Si activé, l'offre NBO la plus basse n'est pas retenue pour la sélection des candidats BO.",
      "durationPresetDays_one": "{{count}} jour",
      "durationPresetDays_other": "{{count}} jours",
      "durationPresets": "Durée rapide",
      "endDate": "Date de fin",
      "fixedPrice": "Prix fixe",
      "fixedPriceInfo": "Prix proposé",
      "fixedPriceLabel": "Prix de vente",
      "guidePrice": "Prix indicatif",
      "nboDays": "Phase NBO (jours)",
      "nboPhase": "Phase NBO",
      "nboReviewDays": "Revue NBO (jours)",
      "nboReviewPhase": "Revue NBO",
      "offerCollection": "Appel d'offres",
      "preview": "Aperçu du calendrier",
      "reservePrice": "Prix de réserve",
      "reservePriceHint": "Interne. Non communiqué aux investisseurs.",
      "saleMode": "Mode de vente",
      "startDate": "Date de début",
      "submissionDays": "Délai de soumission (jours)",
      "submissionPhase": "Délai de soumission",
      "title": "Configuration de vente",
      "totalDuration": "Durée totale"
    },
    "title": "Quality Gate",
    "translations": "{{count}} langues",
    "translationsNone": "Aucune traduction",
    "viewProperty": "Modifier le bien",
    "zefix": {
      "autoLookup": "Chargement des données du vendeur...",
      "contractActive": "Contrat actif",
      "contractActiveSince": "Contrat actif depuis le {{date}}",
      "contractNumber": "Numéro de contrat",
      "expiresAt": "Expire le {{date}}",
      "importContacts": "Importer {{count}} personnes dans le CRM",
      "importDone": "{{count}} contacts ont été importés dans le CRM",
      "importFailed": "Impossible d'importer les contacts",
      "importSuccess": "{{count}} contacts importés avec succès dans le CRM",
      "imported": "Importé",
      "importing": "Importation en cours...",
      "legalForm": "Forme juridique",
      "lookupFailed": "Impossible de charger les données du vendeur",
      "noActiveContract": "Aucun contrat vendeur actif",
      "noActiveContractHint": "Le Quality Gate n'affiche ici que les vendeurs disposant d'un contrat de plateforme actif. Veuillez d'abord créer et faire signer un contrat.",
      "noPersons": "Aucun signataire autorisé trouvé",
      "noPersonsHint": "Les données FOSC ne sont pas disponibles pour cette entreprise. Veuillez ajouter les signataires manuellement dans le CRM.",
      "noUidActive": "L'entreprise «{{company}}» n'a pas d'IDE. Les signataires autorisés ne peuvent pas être chargés depuis le registre du commerce.",
      "openContract": "Ouvrir le contrat",
      "registeredPersons": "Signataires autorisés (ZEFIX)",
      "signedBy": "Signé par",
      "title": "Registre du commerce vendeur",
      "unknownSeller": "Vendeur inconnu"
    },
    "personSearch": {
      "title": "Recherche de personnes",
      "hint": "Attribuer manuellement des contacts ou sociétés CRM comme acheteurs. La classification apparaît immédiatement : actif ou onboarding requis."
    },
    "buyerConditions": {
      "setForAll": "Définir pour tous",
      "setForBuyer": "Définir pour cet acheteur",
      "setForBuyerAria": "Définir la condition pour {{name}}",
      "savedForBuyer": "Condition définie pour {{name}}",
      "modelRequired": "Un modèle d'honoraires est requis pour une condition propre à un acheteur.",
      "dialogTitle": "Définir les conditions pour tous",
      "dialogHint": "Les conditions sont enregistrées comme annexe B de l'objet et s'appliquent à tous les acheteurs attribués qui n'ont pas de condition propre.",
      "dialogTitleBuyer": "Définir la condition pour {{name}}",
      "dialogHintBuyer": "Cet acheteur dispose d'un contrat-cadre (variable). La condition s'applique uniquement à cet objet et est consignée comme annexe B de son contrat-cadre acheteur.",
      "buyerObjectCondition": "Condition de cet objet : {{model}}.",
      "buyerNoObjectCondition": "Aucune condition d'objet n'est enregistrée pour cet objet.",
      "setPlannedForBuyer": "Définir la condition prévue",
      "setPlannedForBuyerAria": "Définir la condition prévue pour {{name}}",
      "plannedSpecialCondition": "condition particulière",
      "plannedNoModel": "Aucune indication — la condition de l'objet s'applique ({{model}})",
      "plannedNoModelMissing": "Aucune indication — ATTENTION : cet objet n'a aucune condition d'objet",
      "plannedNoObjectCondition": "Aucune condition d'objet n'est enregistrée pour cet objet : sans modèle d'honoraires propre, aucune condition ne s'applique à cet acheteur après sa signature.",
      "plannedSetObjectCondition": "Enregistrer la condition de l'objet",
      "dialogTitlePlanned": "Définir la condition prévue pour {{name}}",
      "dialogHintPlanned": "Cet acheteur n'a pas encore de contrat-cadre. Sans modèle d'honoraires propre, la condition de cet objet s'applique à lui. Avec un modèle d'honoraires, il obtient une condition propre à cet objet — elle est enregistrée sur son attribution et reprise automatiquement comme annexe B après sa signature.",
      "emailLabel": "Adresse e-mail de l'acheteur",
      "emailRequired": "Aucune adresse e-mail n'est enregistrée pour cet acheteur — sans elle, aucune invitation ne peut être envoyée. Merci de la compléter maintenant."
    },
    "conditionObjections": {
      "title": "Objections ouvertes aux conditions",
      "hint": "Acheteurs ayant refusé les conditions de l'objet et proposé un autre taux.",
      "property": "Objet",
      "unknownProperty": "Objet #{{id}}",
      "unknownPerson": "Personne inconnue",
      "proposedRate": "Taux souhaité",
      "noRate": "Aucun taux indiqué",
      "reason": "Motivation",
      "date": "Reçue le",
      "accept": "Accepter",
      "acceptHint": "Le taux convenu est consigné comme annexe B de l'objet.",
      "agreedRateLabel": "Taux convenu (%)",
      "acceptConfirm": "Accepter",
      "accepted": "Objection acceptée — annexe B créée avec le taux convenu.",
      "acceptFailed": "L'objection n'a pas pu être acceptée.",
      "reject": "Refuser",
      "rejectHint": "La motivation est transmise à l'acheteur.",
      "rejectReasonLabel": "Motivation",
      "rejectReasonPlaceholder": "Pourquoi la contre-proposition est-elle refusée ?",
      "rejectConfirm": "Refuser",
      "rejected": "Objection refusée — l'acheteur a été informé.",
      "rejectFailed": "L'objection n'a pas pu être refusée."
    }
  },
  "researchLeads": {
    "actions": {
      "approve": "Freigeben",
      "autoMatch": "Auto-Match",
      "import": "Importieren",
      "reject": "Ablehnen",
      "website": "Website"
    },
    "allProjects": "Alle Projekte",
    "batchMatch": "Auto-Match alle",
    "deleteTitle": "Lead löschen",
    "detail": {
      "assessment": "Bewertung",
      "businessModel": "Geschäftsmodell",
      "company": "Firma",
      "companyMatch": "Firma-Match",
      "contact": "Kontakt",
      "contactMatch": "Kontakt-Match",
      "created": "Erstellt",
      "email": "E-Mail",
      "employees": "Mitarbeiter",
      "industry": "Branche",
      "linkedin": "LinkedIn",
      "location": "Standort",
      "matching": "Matching",
      "nextSteps": "Nächste Schritte",
      "phone": "Telefon",
      "position": "Position",
      "profile": "Profil",
      "revenue": "Umsatz",
      "source": "Quelle"
    },
    "empty": "Aucun lead trouvé",
    "reject": "Ablehnen",
    "rejectPlaceholder": "Grund für die Ablehnung...",
    "rejectTitle": "Lead ablehnen",
    "searchPlaceholder": "Rechercher entreprise ou contact...",
    "stats": {
      "approved": "Freigegeben",
      "imported": "Importiert",
      "matched": "Gematcht",
      "new": "Neu",
      "rejected": "Abgelehnt",
      "review": "Review",
      "total": "Gesamt"
    },
    "subtitle": "Zone de transit pour les leads recherchés",
    "table": {
      "companyContact": "Firma / Kontakt",
      "match": "Match",
      "project": "Projekt",
      "score": "Score",
      "status": "Status",
      "type": "Typ"
    },
    "title": "Leads de recherche",
    "toast": {
      "approveError": "Fehler bei Freigabe",
      "approved": "Lead freigegeben",
      "batchError": "Batch-Matching fehlgeschlagen",
      "deleteError": "Fehler beim Löschen",
      "deleted": "Lead gelöscht",
      "importError": "Import fehlgeschlagen",
      "matchError": "Matching fehlgeschlagen",
      "noMatch": "Kein Match gefunden",
      "rejectError": "Fehler beim Ablehnen",
      "rejected": "Lead abgelehnt"
    }
  },
  "researchPanel": {
    "adoptContacts": "Reprendre les contacts",
    "cardAddContact": "Créer comme contact",
    "cardAddContactHint": "Créer comme contact (bientôt disponible)",
    "cardAddOrg": "Créer comme organisation",
    "cardAddOrgHint": "Créer comme organisation (bientôt disponible)",
    "cardPin": "Épingler",
    "cardPinHint": "Épingler comme pertinent (bientôt disponible)",
    "cardShowLess": "Afficher moins",
    "cardShowMore": "Afficher plus",
    "connections": "Réseau & connexions",
    "existingCrmCompanies": "Bestehende CRM-Firmen",
    "existingCrmContacts": "Bestehende CRM-Kontakte",
    "foundContacts": "Contacts trouvés",
    "merge": "Zusammenführen",
    "mergeButtonEnrich": "Zusammenführen & Ergänzen",
    "mergeButtonLink": "Bestehenden verwenden",
    "mergeCompanyTitle": "Firma zusammenführen",
    "mergeContactTitle": "Kontakt zusammenführen",
    "mergeDraft": "Recherche",
    "mergeError": "Fehler beim Zusammenführen",
    "mergeExisting": "Bestand (CRM)",
    "mergeField": "Feld",
    "mergeLoadError": "Fehler beim Laden des Datensatzes",
    "mergeLoading": "Lade Vergleichsdaten...",
    "mergeSubtitle": "Recherche-Daten mit bestehendem Eintrag abgleichen",
    "mergeWhatHappens": "Was passiert?",
    "internEmpty": "Aucune correspondance CRM interne. La recherche n'a trouvé aucun contact ou organisation existant.",
    "noContacts": "Aucun contact trouvé dans la recherche.",
    "overview": "Aperçu",
    "personProfile": "Profil",
    "pinnedSection": "Épinglé ({{count}})",
    "resultsCount": "{{count}} résultat(s)",
    "searchingCrm": "Recherche des entrées CRM existantes...",
    "tabExtern": "Externe",
    "tabIntern": "Interne",
    "tabsLabel": "Domaines de recherche",
    "unnamed": "Sans nom",
    "unnamedQuery": "Recherche",
    "unpin": "Retirer l'épingle"
  },
  "roles": {
    "admin": "Administrateur",
    "investor": "Investisseur",
    "sales": "Ventes"
  },
  "schema": {
    "columns": "Colonnes",
    "primaryKeys": "Clés primaires",
    "relationships": "Relations",
    "subtitle": "Diagramme de relations d'entités (ERD)",
    "tableList": "Aperçu des tables",
    "tables": "Tables",
    "title": "Schéma de base de données"
  },
  "seller": {
    "counts": {
      "bo": "BO",
      "interested": "Intéressés",
      "nbo": "NBO",
      "nda": "NDA"
    },
    "detail": {
      "address": "Adresse",
      "aiHints": "KI-Hinweise",
      "allDetails": "Alle Objektdaten",
      "confidence": "KI-Konfidenz",
      "description": "Beschreibung",
      "downloadFailed": "Download fehlgeschlagen",
      "engagement": "Engagement des investisseurs",
      "engagementHint": "Les statistiques détaillées sont mises à jour en continu.",
      "grossYield": "Bruttorendite",
      "investmentMetrics": "Investment-Kennzahlen",
      "loadFailed": "Immobilie konnte nicht geladen werden",
      "location": "Standort",
      "noDocuments": "Noch keine Dokumente. Laden Sie relevante Unterlagen hoch (Grundbuchauszug, Mieterspiegel, etc.).",
      "pricePerSqm": "Preis/m²",
      "pricePerSqmLand": "Prix/m² terrain",
      "reviewHint": "Dès que toutes les informations sont complètes, soumettez votre bien pour vérification. Notre équipe contrôle les données et publie l'annonce.",
      "submitFailed": "Échec de l'envoi. Veuillez réessayer.",
      "submitReview": "Soumettre pour vérification",
      "submitTitle": "Prêt pour la vérification ?",
      "submitting": "Envoi en cours…",
      "uploadFailed": "Upload fehlgeschlagen"
    },
    "myProperties": {
      "addProperty": "Soumettre un bien",
      "clearFilter": "Réinitialiser le filtre",
      "empty": "Aucun bien",
      "emptyHint": "Vous n'avez pas encore soumis de bien à la commercialisation.",
      "filterActive": "Filtré par : {{status}}",
      "loadFailed": "Impossible de charger les biens",
      "noResultsForFilter": "Aucun bien ne correspond à ce filtre",
      "noResultsForFilterHint": "Aucun bien n'a ce statut.",
      "subtitle": "Aperçu de vos biens immobiliers",
      "title": "Mes biens"
    },
    "wizard": {
      "aiAnalyze": "Démarrer l'analyse IA",
      "aiComplete": "Analyse terminée",
      "aiCompleteHint": "Les données détectées ont été importées dans l'assistant. Veuillez vérifier et compléter les informations.",
      "aiPrefillSuccess": "Données importées par l'IA — veuillez vérifier et compléter.",
      "aiPrefilled": "Pré-rempli par l'IA — veuillez vérifier",
      "aiProcessing": "L'IA analyse vos documents...",
      "aiProcessingFailed": "Échec du traitement IA",
      "aiProcessingWait": "Cela peut prendre 1 à 2 minutes.",
      "aiSkip": "Continuer sans analyse IA",
      "aiUploadDrop": "Glissez des documents PDF ou des images ici",
      "aiUploadFailed": "Échec du téléchargement IA",
      "aiUploadFormats": "PDF, JPG, PNG, WebP — max. 50 Mo par fichier",
      "aiUploadHint": "Téléchargez les documents pertinents : état locatif actuel, descriptif de construction, extrait du registre foncier, attestation d'assurance bâtiment, estimations de valeur (Wüest Partner, Fahrländer etc.) — l'IA remplira automatiquement l'assistant.",
      "classificationHint": "Sélectionnez le type et éventuellement le sous-type de votre bien.",
      "contractDeadlineHint": "Veuillez noter: Le contrat a une date d'expiration. Prévoyez suffisamment de temps pour la transaction.",
      "create": "Soumettre le bien",
      "createFailed": "Échec de la soumission",
      "createSuccess": "Bien soumis avec succès",
      "desiredPrice": "Prix souhaité / Prix indicatif",
      "desiredPriceHint": "Votre prix souhaité — non contraignant, non publié",
      "desiredPricePlaceholder": "p.ex. 1'800'000",
      "desiredTimeline": "Délai souhaité",
      "desiredTimelineHint": "Quand souhaitez-vous idéalement vendre?",
      "desiredTimelinePlaceholder": "p.ex. Vente d'ici Q3 2026, flexible dès maintenant",
      "expectedPrice": "Prix souhaité (CHF)",
      "highlights": "Points forts",
      "highlightsHint": "Ces points apparaissent en évidence sur le teaser pour les investisseurs.",
      "highlightsPlaceholder": "p.ex. Emplacement top à Zurich, fraîchement rénové, entièrement loué, rendement stable...",
      "imagesCount": "images",
      "namePlaceholder": "p.ex. Immeuble Zurich-Seefeld",
      "photosFormats": "JPG, PNG, WEBP — max. 20 Mo par image",
      "photosHint": "De bonnes photos vendent! Téléchargez des photos significatives de votre bien.",
      "photosUpload": "Glissez les photos ici ou cliquez",
      "primaryImage": "Image principale",
      "saleEndDate": "Fin de vente souhaitée",
      "saleStartDate": "Début de vente souhaité",
      "sellerNotes": "Remarques",
      "sellerNotesPlaceholder": "p.ex. Circonstances particulières, durée du contrat, conditions souhaitées...",
      "steps": {
        "aiUpload": "Analyse IA",
        "classification": "Type d'objet",
        "details": "Données objet",
        "photos": "Photos",
        "pricing": "Données clés",
        "summary": "Résumé",
        "titleAddress": "Titre & Adresse"
      },
      "subtitle": "Enregistrez votre bien en quelques étapes",
      "summaryHint": "Après la soumission, notre équipe commerciale examinera votre bien et vous contactera.",
      "timeline": "Période",
      "title": "Soumettre un bien"
    }
  },
  "settings": {
    "ai": "Assistant IA",
    "aiConfig": {
      "configured": "Configuré",
      "currentKey": "Clé actuelle",
      "enterKey": "Veuillez saisir la clé API",
      "notConfigured": "Non configuré",
      "replaceKey": "Remplacer la clé API",
      "saveFailed": "Erreur lors de l'enregistrement",
      "saved": "Clé API enregistrée",
      "setKey": "Définir la clé API",
      "status": "Statut",
      "testConnection": "Tester la connexion",
      "testFailed": "Échec de la connexion",
      "testSuccess": "Connexion réussie ({{model}}, {{duration}}s)",
      "testing": "Test...",
      "title": "Claude AI"
    },
    "aiDescription": "Environnement de test Claude AI",
    "apiTokens": {
      "confirmRevoke": "Vraiment révoquer ?",
      "create": "Nouveau token",
      "createError": "Le token n'a pas pu être créé.",
      "createdTitle": "Token créé avec succès",
      "createdWarning": "Copiez le token maintenant — il ne sera plus affiché.",
      "description": "Créez des tokens API persistants pour l'authentification machine-à-machine et les tests E2E.",
      "dismiss": "Compris, fermer",
      "empty": "Aucun token API créé.",
      "expiresAt": "Expire le",
      "generate": "Générer",
      "nameLabel": "Nom du token",
      "namePlaceholder": "ex. Pipeline CI/CD, Tests E2E",
      "revoke": "Révoquer",
      "revokeError": "Le token n'a pas pu être révoqué.",
      "revoked": "Token révoqué",
      "tabLabel": "Tokens API",
      "title": "Tokens API"
    },
    "commissions": "Modèles d'honoraires",
    "commissionsDescription": "Créer et gérer les modèles d'honoraires",
    "displayMode": "Mode",
    "e2e": {
      "autoGenerated": "Der Report wird automatisch nach jedem E2E-Testlauf generiert.",
      "duration": "Dauer",
      "environment": "Umgebung",
      "failed": "Fehlgeschlagen",
      "generated": "Generiert",
      "loadError": "E2E-Report konnte nicht geladen werden.",
      "noReport": "Kein E2E-Report verfügbar. Starte die Tests mit: npx playwright test",
      "passed": "Bestanden",
      "refresh": "Aktualisieren",
      "subtitle": "Ergebnisse der automatisierten Browser-Tests",
      "title": "E2E Test Reports"
    },
    "investorGroups": "Groupes d'investisseurs",
    "investorGroupsDescription": "Grouper les investisseurs et gérer les accès",
    "kycReview": "Vérifier les identifications",
    "mandanten": "Gestion des mandants",
    "mandantenDescription": "Gérer les utilisateurs et les attributions",
    "media": "Médias",
    "mediaDescription": "Gérer les images et fichiers médias",
    "processVis": {
      "finale": {
        "duration": "Gesamtdauer: 6–12 Monate",
        "subtitle": "Transparenz, Effizienz und Professionalität — für Verkäufer und Investoren gleichermassen.",
        "title": "Deal abgeschlossen."
      },
      "hero": {
        "platform": "Immotron Plattform",
        "scrollHint": "Scroll für den Prozess",
        "subtitle": "Vom ersten Kontakt bis zum Closing — 14 Schritte, 3 Akteure, 1 Plattform.",
        "titleLine1": "Der Weg zum",
        "titleLine2": "erfolgreichen Deal"
      },
      "personas": {
        "employee": "Mitarbeiter",
        "investor": "Investor",
        "vendor": "Verkäufer"
      },
      "scrollMore": "Scroll weiter"
    },
    "processes": "Vue des processus",
    "processesDescription": "Visualisation interactive des 3 processus principaux",
    "schema": "Schéma de base de données",
    "schemaDescription": "Afficher le diagramme de relations d'entités",
    "signatories": "Signataires",
    "signatoriesDescription": "Gérer les signataires autorisés internes",
    "subtitle": "Configuration et gestion du système",
    "system": "Système",
    "systemDescription": "Personnaliser l'apparence et le schéma de couleurs",
    "theme": {
      "preset": "Schéma de couleurs",
      "presets": {
        "default-blue": "Bleu par défaut",
        "immotron-red": "Immotron Rouge"
      },
      "preview": "Aperçu",
      "saved": "Schéma de couleurs enregistré",
      "title": "Apparence"
    },
    "title": "Paramètres",
    "users": "Gestion des utilisateurs",
    "usersDescription": "Créer, modifier et gérer les utilisateurs",
    "regulatedWhitelist": "Listes de surveillance",
    "regulatedWhitelistDescription": "Importer les listes de contreparties surveillées et vérifier les correspondances",
    "zefixSync": "Zefix Sync",
    "zefixSyncDescription": "Gérer la synchronisation avec le registre du commerce",
    "e2eReports": "E2E Tests",
    "e2eReportsDescription": "Automatisierte Browser-Tests und Ergebnisse",
    "aiBalances": {
      "title": "API-Kontostände",
      "monthCost": "Monat",
      "calls": "Aufrufe"
    },
    "profile": "Profil"
  },
  "signatories": {
    "addSignatory": "Ajouter un signataire",
    "addSuccess": "Signataire ajouté avec succès",
    "confirmRemove": "Voulez-vous vraiment supprimer cette association?",
    "editSignatory": "Modifier le signataire",
    "function": "Fonction",
    "noInternalCompanies": "Aucune entreprise interne disponible",
    "noSignatories": "Aucun signataire assigné",
    "removeSignatory": "Supprimer le signataire",
    "removeSuccess": "Signataire supprimé avec succès",
    "selectContact": "Sélectionner un contact",
    "signatureText": "Texte de signature",
    "signatureType": "Pouvoir de signature",
    "subtitle": "Gérer les signataires autorisés des entreprises internes",
    "title": "Signataires internes",
    "updateSuccess": "Signataire mis à jour avec succès"
  },
  "signature": {
    "collectiveMore": "Signature collective à plusieurs",
    "collectiveTwo": "Signature collective à deux",
    "none": "Aucune",
    "single": "Signature individuelle"
  },
  "signaturePad": {
    "handoff": {
      "close": "Fermer",
      "done": "Signature reprise ✓",
      "doneHint": "La signature se trouve maintenant dans le champ. Envoyez ici sur l'ordinateur.",
      "expired": "Le code a expiré.",
      "failed": "Le code n'a pas pu être généré.",
      "lead": "Scannez le code avec l'appareil photo du téléphone et signez-y. Le code est valable {{minutes}} minutes.",
      "open": "Signer sur téléphone ou tablette",
      "qrAlt": "Code QR pour la signature sur le téléphone",
      "regenerate": "Générer un nouveau code",
      "remaining": "Code encore valable {{time}}",
      "retry": "Réessayer",
      "title": "Signer sur le téléphone",
      "waiting": "En attente de la signature depuis le téléphone …"
    },
    "mobile": {
      "doneText": "Vous pouvez retourner à l'ordinateur.",
      "doneTitle": "Signature reprise ✓",
      "error": "La signature n'a pas pu être reprise. Veuillez réessayer.",
      "expired": "Le code a expiré. Générez-en un nouveau sur l'ordinateur.",
      "invalid": "Le code n'est pas valable.",
      "lead": "Signez ici avec le doigt. Vous pourrez ensuite continuer sur l'ordinateur.",
      "loading": "Un instant, nous ouvrons le champ de signature …",
      "padLabel": "Votre signature",
      "submit": "Reprendre",
      "title": "Signer",
      "used": "Une signature a déjà été apposée ici."
    }
  },
  "subTaskTabs": {
    "ariaLabel": "Onglets des sous-tâches",
    "create": "Nouvelle sous-tâche",
    "createAriaLabel": "Créer une nouvelle sous-tâche",
    "defaultTitle": "Nouvelle sous-tâche",
    "discardAriaLabel": "Abandonner la sous-tâche",
    "discardConfirm": "Abandonner la sous-tâche avec contenu? Cette action est irréversible.",
    "discardError": "Impossible d'abandonner la sous-tâche",
    "discarded": "Sous-tâche abandonnée",
    "loading": "Chargement des sous-tâches...",
    "mainFallback": "Tâche principale",
    "untitled": "Sans titre"
  },
  "tasks": {
    "actions": {
      "action": "Aktion",
      "apply": "Übernehmen",
      "backToOverview": "Zurück zur Übersicht...",
      "callNote": "Anruf-Notiz",
      "dashMeansEmpty": "— = bisher leer",
      "dataWillBeAdded": "Folgende Daten werden ergänzt:",
      "description": "Beschreibung",
      "dismiss": "Verwerfen",
      "executed": "Aktion ausgeführt!",
      "meetingNote": "Meeting-Notiz",
      "noteLabel": "Notiz",
      "noteWillBeCreated": "Folgende Notiz wird erstellt:",
      "phone": "Telefon",
      "subject": "Betreff",
      "subtaskWillBeCreated": "Folgende Sub-Pendenz wird erstellt:",
      "title": "Titel"
    },
    "addAttachment": "Ajouter",
    "addDescription": "Remarque",
    "aiApply": "Appliquer",
    "aiSuggestion": "Suggestion IA",
    "attachments": "Pièces jointes",
    "clickToEdit": "Klick zum Bearbeiten",
    "completed": "erledigt",
    "context": "Kontext",
    "createSuccess": "Tâche créée",
    "delete": "Supprimer",
    "deleteConfirm": "Supprimer cette tâche?",
    "deleteSuccess": "Tâche supprimée",
    "descriptionPlaceholder": "Ajouter une remarque...",
    "done": "Erledigt",
    "editTask": "Modifier la tâche",
    "errors": {
      "deleteFailed": "La tâche n'a pas pu être supprimée",
      "downloadFailed": "Le téléchargement a échoué",
      "loadFailed": "Les tâches n'ont pas pu être chargées",
      "titleSaveFailed": "Titel konnte nicht gespeichert werden",
      "updateFailed": "Le statut n'a pas pu être modifié",
      "uploadFailed": "Le téléchargement a échoué"
    },
    "fields": {
      "assignedTo": "Assigné à",
      "attachments": "Anhänge",
      "company": "Entreprise",
      "completedAt": "Erledigt",
      "contact": "Contact",
      "createdAt": "Créé le",
      "createdBy": "Créé par",
      "description": "Description",
      "dueDate": "Échéance",
      "listing": "Annonce",
      "priority": "Priorité",
      "property": "Bien immobilier",
      "status": "Statut",
      "title": "Titre",
      "unassigned": "Nicht zugewiesen",
      "visibility": "Sichtbarkeit",
      "descriptionPlaceholder": "Beschreibung hinzufügen..."
    },
    "goal": {
      "label": "Objectif",
      "prompt": "Quel est votre objectif pour cette tâche ?",
      "hint": "L'objectif guide l'agent dans toutes les actions.",
      "placeholder": "ex. Contacter le client et planifier une visite",
      "edit": "Modifier l'objectif",
      "remove": "Supprimer l'objectif",
      "removed": "Objectif supprimé",
      "saved": "Objectif enregistré",
      "saveFailed": "L'objectif n'a pas pu être enregistré",
      "shortcut": "Cmd/Ctrl + Entrée pour enregistrer",
      "setAriaLabel": "Définir l'objectif de cette tâche",
      "chips": {
        "contact": "Contact",
        "company": "Société",
        "property": "Bien",
        "listing": "Annonce",
        "campaign": "Campagne",
        "teaser": "Teaser",
        "removeAriaLabel": "Retirer {{label}}"
      },
      "contextEmpty": "Aucun contexte lié",
      "createTask": "Créer une tâche depuis l'objectif",
      "createTaskSuccess": "Tâche créée depuis l'objectif",
      "createTaskFailed": "Impossible de créer la tâche",
      "editClick": "Cliquer pour modifier",
      "stats": {
        "chunks_one": "{{count}} note",
        "chunks_other": "{{count}} notes",
        "chunksTooltip": "Notes liées à cette tâche",
        "pins_one": "{{count}} note",
        "pins_other": "{{count}} notes",
        "pinsTooltip": "Réponses du chat épinglées comme notes"
      }
    },
    "groups": {
      "completed": "Terminé",
      "later": "Plus tard",
      "overdue": "En retard",
      "thisWeek": "Cette semaine",
      "today": "Aujourd'hui"
    },
    "linkedCompany": "Entreprise",
    "linkedContact": "Contact",
    "lock": {
      "inProgress": "En cours",
      "inputDisabled": "Saisie verrouillée — la tâche est en cours de traitement par quelqu'un d'autre",
      "readOnlyBanner": "En cours de traitement par {{name}} — lecture seule",
      "unknownUser": "un autre utilisateur"
    },
    "markDone": "Marquer comme terminé",
    "newTask": "Nouvelle tâche",
    "noAttachments": "Aucune pièce jointe",
    "noTasks": "Aucune tâche trouvée",
    "noTasksHint": "Créez une nouvelle tâche avec le bouton ci-dessus.",
    "open": "Offen",
    "overview": {
      "email": "Email",
      "emails": "E-mails",
      "emailNoSubject": "Sans objet",
      "emailStatusDraft": "Brouillon",
      "emailStatusSent": "Envoyé",
      "enrich": "Enrichir",
      "note": "Note",
      "quickActions": "Actions rapides",
      "removePin": "Retirer l'épingle",
      "searchCommercialRegister": "Rechercher au registre du commerce",
      "propertyResidential": "Habit.",
      "propertyCommercial": "Comm.",
      "propertyLot": "Terrain",
      "propertyFloors": "Ét.",
      "propertyYear": "Année",
      "propertyOpen": "Ouvrir le bien",
      "propertyLoading": "Chargement du bien...",
      "propertyDocuments": "Documents",
      "propertyDocsLoading": "Chargement des documents...",
      "propertyImages": "Images",
      "propertyImagesShowAll": "Tout afficher ({{count}})",
      "propertyImagesShowLess": "Afficher moins",
      "attachToEmail": "Joindre à l'e-mail",
      "attachToEmailShort": "Vers e-mail",
      "docAttached": "{{name}} joint à l'e-mail",
      "docAttachedShort": "Joint",
      "emailDiscard": "Supprimer le brouillon",
      "emailArchive": "Archiver l’e-mail",
      "emailUnarchive": "Restaurer",
      "emailDiscarded": "Brouillon supprimé",
      "emailUndo": "Annuler",
      "emailArchivedToast": "E-mail archivé",
      "emailUnarchivedToast": "E-mail restauré",
      "emailArchivedSection": "Archivés ({{count}})",
      "emailSentOn": "Envoyé le {{date}}",
      "emailsAllArchived": "Tous les e-mails archivés"
    },
    "compactHeader": {
      "addContact": "+ Contact",
      "addCompany": "+ Entreprise",
      "addProperty": "+ Bien",
      "removeContact": "Retirer le contact",
      "removeCompany": "Retirer l'entreprise",
      "removeProperty": "Retirer le bien",
      "removeContactFailed": "Impossible de retirer le contact",
      "removeCompanyFailed": "Impossible de retirer l'entreprise",
      "removeFailed": "Impossible de retirer le lien",
      "attachContactFailed": "Impossible de lier le contact",
      "attachCompanyFailed": "Impossible de lier l'entreprise",
      "attachFailed": "Impossible de lier le bien",
      "details": "Détails / Modifier"
    },
    "priority": {
      "HIGH": "Élevé",
      "LOW": "Bas",
      "MEDIUM": "Moyen",
      "URGENT": "Urgent"
    },
    "private": "Privé",
    "public": "Public",
    "quickAdd": "Ajout rapide",
    "reopen": "Rouvrir",
    "resetChat": "Chat zurücksetzen",
    "search": {
      "placeholder": "Rechercher des tâches — nom, e-mail, téléphone, société, bien...",
      "aria": "Recherche plein texte dans les tâches",
      "clear": "Effacer la recherche",
      "noResults": "Aucun résultat",
      "noResultsHint": "Aucune tâche trouvée pour « {{query}} »."
    },
    "smartCreate": {
      "hint": "Quel est ton objectif ? Décris la tâche — les sociétés, contacts et biens sont reconnus automatiquement.",
      "placeholder": "p.ex. « E-mail de vente au CEO de Mansory pour l'Industriestrasse 11 à Dielsdorf »",
      "analyzing": "Analyse...",
      "proposalTitle": "Suggestion",
      "steps": "étapes",
      "manual": "Créer manuellement",
      "smartMode": "Mode intelligent",
      "adjust": "Ajuster",
      "create": "Créer",
      "error": "Analyse échouée",
      "goalPrefix": "Objectif"
    },
    "sort": {
      "createdAt": "Date de création",
      "dueDate": "Date d'échéance",
      "priority": "Priorité",
      "title": "Titre"
    },
    "stats": {
      "done": "Terminé",
      "inProgress": "En cours",
      "open": "Ouvert",
      "overdue": "En retard",
      "total": "Total"
    },
    "status": {
      "CANCELLED": "Annulé",
      "DONE": "Terminé",
      "IN_PROGRESS": "En cours",
      "OPEN": "Ouvert",
      "cancelled": "Abgebrochen",
      "done": "Erledigt",
      "inProgress": "In Bearbeitung",
      "open": "Offen"
    },
    "statuses": {
      "CANCELLED": "Abgebrochen",
      "DONE": "Erledigt",
      "IN_PROGRESS": "In Arbeit",
      "OPEN": "Offen"
    },
    "subtasks": {
      "create": "Créer une sous-tâche",
      "done": "terminé",
      "empty": "Aucune sous-tâche",
      "progress": "Fortschritt",
      "short": "Sous",
      "title": "Sub-Pendenzen"
    },
    "subtitle": "Gérer les tâches et les pendences",
    "title": "Tâches",
    "updateSuccess": "Tâche mise à jour",
    "widget": {
      "empty": "Aucune tâche ouverte",
      "showAll": "Tout afficher",
      "title": "Mes tâches"
    },
    "workflow": {
      "customize": "Anpassen",
      "dismiss": "Ignorieren",
      "exit": "Workflow verlassen",
      "exitShort": "Verlassen",
      "start": "Workflow starten"
    },
    "saveError": "Speichern fehlgeschlagen",
    "deleteError": "Löschen fehlgeschlagen",
    "purge": "Supprimer définitivement",
    "purging": "Suppression définitive …",
    "purged": "Tâche supprimée définitivement",
    "purgeError": "Échec de la suppression définitive",
    "purgeForbidden": "Pas d'autorisation : seul un administrateur ou le créateur peut supprimer définitivement cette tâche.",
    "purgeNotFound": "Tâche introuvable — elle a peut-être déjà été supprimée.",
    "purgeConfirmTitle": "Supprimer définitivement la tâche ?",
    "purgeConfirmDescription": "Cette action est irréversible. Le chat, l'historique, les éléments de connaissance et TOUTES les sous-tâches seront entièrement et définitivement supprimés. Contrairement à la suppression normale, aucune restauration n'est possible.",
    "purgeConfirmButton": "Supprimer définitivement",
    "purgeHint": "Irréversible – sans corbeille, impossible à restaurer.",
    "uploadError": "Upload fehlgeschlagen",
    "deleteAttachmentError": "Anhang löschen fehlgeschlagen",
    "toggleError": "Status ändern fehlgeschlagen",
    "saved": "Pendenz gespeichert",
    "deleted": "Pendenz gelöscht",
    "deleting": "Löschen...",
    "searchProperty": "Immobilie suchen...",
    "noPropertiesFound": "Keine Immobilien gefunden"
  },
  "teaser": {
    "salesContact": "Contact commercial"
  },
  "teaserCard": {
    "accessGranted": "Accès accordé",
    "clubDeal": "Club Deal",
    "noAccess": "Pas d'accès",
    "priceLocked": "Prix après NDA",
    "yieldLocked": "Rendement après NDA"
  },
  "timeline": {
    "activities": "Activités",
    "activityCreated": "Activité créée",
    "addCall": "Enregistrer un appel",
    "addMeeting": "Enregistrer une réunion",
    "addNote": "Ajouter une note",
    "all": "Tous",
    "createContact": "Créer un contact",
    "createContactFor": "Créer un contact pour {{name}}",
    "descriptionPlaceholder": "Détails (optionnel)...",
    "dueDate": "Échéance",
    "durationPlaceholder": "Durée en minutes",
    "emailFrom": "De :",
    "emailHasAttachments": "Pièce jointe",
    "emailInbound": "Reçu",
    "emailOutbound": "Envoyé",
    "emailTo": "À :",
    "emails": "E-mails",
    "empty": "Aucune entrée",
    "entries": "entrées",
    "handledBy": "traité par {{name}}",
    "mailbox": "Boîte {{label}}",
    "mailboxPersonal": "Boîte personnelle",
    "mailboxShared": "Boîte partagée",
    "newCall": "Enregistrer un appel",
    "newMeeting": "Enregistrer une réunion",
    "newNote": "Nouvelle note",
    "subjectPlaceholder": "Objet...",
    "tasks": "Tâches",
    "thread": {
      "label": "Conversation",
      "last": "dernier {{date}}",
      "mails": "{{n}} e-mails",
      "moreContacts": "+{{n}}",
      "noSubject": "(Sans objet)",
      "participantsLabel": "Participants :",
      "unknownParticipant": "Inconnu"
    },
    "title": "Chronologie",
    "unanswered": "sans réponse",
    "activity": "Activités",
    "activity_one": "{{count}} activité",
    "activity_other": "{{count}} activités",
    "daysLeft_one": "Plus qu'1 jour",
    "daysLeft_other": "Encore {{count}} jours",
    "endsToday": "Se termine aujourd'hui!",
    "today": "Aujourd'hui",
    "lastHours": "Dernières {{count}} heures — {{phase}} bientôt terminé!",
    "onlyDaysLeft": "Plus que {{count}} jours — {{phase}} bientôt terminé!",
    "phases": {
      "marketing": "Commercialisation exclusive",
      "nbo": "Tour d'offres",
      "evaluation": "Évaluation",
      "bo": "Tour final",
      "closing": "Conclusion",
      "sale": "Vendu"
    }
  },
  "users": {
    "addCompany": "Ajouter une entreprise",
    "addUser": "Ajouter un utilisateur",
    "allRoles": "Tous les roles",
    "allStatuses": "Tous les statuts",
    "companyAdded": "Entreprise ajoutée avec succès",
    "companyRemoved": "Association supprimée",
    "companyRoles": "Associations d'entreprises",
    "companyUpdated": "Association mise à jour",
    "confirmDelete": "Voulez-vous vraiment supprimer cet utilisateur?",
    "confirmRemoveCompany": "Voulez-vous vraiment supprimer cette association?",
    "contact": "Contact lié",
    "createGroupDescLabel": "Description (facultatif)",
    "createGroupFromSelection": "Créer un groupe",
    "createGroupNameLabel": "Nom du groupe",
    "createGroupSuccess": "Groupe «{{name}}» créé avec {{count}} investisseurs",
    "createGroupTitle": "Créer un groupe d'investisseurs",
    "createSuccess": "Utilisateur créé avec succès",
    "createdAt": "Créé le",
    "creatingFromContact": "Création d'un utilisateur à partir du contact «{{name}}». Sera lié automatiquement.",
    "deleteSuccess": "Utilisateur supprimé avec succès",
    "deleteUser": "Supprimer l'utilisateur",
    "editUser": "Modifier l'utilisateur",
    "email": "E-mail",
    "emailExists": "Adresse e-mail déjà utilisée",
    "firstName": "Prénom",
    "function": "Fonction",
    "isActive": "Actif",
    "lastLogin": "Dernière connexion",
    "lastName": "Nom",
    "noContact": "Aucun contact lié",
    "noInvestorsSelected": "Aucun investisseur dans la sélection",
    "password": "Mot de passe",
    "passwordReset": "Réinitialisation du mot de passe",
    "passwordResetHint": "Envoie un lien de réinitialisation par e-mail",
    "removeContact": "Supprimer le lien",
    "resetLinkCopied": "Lien de réinitialisation copié dans le presse-papiers",
    "resetSent": "Lien de réinitialisation envoyé par e-mail",
    "resultsLabel": "Utilisateurs",
    "role": "Rôle",
    "saveSuccess": "Utilisateur enregistré avec succès",
    "searchContacts": "Rechercher un contact...",
    "selectContact": "Sélectionner un contact",
    "selectedCount": "{{count}} sélectionné(s)",
    "sendReset": "Envoyer la réinitialisation",
    "signatureType": "Pouvoir de signature",
    "status": "Statut",
    "title": "Gestion des utilisateurs",
    "updateSuccess": "Utilisateur mis à jour avec succès"
  },
  "validation": {
    "email": "Veuillez entrer une adresse e-mail valide",
    "maxLength": "Maximum {{max}} caractères autorisés",
    "minLength": "Au moins {{min}} caractères requis",
    "passwordMismatch": "Les mots de passe ne correspondent pas",
    "required": "Ce champ est obligatoire"
  },
  "regulatedWhitelist": {
    "category": {
      "LISTED": "Cotée",
      "PUBLIC_LAW": "Droit public",
      "REGULATED": "Surveillée"
    },
    "columnCategory": "Catégorie",
    "columnCompany": "Entreprise",
    "columnCount": "Entrées",
    "columnDate": "Date",
    "columnEntry": "Entrée de liste",
    "columnLastImport": "Dernier import",
    "columnList": "Liste",
    "columnMatch": "Correspondance",
    "confirm": "Confirmer",
    "confirmFailed": "Échec de la confirmation.",
    "confirmSuccess": "Entreprise confirmée comme contrepartie surveillée.",
    "forbidden": "Aucune autorisation — cette page est réservée aux administrateurs.",
    "hint": "Les correspondances par IDE sont confirmées automatiquement lors de l'exécution mensuelle. Les correspondances par nom doivent être vérifiées ici. Caisses de pension d'entreprise sans entrée de liste : autodéclaration dans le profil de l'entreprise.",
    "importBtn": "Importer les listes maintenant",
    "importFailed": "Échec de l'import.",
    "importListError": "Liste {{list}} : {{error}}",
    "importSuccess": "Import terminé : {{created}} nouvelles, {{updated}} mises à jour, {{removed}} supprimées.",
    "listsEmpty": "Aucune liste importée pour l'instant.",
    "listsTitle": "Listes importées",
    "matchRunBtn": "Lancer la comparaison",
    "matchRunFailed": "Échec de la comparaison.",
    "matchRunSuccess": "Comparaison terminée : {{confirmed}} confirmées automatiquement, {{pending}} à vérifier, {{stale}} obsolètes.",
    "matchType": {
      "name_exact": "Nom exact",
      "name_fuzzy": "Nom approximatif",
      "uid": "IDE"
    },
    "never": "Jamais",
    "noMatches": "Aucune entrée dans cette vue.",
    "queueTitle": "Correspondances à vérifier",
    "reject": "Refuser",
    "rejectFailed": "Échec du refus.",
    "rejectSuccess": "Correspondance refusée.",
    "staleHint": "Entrée de liste inexistante — vérifier manuellement le statut de l'entreprise.",
    "subtitle": "Contreparties surveillées (FINMA, SIX, CHS PP) : importer les listes et vérifier les correspondances.",
    "tabs": {
      "CONFIRMED": "Confirmées",
      "PENDING": "Ouvertes",
      "REJECTED": "Refusées",
      "STALE": "Obsolètes"
    },
    "title": "Listes de surveillance"
  },
  "zefixSync": {
    "companies": "Organisations",
    "companiesProcessed": "entreprises traitées",
    "configFailed": "La configuration Zefix a echoue.",
    "configSaved": "Configuration enregistrée",
    "configuration": "Configuration",
    "duration": "Durée",
    "errors": "Erreurs",
    "history": "Historique",
    "interval": "Intervalle",
    "lastRun": "Dernier lancement",
    "mockModeWarning": "Mode simulation actif — aucune donnée Zefix réelle n'est récupérée",
    "noLogs": "Aucune synchronisation effectuée",
    "rateLimit": "Limite de débit",
    "result": "Résultat",
    "running": "Synchronisation en cours...",
    "startedAt": "Démarré",
    "status": {
      "completed": "Terminé",
      "failed": "Échoué",
      "running": "En cours"
    },
    "subtitle": "Synchronisation automatique avec le registre du commerce",
    "syncFailed": "La synchronisation Zefix a echoue.",
    "syncStarted": "Synchronisation Zefix demarree.",
    "title": "Zefix Sync",
    "trigger": "Déclencheur",
    "triggerManual": "Manuel",
    "triggerScheduler": "Automatique",
    "triggerSync": "Lancer la synchronisation",
    "revert": "Annuler",
    "revertTitle": "Annuler la synchronisation",
    "revertConfirm": "{{added}} contacts ajoutés et {{updated}} contacts mis à jour seront réinitialisés. Continuer ?",
    "revertFailed": "L'annulation a échoué"
  },
  "research": {
    "applyFailed": "La reprise a échoué",
    "proposalTitle": "Proposition de recherche",
    "new": "nouveau",
    "changed": "modifié",
    "selectAll": "Tous",
    "selectOnlyNew": "Nouveaux uniquement",
    "field": "Champ",
    "currentValue": "Actuel (CRM)",
    "proposedValue": "Proposition (recherche)",
    "applyHtmlReport": "Reprendre le rapport HTML",
    "applyKeyPersons": "Synchroniser les contacts",
    "applySelected": "Reprendre",
    "applied": "{{count}} champs repris"
  },
  "researchCard": {
    "location": "Site"
  },
  "emailTemplatePicker": {
    "uncategorized": "Allgemein",
    "loading": "Vorlagen laden...",
    "noTemplate": "Ohne Vorlage",
    "preview": "Vorschau"
  },
  "softDelete": {
    "showDeleted": "Afficher les supprimés",
    "archived": "Archivé",
    "restore": "Restaurer",
    "restoreSuccess": "Restauré avec succès"
  },
  "unifiedProcess": {
    "heading": {
      "create": "Créer un nouveau bien",
      "edit": "Modifier le bien — {{name}}",
      "editStatic": "Modifier le bien",
      "untitled": "Bien sans titre"
    },
    "loadError": "Impossible de charger le bien",
    "tabsAriaLabel": "Onglets d'édition",
    "skeletonNote": "Cet onglet sera complété lors d'une étape ultérieure.",
    "tabs": {
      "ai": "Saisie IA",
      "object": "Objet",
      "location": "Situation",
      "pricing": "Prix et loyer",
      "media": "Médias et textes",
      "review": "Mandat et commercialisation",
      "protocol": "Journal d'extraction IA",
      "knowledge": "Connaissances",
      "aiInsights": "Notes IA"
    },
    "tabHints": {
      "ai": "Télécharger des documents — l'IA extrait les champs automatiquement.",
      "object": "Surfaces, pièces, état et classes énergétiques.",
      "location": "Carte, données du registre des bâtiments (RegBL) et restrictions environnementales.",
      "pricing": "Prix de vente, type de mandat et conditions.",
      "media": "Images, visite virtuelle, points forts et descriptions.",
      "review": "Mandant, configuration des ventes et quality gate.",
      "protocol": "Aperçu de tous les jobs d'extraction IA pour ce bien.",
      "knowledge": "Notes épinglées sur ce bien depuis les tâches."
    },
    "protocol": {
      "title": "Journal d'extraction IA",
      "subtitle": "Aperçu de tous les jobs IA qui ont fourni des données pour ce bien.",
      "empty": "Aucune extraction IA pour ce bien.",
      "loadFailed": "Impossible de charger le journal d'extraction.",
      "jobLabel": "Job #{{id}}",
      "confidenceLabel": "Confiance :",
      "kpi": {
        "confidence": "Confiance",
        "documents": "Documents",
        "images": "Images",
        "fields": "Champs",
        "tokens": "Tokens"
      },
      "documents": {
        "title": "Classification des documents"
      },
      "location": {
        "title": "Données de localisation",
        "summary": "{{found}} sur {{total}} détectés",
        "fields": {
          "address": "Adresse",
          "zip": "Code postal",
          "city": "Ville",
          "municipality": "Commune",
          "canton": "Canton",
          "country": "Pays",
          "coordinates": "Coordonnées"
        }
      },
      "fields": {
        "title": "Champs détectés ({{count}})"
      },
      "images": {
        "title": "Classification des images",
        "summary": "{{kept}} sur {{total}} images conservées"
      },
      "coverage": {
        "title": "Couverture des données",
        "summary": "{{found}} sur {{total}} champs détectés ({{pct}} %)",
        "found": "Détecté",
        "missing": "Manquant",
        "none": "Aucune entrée"
      },
      "warnings": {
        "title": "{{count}} avertissement(s)"
      },
      "technical": {
        "title": "Détails techniques"
      }
    },
    "location": {
      "readOnlyHint": "Toutes les données sont remplies automatiquement — par le téléversement IA ou la saisie d'adresse. L'édition directe n'est pas possible ici.",
      "notAvailable": "non disponible",
      "sections": {
        "basics": "Données de situation",
        "energy": "Énergie et environnement",
        "gwr": "Registre des bâtiments (RegBL)",
        "taxLaw": "Fiscalité et droit",
        "environment": "Environnement et restrictions"
      },
      "fields": {
        "map": "Carte",
        "municipality": "Commune",
        "inhabitants": "Population",
        "coordinates": "Coordonnées (lat / lon)",
        "zoneType": "Zone d'affectation",
        "zoneRegulations": "Réglementation de zone",
        "egid": "EGID (identifiant du bâtiment)",
        "egrid": "EGRID (identifiant de parcelle)",
        "constructionYear": "Année de construction (registre)",
        "noiseSensitivity": "Degré de sensibilité au bruit (DS)",
        "groundwaterZone": "Zone de protection des eaux souterraines",
        "naturalHazard": "Dangers naturels",
        "floodRisk": "Zone de risque d'inondation",
        "earthquakeZone": "Zone sismique",
        "contaminatedSite": "Site contaminé",
        "heritageProtection": "Protection du patrimoine",
        "co2Emissions": "Émissions de CO₂ (bâtiment)",
        "minergie": "Certificat Minergie",
        "solarPotential": "Potentiel solaire (toiture)",
        "taxRateMunicipality": "Taux d'imposition communal",
        "taxRateCanton": "Taux d'imposition cantonal",
        "taxRateMunicipalityLegal": "Taux d'imposition communal (personnes morales)",
        "taxRateCantonLegal": "Taux d'imposition cantonal (personnes morales)",
        "zoning": "Zone d'affectation (communale + cantonale)",
        "bauzone": "Zone à bâtir (catégorie)",
        "oevQuality": "Qualité de desserte TP",
        "noiseDb": "Bruit routier (jour, dB)"
      },
      "taxRateValue": "Revenu : {{income}} · Fortune : {{wealth}}",
      "taxRateLegalValue": "Bénéfice : {{profit}} · Capital : {{capital}}",
      "tooltip": {
        "showDetails": "Afficher les détails",
        "rawValue": "Valeur d'origine : {{raw}}"
      },
      "noiseClassify": {
        "es1": {
          "label": "Zone de repos (DS I)",
          "description": "Zone de détente. Valeurs limites de bruit les plus strictes — idéal pour les usages sensibles au bruit comme les hôpitaux ou les écoles."
        },
        "es2": {
          "label": "Zone résidentielle (DS II)",
          "description": "Zones d'habitation pures. Bonne protection contre le bruit — usage résidentiel standard sans restriction."
        },
        "es3": {
          "label": "Zone mixte (DS III)",
          "description": "Habitation et activités moyennement gênantes mélangées. Bruit commercial possible — généralement acceptable pour l'habitation."
        },
        "es4": {
          "label": "Zone industrielle (DS IV)",
          "description": "Activités fortement gênantes / industrie. Peu de protection contre le bruit — non adapté à l'habitation pure."
        },
        "db_quiet": {
          "label": "Très calme (<45 dB)",
          "description": "Situation rurale, pas de bruit de circulation. Cadre de vie idéal."
        },
        "db_calm": {
          "label": "Calme (45–54 dB)",
          "description": "Situation résidentielle normale, faible bruit de fond."
        },
        "db_moderate": {
          "label": "Modéré (55–64 dB)",
          "description": "Perceptible — fermer les fenêtres la nuit recommandé."
        },
        "db_loud": {
          "label": "Bruyant (65–74 dB)",
          "description": "Route principale ou proximité ferroviaire. Fenêtres antibruit recommandées."
        },
        "db_very_loud": {
          "label": "Très bruyant (≥75 dB)",
          "description": "Autoroute ou aéroport. Habitation uniquement avec mesures d'insonorisation complètes."
        },
        "unknown": {
          "label": "Classification inconnue",
          "description": "La valeur de bruit n'a pas pu être classée clairement."
        }
      },
      "hazardClassify": {
        "none": {
          "label": "Aucun danger",
          "description": "Aucune entrée de danger naturel — aucun risque connu."
        },
        "low": {
          "label": "Faible",
          "description": "Risque minimal. Aucune mesure de protection particulière requise."
        },
        "medium": {
          "label": "Moyen",
          "description": "Glissement de terrain, chute de pierres ou inondation possible. Vérifier la couverture d'assurance."
        },
        "high": {
          "label": "Considérable",
          "description": "Mesures de protection ou exigences officielles possibles. Tenir compte de l'impact sur la valeur."
        },
        "severe": {
          "label": "Élevé",
          "description": "Interdiction de construire ou exigences strictes probables. Décote de valeur notable à prévoir."
        },
        "unknown": {
          "label": "Classification inconnue",
          "description": "La valeur de danger naturel n'a pas pu être classée clairement."
        }
      },
      "earthquakeClassify": {
        "z1": {
          "label": "Zone sismique faible (Z1)",
          "description": "Plus faible aléa en Suisse. Construction standard suffisante."
        },
        "z2": {
          "label": "Zone sismique modérée (Z2)",
          "description": "Exigences de construction accrues selon la norme SIA 261."
        },
        "z3a": {
          "label": "Zone sismique élevée (Z3a)",
          "description": "Dimensionnement plus strict requis — coûts de construction potentiellement plus élevés."
        },
        "z3b": {
          "label": "Zone sismique très élevée (Z3b)",
          "description": "Plus fort aléa suisse (Valais, Bâle). Construction parasismique obligatoire."
        }
      },
      "groundwaterClassify": {
        "none": {
          "label": "Hors zone de protection",
          "description": "Aucune restriction de protection des eaux souterraines pour la construction ou la rénovation."
        },
        "au": {
          "label": "Secteur de protection Au",
          "description": "Secteur de protection général des eaux souterraines exploitables. Exigences mineures pour les travaux."
        },
        "s3": {
          "label": "Zone de protection S3",
          "description": "Zone de protection éloignée — restrictions sur l'excavation, l'infiltration et le stockage de substances polluantes."
        },
        "s2": {
          "label": "Zone de protection S2",
          "description": "Zone de protection rapprochée — exigences importantes, la plupart des constructions nécessitent une autorisation."
        },
        "s1": {
          "label": "Zone de captage S1",
          "description": "Périmètre direct autour du captage d'eau potable. Pratiquement une interdiction de construire."
        },
        "unknown": {
          "label": "Classification inconnue",
          "description": "La zone de protection des eaux souterraines n'a pas pu être classée clairement."
        }
      },
      "co2Classify": {
        "neutral": {
          "label": "Neutre en CO₂",
          "description": "Énergie renouvelable (pompe à chaleur, chauffage à distance, bois). Pas de besoin de rénovation lié au CO₂."
        },
        "low": {
          "label": "Faibles émissions",
          "description": "Sous la moyenne suisse — pas d'obligation de rénovation à court terme attendue."
        },
        "high": {
          "label": "Émissions élevées",
          "description": "Typique d'un chauffage au mazout ou au gaz. Loi sur le CO₂ : obligation de rénovation attendue dans les prochaines années."
        },
        "unknown": {
          "label": "Émissions inconnues",
          "description": "La valeur de CO₂ n'a pas pu être classée clairement."
        }
      },
      "co2Tone": {
        "green": "Faibles émissions de CO₂ (renouvelable)",
        "yellow": "Émissions de CO₂ modérées",
        "red": "Émissions de CO₂ élevées",
        "gray": "Émissions de CO₂ inconnues"
      },
      "hazardTone": {
        "green": "Faible",
        "yellow": "Modéré",
        "red": "Élevé / Important",
        "gray": "Inconnu"
      },
      "noiseTone": {
        "green": "Calme",
        "yellow": "Modéré",
        "red": "Bruyant",
        "gray": "Inconnu"
      },
      "zoneRegulationsDocuments": "Documents de réglementation",
      "zoneRegulationsDocument": "Document",
      "minergie": {
        "none": "Aucun certificat"
      },
      "oevClassify": {
        "a": {
          "label": "TP A (excellente)",
          "description": "Excellente desserte — tram ou gare à haute fréquence à proximité immédiate (situation urbaine de premier ordre)."
        },
        "b": {
          "label": "TP B (bonne)",
          "description": "Bonne desserte — horaire dense à courte distance à pied. Typique pour des quartiers urbains bien reliés."
        },
        "c": {
          "label": "TP C (moyenne)",
          "description": "Desserte moyenne — bus ou train accessibles à fréquence approximativement horaire."
        },
        "d": {
          "label": "TP D (faible)",
          "description": "Desserte faible — peu de liaisons par jour. La voiture est pratiquement nécessaire."
        },
        "e": {
          "label": "TP E (marginale)",
          "description": "Desserte marginale — peu de transports publics. Situation périphérique ou rurale."
        },
        "none": {
          "label": "Aucune desserte TP",
          "description": "Pas de transports publics à distance utile."
        },
        "unknown": {
          "label": "Classe TP inconnue",
          "description": "La classe de qualité TP n'a pas pu être déterminée clairement."
        }
      },
      "bauzoneInfo": {
        "wohnen": "Zones d'habitation — principalement destinées au logement (faible à plusieurs étages).",
        "arbeit": "Zones d'activités — industrie, artisanat et services. L'habitation est généralement limitée.",
        "misch": "Zones mixtes — habitation et activités moyennement gênantes admises à parts égales.",
        "zentrum": "Zones de centre — zones centrales et de vieille ville à forte densité et caractère urbain.",
        "oeffentlich": "Zones d'utilité publique — écoles, administration, hôpitaux, installations sportives.",
        "tourismus": "Zones de tourisme et loisirs — hôtels, complexes, sport et détente.",
        "eingeschraenkt": "Zones à bâtir restreintes — p. ex. hameaux ou zones protégées avec constructibilité limitée.",
        "generic": "Catégorie de zone à bâtir selon la statistique fédérale des zones à bâtir (ARE)."
      },
      "links": {
        "googleMaps": "Ouvrir Google Maps",
        "geoAdmin": "Source : map.geo.admin.ch",
        "geodienste": "Source : geodienste.ch",
        "housingStat": "Source : housing-stat.ch (RegBL)",
        "cadastre": "Source : cadastre.ch",
        "oereb": "Source : Cadastre RDPPF",
        "bfs": "Source : OFS",
        "bafu": "Source : OFEV (cadastre CO₂)",
        "minergie": "Source : minergie.ch",
        "sonnendach": "Source : sonnendach.ch",
        "estv": "Source : AFC calculateur d'impôts",
        "bauzone": "Source : ARE statistique des zones à bâtir",
        "oevQuality": "Source : ARE classes de qualité TP"
      }
    },
    "ai": {
      "upload": {
        "title": "Téléverser des documents pour la saisie IA",
        "subtitle": "Téléversez la documentation de vente, les extraits du registre foncier, les plans ou les images — l'IA remplit ensuite automatiquement les onglets suivants.",
        "dragDrop": "Glissez-déposez les fichiers ou cliquez",
        "hint": "PDF, images ou documents Office (max. 250 Mo par fichier)",
        "chooseFiles": "Choisir des fichiers",
        "chooseDirectory": "Choisir un dossier",
        "noSupportedInDirectory": "Aucun fichier pris en charge dans le dossier (PDF, images ou documents Office)",
        "selectedFiles": "{{count}} fichier(s) sélectionné(s)",
        "removeFile": "Retirer {{name}}",
        "fileTooLarge": "{{name}} : fichier trop volumineux (max. 250 Mo)",
        "startButton": "Démarrer la saisie IA",
        "starting": "Téléversement…",
        "started": "Analyse démarrée",
        "uploadFailed": "Échec du téléversement",
        "startHint": "L'analyse s'exécute en arrière-plan — la progression s'affiche ici.",
        "attachImagesLabel": "Ajouter les images des documents à la galerie",
        "attachImagesHint": "Désactivé par défaut — plus rapide, l'IA n'analyse pas les photos lorsque les images sont désactivées. Il est préférable de téléverser les images du bien séparément."
      },
      "processing": {
        "title": "L'IA traite les documents",
        "hint": "Veuillez patienter — le résultat s'affichera automatiquement."
      },
      "result": {
        "title": "Saisie terminée",
        "subtitle": "Veuillez vérifier le résumé et accepter les données.",
        "confidenceLabel": "Confiance",
        "documentsLabel": "Documents détectés",
        "imagesLabel": "Images",
        "warningsLabel": "{{count}} avertissement(s)",
        "warningsMore": "+{{count}} de plus…",
        "confirmButton": "Accepter les données et continuer",
        "confirming": "Création…",
        "confirmed": "Bien créé — {{count}} champs remplis.",
        "confirmedRecovered": "L'objet #{{id}} a été créé (la connexion a été brièvement interrompue).",
        "confirmFailed": "Impossible d'accepter les données",
        "cancelButton": "Annuler et recommencer"
      },
      "failed": {
        "title": "La saisie IA a échoué",
        "retryButton": "Recommencer"
      },
      "history": {
        "title": "Historique de la saisie IA",
        "subtitle": "Les tâches IA suivantes ont fourni des données pour ce bien.",
        "empty": "Aucune saisie IA pour ce bien.",
        "loadFailed": "Impossible de charger l'historique.",
        "editNoUploadHint": "Aucun nouveau téléversement IA n'est possible en mode édition. Utilisez les onglets suivants pour saisir les données manuellement.",
        "openInJobs": "Ouvrir dans Tâches IA",
        "jobLabel": "Tâche #{{id}}",
        "summary": "{{docs}} document(s) · {{date}}",
        "confidenceLabel": "Confiance :"
      }
    },
    "save": {
      "idle": "Synchronisé",
      "pending": "Modifications en attente",
      "saving": "Enregistrement…",
      "saved": "Enregistré",
      "error": "Échec de l'enregistrement"
    },
    "aiHints": {
      "title": "Notes IA",
      "toggleAria": "Afficher ou masquer les notes IA"
    },
    "pricing": {
      "groups": {
        "pricing": "Prix & Conditions",
        "rentSituation": "Situation locative",
        "rentSituationToggle": "Afficher ou masquer la situation locative"
      },
      "sections": {
        "financialKpis": "Indicateurs financiers",
        "unitMix": "Mix des logements",
        "rentRoll": "État locatif"
      },
      "tablesUnavailableInCreateMode": "Le mix des logements et l'état locatif peuvent être saisis après le premier enregistrement.",
      "unitMixSellerHint": "Le mix des logements est géré par le courtier — consultation seulement.",
      "rentRollSellerHint": "Vous pouvez compléter l'état locatif vous-même — pensez à enregistrer après modification.",
      "saveUnitMix": "Enregistrer le mix des logements",
      "saveRentRoll": "Enregistrer l'état locatif",
      "noUnitMix": "Aucune entrée dans le mix des logements.",
      "noRentRoll": "Aucune entrée dans l'état locatif."
    },
    "media": {
      "requiresProperty": "Veuillez d'abord enregistrer les données de base — les téléversements seront ensuite disponibles.",
      "images": {
        "title": "Images",
        "hint": "Marquez l'image principale et réorganisez les autres par glisser-déposer. Les visualisations, photos, plans et cartes sont regroupés automatiquement.",
        "noFilterMatch": "Aucune image ne correspond au filtre sélectionné.",
        "filters": {
          "ariaLabel": "Filtrer les images par type",
          "all": "Toutes",
          "photo": "Photos",
          "visualisierung": "Visualisations",
          "plan": "Plans",
          "karte": "Cartes",
          "other": "Autres"
        },
        "teaser": {
          "teaserOption": "Teaser",
          "ndaOption": "NDA uniquement",
          "toggleAria": "Visibilité du teaser",
          "riskBadge": "Emplacement",
          "riskTitle": "Permet de déduire l’emplacement exact",
          "confirmUpgrade": "Cette image révèle l’emplacement. L’afficher quand même dans le teaser (avant NDA) ?",
          "confirmYes": "Afficher quand même",
          "captionEmpty": "Aucune description IA",
          "showFull": "Afficher la description complète",
          "summaryTeaser": "{{count}} dans le teaser",
          "summaryNda": "{{count}} NDA uniquement",
          "summaryRisk": "{{count}} à risque d’emplacement",
          "previewToggle": "Aperçu teaser",
          "previewHint": "Afficher uniquement les images visibles par les acheteurs sans NDA",
          "previewEmpty": "Aucune image n’est activée pour le teaser."
        },
        "mediumLabels": {
          "photo": "Photo",
          "visualisierung": "3D",
          "plan": "Plan",
          "karte": "Carte",
          "scan": "Scan",
          "logo": "Logo"
        },
        "subjectLabels": {
          "fassade": "Façade",
          "wohnraum": "Salon",
          "kueche": "Cuisine",
          "bad": "Salle de bain",
          "schlafzimmer": "Chambre",
          "buero": "Bureau",
          "treppenhaus": "Cage d'escalier",
          "keller": "Cave",
          "garten": "Jardin",
          "umgebung": "Environs",
          "luftbild": "Vue aérienne",
          "grundriss": "Plan d'étage",
          "schnitt": "Coupe",
          "ansicht": "Élévation",
          "lageplan": "Plan de situation"
        }
      },
      "dossier": {
        "title": "Documents du dossier",
        "hint": "Téléversez les documents de vente par catégorie (registre foncier, transfert, …)."
      },
      "accessLog": {
        "title": "Journal des accès",
        "hint": "Qui a consulté ou téléchargé quel document et quand — preuve pour l'accord de confidentialité.",
        "count": "{{count}} accès enregistrés",
        "filterLabel": "Acheteur",
        "filterAll": "Tous les acheteurs",
        "empty": "Aucun accès aux documents enregistré pour l'instant.",
        "loadError": "Le journal des accès n'a pas pu être chargé.",
        "pageOf": "Page {{page}} sur {{total}}",
        "typeDownload": "Téléchargement",
        "typePreview": "Aperçu",
        "typePreviewPage": "Aperçu page {{page}}",
        "mayanDocument": "Document {{id}}",
        "columns": {
          "time": "Heure",
          "buyer": "Acheteur",
          "document": "Document",
          "type": "Type",
          "ip": "IP"
        }
      },
      "identifyLeak": {
        "button": "Identifier la fuite",
        "title": "Identifier la fuite",
        "description": "Téléversez le fichier divulgué — l'empreinte invisible révèle quel acheteur l'a reçu.",
        "fileLabel": "Fichier divulgué",
        "fileHint": "Image ou PDF, 30 Mo au maximum. Fonctionne aussi avec des extraits ou des copies compressées.",
        "submit": "Identifier",
        "tooLarge": "Le fichier est trop volumineux (30 Mo au maximum).",
        "error": "L'identification a échoué. Veuillez réessayer.",
        "resultFound": "Appartient à : {{buyer}}, {{document}}, {{time}}",
        "resultNotFound": "Aucune empreinte trouvée.",
        "unknownDocument": "Document inconnu"
      },
      "immotron": {
        "title": "Documents Immotron",
        "hint": "Documents générés par le système — visibles en interne uniquement."
      },
      "highlights": {
        "title": "Points forts et description",
        "hint": "Afficher au maximum 5 points forts — réordonnez par glisser-déposer."
      },
      "vrTour": {
        "title": "Visite virtuelle et liens",
        "hint": "Collez une URL de visite externe (Matterport, Kuula, …)."
      },
      "translations": {
        "title": "Traductions",
        "hint": "Gérez les textes en DE/EN/FR/IT — les champs vides peuvent être traduits automatiquement.",
        "cards": {
          "title": "Titre",
          "description": "Description",
          "location": "Emplacement"
        },
        "placeholders": {
          "name": "p.ex. Immeuble résidentiel et commercial Zurich-Seefeld",
          "subheader": "p.ex. Emplacement de premier ordre dans le quartier d'affaires",
          "highlights": "p.ex. • Entièrement loué • Rénové en 2021 • Transports publics classe A",
          "description": "Description détaillée du bien : emplacement, état, équipement, particularités et possibilités d'utilisation ...",
          "macro": "p.ex. Emplacement central dans la ville de Zurich, espace économique établi ...",
          "micro": "p.ex. Rue latérale calme, commerces et transports publics à distance de marche ..."
        },
        "aiBadge": "Suggestion IA",
        "aiTitle": "Ce texte a été suggéré par l'IA. Modifiez-le pour supprimer l'indication.",
        "translated": "Traduit",
        "notTranslated": "Non traduit",
        "copyFromMaster": "Reprendre depuis DE",
        "reference": "Version originale allemande",
        "charCount": "{{count}} caractères",
        "charCountMax": "{{count}}/{{max}} caractères"
      }
    },
    "object": {
      "sections": {
        "classification": "Classification et statut",
        "address": "Adresse et situation",
        "land": "Terrain",
        "building": "Bâtiment",
        "energy": "Énergie et état"
      },
      "fields": {
        "dealState": "État de la transaction",
        "dealStateNotSet": "Non défini",
        "inhabitants": "Habitants (commune)",
        "coordinates": "Coordonnées",
        "minGroundFloorHeight": "Hauteur min. du rez-de-chaussée",
        "egidNumber": "Numéro EGID (identifiant du bâtiment)",
        "egidPlaceholder": "p. ex. 100123456",
        "energyClassPlaceholder": "p. ex. A, B, C…"
      },
      "noSubtypes": "Aucun sous-type disponible pour ce type."
    },
    "review": {
      "sections": {
        "auftraggeber": "Mandant",
        "sales": "Configuration des ventes",
        "listing": "Configuration de l'annonce",
        "qualityGate": "Quality gate",
        "timeline": "Chronologie du deal"
      },
      "timeline": {
        "subtitle": "Phase actuelle et activités en un coup d'œil."
      },
      "auftraggeber": {
        "subtitle": "Qui a confié le mandat de commercialisation ?",
        "contactLabel": "Mandant",
        "contactPlaceholder": "Rechercher un contact existant…",
        "contactHint": "Utilisé dans le mandat de commercialisation et les contrats.",
        "sellerReadOnly": "Ces informations sont gérées par le courtier.",
        "notSet": "Pas encore défini",
        "searchButton": "Rechercher le contrat",
        "changeButton": "Modifier le contrat",
        "removeButton": "Retirer",
        "removeConfirmTitle": "Retirer le mandant ?",
        "removeConfirmText": "« {{name}} » sera retiré comme mandant de ce bien. Les contrats existants sont conservés ; vous pouvez lier un nouveau mandant à tout moment.",
        "removeConfirmTextNoName": "Le mandant sera retiré de ce bien. Les contrats existants sont conservés ; vous pouvez lier un nouveau mandant à tout moment.",
        "removeSuccess": "Mandant retiré",
        "removeFailed": "Le mandant n'a pas pu être retiré",
        "saveFirstHint": "Veuillez d'abord enregistrer le bien pour lier un mandant."
      },
      "sales": {
        "subtitle": "Conseiller responsable et durée du mandat.",
        "salesUserLabel": "Conseiller responsable",
        "salesUserPlaceholder": "Sélectionner un conseiller…",
        "saleStartDate": "Début du mandat",
        "saleEndDate": "Fin du mandat",
        "assignedTo": "Actuellement attribué à : {{name}}"
      },
      "listing": {
        "subtitle": "Visibilité et paramètres de publication.",
        "privateLabel": "Annonce privée",
        "privateHint": "Seuls les investisseurs ou groupes sélectionnés voient ce bien.",
        "expirationLabel": "L'annonce expire le",
        "expirationHint": "Après cette date, l'annonce est désactivée automatiquement.",
        "investorGroupHint": "Gérez l'accès des investisseurs et des groupes sur la page de détail du bien.",
        "openDetailPage": "Ouvrir la page de détail"
      },
      "qualityGate": {
        "subtitle": "Statut et soumission pour vérification interne.",
        "statusLabel": "Statut actuel",
        "submitButton": "Soumettre pour vérification",
        "submitting": "Envoi en cours…",
        "submitted": "Soumis pour vérification.",
        "submitFailed": "Échec de l'envoi. Veuillez réessayer.",
        "submitHint": "Après l'envoi, un membre interne de l'équipe vérifie le bien.",
        "inReviewHint": "Le bien est en cours de vérification. Vous pouvez continuer à modifier les données jusqu'à la décision.",
        "sellerStateHint": "Le statut actuel est géré par le courtier.",
        "submittedAt": "Soumis le {{date}}",
        "reviewedAt": "Vérifié le {{date}}",
        "rejectedTitle": "Motif du refus",
        "rejectedHint": "Veuillez corriger les points indiqués et soumettre à nouveau."
      }
    },
    "aiInsights": {
      "title": "Notes IA",
      "description": "Toutes les informations IA sur ce bien immobilier en un seul endroit : notes de l'extraction, journal d'extraction et connaissances épinglées.",
      "sectionsAriaLabel": "Notes IA : sections",
      "warningIndicatorAria": "Contient des avertissements",
      "sections": {
        "hints": {
          "label": "Notes",
          "description": "Notes issues de l'extraction IA (propriétaires, servitudes, gages immobiliers, conflits). Les entrées avec ⚠️ sont mises en évidence.",
          "empty": "Aucune note IA disponible pour ce bien immobilier."
        },
        "protocol": {
          "label": "Journal d'extraction"
        },
        "knowledge": {
          "label": "Connaissances",
          "description": "Notes épinglées à ce bien immobilier depuis des tâches."
        }
      }
    }
  },
  "knowledgeBoard": {
    "pageTitle": "Organiser les notes",
    "pageSubtitle": "Faites glisser les notes depuis la recherche vers la cible et réorganisez-les.",
    "instructions": "Glisser-déposer — ou utiliser espace / flèches pour le clavier.",
    "reset": "Réinitialiser",
    "sourceTitle": "Recherche",
    "sourceHint": "Réservoir de notes collectées.",
    "sourceEmpty": "Aucune autre note dans la recherche.",
    "targetTitle": "Cible",
    "targetHint": "Espace de travail — déposez et triez les notes ici.",
    "targetEmpty": "Glissez une note ici pour l'ajouter à la cible.",
    "dragHandle": "Déplacer la note « {{title}} »",
    "a11y": {
      "start": "Note {{id}} saisie.",
      "over": "Note {{id}} au-dessus de {{target}}.",
      "outside": "Note {{id}} en dehors d'une zone valide.",
      "end": "Note {{id}} déposée sur {{target}}.",
      "cancel": "Déplacement de la note {{id}} annulé."
    },
    "samples": {
      "market": {
        "title": "Analyse de marché Zurich Ouest",
        "summary": "Le prix moyen au m² a augmenté de 3,2 % le dernier trimestre, à CHF 11'400.",
        "source": "Recherche · Données de marché"
      },
      "location": {
        "title": "Évaluation du quartier industriel",
        "summary": "Très bonne desserte en transports publics, requalification prévue avec un nouveau parc.",
        "source": "Recherche · Emplacement"
      },
      "zefix": {
        "title": "Profil d'entreprise Musterhaus AG",
        "summary": "Active depuis 1998, 24 employés, secteur construction et rénovation.",
        "source": "Zefix"
      },
      "news": {
        "title": "Actu : nouvelle ligne de tram 17 dès 2027",
        "summary": "Liaison directe avec la gare centrale — valorisation probable des biens du corridor.",
        "source": "Recherche · Actualités"
      }
    }
  },
  "buyerSearch": {
    "placeholder": "Rechercher un nom, une société ou un e-mail …",
    "hint": "Saisissez au moins 2 caractères pour rechercher des contacts, sociétés CRM et le registre du commerce.",
    "empty": "Aucun résultat trouvé dans le CRM ni au registre du commerce.",
    "searchFailed": "Échec de la recherche. Veuillez réessayer.",
    "assign": "Attribuer",
    "assignFailed": "Échec de l'attribution",
    "alreadyAssigned": "Attribué",
    "typeContact": "Contact",
    "typeCompany": "Société",
    "statusActive": "Actif",
    "statusPending": "Onboarding requis",
    "zefixBadge": "Zefix",
    "createFromZefix": "Créer la société",
    "createdFromZefix": "{{name}} et {{count}} personnes créées",
    "createFromZefixFailed": "La société n’a pas pu être créée",
    "noZefixHint": "Pas au registre du commerce ?",
    "noZefixHintLink": "Créer une nouvelle organisation dans le CRM",
    "inactiveAt": "inactif chez {{company}}",
    "inactiveAssignBlocked": "Rôle chez {{company}} terminé",
    "noEmailAssignBlocked": "Aucune adresse e-mail — attribution impossible"
  },
  "emailConflict": {
    "duplicateContactTitle": "E-mail déjà associé à un contact",
    "duplicateCompanyTitle": "E-mail déjà associé à une organisation",
    "existingEntry": "Entrée existante",
    "switchToContact": "Aller au contact",
    "switchToCompany": "Aller à l'organisation",
    "merge": "Fusionner",
    "mergeTitle": "Fusionner les contacts",
    "matchReasonEmail": "Même adresse e-mail",
    "genericTitle": "Adresse générique — la transférer à l'organisation ?",
    "genericDescription": "Cette adresse appartient à une organisation, pas à une personne.",
    "moveToCompany": "Transférer à {{name}}",
    "moveToCompanyHint": "L'adresse est enregistrée auprès de l'organisation et supprimée du contact.",
    "saveAnyway": "Enregistrer quand même",
    "noCompany": "Ce contact n'est associé à aucune organisation.",
    "movedToCompany": "E-mail transféré à l'organisation",
    "moveFailed": "Échec du transfert à l'organisation"
  }
}
